// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/ryugu/v1/ryugu.proto (package mono.ryugu.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { AwardDeliverableRoll, AwardPricedDuty, OrderCeiling, ReviewItem, ReviewSource, StatedObligation } from "../../common/v1/types_pb";
import { NotificationKindPreference, NotificationPreferenceChange } from "../../datagateway/v1/notification_preferences_pb";
import { FindGlossarySectionRequest as FindGlossarySectionRequest$1, FindGlossarySectionResponse as FindGlossarySectionResponse$1, UpsertGlossarySectionRequest, UpsertGlossarySectionResponse } from "../../datagateway/v1/contract_model_pb";
/**
 * OnTimeWindow names a trailing window that pangaea resolves to concrete
 * [from, to) bounds server-side, in UTC, in exactly one place. Clients never
 * compute the boundaries themselves; they name the window and read the
 * applied bounds back off the response. Mirrors datagateway.v1.OnTimeWindow.
 * Value names are retained for wire compatibility even though they now name
 * trailing, not calendar, windows.
 *
 * @generated from enum mono.ryugu.v1.OnTimeWindow
 */ export var OnTimeWindow = /*#__PURE__*/ function(OnTimeWindow) {
    /**
   * Cumulative: no window predicate at all. Default, so every existing caller
   * keeps its current cumulative behaviour unchanged.
   *
   * @generated from enum value: ON_TIME_WINDOW_UNSPECIFIED = 0;
   */ OnTimeWindow[OnTimeWindow["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * The trailing 7 calendar days ending at the request instant: half-open
   * [now - 7d, now) in UTC.
   *
   * @generated from enum value: ON_TIME_WINDOW_PREVIOUS_WEEK = 1;
   */ OnTimeWindow[OnTimeWindow["PREVIOUS_WEEK"] = 1] = "PREVIOUS_WEEK";
    /**
   * The trailing 30 calendar days ending at the request instant: half-open
   * [now - 30d, now) in UTC.
   *
   * @generated from enum value: ON_TIME_WINDOW_PREVIOUS_MONTH = 2;
   */ OnTimeWindow[OnTimeWindow["PREVIOUS_MONTH"] = 2] = "PREVIOUS_MONTH";
    return OnTimeWindow;
}({});
// Retrieve enum metadata with: proto3.getEnumType(OnTimeWindow)
proto3.util.setEnumType(OnTimeWindow, "mono.ryugu.v1.OnTimeWindow", [
    {
        no: 0,
        name: "ON_TIME_WINDOW_UNSPECIFIED"
    },
    {
        no: 1,
        name: "ON_TIME_WINDOW_PREVIOUS_WEEK"
    },
    {
        no: 2,
        name: "ON_TIME_WINDOW_PREVIOUS_MONTH"
    }
]);
/**
 * LifecycleNodeKind is the set of records the resolver can reach today.
 * WATCH / LANDSCAPE arrive with P-L4 and P-L9. OPPORTUNITY and NOTICE are
 * thin chips keyed by the morgans notice_id.
 *
 * @generated from enum mono.ryugu.v1.LifecycleNodeKind
 */ export var LifecycleNodeKind = /*#__PURE__*/ function(LifecycleNodeKind) {
    /**
   * @generated from enum value: LIFECYCLE_NODE_KIND_UNSPECIFIED = 0;
   */ LifecycleNodeKind[LifecycleNodeKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: LIFECYCLE_NODE_KIND_PURSUIT = 1;
   */ LifecycleNodeKind[LifecycleNodeKind["PURSUIT"] = 1] = "PURSUIT";
    /**
   * @generated from enum value: LIFECYCLE_NODE_KIND_PROPOSAL = 2;
   */ LifecycleNodeKind[LifecycleNodeKind["PROPOSAL"] = 2] = "PROPOSAL";
    /**
   * @generated from enum value: LIFECYCLE_NODE_KIND_PRE_AWARD = 3;
   */ LifecycleNodeKind[LifecycleNodeKind["PRE_AWARD"] = 3] = "PRE_AWARD";
    /**
   * @generated from enum value: LIFECYCLE_NODE_KIND_PROGRAM = 4;
   */ LifecycleNodeKind[LifecycleNodeKind["PROGRAM"] = 4] = "PROGRAM";
    /**
   * @generated from enum value: LIFECYCLE_NODE_KIND_RFI_RESPONSE = 5;
   */ LifecycleNodeKind[LifecycleNodeKind["RFI_RESPONSE"] = 5] = "RFI_RESPONSE";
    /**
   * @generated from enum value: LIFECYCLE_NODE_KIND_OPPORTUNITY = 6;
   */ LifecycleNodeKind[LifecycleNodeKind["OPPORTUNITY"] = 6] = "OPPORTUNITY";
    /**
   * @generated from enum value: LIFECYCLE_NODE_KIND_NOTICE = 7;
   */ LifecycleNodeKind[LifecycleNodeKind["NOTICE"] = 7] = "NOTICE";
    /**
   * GRW-10 (SAD-1145): the canonical opportunity (govcon.opportunities),
   * a growth landscape (membership only), and registry people / companies
   * (merge-followed survivors).
   *
   * @generated from enum value: LIFECYCLE_NODE_KIND_CANONICAL_OPPORTUNITY = 8;
   */ LifecycleNodeKind[LifecycleNodeKind["CANONICAL_OPPORTUNITY"] = 8] = "CANONICAL_OPPORTUNITY";
    /**
   * @generated from enum value: LIFECYCLE_NODE_KIND_LANDSCAPE = 9;
   */ LifecycleNodeKind[LifecycleNodeKind["LANDSCAPE"] = 9] = "LANDSCAPE";
    /**
   * @generated from enum value: LIFECYCLE_NODE_KIND_PERSON = 10;
   */ LifecycleNodeKind[LifecycleNodeKind["PERSON"] = 10] = "PERSON";
    /**
   * @generated from enum value: LIFECYCLE_NODE_KIND_COMPANY = 11;
   */ LifecycleNodeKind[LifecycleNodeKind["COMPANY"] = 11] = "COMPANY";
    return LifecycleNodeKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(LifecycleNodeKind)
proto3.util.setEnumType(LifecycleNodeKind, "mono.ryugu.v1.LifecycleNodeKind", [
    {
        no: 0,
        name: "LIFECYCLE_NODE_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "LIFECYCLE_NODE_KIND_PURSUIT"
    },
    {
        no: 2,
        name: "LIFECYCLE_NODE_KIND_PROPOSAL"
    },
    {
        no: 3,
        name: "LIFECYCLE_NODE_KIND_PRE_AWARD"
    },
    {
        no: 4,
        name: "LIFECYCLE_NODE_KIND_PROGRAM"
    },
    {
        no: 5,
        name: "LIFECYCLE_NODE_KIND_RFI_RESPONSE"
    },
    {
        no: 6,
        name: "LIFECYCLE_NODE_KIND_OPPORTUNITY"
    },
    {
        no: 7,
        name: "LIFECYCLE_NODE_KIND_NOTICE"
    },
    {
        no: 8,
        name: "LIFECYCLE_NODE_KIND_CANONICAL_OPPORTUNITY"
    },
    {
        no: 9,
        name: "LIFECYCLE_NODE_KIND_LANDSCAPE"
    },
    {
        no: 10,
        name: "LIFECYCLE_NODE_KIND_PERSON"
    },
    {
        no: 11,
        name: "LIFECYCLE_NODE_KIND_COMPANY"
    }
]);
/**
 * LifecycleEdgeKind distinguishes a promote/convert step from an attachment.
 * A handoff consumes nothing: a pursuit survives its proposal.
 *
 * @generated from enum mono.ryugu.v1.LifecycleEdgeKind
 */ export var LifecycleEdgeKind = /*#__PURE__*/ function(LifecycleEdgeKind) {
    /**
   * @generated from enum value: LIFECYCLE_EDGE_KIND_UNSPECIFIED = 0;
   */ LifecycleEdgeKind[LifecycleEdgeKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: LIFECYCLE_EDGE_KIND_HANDOFF = 1;
   */ LifecycleEdgeKind[LifecycleEdgeKind["HANDOFF"] = 1] = "HANDOFF";
    /**
   * @generated from enum value: LIFECYCLE_EDGE_KIND_LINK = 2;
   */ LifecycleEdgeKind[LifecycleEdgeKind["LINK"] = 2] = "LINK";
    /**
   * @generated from enum value: LIFECYCLE_EDGE_KIND_OWN = 3;
   */ LifecycleEdgeKind[LifecycleEdgeKind["OWN"] = 3] = "OWN";
    return LifecycleEdgeKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(LifecycleEdgeKind)
proto3.util.setEnumType(LifecycleEdgeKind, "mono.ryugu.v1.LifecycleEdgeKind", [
    {
        no: 0,
        name: "LIFECYCLE_EDGE_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "LIFECYCLE_EDGE_KIND_HANDOFF"
    },
    {
        no: 2,
        name: "LIFECYCLE_EDGE_KIND_LINK"
    },
    {
        no: 3,
        name: "LIFECYCLE_EDGE_KIND_OWN"
    }
]);
/**
 * @generated from enum mono.ryugu.v1.AssignedActionKind
 */ export var AssignedActionKind = /*#__PURE__*/ function(AssignedActionKind) {
    /**
   * @generated from enum value: ASSIGNED_ACTION_KIND_UNSPECIFIED = 0;
   */ AssignedActionKind[AssignedActionKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: ASSIGNED_ACTION_KIND_PROGRAM_TASK = 1;
   */ AssignedActionKind[AssignedActionKind["PROGRAM_TASK"] = 1] = "PROGRAM_TASK";
    /**
   * @generated from enum value: ASSIGNED_ACTION_KIND_ISSUE = 2;
   */ AssignedActionKind[AssignedActionKind["ISSUE"] = 2] = "ISSUE";
    /**
   * @generated from enum value: ASSIGNED_ACTION_KIND_CORRECTIVE_ACTION = 3;
   */ AssignedActionKind[AssignedActionKind["CORRECTIVE_ACTION"] = 3] = "CORRECTIVE_ACTION";
    /**
   * @generated from enum value: ASSIGNED_ACTION_KIND_RISK = 4;
   */ AssignedActionKind[AssignedActionKind["RISK"] = 4] = "RISK";
    return AssignedActionKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(AssignedActionKind)
proto3.util.setEnumType(AssignedActionKind, "mono.ryugu.v1.AssignedActionKind", [
    {
        no: 0,
        name: "ASSIGNED_ACTION_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "ASSIGNED_ACTION_KIND_PROGRAM_TASK"
    },
    {
        no: 2,
        name: "ASSIGNED_ACTION_KIND_ISSUE"
    },
    {
        no: 3,
        name: "ASSIGNED_ACTION_KIND_CORRECTIVE_ACTION"
    },
    {
        no: 4,
        name: "ASSIGNED_ACTION_KIND_RISK"
    }
]);
/**
 * @generated from message mono.ryugu.v1.PingRequest
 */ export class PingRequest extends Message {
    static fromBinary(bytes, options) {
        return new PingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PingRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(PingRequest, "runtime", proto3);
_define_property(PingRequest, "typeName", "mono.ryugu.v1.PingRequest");
_define_property(PingRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.PingResponse
 */ export class PingResponse extends Message {
    static fromBinary(bytes, options) {
        return new PingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string message = 1;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PingResponse, "runtime", proto3);
_define_property(PingResponse, "typeName", "mono.ryugu.v1.PingResponse");
_define_property(PingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.PaginationRequest
 */ export class PaginationRequest extends Message {
    static fromBinary(bytes, options) {
        return new PaginationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PaginationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PaginationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PaginationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 page = 1;
   */ _define_property(this, "page", 0), /**
   * @generated from field: int32 page_size = 2;
   */ _define_property(this, "pageSize", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PaginationRequest, "runtime", proto3);
_define_property(PaginationRequest, "typeName", "mono.ryugu.v1.PaginationRequest");
_define_property(PaginationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.PaginationResponse
 */ export class PaginationResponse extends Message {
    static fromBinary(bytes, options) {
        return new PaginationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PaginationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PaginationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PaginationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total = 1;
   */ _define_property(this, "total", 0), /**
   * @generated from field: int32 page = 2;
   */ _define_property(this, "page", 0), /**
   * @generated from field: int32 page_size = 3;
   */ _define_property(this, "pageSize", 0), /**
   * @generated from field: int32 total_pages = 4;
   */ _define_property(this, "totalPages", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PaginationResponse, "runtime", proto3);
_define_property(PaginationResponse, "typeName", "mono.ryugu.v1.PaginationResponse");
_define_property(PaginationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "total_pages",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.Sector
 */ export class Sector extends Message {
    static fromBinary(bytes, options) {
        return new Sector().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Sector().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Sector().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Sector, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Sector, "runtime", proto3);
_define_property(Sector, "typeName", "mono.ryugu.v1.Sector");
_define_property(Sector, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListSectorsRequest
 */ export class ListSectorsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSectorsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSectorsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSectorsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSectorsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSectorsRequest, "runtime", proto3);
_define_property(ListSectorsRequest, "typeName", "mono.ryugu.v1.ListSectorsRequest");
_define_property(ListSectorsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListSectorsResponse
 */ export class ListSectorsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSectorsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSectorsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSectorsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSectorsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.Sector sectors = 1;
   */ _define_property(this, "sectors", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSectorsResponse, "runtime", proto3);
_define_property(ListSectorsResponse, "typeName", "mono.ryugu.v1.ListSectorsResponse");
_define_property(ListSectorsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sectors",
            kind: "message",
            T: Sector,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertSectorRequest
 */ export class UpsertSectorRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertSectorRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertSectorRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertSectorRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertSectorRequest, a, b);
    }
    constructor(data){
        super(), /**
   * empty = create, present = update
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertSectorRequest, "runtime", proto3);
_define_property(UpsertSectorRequest, "typeName", "mono.ryugu.v1.UpsertSectorRequest");
_define_property(UpsertSectorRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertSectorResponse
 */ export class UpsertSectorResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertSectorResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertSectorResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertSectorResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertSectorResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.Sector sector = 1;
   */ _define_property(this, "sector", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertSectorResponse, "runtime", proto3);
_define_property(UpsertSectorResponse, "typeName", "mono.ryugu.v1.UpsertSectorResponse");
_define_property(UpsertSectorResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sector",
            kind: "message",
            T: Sector
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteSectorRequest
 */ export class DeleteSectorRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteSectorRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteSectorRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteSectorRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteSectorRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteSectorRequest, "runtime", proto3);
_define_property(DeleteSectorRequest, "typeName", "mono.ryugu.v1.DeleteSectorRequest");
_define_property(DeleteSectorRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteSectorResponse
 */ export class DeleteSectorResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteSectorResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteSectorResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteSectorResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteSectorResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteSectorResponse, "runtime", proto3);
_define_property(DeleteSectorResponse, "typeName", "mono.ryugu.v1.DeleteSectorResponse");
_define_property(DeleteSectorResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.BusinessUnit
 */ export class BusinessUnit extends Message {
    static fromBinary(bytes, options) {
        return new BusinessUnit().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BusinessUnit().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BusinessUnit().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BusinessUnit, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string sector_id = 3;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string manager_name = 5;
   */ _define_property(this, "managerName", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BusinessUnit, "runtime", proto3);
_define_property(BusinessUnit, "typeName", "mono.ryugu.v1.BusinessUnit");
_define_property(BusinessUnit, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "manager_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListBusinessUnitsRequest
 */ export class ListBusinessUnitsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListBusinessUnitsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListBusinessUnitsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListBusinessUnitsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListBusinessUnitsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * optional filter
   *
   * @generated from field: string sector_id = 2;
   */ _define_property(this, "sectorId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListBusinessUnitsRequest, "runtime", proto3);
_define_property(ListBusinessUnitsRequest, "typeName", "mono.ryugu.v1.ListBusinessUnitsRequest");
_define_property(ListBusinessUnitsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListBusinessUnitsResponse
 */ export class ListBusinessUnitsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListBusinessUnitsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListBusinessUnitsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListBusinessUnitsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListBusinessUnitsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.BusinessUnit business_units = 1;
   */ _define_property(this, "businessUnits", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListBusinessUnitsResponse, "runtime", proto3);
_define_property(ListBusinessUnitsResponse, "typeName", "mono.ryugu.v1.ListBusinessUnitsResponse");
_define_property(ListBusinessUnitsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "business_units",
            kind: "message",
            T: BusinessUnit,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertBusinessUnitRequest
 */ export class UpsertBusinessUnitRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertBusinessUnitRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertBusinessUnitRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertBusinessUnitRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertBusinessUnitRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string sector_id = 3;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string manager_name = 5;
   */ _define_property(this, "managerName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertBusinessUnitRequest, "runtime", proto3);
_define_property(UpsertBusinessUnitRequest, "typeName", "mono.ryugu.v1.UpsertBusinessUnitRequest");
_define_property(UpsertBusinessUnitRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "manager_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertBusinessUnitResponse
 */ export class UpsertBusinessUnitResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertBusinessUnitResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertBusinessUnitResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertBusinessUnitResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertBusinessUnitResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.BusinessUnit business_unit = 1;
   */ _define_property(this, "businessUnit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertBusinessUnitResponse, "runtime", proto3);
_define_property(UpsertBusinessUnitResponse, "typeName", "mono.ryugu.v1.UpsertBusinessUnitResponse");
_define_property(UpsertBusinessUnitResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "business_unit",
            kind: "message",
            T: BusinessUnit
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteBusinessUnitRequest
 */ export class DeleteBusinessUnitRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteBusinessUnitRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteBusinessUnitRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteBusinessUnitRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteBusinessUnitRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteBusinessUnitRequest, "runtime", proto3);
_define_property(DeleteBusinessUnitRequest, "typeName", "mono.ryugu.v1.DeleteBusinessUnitRequest");
_define_property(DeleteBusinessUnitRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteBusinessUnitResponse
 */ export class DeleteBusinessUnitResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteBusinessUnitResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteBusinessUnitResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteBusinessUnitResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteBusinessUnitResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteBusinessUnitResponse, "runtime", proto3);
_define_property(DeleteBusinessUnitResponse, "typeName", "mono.ryugu.v1.DeleteBusinessUnitResponse");
_define_property(DeleteBusinessUnitResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.Portfolio
 */ export class Portfolio extends Message {
    static fromBinary(bytes, options) {
        return new Portfolio().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Portfolio().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Portfolio().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Portfolio, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string business_unit_id = 3;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string director_name = 5;
   */ _define_property(this, "directorName", ""), /**
   * VP, SPfD, PfD
   *
   * @generated from field: string director_role = 6;
   */ _define_property(this, "directorRole", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Portfolio, "runtime", proto3);
_define_property(Portfolio, "typeName", "mono.ryugu.v1.Portfolio");
_define_property(Portfolio, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "director_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "director_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListPortfoliosRequest
 */ export class ListPortfoliosRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPortfoliosRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPortfoliosRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPortfoliosRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPortfoliosRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * optional filter
   *
   * @generated from field: string business_unit_id = 2;
   */ _define_property(this, "businessUnitId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPortfoliosRequest, "runtime", proto3);
_define_property(ListPortfoliosRequest, "typeName", "mono.ryugu.v1.ListPortfoliosRequest");
_define_property(ListPortfoliosRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListPortfoliosResponse
 */ export class ListPortfoliosResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPortfoliosResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPortfoliosResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPortfoliosResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPortfoliosResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.Portfolio portfolios = 1;
   */ _define_property(this, "portfolios", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPortfoliosResponse, "runtime", proto3);
_define_property(ListPortfoliosResponse, "typeName", "mono.ryugu.v1.ListPortfoliosResponse");
_define_property(ListPortfoliosResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "portfolios",
            kind: "message",
            T: Portfolio,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertPortfolioRequest
 */ export class UpsertPortfolioRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertPortfolioRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertPortfolioRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertPortfolioRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertPortfolioRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string business_unit_id = 3;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string director_name = 5;
   */ _define_property(this, "directorName", ""), /**
   * @generated from field: string director_role = 6;
   */ _define_property(this, "directorRole", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertPortfolioRequest, "runtime", proto3);
_define_property(UpsertPortfolioRequest, "typeName", "mono.ryugu.v1.UpsertPortfolioRequest");
_define_property(UpsertPortfolioRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "director_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "director_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertPortfolioResponse
 */ export class UpsertPortfolioResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertPortfolioResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertPortfolioResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertPortfolioResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertPortfolioResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.Portfolio portfolio = 1;
   */ _define_property(this, "portfolio", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertPortfolioResponse, "runtime", proto3);
_define_property(UpsertPortfolioResponse, "typeName", "mono.ryugu.v1.UpsertPortfolioResponse");
_define_property(UpsertPortfolioResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "portfolio",
            kind: "message",
            T: Portfolio
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeletePortfolioRequest
 */ export class DeletePortfolioRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeletePortfolioRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePortfolioRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePortfolioRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePortfolioRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeletePortfolioRequest, "runtime", proto3);
_define_property(DeletePortfolioRequest, "typeName", "mono.ryugu.v1.DeletePortfolioRequest");
_define_property(DeletePortfolioRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeletePortfolioResponse
 */ export class DeletePortfolioResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeletePortfolioResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePortfolioResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePortfolioResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePortfolioResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeletePortfolioResponse, "runtime", proto3);
_define_property(DeletePortfolioResponse, "typeName", "mono.ryugu.v1.DeletePortfolioResponse");
_define_property(DeletePortfolioResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.Program
 */ export class Program extends Message {
    static fromBinary(bytes, options) {
        return new Program().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Program().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Program().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Program, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * Identity
   *
   * @generated from field: string program_name_full = 3;
   */ _define_property(this, "programNameFull", ""), /**
   * @generated from field: string program_name_short = 4;
   */ _define_property(this, "programNameShort", ""), /**
   * @generated from field: string deltek_project_number = 5;
   */ _define_property(this, "deltekProjectNumber", ""), /**
   * Contract details
   *
   * @generated from field: string contract_number = 6;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string task_number = 7;
   */ _define_property(this, "taskNumber", ""), /**
   * FK to ContractVehicle registry
   *
   * @generated from field: string contract_vehicle_id = 8;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string naics_code = 10;
   */ _define_property(this, "naicsCode", ""), /**
   * @generated from field: string contract_title = 13;
   */ _define_property(this, "contractTitle", ""), /**
   * @generated from field: google.protobuf.Timestamp award_date = 14;
   */ _define_property(this, "awardDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 15;
   */ _define_property(this, "effectiveDate", void 0), /**
   * original TCV at time of award
   *
   * @generated from field: double tcv_on_award = 40;
   */ _define_property(this, "tcvOnAward", 0), /**
   * exempt from DSO compliance
   *
   * @generated from field: bool deliverable_based_invoicing = 41;
   */ _define_property(this, "deliverableBasedInvoicing", false), /**
   * Org hierarchy
   *
   * @generated from field: string sector_id = 16;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string business_unit_id = 17;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string portfolio_id = 18;
   */ _define_property(this, "portfolioId", ""), /**
   * Dates
   *
   * @generated from field: google.protobuf.Timestamp contract_start_date = 22;
   */ _define_property(this, "contractStartDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp contract_end_date = 23;
   */ _define_property(this, "contractEndDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp company_start_date = 24;
   */ _define_property(this, "companyStartDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp company_end_date = 25;
   */ _define_property(this, "companyEndDate", void 0), /**
   * Description
   *
   * @generated from field: string description = 30;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string work_unique = 31;
   */ _define_property(this, "workUnique", ""), /**
   * @generated from field: repeated string work_types = 32;
   */ _define_property(this, "workTypes", []), /**
   * @generated from field: repeated string technologies = 33;
   */ _define_property(this, "technologies", []), /**
   * @generated from field: repeated string tools = 34;
   */ _define_property(this, "tools", []), /**
   * Linking
   *
   * @generated from field: string zou_project_id = 35;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string idiq_program_id = 36;
   */ _define_property(this, "idiqProgramId", ""), /**
   * @generated from field: google.protobuf.Timestamp last_synced_from_zou_at = 37;
   */ _define_property(this, "lastSyncedFromZouAt", void 0), /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 38;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 39;
   */ _define_property(this, "updatedAt", void 0), /**
   * Foundation (000010): normalized program fields
   *
   * @generated from field: string pricing_type = 42;
   */ _define_property(this, "pricingType", ""), /**
   * @generated from field: string company_role_type = 43;
   */ _define_property(this, "companyRoleType", ""), /**
   * contracting office
   *
   * @generated from field: string government_organization_id = 44;
   */ _define_property(this, "governmentOrganizationId", ""), /**
   * @generated from field: string customer_org_id = 45;
   */ _define_property(this, "customerOrgId", ""), /**
   * @generated from field: string prime_contractor_company_id = 46;
   */ _define_property(this, "primeContractorCompanyId", ""), /**
   * @generated from field: string legal_entity_company_id = 47;
   */ _define_property(this, "legalEntityCompanyId", ""), /**
   * @generated from field: string record_status_id = 48;
   */ _define_property(this, "recordStatusId", ""), /**
   * @generated from field: string contract_lifecycle_state_id = 49;
   */ _define_property(this, "contractLifecycleStateId", ""), /**
   * @generated from field: string operational_state_id = 50;
   */ _define_property(this, "operationalStateId", ""), /**
   * @generated from field: string delivery_model_type_id = 51;
   */ _define_property(this, "deliveryModelTypeId", ""), /**
   * Read helpers (from pangaea JOINs)
   *
   * @generated from field: string government_organization_name = 52;
   */ _define_property(this, "governmentOrganizationName", ""), /**
   * @generated from field: string customer_org_name = 53;
   */ _define_property(this, "customerOrgName", ""), /**
   * @generated from field: string cabinet_name = 54;
   */ _define_property(this, "cabinetName", ""), /**
   * @generated from field: string agency_name = 55;
   */ _define_property(this, "agencyName", ""), /**
   * @generated from field: string prime_contractor_company_name = 56;
   */ _define_property(this, "primeContractorCompanyName", ""), /**
   * @generated from field: string legal_entity_company_name = 57;
   */ _define_property(this, "legalEntityCompanyName", ""), /**
   * @generated from field: string operational_state_label = 58;
   */ _define_property(this, "operationalStateLabel", ""), /**
   * @generated from field: string contract_lifecycle_state_label = 59;
   */ _define_property(this, "contractLifecycleStateLabel", ""), /**
   * @generated from field: string record_status_label = 60;
   */ _define_property(this, "recordStatusLabel", ""), /**
   * @generated from field: string delivery_model_type_label = 61;
   */ _define_property(this, "deliveryModelTypeLabel", ""), /**
   * SDS financial baseline (Phase 4d): written authoritatively by pangaea
   * ApplyChangeSet (award commit + modification apply); tcv_on_award (field
   * 40) is the original award, current_tcv the running TCV after mods.
   *
   * @generated from field: double funded_amount = 62;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double funded_percent = 63;
   */ _define_property(this, "fundedPercent", 0), /**
   * @generated from field: double current_tcv = 64;
   */ _define_property(this, "currentTcv", 0), /**
   * Read helper, derived by pangaea on every read (never stored): no active role
   * assignment on this program holds the lead role (role_bundle_key
   * delivery_pm), so the program is waiting on the Delivery VP to name a lead.
   * False for every program when the tenant has no role_type mapped to
   * delivery_pm — see the field's comment in datagateway/v1/delivery.proto.
   *
   * @generated from field: bool needs_program_lead = 65;
   */ _define_property(this, "needsProgramLead", false), /**
   * SAD-186 project closeout lifecycle transition. Set once the program's
   * closeout checklist is Completed and DeliveryService.CloseProgram
   * succeeds; empty means the program is still open.
   *
   * @generated from field: google.protobuf.Timestamp closed_at = 66;
   */ _define_property(this, "closedAt", void 0), /**
   * @generated from field: string closed_by = 67;
   */ _define_property(this, "closedBy", ""), /**
   * @generated from field: optional string funding_basis = 68;
   */ _define_property(this, "fundingBasis", void 0), /**
   * @generated from field: optional double unallocated_funding = 69;
   */ _define_property(this, "unallocatedFunding", void 0), /**
   * Read-only canonical presence: absent legacy, false unknown, true reviewed.
   *
   * @generated from field: optional bool tcv_on_award_known = 70;
   */ _define_property(this, "tcvOnAwardKnown", void 0), /**
   * @generated from field: optional bool current_tcv_known = 71;
   */ _define_property(this, "currentTcvKnown", void 0), /**
   * The award's total ceiling, as pangaea holds it (Program Home's funding rail).
   *
   * @generated from field: double total_ceiling = 72;
   */ _define_property(this, "totalCeiling", 0), /**
   * Archived (soft-deleted). Only ever true on an include_archived listing.
   *
   * @generated from field: bool archived = 73;
   */ _define_property(this, "archived", false), /**
   * SAD-1342: the day (YYYY-MM-DD, UTC) the current ON_HOLD stretch began;
   * absent when the program is not on hold. Unfiled deliverable dates due on
   * or after it read "on_hold" instead of late/due_soon/upcoming.
   *
   * @generated from field: optional string on_hold_since = 74;
   */ _define_property(this, "onHoldSince", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Program, "runtime", proto3);
_define_property(Program, "typeName", "mono.ryugu.v1.Program");
_define_property(Program, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_name_full",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "program_name_short",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "deltek_project_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "task_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "naics_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "contract_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "award_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 40,
            name: "tcv_on_award",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 41,
            name: "deliverable_based_invoicing",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 16,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "contract_start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 23,
            name: "contract_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 24,
            name: "company_start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 25,
            name: "company_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 30,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 31,
            name: "work_unique",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 32,
            name: "work_types",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 33,
            name: "technologies",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 34,
            name: "tools",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 35,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 36,
            name: "idiq_program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 37,
            name: "last_synced_from_zou_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 38,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 39,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 42,
            name: "pricing_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 43,
            name: "company_role_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 44,
            name: "government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 45,
            name: "customer_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 46,
            name: "prime_contractor_company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 47,
            name: "legal_entity_company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 48,
            name: "record_status_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 49,
            name: "contract_lifecycle_state_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 50,
            name: "operational_state_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 51,
            name: "delivery_model_type_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 52,
            name: "government_organization_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 53,
            name: "customer_org_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 54,
            name: "cabinet_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 55,
            name: "agency_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 56,
            name: "prime_contractor_company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 57,
            name: "legal_entity_company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 58,
            name: "operational_state_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 59,
            name: "contract_lifecycle_state_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 60,
            name: "record_status_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 61,
            name: "delivery_model_type_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 62,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 63,
            name: "funded_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 64,
            name: "current_tcv",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 65,
            name: "needs_program_lead",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 66,
            name: "closed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 67,
            name: "closed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 68,
            name: "funding_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 69,
            name: "unallocated_funding",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 70,
            name: "tcv_on_award_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 71,
            name: "current_tcv_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 72,
            name: "total_ceiling",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 73,
            name: "archived",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 74,
            name: "on_hold_since",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateProgramRequest
 */ export class CreateProgramRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string program_name_full = 2;
   */ _define_property(this, "programNameFull", ""), /**
   * @generated from field: string program_name_short = 3;
   */ _define_property(this, "programNameShort", ""), /**
   * @generated from field: string contract_number = 4;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string task_number = 5;
   */ _define_property(this, "taskNumber", ""), /**
   * @generated from field: string contract_vehicle_id = 6;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string contract_title = 9;
   */ _define_property(this, "contractTitle", ""), /**
   * @generated from field: string sector_id = 10;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string business_unit_id = 11;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string portfolio_id = 12;
   */ _define_property(this, "portfolioId", ""), /**
   * @generated from field: string zou_project_id = 19;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string pricing_type = 20;
   */ _define_property(this, "pricingType", ""), /**
   * @generated from field: string company_role_type = 21;
   */ _define_property(this, "companyRoleType", ""), /**
   * @generated from field: string government_organization_id = 22;
   */ _define_property(this, "governmentOrganizationId", ""), /**
   * @generated from field: string customer_org_id = 23;
   */ _define_property(this, "customerOrgId", ""), /**
   * @generated from field: string prime_contractor_company_id = 24;
   */ _define_property(this, "primeContractorCompanyId", ""), /**
   * @generated from field: string legal_entity_company_id = 25;
   */ _define_property(this, "legalEntityCompanyId", ""), /**
   * @generated from field: string operational_state_id = 26;
   */ _define_property(this, "operationalStateId", ""), /**
   * @generated from field: string record_status_id = 27;
   */ _define_property(this, "recordStatusId", ""), /**
   * @generated from field: string contract_lifecycle_state_id = 28;
   */ _define_property(this, "contractLifecycleStateId", ""), /**
   * @generated from field: string delivery_model_type_id = 29;
   */ _define_property(this, "deliveryModelTypeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramRequest, "runtime", proto3);
_define_property(CreateProgramRequest, "typeName", "mono.ryugu.v1.CreateProgramRequest");
_define_property(CreateProgramRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_name_full",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_name_short",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "task_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "contract_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "pricing_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "company_role_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "customer_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "prime_contractor_company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "legal_entity_company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "operational_state_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "record_status_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "contract_lifecycle_state_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "delivery_model_type_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateProgramResponse
 */ export class CreateProgramResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.Program program = 1;
   */ _define_property(this, "program", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramResponse, "runtime", proto3);
_define_property(CreateProgramResponse, "typeName", "mono.ryugu.v1.CreateProgramResponse");
_define_property(CreateProgramResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program",
            kind: "message",
            T: Program
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetProgramRequest
 */ export class GetProgramRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramRequest, "runtime", proto3);
_define_property(GetProgramRequest, "typeName", "mono.ryugu.v1.GetProgramRequest");
_define_property(GetProgramRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetProgramResponse
 */ export class GetProgramResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.Program program = 1;
   */ _define_property(this, "program", void 0), /**
   * Whether the calling principal may edit this program — resolved
   * server-side (action "update" against the program's scope node) so the UI
   * never re-implements policy. True when viewmode enforcement is off (legacy
   * behavior) or for trusted principal-less internal callers.
   *
   * @generated from field: bool can_edit = 2;
   */ _define_property(this, "canEdit", false), /**
   * Whether the caller holds manage_quality transition authority on this program
   * — the authority CompleteAudit/VerifyCorrectiveAction require. Lets the UI
   * avoid offering an audit flow (e.g. the Start Audit reminder) the caller
   * couldn't finish. Same off/principal-less trust semantics as can_edit.
   *
   * @generated from field: bool can_manage_quality = 3;
   */ _define_property(this, "canManageQuality", false), /**
   * Whether the caller holds manage_contacts transition authority on this
   * program — the authority DeleteProgramContact requires. Lets the UI disable
   * the program-contact Delete affordance for a non-PM. Same off/principal-less
   * trust semantics as can_edit / can_manage_quality.
   *
   * @generated from field: bool can_manage_contacts = 4;
   */ _define_property(this, "canManageContacts", false), /**
   * Whether the caller holds manage_self_assessment transition authority on
   * this program — the authority the program self-assessment (Audits) lifecycle
   * requires (Start/Complete/Upsert*, corrective-action verify/withdraw). Lets
   * the UI render an honest view-only state for a caller (e.g. Quality) who may
   * view the self-assessment but not mutate it. Same off/principal-less trust
   * semantics as can_edit / can_manage_quality.
   *
   * @generated from field: bool can_manage_self_assessment = 5;
   */ _define_property(this, "canManageSelfAssessment", false), /**
   * Whether the caller holds FULL self-assessment read authority on this
   * program (SAD-143: manage_self_assessment OR area:quality — the same two
   * verbs can_manage_self_assessment/quality already resolve, composed rather
   * than a new domain verb). Lets the UI render an honest "no access" state
   * on the Audits tab / audit checklist panel for a caller outside that read
   * set (e.g. a Correction assignee, who resolves their own correction from
   * the Dashboard's "Assigned to you" card instead) rather than a panel that
   * errors against a server that now refuses GetAudit/ListAuditQuestions for
   * them. Same off/principal-less trust semantics as can_edit.
   *
   * @generated from field: bool can_view_self_assessment = 6;
   */ _define_property(this, "canViewSelfAssessment", false), /**
   * Whether the caller holds manage_members authority on this program — the
   * program lead (full) or delivery VP (narrow, to the lead seat) authority
   * member_authority.go's requireManageMembersAuthority resolves. Lets the UI
   * show the Roles tab's Access/How columns and Remove affordance only to
   * the two personas who may act on them (SAD-99) — write access on the
   * program's own area is not sufficient. Same off/principal-less trust
   * semantics as can_edit / can_manage_quality.
   *
   * @generated from field: bool can_manage_members = 7;
   */ _define_property(this, "canManageMembers", false), /**
   * Whether the caller holds `close` or `manage_quality` transition authority
   * on this program — either is what DeleteCPARSScore/DeleteQASPScore require
   * (SAD-171/SAD-174, Matt's "for the program manager and quality" delete
   * request). Lets the UI hide the score-delete affordance for a caller who is
   * not the Program Manager or Quality Assurance tier. Same off/principal-less
   * trust semantics as can_edit.
   *
   * @generated from field: bool can_delete_quality_score = 8;
   */ _define_property(this, "canDeleteQualityScore", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramResponse, "runtime", proto3);
_define_property(GetProgramResponse, "typeName", "mono.ryugu.v1.GetProgramResponse");
_define_property(GetProgramResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program",
            kind: "message",
            T: Program
        },
        {
            no: 2,
            name: "can_edit",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "can_manage_quality",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "can_manage_contacts",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "can_manage_self_assessment",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "can_view_self_assessment",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "can_manage_members",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "can_delete_quality_score",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateProgramRequest
 */ export class UpdateProgramRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * full replacement of mutable fields
   *
   * @generated from field: mono.ryugu.v1.Program program = 2;
   */ _define_property(this, "program", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramRequest, "runtime", proto3);
_define_property(UpdateProgramRequest, "typeName", "mono.ryugu.v1.UpdateProgramRequest");
_define_property(UpdateProgramRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program",
            kind: "message",
            T: Program
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateProgramResponse
 */ export class UpdateProgramResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.Program program = 1;
   */ _define_property(this, "program", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramResponse, "runtime", proto3);
_define_property(UpdateProgramResponse, "typeName", "mono.ryugu.v1.UpdateProgramResponse");
_define_property(UpdateProgramResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program",
            kind: "message",
            T: Program
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramsRequest
 */ export class ListProgramsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * optional filters
   *
   * @generated from field: string sector_id = 2;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string business_unit_id = 3;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string portfolio_id = 4;
   */ _define_property(this, "portfolioId", ""), /**
   * @generated from field: mono.ryugu.v1.PaginationRequest pagination = 6;
   */ _define_property(this, "pagination", void 0), /**
   * filter by vehicle
   *
   * @generated from field: string contract_vehicle_id = 7;
   */ _define_property(this, "contractVehicleId", ""), /**
   * filter by parent IDIQ
   *
   * @generated from field: string idiq_program_id = 8;
   */ _define_property(this, "idiqProgramId", ""), /**
   * search by name or contract number
   *
   * @generated from field: string search = 9;
   */ _define_property(this, "search", ""), /**
   * @generated from field: string operational_state_id = 10;
   */ _define_property(this, "operationalStateId", ""), /**
   * the backing zou project (reverse lookup)
   *
   * @generated from field: string zou_project_id = 11;
   */ _define_property(this, "zouProjectId", ""), /**
   * Exact contract-identity filters (the program dedup key). Used by the
   * extraction pipeline to resolve a project's program when the project
   * converged onto a program bound to a different zou project.
   *
   * @generated from field: string contract_number = 12;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string task_number = 13;
   */ _define_property(this, "taskNumber", ""), /**
   * Closed programs (non-null closed_at) are excluded by default; set true
   * to include them (mirrors datagateway ProgramFilter.include_closed).
   *
   * @generated from field: bool include_closed = 14;
   */ _define_property(this, "includeClosed", false), /**
   * Archived programs are excluded by default. Tenant admins only
   * (delivery_program_purge `list_archived`) — it is how an admin finds a
   * program to purge, so it lists EVERY program in the tenant (no per-program
   * projection) carrying identity fields only: id, names, contract number,
   * archived. Never a read of program data.
   *
   * @generated from field: bool include_archived = 15;
   */ _define_property(this, "includeArchived", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramsRequest, "runtime", proto3);
_define_property(ListProgramsRequest, "typeName", "mono.ryugu.v1.ListProgramsRequest");
_define_property(ListProgramsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "pagination",
            kind: "message",
            T: PaginationRequest
        },
        {
            no: 7,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "idiq_program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "operational_state_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "task_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "include_closed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 15,
            name: "include_archived",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramsResponse
 */ export class ListProgramsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.Program programs = 1;
   */ _define_property(this, "programs", []), /**
   * @generated from field: mono.ryugu.v1.PaginationResponse pagination = 2;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramsResponse, "runtime", proto3);
_define_property(ListProgramsResponse, "typeName", "mono.ryugu.v1.ListProgramsResponse");
_define_property(ListProgramsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "programs",
            kind: "message",
            T: Program,
            repeated: true
        },
        {
            no: 2,
            name: "pagination",
            kind: "message",
            T: PaginationResponse
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ResolveContractProgramRequest
 */ export class ResolveContractProgramRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveContractProgramRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveContractProgramRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveContractProgramRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveContractProgramRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contract_number = 1;
   */ _define_property(this, "contractNumber", ""), /**
   * optional; empty for base contracts
   *
   * @generated from field: string task_number = 2;
   */ _define_property(this, "taskNumber", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveContractProgramRequest, "runtime", proto3);
_define_property(ResolveContractProgramRequest, "typeName", "mono.ryugu.v1.ResolveContractProgramRequest");
_define_property(ResolveContractProgramRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "task_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ResolveContractProgramResponse
 */ export class ResolveContractProgramResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveContractProgramResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveContractProgramResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveContractProgramResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveContractProgramResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ResolveContractProgramResponse.Access access = 1;
   */ _define_property(this, "access", 0), /**
   * set when ACCESS_VIEWABLE or ACCESS_NO_ACCESS
   *
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveContractProgramResponse, "runtime", proto3);
_define_property(ResolveContractProgramResponse, "typeName", "mono.ryugu.v1.ResolveContractProgramResponse");
_define_property(ResolveContractProgramResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "access",
            kind: "enum",
            T: proto3.getEnumType(ResolveContractProgramResponse_Access)
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from enum mono.ryugu.v1.ResolveContractProgramResponse.Access
 */ export var ResolveContractProgramResponse_Access = /*#__PURE__*/ function(ResolveContractProgramResponse_Access) {
    /**
   * @generated from enum value: ACCESS_UNSPECIFIED = 0;
   */ ResolveContractProgramResponse_Access[ResolveContractProgramResponse_Access["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: ACCESS_NOT_FOUND = 1;
   */ ResolveContractProgramResponse_Access[ResolveContractProgramResponse_Access["NOT_FOUND"] = 1] = "NOT_FOUND";
    /**
   * @generated from enum value: ACCESS_VIEWABLE = 2;
   */ ResolveContractProgramResponse_Access[ResolveContractProgramResponse_Access["VIEWABLE"] = 2] = "VIEWABLE";
    /**
   * @generated from enum value: ACCESS_NO_ACCESS = 3;
   */ ResolveContractProgramResponse_Access[ResolveContractProgramResponse_Access["NO_ACCESS"] = 3] = "NO_ACCESS";
    return ResolveContractProgramResponse_Access;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ResolveContractProgramResponse_Access)
proto3.util.setEnumType(ResolveContractProgramResponse_Access, "mono.ryugu.v1.ResolveContractProgramResponse.Access", [
    {
        no: 0,
        name: "ACCESS_UNSPECIFIED"
    },
    {
        no: 1,
        name: "ACCESS_NOT_FOUND"
    },
    {
        no: 2,
        name: "ACCESS_VIEWABLE"
    },
    {
        no: 3,
        name: "ACCESS_NO_ACCESS"
    }
]);
/**
 * @generated from message mono.ryugu.v1.DeleteProgramRequest
 */ export class DeleteProgramRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramRequest, "runtime", proto3);
_define_property(DeleteProgramRequest, "typeName", "mono.ryugu.v1.DeleteProgramRequest");
_define_property(DeleteProgramRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteProgramResponse
 */ export class DeleteProgramResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramResponse, "runtime", proto3);
_define_property(DeleteProgramResponse, "typeName", "mono.ryugu.v1.DeleteProgramResponse");
_define_property(DeleteProgramResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.PurgeProgramRequest
 */ export class PurgeProgramRequest extends Message {
    static fromBinary(bytes, options) {
        return new PurgeProgramRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PurgeProgramRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PurgeProgramRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PurgeProgramRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool dry_run = 2;
   */ _define_property(this, "dryRun", false), /**
   * @generated from field: string confirm_name = 3;
   */ _define_property(this, "confirmName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PurgeProgramRequest, "runtime", proto3);
_define_property(PurgeProgramRequest, "typeName", "mono.ryugu.v1.PurgeProgramRequest");
_define_property(PurgeProgramRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "dry_run",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "confirm_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.PurgeTableCount
 */ export class PurgeTableCount extends Message {
    static fromBinary(bytes, options) {
        return new PurgeTableCount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PurgeTableCount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PurgeTableCount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PurgeTableCount, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string table = 1;
   */ _define_property(this, "table", ""), /**
   * @generated from field: int64 rows_deleted = 2;
   */ _define_property(this, "rowsDeleted", protoInt64.zero), /**
   * @generated from field: int64 rows_updated = 3;
   */ _define_property(this, "rowsUpdated", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PurgeTableCount, "runtime", proto3);
_define_property(PurgeTableCount, "typeName", "mono.ryugu.v1.PurgeTableCount");
_define_property(PurgeTableCount, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "table",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rows_deleted",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "rows_updated",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.PurgeProgramResponse
 */ export class PurgeProgramResponse extends Message {
    static fromBinary(bytes, options) {
        return new PurgeProgramResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PurgeProgramResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PurgeProgramResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PurgeProgramResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string program_name = 2;
   */ _define_property(this, "programName", ""), /**
   * @generated from field: bool dry_run = 3;
   */ _define_property(this, "dryRun", false), /**
   * @generated from field: repeated mono.ryugu.v1.PurgeTableCount tables = 4;
   */ _define_property(this, "tables", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PurgeProgramResponse, "runtime", proto3);
_define_property(PurgeProgramResponse, "typeName", "mono.ryugu.v1.PurgeProgramResponse");
_define_property(PurgeProgramResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "dry_run",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "tables",
            kind: "message",
            T: PurgeTableCount,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProgramRole
 */ export class ProgramRole extends Message {
    static fromBinary(bytes, options) {
        return new ProgramRole().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramRole().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramRole().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramRole, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * Program Manager, Portfolio, Business Unit, Assistant, Controller, etc.
   *
   * @generated from field: string role = 3;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string email = 5;
   */ _define_property(this, "email", ""), /**
   * @generated from field: bool is_primary = 6;
   */ _define_property(this, "isPrimary", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramRole, "runtime", proto3);
_define_property(ProgramRole, "typeName", "mono.ryugu.v1.ProgramRole");
_define_property(ProgramRole, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "is_primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramRolesRequest
 */ export class ListProgramRolesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramRolesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramRolesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramRolesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramRolesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramRolesRequest, "runtime", proto3);
_define_property(ListProgramRolesRequest, "typeName", "mono.ryugu.v1.ListProgramRolesRequest");
_define_property(ListProgramRolesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramRolesResponse
 */ export class ListProgramRolesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramRolesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramRolesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramRolesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramRolesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ProgramRole roles = 1;
   */ _define_property(this, "roles", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramRolesResponse, "runtime", proto3);
_define_property(ListProgramRolesResponse, "typeName", "mono.ryugu.v1.ListProgramRolesResponse");
_define_property(ListProgramRolesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "roles",
            kind: "message",
            T: ProgramRole,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertProgramRoleRequest
 */ export class UpsertProgramRoleRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramRoleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramRoleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramRoleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramRoleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string role = 3;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string email = 5;
   */ _define_property(this, "email", ""), /**
   * @generated from field: bool is_primary = 6;
   */ _define_property(this, "isPrimary", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramRoleRequest, "runtime", proto3);
_define_property(UpsertProgramRoleRequest, "typeName", "mono.ryugu.v1.UpsertProgramRoleRequest");
_define_property(UpsertProgramRoleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "is_primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertProgramRoleResponse
 */ export class UpsertProgramRoleResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramRoleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramRoleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramRoleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramRoleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ProgramRole role = 1;
   */ _define_property(this, "role", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramRoleResponse, "runtime", proto3);
_define_property(UpsertProgramRoleResponse, "typeName", "mono.ryugu.v1.UpsertProgramRoleResponse");
_define_property(UpsertProgramRoleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "role",
            kind: "message",
            T: ProgramRole
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteProgramRoleRequest
 */ export class DeleteProgramRoleRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramRoleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramRoleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramRoleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramRoleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramRoleRequest, "runtime", proto3);
_define_property(DeleteProgramRoleRequest, "typeName", "mono.ryugu.v1.DeleteProgramRoleRequest");
_define_property(DeleteProgramRoleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteProgramRoleResponse
 */ export class DeleteProgramRoleResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramRoleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramRoleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramRoleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramRoleResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramRoleResponse, "runtime", proto3);
_define_property(DeleteProgramRoleResponse, "typeName", "mono.ryugu.v1.DeleteProgramRoleResponse");
_define_property(DeleteProgramRoleResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.TenantEnumValueProto
 */ export class TenantEnumValueProto extends Message {
    static fromBinary(bytes, options) {
        return new TenantEnumValueProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TenantEnumValueProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TenantEnumValueProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TenantEnumValueProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string domain = 3;
   */ _define_property(this, "domain", ""), /**
   * @generated from field: string code = 4;
   */ _define_property(this, "code", ""), /**
   * @generated from field: string display_label = 5;
   */ _define_property(this, "displayLabel", ""), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", ""), /**
   * @generated from field: int32 sort_order = 7;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: bool is_system = 8;
   */ _define_property(this, "isSystem", false), /**
   * @generated from field: bool is_leadership = 9;
   */ _define_property(this, "isLeadership", false), /**
   * Names a row in authz.role_bundle — the permission template this role name
   * resolves to. Empty means "no bundle linked": the name is purely
   * informational and grants nothing. Only meaningful when domain='role_type'
   * (a DB CHECK in pangaea rejects it elsewhere).
   *
   * @generated from field: string role_bundle_key = 10;
   */ _define_property(this, "roleBundleKey", ""), /**
   * Business unit this role name is offered in. Empty means "available in
   * EVERY business unit", not "unassigned" — most role names are company-wide.
   * Only meaningful when domain='role_type'.
   *
   * @generated from field: string business_unit_id = 11;
   */ _define_property(this, "businessUnitId", ""), /**
   * JSON-encoded metadata. role_type rows carry the roster->grant mapping:
   * {"bundle_key": "...", "self_service": bool} — the Roles tab renders the
   * access consequence from it.
   *
   * @generated from field: string metadata_json = 12;
   */ _define_property(this, "metadataJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TenantEnumValueProto, "runtime", proto3);
_define_property(TenantEnumValueProto, "typeName", "mono.ryugu.v1.TenantEnumValueProto");
_define_property(TenantEnumValueProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "domain",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "display_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "is_system",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "is_leadership",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "role_bundle_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "metadata_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListTenantEnumValuesRequest
 */ export class ListTenantEnumValuesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListTenantEnumValuesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTenantEnumValuesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTenantEnumValuesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTenantEnumValuesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string domain = 2;
   */ _define_property(this, "domain", ""), /**
   * @generated from field: bool include_system = 3;
   */ _define_property(this, "includeSystem", false), /**
   * When set, returns rows whose business_unit_id is empty **OR** equals this
   * id — the globally-available role names PLUS this BU's own. This is NOT an
   * equality filter: matching on equality alone would hide every global role
   * name (PM, PfD, …) and leave a BU showing only its handful of local ones.
   * Empty means no BU filtering at all (every row, global and scoped).
   *
   * @generated from field: string business_unit_id = 4;
   */ _define_property(this, "businessUnitId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTenantEnumValuesRequest, "runtime", proto3);
_define_property(ListTenantEnumValuesRequest, "typeName", "mono.ryugu.v1.ListTenantEnumValuesRequest");
_define_property(ListTenantEnumValuesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "domain",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "include_system",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListTenantEnumValuesResponse
 */ export class ListTenantEnumValuesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListTenantEnumValuesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTenantEnumValuesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTenantEnumValuesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTenantEnumValuesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.TenantEnumValueProto values = 1;
   */ _define_property(this, "values", []), /**
   * @generated from field: map<string, int32> usage_program_count_by_id = 2;
   */ _define_property(this, "usageProgramCountById", {}), /**
   * @generated from field: map<string, int32> usage_contract_count_by_id = 3;
   */ _define_property(this, "usageContractCountById", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTenantEnumValuesResponse, "runtime", proto3);
_define_property(ListTenantEnumValuesResponse, "typeName", "mono.ryugu.v1.ListTenantEnumValuesResponse");
_define_property(ListTenantEnumValuesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "values",
            kind: "message",
            T: TenantEnumValueProto,
            repeated: true
        },
        {
            no: 2,
            name: "usage_program_count_by_id",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        },
        {
            no: 3,
            name: "usage_contract_count_by_id",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        }
    ]));
/**
 * General-purpose across every enum domain — role_bundle_key/business_unit_id
 * are only accepted for domain='role_type', which pangaea's DB CHECK enforces
 * rather than this schema.
 *
 * @generated from message mono.ryugu.v1.UpsertTenantEnumValueRequest
 */ export class UpsertTenantEnumValueRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertTenantEnumValueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertTenantEnumValueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertTenantEnumValueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertTenantEnumValueRequest, a, b);
    }
    constructor(data){
        super(), /**
   * empty = create, present = update
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string domain = 3;
   */ _define_property(this, "domain", ""), /**
   * @generated from field: string code = 4;
   */ _define_property(this, "code", ""), /**
   * @generated from field: string display_label = 5;
   */ _define_property(this, "displayLabel", ""), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", ""), /**
   * @generated from field: int32 sort_order = 7;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: bool is_leadership = 8;
   */ _define_property(this, "isLeadership", false), /**
   * Empty means "no bundle linked" — an informational name that grants nothing.
   *
   * @generated from field: string role_bundle_key = 9;
   */ _define_property(this, "roleBundleKey", ""), /**
   * Empty means "offered in EVERY business unit", not "unassigned".
   *
   * @generated from field: string business_unit_id = 10;
   */ _define_property(this, "businessUnitId", ""), /**
   * Roster self-service eligibility (behind the tenant flag + guards) —
   * stored in the row's metadata; carried here so the general-purpose
   * upsert doesn't strand it (reconciliation).
   *
   * @generated from field: bool self_service = 11;
   */ _define_property(this, "selfService", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertTenantEnumValueRequest, "runtime", proto3);
_define_property(UpsertTenantEnumValueRequest, "typeName", "mono.ryugu.v1.UpsertTenantEnumValueRequest");
_define_property(UpsertTenantEnumValueRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "domain",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "display_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "is_leadership",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "role_bundle_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "self_service",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertTenantEnumValueResponse
 */ export class UpsertTenantEnumValueResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertTenantEnumValueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertTenantEnumValueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertTenantEnumValueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertTenantEnumValueResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.TenantEnumValueProto value = 1;
   */ _define_property(this, "value", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertTenantEnumValueResponse, "runtime", proto3);
_define_property(UpsertTenantEnumValueResponse, "typeName", "mono.ryugu.v1.UpsertTenantEnumValueResponse");
_define_property(UpsertTenantEnumValueResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "value",
            kind: "message",
            T: TenantEnumValueProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteRoleTypeRequest
 */ export class DeleteRoleTypeRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteRoleTypeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteRoleTypeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteRoleTypeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteRoleTypeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteRoleTypeRequest, "runtime", proto3);
_define_property(DeleteRoleTypeRequest, "typeName", "mono.ryugu.v1.DeleteRoleTypeRequest");
_define_property(DeleteRoleTypeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteRoleTypeResponse
 */ export class DeleteRoleTypeResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteRoleTypeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteRoleTypeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteRoleTypeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteRoleTypeResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteRoleTypeResponse, "runtime", proto3);
_define_property(DeleteRoleTypeResponse, "typeName", "mono.ryugu.v1.DeleteRoleTypeResponse");
_define_property(DeleteRoleTypeResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.GovernmentOrganizationProto
 */ export class GovernmentOrganizationProto extends Message {
    static fromBinary(bytes, options) {
        return new GovernmentOrganizationProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovernmentOrganizationProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovernmentOrganizationProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovernmentOrganizationProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string acronym = 4;
   */ _define_property(this, "acronym", ""), /**
   * @generated from field: string org_type = 5;
   */ _define_property(this, "orgType", ""), /**
   * @generated from field: string parent_id = 6;
   */ _define_property(this, "parentId", ""), /**
   * @generated from field: int32 level = 7;
   */ _define_property(this, "level", 0), /**
   * @generated from field: string materialized_path = 8;
   */ _define_property(this, "materializedPath", ""), /**
   * @generated from field: string website = 9;
   */ _define_property(this, "website", ""), /**
   * @generated from field: string notes = 10;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string display_path = 13;
   */ _define_property(this, "displayPath", ""), /**
   * SAM AAC; trimmed+uppercased, empty = none; unique per tenant
   *
   * @generated from field: string office_code = 14;
   */ _define_property(this, "officeCode", ""), /**
   * @generated from field: string location_text = 15;
   */ _define_property(this, "locationText", ""), /**
   * TENANT|USASPENDING|CURATED|SAM_FEDERAL_HIERARCHY (empty = TENANT)
   *
   * @generated from field: string reference_source = 16;
   */ _define_property(this, "referenceSource", ""), /**
   * @generated from field: string reference_source_id = 17;
   */ _define_property(this, "referenceSourceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovernmentOrganizationProto, "runtime", proto3);
_define_property(GovernmentOrganizationProto, "typeName", "mono.ryugu.v1.GovernmentOrganizationProto");
_define_property(GovernmentOrganizationProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "org_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "level",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "materialized_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "website",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "display_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "office_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "location_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "reference_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "reference_source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListGovernmentOrganizationsRequest
 */ export class ListGovernmentOrganizationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListGovernmentOrganizationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGovernmentOrganizationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGovernmentOrganizationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGovernmentOrganizationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string parent_id = 2;
   */ _define_property(this, "parentId", ""), /**
   * @generated from field: string org_type = 3;
   */ _define_property(this, "orgType", ""), /**
   * @generated from field: string name_prefix = 4;
   */ _define_property(this, "namePrefix", ""), /**
   * @generated from field: bool include_system = 5;
   */ _define_property(this, "includeSystem", false), /**
   * @generated from field: bool include_usaspending_offices = 6;
   */ _define_property(this, "includeUsaspendingOffices", false), /**
   * @generated from field: string search = 7;
   */ _define_property(this, "search", ""), /**
   * @generated from field: bool roots_only = 8;
   */ _define_property(this, "rootsOnly", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGovernmentOrganizationsRequest, "runtime", proto3);
_define_property(ListGovernmentOrganizationsRequest, "typeName", "mono.ryugu.v1.ListGovernmentOrganizationsRequest");
_define_property(ListGovernmentOrganizationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "org_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name_prefix",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "include_system",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "include_usaspending_offices",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "roots_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListGovernmentOrganizationsResponse
 */ export class ListGovernmentOrganizationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListGovernmentOrganizationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGovernmentOrganizationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGovernmentOrganizationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGovernmentOrganizationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.GovernmentOrganizationProto organizations = 1;
   */ _define_property(this, "organizations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGovernmentOrganizationsResponse, "runtime", proto3);
_define_property(ListGovernmentOrganizationsResponse, "typeName", "mono.ryugu.v1.ListGovernmentOrganizationsResponse");
_define_property(ListGovernmentOrganizationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "organizations",
            kind: "message",
            T: GovernmentOrganizationProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertGovernmentOrganizationRequest
 */ export class UpsertGovernmentOrganizationRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertGovernmentOrganizationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertGovernmentOrganizationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertGovernmentOrganizationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertGovernmentOrganizationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string acronym = 4;
   */ _define_property(this, "acronym", ""), /**
   * @generated from field: string org_type = 5;
   */ _define_property(this, "orgType", ""), /**
   * @generated from field: string parent_id = 6;
   */ _define_property(this, "parentId", ""), /**
   * @generated from field: int32 level = 7;
   */ _define_property(this, "level", 0), /**
   * @generated from field: string website = 8;
   */ _define_property(this, "website", ""), /**
   * @generated from field: string notes = 9;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: optional string office_code = 10;
   */ _define_property(this, "officeCode", void 0), /**
   * @generated from field: optional string location_text = 11;
   */ _define_property(this, "locationText", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertGovernmentOrganizationRequest, "runtime", proto3);
_define_property(UpsertGovernmentOrganizationRequest, "typeName", "mono.ryugu.v1.UpsertGovernmentOrganizationRequest");
_define_property(UpsertGovernmentOrganizationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "org_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "level",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "website",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "office_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 11,
            name: "location_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertGovernmentOrganizationResponse
 */ export class UpsertGovernmentOrganizationResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertGovernmentOrganizationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertGovernmentOrganizationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertGovernmentOrganizationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertGovernmentOrganizationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.GovernmentOrganizationProto organization = 1;
   */ _define_property(this, "organization", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertGovernmentOrganizationResponse, "runtime", proto3);
_define_property(UpsertGovernmentOrganizationResponse, "typeName", "mono.ryugu.v1.UpsertGovernmentOrganizationResponse");
_define_property(UpsertGovernmentOrganizationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "organization",
            kind: "message",
            T: GovernmentOrganizationProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteGovernmentOrganizationRequest
 */ export class DeleteGovernmentOrganizationRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteGovernmentOrganizationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteGovernmentOrganizationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteGovernmentOrganizationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteGovernmentOrganizationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteGovernmentOrganizationRequest, "runtime", proto3);
_define_property(DeleteGovernmentOrganizationRequest, "typeName", "mono.ryugu.v1.DeleteGovernmentOrganizationRequest");
_define_property(DeleteGovernmentOrganizationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteGovernmentOrganizationResponse
 */ export class DeleteGovernmentOrganizationResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteGovernmentOrganizationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteGovernmentOrganizationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteGovernmentOrganizationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteGovernmentOrganizationResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteGovernmentOrganizationResponse, "runtime", proto3);
_define_property(DeleteGovernmentOrganizationResponse, "typeName", "mono.ryugu.v1.DeleteGovernmentOrganizationResponse");
_define_property(DeleteGovernmentOrganizationResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.ProgramRoleAssignmentProto
 */ export class ProgramRoleAssignmentProto extends Message {
    static fromBinary(bytes, options) {
        return new ProgramRoleAssignmentProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramRoleAssignmentProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramRoleAssignmentProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramRoleAssignmentProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string contact_id = 4;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string role_category = 5;
   */ _define_property(this, "roleCategory", ""), /**
   * @generated from field: string role_type_id = 6;
   */ _define_property(this, "roleTypeId", ""), /**
   * @generated from field: string role_type_code = 7;
   */ _define_property(this, "roleTypeCode", ""), /**
   * @generated from field: string organization_id = 8;
   */ _define_property(this, "organizationId", ""), /**
   * @generated from field: bool is_primary = 9;
   */ _define_property(this, "isPrimary", false), /**
   * @generated from field: google.protobuf.Timestamp assigned_at = 10;
   */ _define_property(this, "assignedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp removed_at = 11;
   */ _define_property(this, "removedAt", void 0), /**
   * @generated from field: string notes = 12;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string contact_display_name = 13;
   */ _define_property(this, "contactDisplayName", ""), /**
   * @generated from field: string contact_email = 14;
   */ _define_property(this, "contactEmail", ""), /**
   * @generated from field: string role_type_label = 15;
   */ _define_property(this, "roleTypeLabel", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramRoleAssignmentProto, "runtime", proto3);
_define_property(ProgramRoleAssignmentProto, "typeName", "mono.ryugu.v1.ProgramRoleAssignmentProto");
_define_property(ProgramRoleAssignmentProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "role_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "role_type_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "role_type_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "is_primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "assigned_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "removed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "contact_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "contact_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "role_type_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramRoleAssignmentsRequest
 */ export class ListProgramRoleAssignmentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramRoleAssignmentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramRoleAssignmentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramRoleAssignmentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramRoleAssignmentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string role_category = 2;
   */ _define_property(this, "roleCategory", ""), /**
   * @generated from field: bool active_only = 3;
   */ _define_property(this, "activeOnly", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramRoleAssignmentsRequest, "runtime", proto3);
_define_property(ListProgramRoleAssignmentsRequest, "typeName", "mono.ryugu.v1.ListProgramRoleAssignmentsRequest");
_define_property(ListProgramRoleAssignmentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "role_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "active_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramRoleAssignmentsResponse
 */ export class ListProgramRoleAssignmentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramRoleAssignmentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramRoleAssignmentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramRoleAssignmentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramRoleAssignmentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ProgramRoleAssignmentProto assignments = 1;
   */ _define_property(this, "assignments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramRoleAssignmentsResponse, "runtime", proto3);
_define_property(ListProgramRoleAssignmentsResponse, "typeName", "mono.ryugu.v1.ListProgramRoleAssignmentsResponse");
_define_property(ListProgramRoleAssignmentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assignments",
            kind: "message",
            T: ProgramRoleAssignmentProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertProgramRoleAssignmentRequest
 */ export class UpsertProgramRoleAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramRoleAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramRoleAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramRoleAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramRoleAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string contact_id = 3;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string role_category = 4;
   */ _define_property(this, "roleCategory", ""), /**
   * @generated from field: string role_type_id = 5;
   */ _define_property(this, "roleTypeId", ""), /**
   * @generated from field: string organization_id = 6;
   */ _define_property(this, "organizationId", ""), /**
   * @generated from field: bool is_primary = 7;
   */ _define_property(this, "isPrimary", false), /**
   * @generated from field: google.protobuf.Timestamp removed_at = 8;
   */ _define_property(this, "removedAt", void 0), /**
   * @generated from field: string notes = 9;
   */ _define_property(this, "notes", ""), /**
   * SAD-832: an alternative to contact_id on CREATE, for a picker that now
   * offers a tenant's platform users directly instead of only existing
   * registry contacts. Ignored if contact_id is also set, and ignored
   * entirely on update (the contact a seat names never changes after
   * create). ryugu resolves it server-side to a contact id, in order: one
   * already linked to this user; else one sharing the user's email, linked
   * in place; else a freshly created INTERNAL contact named from the user
   * record. See UpsertProgramRoleAssignment/resolveContactForUser.
   *
   * @generated from field: string user_id = 10;
   */ _define_property(this, "userId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramRoleAssignmentRequest, "runtime", proto3);
_define_property(UpsertProgramRoleAssignmentRequest, "typeName", "mono.ryugu.v1.UpsertProgramRoleAssignmentRequest");
_define_property(UpsertProgramRoleAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "role_type_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "is_primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "removed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertProgramRoleAssignmentResponse
 */ export class UpsertProgramRoleAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramRoleAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramRoleAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramRoleAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramRoleAssignmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ProgramRoleAssignmentProto assignment = 1;
   */ _define_property(this, "assignment", void 0), /**
   * Roster→grant outcome for this assignment (permissioning push §4.2):
   * active | no_account | roster_only | requires_admin | grant_pending.
   * Empty on updates that didn't touch access.
   *
   * @generated from field: string access_state = 2;
   */ _define_property(this, "accessState", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramRoleAssignmentResponse, "runtime", proto3);
_define_property(UpsertProgramRoleAssignmentResponse, "typeName", "mono.ryugu.v1.UpsertProgramRoleAssignmentResponse");
_define_property(UpsertProgramRoleAssignmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assignment",
            kind: "message",
            T: ProgramRoleAssignmentProto
        },
        {
            no: 2,
            name: "access_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteProgramRoleAssignmentRequest
 */ export class DeleteProgramRoleAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramRoleAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramRoleAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramRoleAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramRoleAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramRoleAssignmentRequest, "runtime", proto3);
_define_property(DeleteProgramRoleAssignmentRequest, "typeName", "mono.ryugu.v1.DeleteProgramRoleAssignmentRequest");
_define_property(DeleteProgramRoleAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteProgramRoleAssignmentResponse
 */ export class DeleteProgramRoleAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramRoleAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramRoleAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramRoleAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramRoleAssignmentResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramRoleAssignmentResponse, "runtime", proto3);
_define_property(DeleteProgramRoleAssignmentResponse, "typeName", "mono.ryugu.v1.DeleteProgramRoleAssignmentResponse");
_define_property(DeleteProgramRoleAssignmentResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.ListProgramGrantsRequest
 */ export class ListProgramGrantsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramGrantsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramGrantsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramGrantsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramGrantsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramGrantsRequest, "runtime", proto3);
_define_property(ListProgramGrantsRequest, "typeName", "mono.ryugu.v1.ListProgramGrantsRequest");
_define_property(ListProgramGrantsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ProgramGrant is a live authz.role_assignment reaching this program, with
 * display data pre-resolved server-side (role bundle name/view mode, scope
 * node name) so the caller never needs enies-lobby's admin-only bundle/tree
 * RPCs just to render the Access column.
 *
 * @generated from message mono.ryugu.v1.ProgramGrant
 */ export class ProgramGrant extends Message {
    static fromBinary(bytes, options) {
        return new ProgramGrant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramGrant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramGrant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramGrant, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string group_id = 3;
   */ _define_property(this, "groupId", ""), /**
   * @generated from field: string role_bundle_key = 4;
   */ _define_property(this, "roleBundleKey", ""), /**
   * @generated from field: string role_bundle_display_name = 5;
   */ _define_property(this, "roleBundleDisplayName", ""), /**
   * full | simplified | masked | no_view | action_blocked
   *
   * @generated from field: string default_view_mode = 6;
   */ _define_property(this, "defaultViewMode", ""), /**
   * Node the grant actually sits on — this program's own node, or an
   * ancestor (business unit, portfolio, tenant root).
   *
   * @generated from field: string scope_node_id = 7;
   */ _define_property(this, "scopeNodeId", ""), /**
   * @generated from field: string scope_node_name = 8;
   */ _define_property(this, "scopeNodeName", ""), /**
   * true when granted on an ancestor, not the program's own node
   *
   * @generated from field: bool inherited = 9;
   */ _define_property(this, "inherited", false), /**
   * primary | backup | designee | temporary | break_glass
   *
   * @generated from field: string assignment_type = 10;
   */ _define_property(this, "assignmentType", ""), /**
   * @generated from field: string reason = 11;
   */ _define_property(this, "reason", ""), /**
   * designees only
   *
   * @generated from field: string original_owner_user_id = 12;
   */ _define_property(this, "originalOwnerUserId", ""), /**
   * Resolved server-side (bounded, best-effort — see ryugu's
   * stampGrantDisplayNames) so a Program Lead/Delivery VP can read a name
   * without the admin-only identity resolver they're not authorized to call.
   * Empty when the lookup missed (unresolvable id, blown budget, no client
   * wired) — callers fall back to the raw id already on the grant.
   *
   * @generated from field: string user_display_name = 13;
   */ _define_property(this, "userDisplayName", ""), /**
   * @generated from field: string group_display_name = 14;
   */ _define_property(this, "groupDisplayName", ""), /**
   * designees only
   *
   * @generated from field: string original_owner_display_name = 15;
   */ _define_property(this, "originalOwnerDisplayName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramGrant, "runtime", proto3);
_define_property(ProgramGrant, "typeName", "mono.ryugu.v1.ProgramGrant");
_define_property(ProgramGrant, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "group_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role_bundle_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "role_bundle_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "default_view_mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "scope_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "scope_node_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "inherited",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "assignment_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "original_owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "user_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "group_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "original_owner_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramGrantsResponse
 */ export class ListProgramGrantsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramGrantsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramGrantsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramGrantsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramGrantsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ProgramGrant grants = 1;
   */ _define_property(this, "grants", []), /**
   * Grants held at the tenant root, summarized rather than itemized — dozens
   * of org-wide rows would bury the program's own story (mirrors
   * useProgramGrants' old client-side chain walk, now computed server-side).
   *
   * @generated from field: int32 org_wide_grant_count = 2;
   */ _define_property(this, "orgWideGrantCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramGrantsResponse, "runtime", proto3);
_define_property(ListProgramGrantsResponse, "typeName", "mono.ryugu.v1.ListProgramGrantsResponse");
_define_property(ListProgramGrantsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "grants",
            kind: "message",
            T: ProgramGrant,
            repeated: true
        },
        {
            no: 2,
            name: "org_wide_grant_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SyncFromExtractionRequest
 */ export class SyncFromExtractionRequest extends Message {
    static fromBinary(bytes, options) {
        return new SyncFromExtractionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncFromExtractionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncFromExtractionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncFromExtractionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string zou_project_id = 2;
   */ _define_property(this, "zouProjectId", ""), /**
   * Contract header extracted from documents
   *
   * @generated from field: string contract_number = 3;
   */ _define_property(this, "contractNumber", ""), /**
   * distinguishes task orders under same IDIQ contract
   *
   * @generated from field: string task_number = 15;
   */ _define_property(this, "taskNumber", ""), /**
   * @generated from field: string contract_title = 4;
   */ _define_property(this, "contractTitle", ""), /**
   * @generated from field: string contract_type = 5;
   */ _define_property(this, "contractType", ""), /**
   * @generated from field: string agency_name = 6;
   */ _define_property(this, "agencyName", ""), /**
   * @generated from field: string agency_acronym = 7;
   */ _define_property(this, "agencyAcronym", ""), /**
   * @generated from field: string contract_vehicle = 8;
   */ _define_property(this, "contractVehicle", ""), /**
   * @generated from field: string vehicle_type = 9;
   */ _define_property(this, "vehicleType", ""), /**
   * @generated from field: google.protobuf.Timestamp contract_start_date = 10;
   */ _define_property(this, "contractStartDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp contract_end_date = 11;
   */ _define_property(this, "contractEndDate", void 0), /**
   * Extracted parties
   *
   * @generated from field: repeated mono.ryugu.v1.ExtractedParty parties = 12;
   */ _define_property(this, "parties", []), /**
   * Extracted government contacts
   *
   * @generated from field: repeated mono.ryugu.v1.ExtractedContact contacts = 13;
   */ _define_property(this, "contacts", []), /**
   * Extracted periods
   *
   * @generated from field: repeated mono.ryugu.v1.ExtractedPeriod periods = 14;
   */ _define_property(this, "periods", []), /**
   * Extracted modifications (audit trail)
   *
   * @generated from field: repeated mono.ryugu.v1.ExtractedModification modifications = 16;
   */ _define_property(this, "modifications", []), /**
   * Extracted contract line items (CLINs and SLINs)
   *
   * @generated from field: repeated mono.ryugu.v1.ExtractedClin clins = 17;
   */ _define_property(this, "clins", []), /**
   * Extracted places of performance (work locations)
   *
   * @generated from field: repeated mono.ryugu.v1.ExtractedPlaceOfPerformance places_of_performance = 18;
   */ _define_property(this, "placesOfPerformance", []), /**
   * @generated from field: string solicitation_number = 19;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: string naics_code = 20;
   */ _define_property(this, "naicsCode", ""), /**
   * ISO 8601
   *
   * @generated from field: string award_date = 21;
   */ _define_property(this, "awardDate", ""), /**
   * ISO 8601
   *
   * @generated from field: string effective_date = 22;
   */ _define_property(this, "effectiveDate", ""), /**
   * Vehicle/IDIQ contract number (the parent of a task order); used to
   * find-or-create the linked contract_vehicles row.
   *
   * @generated from field: string vehicle_contract_number = 23;
   */ _define_property(this, "vehicleContractNumber", ""), /**
   * Uploading user, for viewmode seeding ONLY — never authorization. The
   * sync arrives principal-less through the trusted service lane (the
   * delivery_write gate's internal allowlist rejects end-user principals),
   * so the acting user rides the body to feed the scope-node seed that
   * makes the program visible to its uploader.
   *
   * @generated from field: string acting_user_id = 24;
   */ _define_property(this, "actingUserId", ""), /**
   * The document's own declared total ("The Total Task Order Value is $X") —
   * the evaluated award value, as distinct from the CLIN-table sum (which
   * prices optional-task CEILINGS and can legitimately exceed it). 0 when the
   * document states none; the import then falls back to the computed sum.
   *
   * @generated from field: double stated_total_value = 25;
   */ _define_property(this, "statedTotalValue", 0), /**
   * Facts code could not settle (D93), forwarded to pangaea unchanged.
   *
   * @generated from field: repeated mono.common.v1.ReviewItem review_items = 26;
   */ _define_property(this, "reviewItems", []), /**
   * S7a priced-line duties (SAD-752 S7c-lite), written by pangaea
   * ImportAwardDuties during SyncProgramFromExtraction.
   *
   * @generated from field: repeated mono.common.v1.AwardPricedDuty award_duties = 27;
   */ _define_property(this, "awardDuties", []), /**
   * Upload identity for import-event dedupe (SAD-788): one upload's two
   * syncs (per-doc then cross-doc) share these; a later upload into the same
   * project must not. source_document_id is the baltigo/attachment document;
   * import_job_id is the reverie ETL job that owns both syncs.
   *
   * @generated from field: string source_document_id = 28;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string import_job_id = 29;
   */ _define_property(this, "importJobId", ""), /**
   * The issuing (contracting) office the cover form prints under its agency
   * (agency_name), and the office's code. pangaea resolves it to the
   * program's contracting office (government_organization_id).
   *
   * @generated from field: string sub_agency = 30;
   */ _define_property(this, "subAgency", ""), /**
   * @generated from field: string sub_agency_acronym = 31;
   */ _define_property(this, "subAgencyAcronym", ""), /**
   * The obligated total the award prints (SAD-885), forwarded to pangaea
   * unchanged: the program's funded amount.
   *
   * @generated from field: mono.common.v1.StatedObligation stated_obligation = 32;
   */ _define_property(this, "statedObligation", void 0), /**
   * reextract (SAD-974): an explicit Re-extract of the award, not an
   * upload's read, forwarded to pangaea unchanged.
   *
   * @generated from field: bool reextract = 33;
   */ _define_property(this, "reextract", false), /**
   * The ceilings the award states for the whole order, forwarded to pangaea
   * unchanged.
   *
   * @generated from field: repeated mono.common.v1.OrderCeiling order_ceilings = 34;
   */ _define_property(this, "orderCeilings", []), /**
   * The award's weekend/holiday roll for due dates, forwarded to pangaea
   * unchanged.
   *
   * @generated from field: mono.common.v1.AwardDeliverableRoll deliverable_roll = 35;
   */ _define_property(this, "deliverableRoll", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncFromExtractionRequest, "runtime", proto3);
_define_property(SyncFromExtractionRequest, "typeName", "mono.ryugu.v1.SyncFromExtractionRequest");
_define_property(SyncFromExtractionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "task_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contract_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "agency_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "agency_acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "contract_vehicle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "vehicle_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "contract_start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "contract_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "parties",
            kind: "message",
            T: ExtractedParty,
            repeated: true
        },
        {
            no: 13,
            name: "contacts",
            kind: "message",
            T: ExtractedContact,
            repeated: true
        },
        {
            no: 14,
            name: "periods",
            kind: "message",
            T: ExtractedPeriod,
            repeated: true
        },
        {
            no: 16,
            name: "modifications",
            kind: "message",
            T: ExtractedModification,
            repeated: true
        },
        {
            no: 17,
            name: "clins",
            kind: "message",
            T: ExtractedClin,
            repeated: true
        },
        {
            no: 18,
            name: "places_of_performance",
            kind: "message",
            T: ExtractedPlaceOfPerformance,
            repeated: true
        },
        {
            no: 19,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "naics_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "award_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "effective_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "vehicle_contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "acting_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "stated_total_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 26,
            name: "review_items",
            kind: "message",
            T: ReviewItem,
            repeated: true
        },
        {
            no: 27,
            name: "award_duties",
            kind: "message",
            T: AwardPricedDuty,
            repeated: true
        },
        {
            no: 28,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "import_job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 30,
            name: "sub_agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 31,
            name: "sub_agency_acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 32,
            name: "stated_obligation",
            kind: "message",
            T: StatedObligation
        },
        {
            no: 33,
            name: "reextract",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 34,
            name: "order_ceilings",
            kind: "message",
            T: OrderCeiling,
            repeated: true
        },
        {
            no: 35,
            name: "deliverable_roll",
            kind: "message",
            T: AwardDeliverableRoll
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ExtractedParty
 */ export class ExtractedParty extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedParty().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedParty().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedParty().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedParty, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * prime, subcontractor, teaming_partner
   *
   * @generated from field: string role = 2;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string duns = 3;
   */ _define_property(this, "duns", ""), /**
   * @generated from field: string uei = 4;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string cage_code = 5;
   */ _define_property(this, "cageCode", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedParty, "runtime", proto3);
_define_property(ExtractedParty, "typeName", "mono.ryugu.v1.ExtractedParty");
_define_property(ExtractedParty, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "duns",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "cage_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ExtractedContact
 */ export class ExtractedContact extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedContact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedContact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedContact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedContact, a, b);
    }
    constructor(data){
        super(), /**
   * contracting_officer, cor, technical_poc, program_manager, other
   *
   * @generated from field: string role = 1;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string email = 4;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string phone = 5;
   */ _define_property(this, "phone", ""), /**
   * @generated from field: string organization = 6;
   */ _define_property(this, "organization", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedContact, "runtime", proto3);
_define_property(ExtractedContact, "typeName", "mono.ryugu.v1.ExtractedContact");
_define_property(ExtractedContact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ExtractedPeriod
 */ export class ExtractedPeriod extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedPeriod().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedPeriod().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedPeriod().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedPeriod, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * base, option_period
   *
   * @generated from field: string type = 2;
   */ _define_property(this, "type", ""), /**
   * @generated from field: int32 option_number = 3;
   */ _define_property(this, "optionNumber", 0), /**
   * @generated from field: google.protobuf.Timestamp start_date = 4;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 5;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: double total_value = 6;
   */ _define_property(this, "totalValue", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedPeriod, "runtime", proto3);
_define_property(ExtractedPeriod, "typeName", "mono.ryugu.v1.ExtractedPeriod");
_define_property(ExtractedPeriod, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "option_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "total_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * ExtractedClin mirrors the govcon CLIN extraction (reverie's
 * ExtractCLINs stage) — contract line items including SLINs (a non-empty
 * parent_clin_number marks a subline). Pricing carries the semantically
 * parsed values (numeric amount, NSP/NTE/TBD flags) rather than raw
 * strings. The amendment fields (amendment_status, last_modified_in) carry
 * the base-vs-mod trail, stamped from per-mod analysis deltas when the
 * document set includes modifications; base-only sets leave them empty.
 *
 * @generated from message mono.ryugu.v1.ExtractedClin
 */ export class ExtractedClin extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedClin().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedClin().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedClin().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedClin, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string clin_number = 1;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string parent_clin_number = 2;
   */ _define_property(this, "parentClinNumber", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string option_type = 5;
   */ _define_property(this, "optionType", ""), /**
   * pricing structure (FFP, T&M, ...)
   *
   * @generated from field: string contract_type = 6;
   */ _define_property(this, "contractType", ""), /**
   * @generated from field: string unit = 7;
   */ _define_property(this, "unit", ""), /**
   * parsed numeric (0 when non-numeric)
   *
   * @generated from field: double unit_price = 8;
   */ _define_property(this, "unitPrice", 0), /**
   * parsed numeric total
   *
   * @generated from field: double extended_price = 9;
   */ _define_property(this, "extendedPrice", 0), /**
   * @generated from field: bool not_separately_priced = 10;
   */ _define_property(this, "notSeparatelyPriced", false), /**
   * @generated from field: bool not_to_exceed = 11;
   */ _define_property(this, "notToExceed", false), /**
   * @generated from field: double nte_ceiling = 12;
   */ _define_property(this, "nteCeiling", 0), /**
   * @generated from field: bool to_be_determined = 13;
   */ _define_property(this, "toBeDetermined", false), /**
   * @generated from field: string period_name = 14;
   */ _define_property(this, "periodName", ""), /**
   * base | option_period | optional_task
   *
   * @generated from field: string period_type = 15;
   */ _define_property(this, "periodType", ""), /**
   * @generated from field: int32 option_number = 16;
   */ _define_property(this, "optionNumber", 0), /**
   * UNCHANGED | MODIFIED | ADDED | REMOVED
   *
   * @generated from field: string amendment_status = 17;
   */ _define_property(this, "amendmentStatus", ""), /**
   * mod number that last touched this CLIN (0 = original)
   *
   * @generated from field: int32 last_modified_in = 18;
   */ _define_property(this, "lastModifiedIn", 0), /**
   * @generated from field: string corresponding_base_clin = 19;
   */ _define_property(this, "correspondingBaseClin", ""), /**
   * @generated from field: repeated string pws_references = 20;
   */ _define_property(this, "pwsReferences", []), /**
   * @generated from field: repeated string attachment_references = 21;
   */ _define_property(this, "attachmentReferences", []), /**
   * @generated from field: double confidence = 22;
   */ _define_property(this, "confidence", 0), /**
   * RequirementSource provenance, JSON-encoded
   *
   * @generated from field: string source_json = 23;
   */ _define_property(this, "sourceJson", ""), /**
   * @generated from field: int32 quantity = 24;
   */ _define_property(this, "quantity", 0), /**
   * FAR 52.232-7 obligated dollars
   *
   * @generated from field: double funded_amount = 25;
   */ _define_property(this, "fundedAmount", 0), /**
   * ceiling not yet obligated
   *
   * @generated from field: double unfunded_amount = 26;
   */ _define_property(this, "unfundedAmount", 0), /**
   * Deliverables borne by this CLIN/SLIN (empty for non-deliverable lines such
   * as T&M/funding iteration SLINs). Presence is the deliverable gate.
   * MUST stay at tag 27 — it shipped on main as `deliverables = 27`. New fields
   * are appended at 28+; reusing 27 for a string silently misparsed old binary.
   *
   * @generated from field: repeated mono.ryugu.v1.ExtractedDeliverable deliverables = 27;
   */ _define_property(this, "deliverables", []), /**
   * Per-CLIN period of performance — stated on the CLIN itself ("PoP: <start>
   * through <end>"), which can differ from the contract option period.
   *
   * @generated from field: string pop_start_date = 28;
   */ _define_property(this, "popStartDate", ""), /**
   * @generated from field: string pop_end_date = 29;
   */ _define_property(this, "popEndDate", ""), /**
   * @generated from field: string pop_period_name = 30;
   */ _define_property(this, "popPeriodName", ""), /**
   * JSON rate card from the CLIN's embedded LCAT table (see govcon CLIN.labor_mix_json).
   *
   * @generated from field: string labor_mix_json = 31;
   */ _define_property(this, "laborMixJson", ""), /**
   * Optional-task identity from baltigo's description detector (independent of
   * period_type). True when this CLIN is an optional task; number/title from
   * the "OPTIONAL TASK <n> – <title>" header, propagated to sublines.
   *
   * @generated from field: bool is_optional_task = 32;
   */ _define_property(this, "isOptionalTask", false), /**
   * @generated from field: int32 optional_task_number = 33;
   */ _define_property(this, "optionalTaskNumber", 0), /**
   * @generated from field: string optional_task_title = 34;
   */ _define_property(this, "optionalTaskTitle", ""), /**
   * Cost classification (labor | travel | odc | materials | subcontractor | other)
   * from baltigo's metadata enrichment — drives invoicing categorization.
   *
   * @generated from field: string cost_type = 35;
   */ _define_property(this, "costType", ""), /**
   * Original pricing observations. Presence distinguishes older producers from
   * an explicitly supplied empty cell. Parsed JSON retains its presence flags;
   * these strings do not authorize funding or repair an unsupported quantity.
   *
   * @generated from field: optional string raw_unit_price = 36;
   */ _define_property(this, "rawUnitPrice", void 0), /**
   * @generated from field: optional string raw_extended_price = 37;
   */ _define_property(this, "rawExtendedPrice", void 0), /**
   * @generated from field: optional string raw_quantity = 38;
   */ _define_property(this, "rawQuantity", void 0), /**
   * @generated from field: optional string raw_ceiling = 39;
   */ _define_property(this, "rawCeiling", void 0), /**
   * @generated from field: optional string unit_price_parsed_json = 40;
   */ _define_property(this, "unitPriceParsedJson", void 0), /**
   * @generated from field: optional string extended_price_parsed_json = 41;
   */ _define_property(this, "extendedPriceParsedJson", void 0), /**
   * K9c-1c (D103): the task's exercise cap, read from the document's own
   * "may be exercised up to N times" sentences (Section B, and the PWS's "can
   * be exercised up to N times"), never from the family's printed quantity.
   * Set on the family's parent line only; known is false when the document
   * states none, and a stated 0 (or "once" = 1) is known.
   *
   * @generated from field: int32 optional_task_max_exercises = 42;
   */ _define_property(this, "optionalTaskMaxExercises", 0), /**
   * @generated from field: bool optional_task_max_exercises_known = 43;
   */ _define_property(this, "optionalTaskMaxExercisesKnown", false), /**
   * @generated from field: repeated mono.common.v1.ReviewSource optional_task_max_exercises_sources = 44;
   */ _define_property(this, "optionalTaskMaxExercisesSources", []), /**
   * The line's exercise terms as compact JSON (baltigo's CLINExerciseInfo,
   * the shape contract_clins.exercise_info_json stores). Carries the line's
   * scope identity: the name its own row states, or the project a funding
   * map pairs it with. Empty when the line states none.
   *
   * @generated from field: string exercise_info_json = 45;
   */ _define_property(this, "exerciseInfoJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedClin, "runtime", proto3);
_define_property(ExtractedClin, "typeName", "mono.ryugu.v1.ExtractedClin");
_define_property(ExtractedClin, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "parent_clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "option_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "unit_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "extended_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "not_separately_priced",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "not_to_exceed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "nte_ceiling",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 13,
            name: "to_be_determined",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "period_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "period_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "option_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 17,
            name: "amendment_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "last_modified_in",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 19,
            name: "corresponding_base_clin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "pws_references",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 21,
            name: "attachment_references",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 22,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 23,
            name: "source_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "quantity",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 25,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 26,
            name: "unfunded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 27,
            name: "deliverables",
            kind: "message",
            T: ExtractedDeliverable,
            repeated: true
        },
        {
            no: 28,
            name: "pop_start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "pop_end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 30,
            name: "pop_period_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 31,
            name: "labor_mix_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 32,
            name: "is_optional_task",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 33,
            name: "optional_task_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 34,
            name: "optional_task_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 35,
            name: "cost_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 36,
            name: "raw_unit_price",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 37,
            name: "raw_extended_price",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 38,
            name: "raw_quantity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 39,
            name: "raw_ceiling",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 40,
            name: "unit_price_parsed_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 41,
            name: "extended_price_parsed_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 42,
            name: "optional_task_max_exercises",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 43,
            name: "optional_task_max_exercises_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 44,
            name: "optional_task_max_exercises_sources",
            kind: "message",
            T: ReviewSource,
            repeated: true
        },
        {
            no: 45,
            name: "exercise_info_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ExtractedDeliverable is a contract deliverable read from a CLIN's PWS-linked
 * line (e.g. "Monthly Progress Report IAW 5.1.2, due the 5th business day of
 * each month"). due_date holds the initial/explicit due, cadence the recurrence
 * class (monthly|weekly|biweekly|annual|one-time|event), recurring_detail the
 * verbatim rule.
 *
 * @generated from message mono.ryugu.v1.ExtractedDeliverable
 */ export class ExtractedDeliverable extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedDeliverable().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedDeliverable().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedDeliverable().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedDeliverable, a, b);
    }
    constructor(data){
        super(), /**
   * Tags 1-8 MUST match what shipped on main (renumbering silently misparsed old
   * binary payloads). New fields are appended at 9+.
   *
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 2;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string due_date = 3;
   */ _define_property(this, "dueDate", ""), /**
   * @generated from field: string cadence = 4;
   */ _define_property(this, "cadence", ""), /**
   * @generated from field: string deliverable_type = 5;
   */ _define_property(this, "deliverableType", ""), /**
   * @generated from field: string cdrl_reference = 6;
   */ _define_property(this, "cdrlReference", ""), /**
   * Deprecated: CDRL-ness now derives from a non-empty cdrl_reference; the
   * extractor no longer sets this. Kept at tag 7 (not reused/deleted) for wire
   * compatibility with payloads produced before the award-accuracy work.
   *
   * @generated from field: bool is_cdrl = 7;
   */ _define_property(this, "isCdrl", false), /**
   * @generated from field: string recurring_detail = 8;
   */ _define_property(this, "recurringDetail", ""), /**
   * @generated from field: string deliverable_number = 9;
   */ _define_property(this, "deliverableNumber", ""), /**
   * @generated from field: repeated string pws_references = 10;
   */ _define_property(this, "pwsReferences", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedDeliverable, "runtime", proto3);
_define_property(ExtractedDeliverable, "typeName", "mono.ryugu.v1.ExtractedDeliverable");
_define_property(ExtractedDeliverable, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "due_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "cadence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "deliverable_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "cdrl_reference",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "is_cdrl",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "recurring_detail",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "deliverable_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "pws_references",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * ExtractedPlaceOfPerformance mirrors govcon PlaceOfPerformanceExtracted —
 * a work location read from the contract (primary site + percentage split).
 *
 * @generated from message mono.ryugu.v1.ExtractedPlaceOfPerformance
 */ export class ExtractedPlaceOfPerformance extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedPlaceOfPerformance().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedPlaceOfPerformance().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedPlaceOfPerformance().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedPlaceOfPerformance, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool primary = 1;
   */ _define_property(this, "primary", false), /**
   * @generated from field: string description = 2;
   */ _define_property(this, "description", ""), /**
   * @generated from field: double percentage = 3;
   */ _define_property(this, "percentage", 0), /**
   * @generated from field: string city = 4;
   */ _define_property(this, "city", ""), /**
   * @generated from field: string state = 5;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string zip_code = 6;
   */ _define_property(this, "zipCode", ""), /**
   * @generated from field: string country = 7;
   */ _define_property(this, "country", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedPlaceOfPerformance, "runtime", proto3);
_define_property(ExtractedPlaceOfPerformance, "typeName", "mono.ryugu.v1.ExtractedPlaceOfPerformance");
_define_property(ExtractedPlaceOfPerformance, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "city",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "zip_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "country",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SyncFromExtractionResponse
 */ export class SyncFromExtractionResponse extends Message {
    static fromBinary(bytes, options) {
        return new SyncFromExtractionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncFromExtractionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncFromExtractionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncFromExtractionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * true if new program was created, false if updated existing
   *
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncFromExtractionResponse, "runtime", proto3);
_define_property(SyncFromExtractionResponse, "typeName", "mono.ryugu.v1.SyncFromExtractionResponse");
_define_property(SyncFromExtractionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ExtractedModification
 */ export class ExtractedModification extends Message {
    static fromBinary(bytes, options) {
        return new ExtractedModification().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractedModification().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractedModification().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractedModification, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string modification_number = 1;
   */ _define_property(this, "modificationNumber", ""), /**
   * @generated from field: string modification_type = 2;
   */ _define_property(this, "modificationType", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 3;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: string purpose = 4;
   */ _define_property(this, "purpose", ""), /**
   * @generated from field: repeated string change_categories = 5;
   */ _define_property(this, "changeCategories", []), /**
   * @generated from field: bool no_cost_modification = 6;
   */ _define_property(this, "noCostModification", false), /**
   * @generated from field: double total_funding_impact = 7;
   */ _define_property(this, "totalFundingImpact", 0), /**
   * @generated from field: double cumulative_contract_value = 8;
   */ _define_property(this, "cumulativeContractValue", 0), /**
   * @generated from field: string period_changes_json = 9;
   */ _define_property(this, "periodChangesJson", ""), /**
   * @generated from field: string funding_changes_json = 10;
   */ _define_property(this, "fundingChangesJson", ""), /**
   * @generated from field: string scope_changes_json = 11;
   */ _define_property(this, "scopeChangesJson", ""), /**
   * @generated from field: string document_attachment_id = 12;
   */ _define_property(this, "documentAttachmentId", ""), /**
   * @generated from field: string zou_modification_id = 13;
   */ _define_property(this, "zouModificationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractedModification, "runtime", proto3);
_define_property(ExtractedModification, "typeName", "mono.ryugu.v1.ExtractedModification");
_define_property(ExtractedModification, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "modification_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "modification_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "purpose",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "change_categories",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "no_cost_modification",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "total_funding_impact",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "cumulative_contract_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "period_changes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "funding_changes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "scope_changes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "document_attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "zou_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramModificationsRequest
 */ export class ListProgramModificationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramModificationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramModificationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramModificationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramModificationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramModificationsRequest, "runtime", proto3);
_define_property(ListProgramModificationsRequest, "typeName", "mono.ryugu.v1.ListProgramModificationsRequest");
_define_property(ListProgramModificationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramModificationsResponse
 */ export class ListProgramModificationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramModificationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramModificationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramModificationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramModificationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ProgramModificationProto modifications = 1;
   */ _define_property(this, "modifications", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramModificationsResponse, "runtime", proto3);
_define_property(ListProgramModificationsResponse, "typeName", "mono.ryugu.v1.ListProgramModificationsResponse");
_define_property(ListProgramModificationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "modifications",
            kind: "message",
            T: ProgramModificationProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProgramModificationProto
 */ export class ProgramModificationProto extends Message {
    static fromBinary(bytes, options) {
        return new ProgramModificationProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramModificationProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramModificationProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramModificationProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string modification_number = 3;
   */ _define_property(this, "modificationNumber", ""), /**
   * @generated from field: string modification_type = 4;
   */ _define_property(this, "modificationType", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 5;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp signed_date = 6;
   */ _define_property(this, "signedDate", void 0), /**
   * @generated from field: string purpose = 7;
   */ _define_property(this, "purpose", ""), /**
   * @generated from field: repeated string change_categories = 8;
   */ _define_property(this, "changeCategories", []), /**
   * @generated from field: bool no_cost_modification = 9;
   */ _define_property(this, "noCostModification", false), /**
   * @generated from field: double total_funding_impact = 10;
   */ _define_property(this, "totalFundingImpact", 0), /**
   * @generated from field: double cumulative_contract_value = 11;
   */ _define_property(this, "cumulativeContractValue", 0), /**
   * @generated from field: string period_changes_json = 12;
   */ _define_property(this, "periodChangesJson", ""), /**
   * @generated from field: string funding_changes_json = 13;
   */ _define_property(this, "fundingChangesJson", ""), /**
   * @generated from field: string scope_changes_json = 14;
   */ _define_property(this, "scopeChangesJson", ""), /**
   * @generated from field: string document_attachment_id = 15;
   */ _define_property(this, "documentAttachmentId", ""), /**
   * applied | superseded — the registry is append-only: re-applying the same
   * mod supersedes the prior row rather than replacing it.
   *
   * @generated from field: string status = 16;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramModificationProto, "runtime", proto3);
_define_property(ProgramModificationProto, "typeName", "mono.ryugu.v1.ProgramModificationProto");
_define_property(ProgramModificationProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "modification_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "modification_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "signed_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "purpose",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "change_categories",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "no_cost_modification",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "total_funding_impact",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "cumulative_contract_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "period_changes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "funding_changes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "scope_changes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "document_attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CompanyProfileProto
 */ export class CompanyProfileProto extends Message {
    static fromBinary(bytes, options) {
        return new CompanyProfileProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyProfileProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyProfileProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyProfileProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string cage_code = 4;
   */ _define_property(this, "cageCode", ""), /**
   * @generated from field: string duns_number = 5;
   */ _define_property(this, "dunsNumber", ""), /**
   * @generated from field: string uei = 6;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string socioeconomic_status = 7;
   */ _define_property(this, "socioeconomicStatus", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */ _define_property(this, "updatedAt", void 0), /**
   * True on the tenant's own registry profile (the "who we are" row the
   * prime autofill resolves). READ-ONLY on this surface: upserts never
   * forward it — the stamp's only writer is pangaea's ResolveOwnCompany.
   *
   * @generated from field: bool is_own_company = 10;
   */ _define_property(this, "isOwnCompany", false), /**
   * @generated from field: string website = 11;
   */ _define_property(this, "website", ""), /**
   * REG-04: analyst/manual size tier. Closed set MID_SIZE|SMALL|LARGE|OTHER_THAN_SMALL|UNKNOWN (empty = UNKNOWN).
   *
   * @generated from field: string business_size = 12;
   */ _define_property(this, "businessSize", ""), /**
   * ''|MANUAL|SAM_ENTITY|USASPENDING
   *
   * @generated from field: string business_size_source = 13;
   */ _define_property(this, "businessSizeSource", ""), /**
   * REG-04: SAM size facts. OUTPUT ONLY — never written from a form; DAT-18 is the only writer.
   *
   * @generated from field: string sam_business_size = 14;
   */ _define_property(this, "samBusinessSize", ""), /**
   * @generated from field: string sam_business_size_naics = 15;
   */ _define_property(this, "samBusinessSizeNaics", ""), /**
   * @generated from field: google.protobuf.Timestamp sam_business_size_retrieved_at = 16;
   */ _define_property(this, "samBusinessSizeRetrievedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyProfileProto, "runtime", proto3);
_define_property(CompanyProfileProto, "typeName", "mono.ryugu.v1.CompanyProfileProto");
_define_property(CompanyProfileProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "cage_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "duns_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "socioeconomic_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "is_own_company",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "website",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "business_size",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "business_size_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "sam_business_size",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "sam_business_size_naics",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "sam_business_size_retrieved_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCompanyProfilesRequest
 */ export class ListCompanyProfilesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyProfilesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyProfilesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyProfilesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyProfilesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * optional name search
   *
   * @generated from field: string search = 2;
   */ _define_property(this, "search", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyProfilesRequest, "runtime", proto3);
_define_property(ListCompanyProfilesRequest, "typeName", "mono.ryugu.v1.ListCompanyProfilesRequest");
_define_property(ListCompanyProfilesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCompanyProfilesResponse
 */ export class ListCompanyProfilesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyProfilesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyProfilesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyProfilesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyProfilesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.CompanyProfileProto profiles = 1;
   */ _define_property(this, "profiles", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyProfilesResponse, "runtime", proto3);
_define_property(ListCompanyProfilesResponse, "typeName", "mono.ryugu.v1.ListCompanyProfilesResponse");
_define_property(ListCompanyProfilesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profiles",
            kind: "message",
            T: CompanyProfileProto,
            repeated: true
        }
    ]));
/**
 * Lineage shapes mirror mono.datagateway.v1 field-for-field; ryugu proxies.
 *
 * @generated from message mono.ryugu.v1.CompanyAlias
 */ export class CompanyAlias extends Message {
    static fromBinary(bytes, options) {
        return new CompanyAlias().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyAlias().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyAlias().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyAlias, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string alias_name = 3;
   */ _define_property(this, "aliasName", ""), /**
   * previous | trading_as | dba | former
   *
   * @generated from field: string alias_type = 4;
   */ _define_property(this, "aliasType", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 5;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 6;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyAlias, "runtime", proto3);
_define_property(CompanyAlias, "typeName", "mono.ryugu.v1.CompanyAlias");
_define_property(CompanyAlias, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "alias_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "alias_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertCompanyAliasRequest
 */ export class UpsertCompanyAliasRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCompanyAliasRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCompanyAliasRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCompanyAliasRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCompanyAliasRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: mono.ryugu.v1.CompanyAlias alias = 2;
   */ _define_property(this, "alias", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCompanyAliasRequest, "runtime", proto3);
_define_property(UpsertCompanyAliasRequest, "typeName", "mono.ryugu.v1.UpsertCompanyAliasRequest");
_define_property(UpsertCompanyAliasRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "alias",
            kind: "message",
            T: CompanyAlias
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertCompanyAliasResponse
 */ export class UpsertCompanyAliasResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCompanyAliasResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCompanyAliasResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCompanyAliasResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCompanyAliasResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CompanyAlias alias = 1;
   */ _define_property(this, "alias", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCompanyAliasResponse, "runtime", proto3);
_define_property(UpsertCompanyAliasResponse, "typeName", "mono.ryugu.v1.UpsertCompanyAliasResponse");
_define_property(UpsertCompanyAliasResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "alias",
            kind: "message",
            T: CompanyAlias
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCompanyAliasesRequest
 */ export class ListCompanyAliasesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyAliasesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyAliasesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyAliasesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyAliasesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyAliasesRequest, "runtime", proto3);
_define_property(ListCompanyAliasesRequest, "typeName", "mono.ryugu.v1.ListCompanyAliasesRequest");
_define_property(ListCompanyAliasesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCompanyAliasesResponse
 */ export class ListCompanyAliasesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyAliasesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyAliasesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyAliasesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyAliasesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.CompanyAlias aliases = 1;
   */ _define_property(this, "aliases", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyAliasesResponse, "runtime", proto3);
_define_property(ListCompanyAliasesResponse, "typeName", "mono.ryugu.v1.ListCompanyAliasesResponse");
_define_property(ListCompanyAliasesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "aliases",
            kind: "message",
            T: CompanyAlias,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteCompanyAliasRequest
 */ export class DeleteCompanyAliasRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCompanyAliasRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCompanyAliasRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCompanyAliasRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCompanyAliasRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string alias_id = 2;
   */ _define_property(this, "aliasId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCompanyAliasRequest, "runtime", proto3);
_define_property(DeleteCompanyAliasRequest, "typeName", "mono.ryugu.v1.DeleteCompanyAliasRequest");
_define_property(DeleteCompanyAliasRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "alias_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteCompanyAliasResponse
 */ export class DeleteCompanyAliasResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCompanyAliasResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCompanyAliasResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCompanyAliasResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCompanyAliasResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCompanyAliasResponse, "runtime", proto3);
_define_property(DeleteCompanyAliasResponse, "typeName", "mono.ryugu.v1.DeleteCompanyAliasResponse");
_define_property(DeleteCompanyAliasResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.CompanyRelationship
 */ export class CompanyRelationship extends Message {
    static fromBinary(bytes, options) {
        return new CompanyRelationship().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyRelationship().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyRelationship().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyRelationship, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string from_company_id = 2;
   */ _define_property(this, "fromCompanyId", ""), /**
   * @generated from field: string to_company_id = 3;
   */ _define_property(this, "toCompanyId", ""), /**
   * subsidiary | acquisition | merger | joint_venture | rename | spinoff |
   * jv_member | novation | affiliate | reseller (REG-62) | mentor_protege (DAT-25,
   * projector-only). from = the absorbed / renamed / subsidiary / spun-off /
   * novating company or the JV member; to = the acquirer / parent / successor /
   * transferee or the JV company. affiliate is symmetric. reseller: from =
   * the software vendor / OEM, to = the reseller or distributor.
   *
   * @generated from field: string relationship_type = 4;
   */ _define_property(this, "relationshipType", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_start = 5;
   */ _define_property(this, "effectiveStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp effective_end = 6;
   */ _define_property(this, "effectiveEnd", void 0), /**
   * @generated from field: string notes = 7;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * DAT-25: manual | sba_mp_xlsx (mentor_protege rows projected from SBA's
   * list; read-only, removed only when SBA drops the agreement).
   *
   * @generated from field: string source = 9;
   */ _define_property(this, "source", ""), /**
   * @generated from field: google.protobuf.Timestamp observed_as_of = 10;
   */ _define_property(this, "observedAsOf", void 0), /**
   * @generated from field: string end_basis = 11;
   */ _define_property(this, "endBasis", ""), /**
   * REG-31 / REG-62: people who moved over (acquisition | merger only).
   *
   * @generated from field: optional int32 transferred_headcount = 12;
   */ _define_property(this, "transferredHeadcount", void 0), /**
   * @generated from field: string transferred_headcount_source = 13;
   */ _define_property(this, "transferredHeadcountSource", ""), /**
   * REG-62: artifact id of the document the event was recorded from.
   *
   * @generated from field: string source_artifact_id = 14;
   */ _define_property(this, "sourceArtifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyRelationship, "runtime", proto3);
_define_property(CompanyRelationship, "typeName", "mono.ryugu.v1.CompanyRelationship");
_define_property(CompanyRelationship, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "from_company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "to_company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "relationship_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "effective_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "effective_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "observed_as_of",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "end_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "transferred_headcount",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            opt: true
        },
        {
            no: 13,
            name: "transferred_headcount_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateCompanyRelationshipRequest
 */ export class CreateCompanyRelationshipRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCompanyRelationshipRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCompanyRelationshipRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCompanyRelationshipRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCompanyRelationshipRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: mono.ryugu.v1.CompanyRelationship relationship = 2;
   */ _define_property(this, "relationship", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCompanyRelationshipRequest, "runtime", proto3);
_define_property(CreateCompanyRelationshipRequest, "typeName", "mono.ryugu.v1.CreateCompanyRelationshipRequest");
_define_property(CreateCompanyRelationshipRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "relationship",
            kind: "message",
            T: CompanyRelationship
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateCompanyRelationshipResponse
 */ export class CreateCompanyRelationshipResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCompanyRelationshipResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCompanyRelationshipResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCompanyRelationshipResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCompanyRelationshipResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CompanyRelationship relationship = 1;
   */ _define_property(this, "relationship", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCompanyRelationshipResponse, "runtime", proto3);
_define_property(CreateCompanyRelationshipResponse, "typeName", "mono.ryugu.v1.CreateCompanyRelationshipResponse");
_define_property(CreateCompanyRelationshipResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "relationship",
            kind: "message",
            T: CompanyRelationship
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCompanyRelationshipsRequest
 */ export class ListCompanyRelationshipsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyRelationshipsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyRelationshipsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyRelationshipsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyRelationshipsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyRelationshipsRequest, "runtime", proto3);
_define_property(ListCompanyRelationshipsRequest, "typeName", "mono.ryugu.v1.ListCompanyRelationshipsRequest");
_define_property(ListCompanyRelationshipsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCompanyRelationshipsResponse
 */ export class ListCompanyRelationshipsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyRelationshipsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyRelationshipsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyRelationshipsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyRelationshipsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.CompanyRelationship relationships = 1;
   */ _define_property(this, "relationships", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyRelationshipsResponse, "runtime", proto3);
_define_property(ListCompanyRelationshipsResponse, "typeName", "mono.ryugu.v1.ListCompanyRelationshipsResponse");
_define_property(ListCompanyRelationshipsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "relationships",
            kind: "message",
            T: CompanyRelationship,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteCompanyRelationshipRequest
 */ export class DeleteCompanyRelationshipRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCompanyRelationshipRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCompanyRelationshipRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCompanyRelationshipRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCompanyRelationshipRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string relationship_id = 2;
   */ _define_property(this, "relationshipId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCompanyRelationshipRequest, "runtime", proto3);
_define_property(DeleteCompanyRelationshipRequest, "typeName", "mono.ryugu.v1.DeleteCompanyRelationshipRequest");
_define_property(DeleteCompanyRelationshipRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "relationship_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteCompanyRelationshipResponse
 */ export class DeleteCompanyRelationshipResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCompanyRelationshipResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCompanyRelationshipResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCompanyRelationshipResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCompanyRelationshipResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCompanyRelationshipResponse, "runtime", proto3);
_define_property(DeleteCompanyRelationshipResponse, "typeName", "mono.ryugu.v1.DeleteCompanyRelationshipResponse");
_define_property(DeleteCompanyRelationshipResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.UpdateCompanyRelationshipRequest
 */ export class UpdateCompanyRelationshipRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCompanyRelationshipRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCompanyRelationshipRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCompanyRelationshipRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCompanyRelationshipRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: mono.ryugu.v1.CompanyRelationship relationship = 2;
   */ _define_property(this, "relationship", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCompanyRelationshipRequest, "runtime", proto3);
_define_property(UpdateCompanyRelationshipRequest, "typeName", "mono.ryugu.v1.UpdateCompanyRelationshipRequest");
_define_property(UpdateCompanyRelationshipRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "relationship",
            kind: "message",
            T: CompanyRelationship
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateCompanyRelationshipResponse
 */ export class UpdateCompanyRelationshipResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCompanyRelationshipResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCompanyRelationshipResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCompanyRelationshipResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCompanyRelationshipResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CompanyRelationship relationship = 1;
   */ _define_property(this, "relationship", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCompanyRelationshipResponse, "runtime", proto3);
_define_property(UpdateCompanyRelationshipResponse, "typeName", "mono.ryugu.v1.UpdateCompanyRelationshipResponse");
_define_property(UpdateCompanyRelationshipResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "relationship",
            kind: "message",
            T: CompanyRelationship
        }
    ]));
/**
 * Mirrors mono.datagateway.v1.VehicleCompanyAccess field-for-field; ryugu
 * proxies. Read-only: maintenance is C1.4/SAD-435's job.
 *
 * @generated from message mono.ryugu.v1.VehicleCompanyAccess
 */ export class VehicleCompanyAccess extends Message {
    static fromBinary(bytes, options) {
        return new VehicleCompanyAccess().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleCompanyAccess().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleCompanyAccess().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleCompanyAccess, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string vehicle_id = 2;
   */ _define_property(this, "vehicleId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * direct_holder | jv_participant | team_member | other
   *
   * @generated from field: string access_type = 4;
   */ _define_property(this, "accessType", ""), /**
   * @generated from field: string contract_holder_number = 5;
   */ _define_property(this, "contractHolderNumber", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 6;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp expiration_date = 7;
   */ _define_property(this, "expirationDate", void 0), /**
   * @generated from field: string notes = 8;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string vehicle_name = 11;
   */ _define_property(this, "vehicleName", ""), /**
   * @generated from field: string vehicle_contract_number = 12;
   */ _define_property(this, "vehicleContractNumber", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleCompanyAccess, "runtime", proto3);
_define_property(VehicleCompanyAccess, "typeName", "mono.ryugu.v1.VehicleCompanyAccess");
_define_property(VehicleCompanyAccess, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "access_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_holder_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "expiration_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "vehicle_contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCompanyVehicleHoldingsRequest
 */ export class ListCompanyVehicleHoldingsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyVehicleHoldingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyVehicleHoldingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyVehicleHoldingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyVehicleHoldingsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyVehicleHoldingsRequest, "runtime", proto3);
_define_property(ListCompanyVehicleHoldingsRequest, "typeName", "mono.ryugu.v1.ListCompanyVehicleHoldingsRequest");
_define_property(ListCompanyVehicleHoldingsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCompanyVehicleHoldingsResponse
 */ export class ListCompanyVehicleHoldingsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyVehicleHoldingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyVehicleHoldingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyVehicleHoldingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyVehicleHoldingsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.VehicleCompanyAccess holdings = 1;
   */ _define_property(this, "holdings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyVehicleHoldingsResponse, "runtime", proto3);
_define_property(ListCompanyVehicleHoldingsResponse, "typeName", "mono.ryugu.v1.ListCompanyVehicleHoldingsResponse");
_define_property(ListCompanyVehicleHoldingsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "holdings",
            kind: "message",
            T: VehicleCompanyAccess,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertCompanyProfileRequest
 */ export class UpsertCompanyProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCompanyProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCompanyProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCompanyProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCompanyProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string cage_code = 4;
   */ _define_property(this, "cageCode", ""), /**
   * @generated from field: string duns_number = 5;
   */ _define_property(this, "dunsNumber", ""), /**
   * @generated from field: string uei = 6;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string socioeconomic_status = 7;
   */ _define_property(this, "socioeconomicStatus", ""), /**
   * @generated from field: optional string website = 8;
   */ _define_property(this, "website", void 0), /**
   * @generated from field: optional string business_size = 9;
   */ _define_property(this, "businessSize", void 0), /**
   * @generated from field: optional string business_size_source = 10;
   */ _define_property(this, "businessSizeSource", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCompanyProfileRequest, "runtime", proto3);
_define_property(UpsertCompanyProfileRequest, "typeName", "mono.ryugu.v1.UpsertCompanyProfileRequest");
_define_property(UpsertCompanyProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "cage_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "duns_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "socioeconomic_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "website",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 9,
            name: "business_size",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 10,
            name: "business_size_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertCompanyProfileResponse
 */ export class UpsertCompanyProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCompanyProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCompanyProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCompanyProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCompanyProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CompanyProfileProto profile = 1;
   */ _define_property(this, "profile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCompanyProfileResponse, "runtime", proto3);
_define_property(UpsertCompanyProfileResponse, "typeName", "mono.ryugu.v1.UpsertCompanyProfileResponse");
_define_property(UpsertCompanyProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile",
            kind: "message",
            T: CompanyProfileProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteCompanyProfileRequest
 */ export class DeleteCompanyProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCompanyProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCompanyProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCompanyProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCompanyProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCompanyProfileRequest, "runtime", proto3);
_define_property(DeleteCompanyProfileRequest, "typeName", "mono.ryugu.v1.DeleteCompanyProfileRequest");
_define_property(DeleteCompanyProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteCompanyProfileResponse
 */ export class DeleteCompanyProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCompanyProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCompanyProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCompanyProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCompanyProfileResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCompanyProfileResponse, "runtime", proto3);
_define_property(DeleteCompanyProfileResponse, "typeName", "mono.ryugu.v1.DeleteCompanyProfileResponse");
_define_property(DeleteCompanyProfileResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.GetOwnCompanyProfileRequest
 */ export class GetOwnCompanyProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOwnCompanyProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOwnCompanyProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOwnCompanyProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOwnCompanyProfileRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOwnCompanyProfileRequest, "runtime", proto3);
_define_property(GetOwnCompanyProfileRequest, "typeName", "mono.ryugu.v1.GetOwnCompanyProfileRequest");
_define_property(GetOwnCompanyProfileRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * profile is unset when no own-org resolves for the caller's tenant.
 *
 * @generated from message mono.ryugu.v1.GetOwnCompanyProfileResponse
 */ export class GetOwnCompanyProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOwnCompanyProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOwnCompanyProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOwnCompanyProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOwnCompanyProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CompanyProfileProto profile = 1;
   */ _define_property(this, "profile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOwnCompanyProfileResponse, "runtime", proto3);
_define_property(GetOwnCompanyProfileResponse, "typeName", "mono.ryugu.v1.GetOwnCompanyProfileResponse");
_define_property(GetOwnCompanyProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile",
            kind: "message",
            T: CompanyProfileProto
        }
    ]));
/**
 * The request carries no tenant id: like GetOwnCompanyProfileRequest, the
 * tenant can only ever be the authenticated caller's.
 *
 * @generated from message mono.ryugu.v1.SetOwnCompanyProfileRequest
 */ export class SetOwnCompanyProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetOwnCompanyProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetOwnCompanyProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetOwnCompanyProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetOwnCompanyProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_profile_id = 1;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetOwnCompanyProfileRequest, "runtime", proto3);
_define_property(SetOwnCompanyProfileRequest, "typeName", "mono.ryugu.v1.SetOwnCompanyProfileRequest");
_define_property(SetOwnCompanyProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SetOwnCompanyProfileResponse
 */ export class SetOwnCompanyProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetOwnCompanyProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetOwnCompanyProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetOwnCompanyProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetOwnCompanyProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CompanyProfileProto profile = 1;
   */ _define_property(this, "profile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetOwnCompanyProfileResponse, "runtime", proto3);
_define_property(SetOwnCompanyProfileResponse, "typeName", "mono.ryugu.v1.SetOwnCompanyProfileResponse");
_define_property(SetOwnCompanyProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile",
            kind: "message",
            T: CompanyProfileProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListOwnCompanyDesignationsRequest
 */ export class ListOwnCompanyDesignationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOwnCompanyDesignationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOwnCompanyDesignationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOwnCompanyDesignationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOwnCompanyDesignationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 limit = 1;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOwnCompanyDesignationsRequest, "runtime", proto3);
_define_property(ListOwnCompanyDesignationsRequest, "typeName", "mono.ryugu.v1.ListOwnCompanyDesignationsRequest");
_define_property(ListOwnCompanyDesignationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListOwnCompanyDesignationsResponse
 */ export class ListOwnCompanyDesignationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOwnCompanyDesignationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOwnCompanyDesignationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOwnCompanyDesignationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOwnCompanyDesignationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.OwnCompanyDesignationProto designations = 1;
   */ _define_property(this, "designations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOwnCompanyDesignationsResponse, "runtime", proto3);
_define_property(ListOwnCompanyDesignationsResponse, "typeName", "mono.ryugu.v1.ListOwnCompanyDesignationsResponse");
_define_property(ListOwnCompanyDesignationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "designations",
            kind: "message",
            T: OwnCompanyDesignationProto,
            repeated: true
        }
    ]));
/**
 * OwnCompanyDesignation is the append-only audit record of who designated
 * which company profile as a tenant's Our Company, and what it superseded —
 * the decision is explicit, auditable and correctable, and it never rewrites
 * the relationships, rates or attributions already recorded against either
 * company (SAD-548).
 *
 * @generated from message mono.ryugu.v1.OwnCompanyDesignationProto
 */ export class OwnCompanyDesignationProto extends Message {
    static fromBinary(bytes, options) {
        return new OwnCompanyDesignationProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OwnCompanyDesignationProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OwnCompanyDesignationProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OwnCompanyDesignationProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string previous_company_profile_id = 3;
   */ _define_property(this, "previousCompanyProfileId", ""), /**
   * @generated from field: string decided_by_user_id = 4;
   */ _define_property(this, "decidedByUserId", ""), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 6;
   */ _define_property(this, "decidedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OwnCompanyDesignationProto, "runtime", proto3);
_define_property(OwnCompanyDesignationProto, "typeName", "mono.ryugu.v1.OwnCompanyDesignationProto");
_define_property(OwnCompanyDesignationProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "previous_company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "decided_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * Program Company Assignments (junction: program × company profile)
 *
 * @generated from message mono.ryugu.v1.ProgramCompanyAssignmentProto
 */ export class ProgramCompanyAssignmentProto extends Message {
    static fromBinary(bytes, options) {
        return new ProgramCompanyAssignmentProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramCompanyAssignmentProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramCompanyAssignmentProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramCompanyAssignmentProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: bool active = 4;
   */ _define_property(this, "active", false), /**
   * Prime, Sub, Consultant
   *
   * @generated from field: string type = 5;
   */ _define_property(this, "type", ""), /**
   * @generated from field: double fte_count = 6;
   */ _define_property(this, "fteCount", 0), /**
   * @generated from field: int32 vacancies = 7;
   */ _define_property(this, "vacancies", 0), /**
   * Denormalized from CompanyProfile for convenience
   *
   * @generated from field: string company_name = 8;
   */ _define_property(this, "companyName", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp termination_date = 11;
   */ _define_property(this, "terminationDate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramCompanyAssignmentProto, "runtime", proto3);
_define_property(ProgramCompanyAssignmentProto, "typeName", "mono.ryugu.v1.ProgramCompanyAssignmentProto");
_define_property(ProgramCompanyAssignmentProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "fte_count",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "vacancies",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "termination_date",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramCompaniesRequest
 */ export class ListProgramCompaniesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramCompaniesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramCompaniesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramCompaniesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramCompaniesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramCompaniesRequest, "runtime", proto3);
_define_property(ListProgramCompaniesRequest, "typeName", "mono.ryugu.v1.ListProgramCompaniesRequest");
_define_property(ListProgramCompaniesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramCompaniesResponse
 */ export class ListProgramCompaniesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramCompaniesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramCompaniesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramCompaniesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramCompaniesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ProgramCompanyAssignmentProto assignments = 1;
   */ _define_property(this, "assignments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramCompaniesResponse, "runtime", proto3);
_define_property(ListProgramCompaniesResponse, "typeName", "mono.ryugu.v1.ListProgramCompaniesResponse");
_define_property(ListProgramCompaniesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assignments",
            kind: "message",
            T: ProgramCompanyAssignmentProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertProgramCompanyAssignmentRequest
 */ export class UpsertProgramCompanyAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramCompanyAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramCompanyAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramCompanyAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramCompanyAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: bool active = 4;
   */ _define_property(this, "active", false), /**
   * @generated from field: string type = 5;
   */ _define_property(this, "type", ""), /**
   * @generated from field: double fte_count = 6;
   */ _define_property(this, "fteCount", 0), /**
   * @generated from field: int32 vacancies = 7;
   */ _define_property(this, "vacancies", 0), /**
   * @generated from field: google.protobuf.Timestamp termination_date = 8;
   */ _define_property(this, "terminationDate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramCompanyAssignmentRequest, "runtime", proto3);
_define_property(UpsertProgramCompanyAssignmentRequest, "typeName", "mono.ryugu.v1.UpsertProgramCompanyAssignmentRequest");
_define_property(UpsertProgramCompanyAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "fte_count",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "vacancies",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "termination_date",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertProgramCompanyAssignmentResponse
 */ export class UpsertProgramCompanyAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramCompanyAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramCompanyAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramCompanyAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramCompanyAssignmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ProgramCompanyAssignmentProto assignment = 1;
   */ _define_property(this, "assignment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramCompanyAssignmentResponse, "runtime", proto3);
_define_property(UpsertProgramCompanyAssignmentResponse, "typeName", "mono.ryugu.v1.UpsertProgramCompanyAssignmentResponse");
_define_property(UpsertProgramCompanyAssignmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assignment",
            kind: "message",
            T: ProgramCompanyAssignmentProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteProgramCompanyAssignmentRequest
 */ export class DeleteProgramCompanyAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramCompanyAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramCompanyAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramCompanyAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramCompanyAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramCompanyAssignmentRequest, "runtime", proto3);
_define_property(DeleteProgramCompanyAssignmentRequest, "typeName", "mono.ryugu.v1.DeleteProgramCompanyAssignmentRequest");
_define_property(DeleteProgramCompanyAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteProgramCompanyAssignmentResponse
 */ export class DeleteProgramCompanyAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramCompanyAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramCompanyAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramCompanyAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramCompanyAssignmentResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramCompanyAssignmentResponse, "runtime", proto3);
_define_property(DeleteProgramCompanyAssignmentResponse, "typeName", "mono.ryugu.v1.DeleteProgramCompanyAssignmentResponse");
_define_property(DeleteProgramCompanyAssignmentResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * Program Company Staffing Lines — one position under a company assignment,
 * not one person and not a timecard. A line with no contact_id is a vacancy.
 * lcat_id is the tenant registry LCAT entry id (Phase 2a of
 * major-push/lcat-intelligence/) — never a zou LaborCategory id/code; empty
 * until a registry entry is picked, with lcat_title as free-text fallback.
 * fte_count / vacancies on ProgramCompanyAssignmentProto above are SERVED —
 * pangaea recomputes them from these rows on every write (decision 1(c),
 * major-push/7-29-specra/09-subcontractor-fte-drilldown.md).
 *
 * @generated from message mono.ryugu.v1.ProgramCompanyStaffingLineProto
 */ export class ProgramCompanyStaffingLineProto extends Message {
    static fromBinary(bytes, options) {
        return new ProgramCompanyStaffingLineProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramCompanyStaffingLineProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramCompanyStaffingLineProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramCompanyStaffingLineProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string company_assignment_id = 3;
   */ _define_property(this, "companyAssignmentId", ""), /**
   * @generated from field: string lcat_id = 4;
   */ _define_property(this, "lcatId", ""), /**
   * @generated from field: string lcat_title = 5;
   */ _define_property(this, "lcatTitle", ""), /**
   * @generated from field: string position_title = 6;
   */ _define_property(this, "positionTitle", ""), /**
   * @generated from field: double fte = 7;
   */ _define_property(this, "fte", 0), /**
   * @generated from field: string contact_id = 8;
   */ _define_property(this, "contactId", ""), /**
   * Denormalized read helpers (JOIN / lookup, not stored on the row) — the
   * drawer needs a person's name and the company name without a second round
   * trip, the way SubcontractorReviewProto.company_name does.
   *
   * @generated from field: string contact_name = 9;
   */ _define_property(this, "contactName", ""), /**
   * @generated from field: string company_name = 10;
   */ _define_property(this, "companyName", ""), /**
   * @generated from field: google.protobuf.Timestamp start_date = 11;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 12;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: string notes = 13;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 15;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramCompanyStaffingLineProto, "runtime", proto3);
_define_property(ProgramCompanyStaffingLineProto, "typeName", "mono.ryugu.v1.ProgramCompanyStaffingLineProto");
_define_property(ProgramCompanyStaffingLineProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "lcat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "lcat_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "position_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "fte",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "contact_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramCompanyStaffingLinesRequest
 */ export class ListProgramCompanyStaffingLinesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramCompanyStaffingLinesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramCompanyStaffingLinesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramCompanyStaffingLinesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramCompanyStaffingLinesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * optional filter
   *
   * @generated from field: string company_assignment_id = 2;
   */ _define_property(this, "companyAssignmentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramCompanyStaffingLinesRequest, "runtime", proto3);
_define_property(ListProgramCompanyStaffingLinesRequest, "typeName", "mono.ryugu.v1.ListProgramCompanyStaffingLinesRequest");
_define_property(ListProgramCompanyStaffingLinesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramCompanyStaffingLinesResponse
 */ export class ListProgramCompanyStaffingLinesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramCompanyStaffingLinesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramCompanyStaffingLinesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramCompanyStaffingLinesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramCompanyStaffingLinesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ProgramCompanyStaffingLineProto lines = 1;
   */ _define_property(this, "lines", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramCompanyStaffingLinesResponse, "runtime", proto3);
_define_property(ListProgramCompanyStaffingLinesResponse, "typeName", "mono.ryugu.v1.ListProgramCompanyStaffingLinesResponse");
_define_property(ListProgramCompanyStaffingLinesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "lines",
            kind: "message",
            T: ProgramCompanyStaffingLineProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertProgramCompanyStaffingLineRequest
 */ export class UpsertProgramCompanyStaffingLineRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramCompanyStaffingLineRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramCompanyStaffingLineRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramCompanyStaffingLineRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramCompanyStaffingLineRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string company_assignment_id = 3;
   */ _define_property(this, "companyAssignmentId", ""), /**
   * @generated from field: string lcat_id = 4;
   */ _define_property(this, "lcatId", ""), /**
   * @generated from field: string lcat_title = 5;
   */ _define_property(this, "lcatTitle", ""), /**
   * @generated from field: string position_title = 6;
   */ _define_property(this, "positionTitle", ""), /**
   * @generated from field: double fte = 7;
   */ _define_property(this, "fte", 0), /**
   * @generated from field: string contact_id = 8;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: google.protobuf.Timestamp start_date = 9;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 10;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: string notes = 11;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramCompanyStaffingLineRequest, "runtime", proto3);
_define_property(UpsertProgramCompanyStaffingLineRequest, "typeName", "mono.ryugu.v1.UpsertProgramCompanyStaffingLineRequest");
_define_property(UpsertProgramCompanyStaffingLineRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "lcat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "lcat_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "position_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "fte",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertProgramCompanyStaffingLineResponse
 */ export class UpsertProgramCompanyStaffingLineResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramCompanyStaffingLineResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramCompanyStaffingLineResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramCompanyStaffingLineResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramCompanyStaffingLineResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ProgramCompanyStaffingLineProto line = 1;
   */ _define_property(this, "line", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramCompanyStaffingLineResponse, "runtime", proto3);
_define_property(UpsertProgramCompanyStaffingLineResponse, "typeName", "mono.ryugu.v1.UpsertProgramCompanyStaffingLineResponse");
_define_property(UpsertProgramCompanyStaffingLineResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "line",
            kind: "message",
            T: ProgramCompanyStaffingLineProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteProgramCompanyStaffingLineRequest
 */ export class DeleteProgramCompanyStaffingLineRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramCompanyStaffingLineRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramCompanyStaffingLineRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramCompanyStaffingLineRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramCompanyStaffingLineRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramCompanyStaffingLineRequest, "runtime", proto3);
_define_property(DeleteProgramCompanyStaffingLineRequest, "typeName", "mono.ryugu.v1.DeleteProgramCompanyStaffingLineRequest");
_define_property(DeleteProgramCompanyStaffingLineRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteProgramCompanyStaffingLineResponse
 */ export class DeleteProgramCompanyStaffingLineResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramCompanyStaffingLineResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramCompanyStaffingLineResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramCompanyStaffingLineResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramCompanyStaffingLineResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramCompanyStaffingLineResponse, "runtime", proto3);
_define_property(DeleteProgramCompanyStaffingLineResponse, "typeName", "mono.ryugu.v1.DeleteProgramCompanyStaffingLineResponse");
_define_property(DeleteProgramCompanyStaffingLineResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.ContactProto
 */ export class ContactProto extends Message {
    static fromBinary(bytes, options) {
        return new ContactProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContactProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContactProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContactProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string first_name = 3;
   */ _define_property(this, "firstName", ""), /**
   * @generated from field: string last_name = 4;
   */ _define_property(this, "lastName", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string email = 6;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string phone = 7;
   */ _define_property(this, "phone", ""), /**
   * @generated from field: string location = 8;
   */ _define_property(this, "location", ""), /**
   * @generated from field: string organization = 9;
   */ _define_property(this, "organization", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string contact_type = 12;
   */ _define_property(this, "contactType", ""), /**
   * @generated from field: string company_profile_id = 13;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string government_organization_id = 14;
   */ _define_property(this, "governmentOrganizationId", ""), /**
   * @generated from field: bool is_active = 15;
   */ _define_property(this, "isActive", false), /**
   * Read helpers (JOIN / lookup, not stored on contact row)
   *
   * @generated from field: string company_profile_name = 16;
   */ _define_property(this, "companyProfileName", ""), /**
   * @generated from field: string government_organization_name = 17;
   */ _define_property(this, "governmentOrganizationName", ""), /**
   * The platform user this contact maps to (if any) — lets the UI tell whether
   * the current user IS a given contact (e.g. the assigned corrective-action
   * owner), so it can offer owner-only actions without a guaranteed denial.
   *
   * @generated from field: string platform_user_id = 18;
   */ _define_property(this, "platformUserId", ""), /**
   * Registry-assigned role (tenant role_type enum id). For INTERNAL contacts:
   * program role assignments inherit this and treat it as static.
   *
   * @generated from field: string role_type_id = 19;
   */ _define_property(this, "roleTypeId", ""), /**
   * Labeled addresses. `email` (field 6) is the server-derived primary; see
   * Contact.corporate_email / government_email in datagateway/v1/delivery.proto.
   *
   * @generated from field: string corporate_email = 20;
   */ _define_property(this, "corporateEmail", ""), /**
   * @generated from field: string government_email = 21;
   */ _define_property(this, "governmentEmail", ""), /**
   * People Graph: a seat-shaped contact minted from a vacant staffing line.
   *
   * @generated from field: bool is_placeholder = 22;
   */ _define_property(this, "isPlaceholder", false), /**
   * Business-unit scope (SAD-75). Empty means "not scoped to a business
   * unit — visible everywhere", mirroring TenantEnumValueProto's field of
   * the same name. See Contact.business_unit_id in datagateway/v1/delivery.proto.
   *
   * @generated from field: string business_unit_id = 23;
   */ _define_property(this, "businessUnitId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContactProto, "runtime", proto3);
_define_property(ContactProto, "typeName", "mono.ryugu.v1.ContactProto");
_define_property(ContactProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "first_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "last_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "location",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "contact_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "is_active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 16,
            name: "company_profile_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "government_organization_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "platform_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "role_type_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "corporate_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "government_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "is_placeholder",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 23,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListContactsRequest
 */ export class ListContactsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListContactsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * optional name/email search
   *
   * @generated from field: string search = 2;
   */ _define_property(this, "search", ""), /**
   * When set, returns contacts whose business_unit_id is empty **OR** equals
   * this id — the globally-visible contacts PLUS this BU's own, same
   * NULL-or-match semantics as ListTenantEnumValuesRequest.business_unit_id.
   * Empty means no BU filtering at all.
   *
   * @generated from field: string business_unit_id = 3;
   */ _define_property(this, "businessUnitId", ""), /**
   * Deactivated contacts are left out of ordinary lists and pickers (SAD-433);
   * set to include them for the explicit inactive view.
   *
   * @generated from field: bool include_inactive = 4;
   */ _define_property(this, "includeInactive", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactsRequest, "runtime", proto3);
_define_property(ListContactsRequest, "typeName", "mono.ryugu.v1.ListContactsRequest");
_define_property(ListContactsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "include_inactive",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListContactsResponse
 */ export class ListContactsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListContactsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ContactProto contacts = 1;
   */ _define_property(this, "contacts", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactsResponse, "runtime", proto3);
_define_property(ListContactsResponse, "typeName", "mono.ryugu.v1.ListContactsResponse");
_define_property(ListContactsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contacts",
            kind: "message",
            T: ContactProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.LinkContactUserRequest
 */ export class LinkContactUserRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkContactUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkContactUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkContactUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkContactUserRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", ""), /**
   * The platform user to link. Empty + non-empty email = resolve by email
   * (the form's "suggested match" path — refused when ambiguous).
   *
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string email = 4;
   */ _define_property(this, "email", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkContactUserRequest, "runtime", proto3);
_define_property(LinkContactUserRequest, "typeName", "mono.ryugu.v1.LinkContactUserRequest");
_define_property(LinkContactUserRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.LinkContactUserResponse
 */ export class LinkContactUserResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkContactUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkContactUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkContactUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkContactUserResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ContactProto contact = 1;
   */ _define_property(this, "contact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkContactUserResponse, "runtime", proto3);
_define_property(LinkContactUserResponse, "typeName", "mono.ryugu.v1.LinkContactUserResponse");
_define_property(LinkContactUserResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact",
            kind: "message",
            T: ContactProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UnlinkContactUserRequest
 */ export class UnlinkContactUserRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkContactUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkContactUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkContactUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkContactUserRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkContactUserRequest, "runtime", proto3);
_define_property(UnlinkContactUserRequest, "typeName", "mono.ryugu.v1.UnlinkContactUserRequest");
_define_property(UnlinkContactUserRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Unlink stops FUTURE roster grants from resolving through this contact;
 * existing grants stand until revoked.
 *
 * @generated from message mono.ryugu.v1.UnlinkContactUserResponse
 */ export class UnlinkContactUserResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkContactUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkContactUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkContactUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkContactUserResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ContactProto contact = 1;
   */ _define_property(this, "contact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkContactUserResponse, "runtime", proto3);
_define_property(UnlinkContactUserResponse, "typeName", "mono.ryugu.v1.UnlinkContactUserResponse");
_define_property(UnlinkContactUserResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact",
            kind: "message",
            T: ContactProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertContactRequest
 */ export class UpsertContactRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertContactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertContactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertContactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertContactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string first_name = 3;
   */ _define_property(this, "firstName", ""), /**
   * @generated from field: string last_name = 4;
   */ _define_property(this, "lastName", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string email = 6;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string phone = 7;
   */ _define_property(this, "phone", ""), /**
   * @generated from field: string location = 8;
   */ _define_property(this, "location", ""), /**
   * @generated from field: string organization = 9;
   */ _define_property(this, "organization", ""), /**
   * @generated from field: string contact_type = 10;
   */ _define_property(this, "contactType", ""), /**
   * Plain scalar, honored on CREATE only (SAD-94): a brand-new contact has
   * no stored affiliation to protect, so presence doesn't matter here. They
   * predate explicit presence and can't be changed to `optional` in place —
   * `buf breaking` (FILE category) flags a cardinality change on an
   * existing field number as breaking. UPDATE must use the presence-safe
   * companion fields below (19/20) instead; the server ignores 11/12
   * entirely on update rather than risk a stale full-row echo silently
   * clobbering the stored affiliation — see company_profile_id_v2.
   *
   * @generated from field: string company_profile_id = 11;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string government_organization_id = 12;
   */ _define_property(this, "governmentOrganizationId", ""), /**
   * @generated from field: bool is_active = 13;
   */ _define_property(this, "isActive", false), /**
   * Explicit presence: absent leaves the stored registry role untouched, set
   * to "" clears it. A plain scalar forced every full-row caller to remember
   * to echo the role back or silently wipe it.
   *
   * @generated from field: optional string role_type_id = 14;
   */ _define_property(this, "roleTypeId", void 0), /**
   * The platform user this contact IS, same explicit presence as role_type_id:
   * absent leaves the stored link untouched, "" clears it deliberately.
   *
   * An empty link is the whole "contact only — no platform access" state: a
   * registry contact is a person on the program, which is worth recording
   * whether or not they can log in. There is deliberately NO companion boolean
   * — a nullable link already encodes both states, while a second flag would
   * admit a row that is linked AND marked contact-only, which nothing could
   * resolve. The UI forces an explicit pick so nobody lands here by accident.
   *
   * A non-empty value must name a real user in the acting tenant; ryugu
   * validates it (see UpsertContact) because the Roles section later mints
   * access grants from this link.
   *
   * @generated from field: optional string platform_user_id = 15;
   */ _define_property(this, "platformUserId", void 0), /**
   * Explicit presence, same reasoning as role_type_id/platform_user_id above:
   * full-row callers (e.g. ProgramContactsTab's edit-phone-from-list-cache
   * path) must not silently wipe the other labeled address by omission.
   * Absent leaves the stored value untouched; "" clears it deliberately.
   *
   * @generated from field: optional string corporate_email = 16;
   */ _define_property(this, "corporateEmail", void 0), /**
   * @generated from field: optional string government_email = 17;
   */ _define_property(this, "governmentEmail", void 0), /**
   * Presence-gated like the fields above: absent leaves the stored flag
   * untouched; set writes it (the placeholder-from-vacancy button sets true,
   * "fill the seat" flows set false).
   *
   * @generated from field: optional bool is_placeholder = 18;
   */ _define_property(this, "isPlaceholder", void 0), /**
   * Presence-safe companions to company_profile_id/government_organization_id
   * (11/12), used on the UPDATE path only (SAD-94). Same explicit-presence
   * contract as role_type_id/platform_user_id above: absent leaves the
   * stored affiliation untouched, "" clears it deliberately (e.g. switching
   * a contact to GOVERNMENT clears the company link), a non-empty value
   * sets it. The Affiliation column falls back government-org -> company ->
   * free-text organization, so either one left unguarded would blank a real
   * affiliation on any partial update that merely echoes a stale value.
   *
   * @generated from field: optional string company_profile_id_v2 = 19;
   */ _define_property(this, "companyProfileIdV2", void 0), /**
   * @generated from field: optional string government_organization_id_v2 = 20;
   */ _define_property(this, "governmentOrganizationIdV2", void 0), /**
   * Business-unit scope (SAD-75), same explicit-presence contract as
   * role_type_id/platform_user_id above: absent leaves the stored value
   * untouched, "" clears it deliberately (unscope the contact — visible in
   * every BU's picker again), a non-empty value scopes it. Must name a real
   * business unit in the acting tenant — ryugu validates it (see
   * UpsertContact), and a contact whose business unit actively conflicts
   * with its chosen role_type_id's business unit is refused.
   *
   * @generated from field: optional string business_unit_id = 21;
   */ _define_property(this, "businessUnitId", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertContactRequest, "runtime", proto3);
_define_property(UpsertContactRequest, "typeName", "mono.ryugu.v1.UpsertContactRequest");
_define_property(UpsertContactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "first_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "last_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "location",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "contact_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "is_active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "role_type_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 15,
            name: "platform_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 16,
            name: "corporate_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 17,
            name: "government_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 18,
            name: "is_placeholder",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 19,
            name: "company_profile_id_v2",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 20,
            name: "government_organization_id_v2",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 21,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertContactResponse
 */ export class UpsertContactResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertContactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertContactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertContactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertContactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ContactProto contact = 1;
   */ _define_property(this, "contact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertContactResponse, "runtime", proto3);
_define_property(UpsertContactResponse, "typeName", "mono.ryugu.v1.UpsertContactResponse");
_define_property(UpsertContactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact",
            kind: "message",
            T: ContactProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteContactRequest
 */ export class DeleteContactRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteContactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteContactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteContactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteContactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteContactRequest, "runtime", proto3);
_define_property(DeleteContactRequest, "typeName", "mono.ryugu.v1.DeleteContactRequest");
_define_property(DeleteContactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteContactResponse
 */ export class DeleteContactResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteContactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteContactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteContactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteContactResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteContactResponse, "runtime", proto3);
_define_property(DeleteContactResponse, "typeName", "mono.ryugu.v1.DeleteContactResponse");
_define_property(DeleteContactResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.RetireContactRequest
 */ export class RetireContactRequest extends Message {
    static fromBinary(bytes, options) {
        return new RetireContactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetireContactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetireContactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetireContactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetireContactRequest, "runtime", proto3);
_define_property(RetireContactRequest, "typeName", "mono.ryugu.v1.RetireContactRequest");
_define_property(RetireContactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RetireContactResponse
 */ export class RetireContactResponse extends Message {
    static fromBinary(bytes, options) {
        return new RetireContactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetireContactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetireContactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetireContactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ContactProto contact = 1;
   */ _define_property(this, "contact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetireContactResponse, "runtime", proto3);
_define_property(RetireContactResponse, "typeName", "mono.ryugu.v1.RetireContactResponse");
_define_property(RetireContactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact",
            kind: "message",
            T: ContactProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ReactivateContactRequest
 */ export class ReactivateContactRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReactivateContactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReactivateContactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReactivateContactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReactivateContactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReactivateContactRequest, "runtime", proto3);
_define_property(ReactivateContactRequest, "typeName", "mono.ryugu.v1.ReactivateContactRequest");
_define_property(ReactivateContactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ReactivateContactResponse
 */ export class ReactivateContactResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReactivateContactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReactivateContactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReactivateContactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReactivateContactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ContactProto contact = 1;
   */ _define_property(this, "contact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReactivateContactResponse, "runtime", proto3);
_define_property(ReactivateContactResponse, "typeName", "mono.ryugu.v1.ReactivateContactResponse");
_define_property(ReactivateContactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact",
            kind: "message",
            T: ContactProto
        }
    ]));
/**
 * One touchpoint a contact took part in, with the affiliation the contact held
 * when it was recorded (frozen; not the contact's current employer). Meeting
 * content (descriptions, comments, attendees) is deliberately absent: this is
 * the contact's history, not a program read.
 *
 * @generated from message mono.ryugu.v1.ContactTouchpointProto
 */ export class ContactTouchpointProto extends Message {
    static fromBinary(bytes, options) {
        return new ContactTouchpointProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContactTouchpointProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContactTouchpointProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContactTouchpointProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string method = 3;
   */ _define_property(this, "method", ""), /**
   * @generated from field: google.protobuf.Timestamp date_of_briefing = 4;
   */ _define_property(this, "dateOfBriefing", void 0), /**
   * "provided_to" or "provided_by": which side of the touchpoint the contact was.
   *
   * @generated from field: string role = 5;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string affiliation_company_profile_id = 6;
   */ _define_property(this, "affiliationCompanyProfileId", ""), /**
   * @generated from field: string affiliation_government_organization_id = 7;
   */ _define_property(this, "affiliationGovernmentOrganizationId", ""), /**
   * @generated from field: string affiliation_employment_id = 8;
   */ _define_property(this, "affiliationEmploymentId", ""), /**
   * Display label (lookup, not stored). Empty when the affiliation was unknown.
   *
   * @generated from field: string affiliation_name = 9;
   */ _define_property(this, "affiliationName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContactTouchpointProto, "runtime", proto3);
_define_property(ContactTouchpointProto, "typeName", "mono.ryugu.v1.ContactTouchpointProto");
_define_property(ContactTouchpointProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "date_of_briefing",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "affiliation_company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "affiliation_government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "affiliation_employment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "affiliation_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListContactTouchpointsRequest
 */ export class ListContactTouchpointsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListContactTouchpointsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactTouchpointsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactTouchpointsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactTouchpointsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactTouchpointsRequest, "runtime", proto3);
_define_property(ListContactTouchpointsRequest, "typeName", "mono.ryugu.v1.ListContactTouchpointsRequest");
_define_property(ListContactTouchpointsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListContactTouchpointsResponse
 */ export class ListContactTouchpointsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListContactTouchpointsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactTouchpointsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactTouchpointsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactTouchpointsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ContactTouchpointProto touchpoints = 1;
   */ _define_property(this, "touchpoints", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactTouchpointsResponse, "runtime", proto3);
_define_property(ListContactTouchpointsResponse, "typeName", "mono.ryugu.v1.ListContactTouchpointsResponse");
_define_property(ListContactTouchpointsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "touchpoints",
            kind: "message",
            T: ContactTouchpointProto,
            repeated: true
        }
    ]));
/**
 * Browser projection of one employer fact, with the employer's display name
 * resolved server-side so the drawer renders without N+1 lookups.
 *
 * @generated from message mono.ryugu.v1.ContactEmploymentProto
 */ export class ContactEmploymentProto extends Message {
    static fromBinary(bytes, options) {
        return new ContactEmploymentProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContactEmploymentProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContactEmploymentProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContactEmploymentProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string government_organization_id = 4;
   */ _define_property(this, "governmentOrganizationId", ""), /**
   * Display label (lookup, not stored): the company or gov-org name.
   *
   * @generated from field: string employer_name = 5;
   */ _define_property(this, "employerName", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * EMPLOYEE | CONTRACTOR | ADVISOR | GOV_CIVILIAN | MILITARY | UNKNOWN
   *
   * @generated from field: string employment_type = 7;
   */ _define_property(this, "employmentType", ""), /**
   * @generated from field: google.protobuf.Timestamp start_date = 8;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 9;
   */ _define_property(this, "endDate", void 0), /**
   * MANUAL | DERIVED | IMPORT
   *
   * @generated from field: string source = 10;
   */ _define_property(this, "source", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContactEmploymentProto, "runtime", proto3);
_define_property(ContactEmploymentProto, "typeName", "mono.ryugu.v1.ContactEmploymentProto");
_define_property(ContactEmploymentProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "employer_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "employment_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListContactEmploymentsRequest
 */ export class ListContactEmploymentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListContactEmploymentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactEmploymentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactEmploymentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactEmploymentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactEmploymentsRequest, "runtime", proto3);
_define_property(ListContactEmploymentsRequest, "typeName", "mono.ryugu.v1.ListContactEmploymentsRequest");
_define_property(ListContactEmploymentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListContactEmploymentsResponse
 */ export class ListContactEmploymentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListContactEmploymentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactEmploymentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactEmploymentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactEmploymentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ContactEmploymentProto employments = 1;
   */ _define_property(this, "employments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactEmploymentsResponse, "runtime", proto3);
_define_property(ListContactEmploymentsResponse, "typeName", "mono.ryugu.v1.ListContactEmploymentsResponse");
_define_property(ListContactEmploymentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "employments",
            kind: "message",
            T: ContactEmploymentProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateContactEmploymentRequest
 */ export class CreateContactEmploymentRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateContactEmploymentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateContactEmploymentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateContactEmploymentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateContactEmploymentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", ""), /**
   * Exactly one of the two employer ids.
   *
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string government_organization_id = 4;
   */ _define_property(this, "governmentOrganizationId", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string employment_type = 6;
   */ _define_property(this, "employmentType", ""), /**
   * @generated from field: google.protobuf.Timestamp start_date = 7;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 8;
   */ _define_property(this, "endDate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateContactEmploymentRequest, "runtime", proto3);
_define_property(CreateContactEmploymentRequest, "typeName", "mono.ryugu.v1.CreateContactEmploymentRequest");
_define_property(CreateContactEmploymentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "employment_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "end_date",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateContactEmploymentResponse
 */ export class CreateContactEmploymentResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateContactEmploymentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateContactEmploymentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateContactEmploymentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateContactEmploymentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ContactEmploymentProto employment = 1;
   */ _define_property(this, "employment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateContactEmploymentResponse, "runtime", proto3);
_define_property(CreateContactEmploymentResponse, "typeName", "mono.ryugu.v1.CreateContactEmploymentResponse");
_define_property(CreateContactEmploymentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "employment",
            kind: "message",
            T: ContactEmploymentProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.EndContactEmploymentRequest
 */ export class EndContactEmploymentRequest extends Message {
    static fromBinary(bytes, options) {
        return new EndContactEmploymentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EndContactEmploymentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EndContactEmploymentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EndContactEmploymentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: google.protobuf.Timestamp end_date = 3;
   */ _define_property(this, "endDate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EndContactEmploymentRequest, "runtime", proto3);
_define_property(EndContactEmploymentRequest, "typeName", "mono.ryugu.v1.EndContactEmploymentRequest");
_define_property(EndContactEmploymentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "end_date",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.EndContactEmploymentResponse
 */ export class EndContactEmploymentResponse extends Message {
    static fromBinary(bytes, options) {
        return new EndContactEmploymentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EndContactEmploymentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EndContactEmploymentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EndContactEmploymentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ContactEmploymentProto employment = 1;
   */ _define_property(this, "employment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EndContactEmploymentResponse, "runtime", proto3);
_define_property(EndContactEmploymentResponse, "typeName", "mono.ryugu.v1.EndContactEmploymentResponse");
_define_property(EndContactEmploymentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "employment",
            kind: "message",
            T: ContactEmploymentProto
        }
    ]));
/**
 * Merge folds loser into survivor — audited, reversible, and refused with
 * FAILED_PRECONDITION when both parties carry platform accounts (B5) or the
 * target is itself merged/deleted/self.
 *
 * @generated from message mono.ryugu.v1.MergeContactsRequest
 */ export class MergeContactsRequest extends Message {
    static fromBinary(bytes, options) {
        return new MergeContactsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergeContactsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergeContactsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergeContactsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string loser_contact_id = 2;
   */ _define_property(this, "loserContactId", ""), /**
   * @generated from field: string survivor_contact_id = 3;
   */ _define_property(this, "survivorContactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MergeContactsRequest, "runtime", proto3);
_define_property(MergeContactsRequest, "typeName", "mono.ryugu.v1.MergeContactsRequest");
_define_property(MergeContactsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "loser_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "survivor_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.MergeContactsResponse
 */ export class MergeContactsResponse extends Message {
    static fromBinary(bytes, options) {
        return new MergeContactsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergeContactsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergeContactsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergeContactsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ContactProto survivor = 1;
   */ _define_property(this, "survivor", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MergeContactsResponse, "runtime", proto3);
_define_property(MergeContactsResponse, "typeName", "mono.ryugu.v1.MergeContactsResponse");
_define_property(MergeContactsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "survivor",
            kind: "message",
            T: ContactProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UnmergeContactsRequest
 */ export class UnmergeContactsRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnmergeContactsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnmergeContactsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnmergeContactsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnmergeContactsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnmergeContactsRequest, "runtime", proto3);
_define_property(UnmergeContactsRequest, "typeName", "mono.ryugu.v1.UnmergeContactsRequest");
_define_property(UnmergeContactsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UnmergeContactsResponse
 */ export class UnmergeContactsResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnmergeContactsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnmergeContactsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnmergeContactsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnmergeContactsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ContactProto contact = 1;
   */ _define_property(this, "contact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnmergeContactsResponse, "runtime", proto3);
_define_property(UnmergeContactsResponse, "typeName", "mono.ryugu.v1.UnmergeContactsResponse");
_define_property(UnmergeContactsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact",
            kind: "message",
            T: ContactProto
        }
    ]));
/**
 * Browser projection of a merge event: the loser's display name comes from
 * the audited snapshot, so history renders even after the loser row moves on.
 *
 * @generated from message mono.ryugu.v1.ContactMergeEventProto
 */ export class ContactMergeEventProto extends Message {
    static fromBinary(bytes, options) {
        return new ContactMergeEventProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContactMergeEventProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContactMergeEventProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContactMergeEventProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string loser_contact_id = 2;
   */ _define_property(this, "loserContactId", ""), /**
   * @generated from field: string survivor_contact_id = 3;
   */ _define_property(this, "survivorContactId", ""), /**
   * @generated from field: string loser_name = 4;
   */ _define_property(this, "loserName", ""), /**
   * @generated from field: string decided_by = 5;
   */ _define_property(this, "decidedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp reversed_at = 7;
   */ _define_property(this, "reversedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContactMergeEventProto, "runtime", proto3);
_define_property(ContactMergeEventProto, "typeName", "mono.ryugu.v1.ContactMergeEventProto");
_define_property(ContactMergeEventProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "loser_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "survivor_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "loser_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "reversed_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListContactMergeEventsRequest
 */ export class ListContactMergeEventsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListContactMergeEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactMergeEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactMergeEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactMergeEventsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactMergeEventsRequest, "runtime", proto3);
_define_property(ListContactMergeEventsRequest, "typeName", "mono.ryugu.v1.ListContactMergeEventsRequest");
_define_property(ListContactMergeEventsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListContactMergeEventsResponse
 */ export class ListContactMergeEventsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListContactMergeEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactMergeEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactMergeEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactMergeEventsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ContactMergeEventProto events = 1;
   */ _define_property(this, "events", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactMergeEventsResponse, "runtime", proto3);
_define_property(ListContactMergeEventsResponse, "typeName", "mono.ryugu.v1.ListContactMergeEventsResponse");
_define_property(ListContactMergeEventsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: ContactMergeEventProto,
            repeated: true
        }
    ]));
/**
 * Browser projection of one money fact, with display labels resolved server
 * side. Person-level rows (PAY / contact-scoped) never reach this surface —
 * they are vault-gated (W4-B) and refused with FAILED_PRECONDITION.
 *
 * @generated from message mono.ryugu.v1.RateObservationProto
 */ export class RateObservationProto extends Message {
    static fromBinary(bytes, options) {
        return new RateObservationProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateObservationProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateObservationProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateObservationProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string lcat_entry_id = 2;
   */ _define_property(this, "lcatEntryId", ""), /**
   * display label (lookup, not stored)
   *
   * @generated from field: string lcat_title = 3;
   */ _define_property(this, "lcatTitle", ""), /**
   * @generated from field: string company_profile_id = 4;
   */ _define_property(this, "companyProfileId", ""), /**
   * display label
   *
   * @generated from field: string company_name = 5;
   */ _define_property(this, "companyName", ""), /**
   * @generated from field: string contract_vehicle_id = 6;
   */ _define_property(this, "contractVehicleId", ""), /**
   * display label
   *
   * @generated from field: string vehicle_name = 7;
   */ _define_property(this, "vehicleName", ""), /**
   * CEILING | PROPOSED | SUBK_AGREED | BILLED | INFERRED
   *
   * @generated from field: string observation_type = 8;
   */ _define_property(this, "observationType", ""), /**
   * @generated from field: double amount = 9;
   */ _define_property(this, "amount", 0), /**
   * @generated from field: string currency = 10;
   */ _define_property(this, "currency", ""), /**
   * @generated from field: string rate_unit = 11;
   */ _define_property(this, "rateUnit", ""), /**
   * @generated from field: string burden_basis = 12;
   */ _define_property(this, "burdenBasis", ""), /**
   * the sheet's own words
   *
   * @generated from field: string period_label = 13;
   */ _define_property(this, "periodLabel", ""), /**
   * @generated from field: google.protobuf.Timestamp period_start = 14;
   */ _define_property(this, "periodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp period_end = 15;
   */ _define_property(this, "periodEnd", void 0), /**
   * @generated from field: string period_kind = 16;
   */ _define_property(this, "periodKind", ""), /**
   * @generated from field: string normalized_period_key = 17;
   */ _define_property(this, "normalizedPeriodKey", ""), /**
   * @generated from field: string worksite = 18;
   */ _define_property(this, "worksite", ""), /**
   * @generated from field: string locality = 19;
   */ _define_property(this, "locality", ""), /**
   * @generated from field: string source = 20;
   */ _define_property(this, "source", ""), /**
   * @generated from field: optional double confidence = 21;
   */ _define_property(this, "confidence", void 0), /**
   * @generated from field: string evidence_json = 22;
   */ _define_property(this, "evidenceJson", ""), /**
   * @generated from field: string corrects_id = 23;
   */ _define_property(this, "correctsId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 24;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string correction_reason = 25;
   */ _define_property(this, "correctionReason", ""), /**
   * @generated from field: string corrected_by_id = 26;
   */ _define_property(this, "correctedById", ""), /**
   * @generated from field: string invalidation_reason = 27;
   */ _define_property(this, "invalidationReason", ""), /**
   * @generated from field: string invalidated_by = 28;
   */ _define_property(this, "invalidatedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp invalidated_at = 29;
   */ _define_property(this, "invalidatedAt", void 0), /**
   * @generated from field: string replacement_id = 30;
   */ _define_property(this, "replacementId", ""), /**
   * @generated from field: string replaces_id = 31;
   */ _define_property(this, "replacesId", ""), /**
   * @generated from field: string recorded_by = 32;
   */ _define_property(this, "recordedBy", ""), /**
   * SAD-450: exact source of a pricing-sheet rate (see datagateway RateObservation).
   *
   * @generated from field: string source_generation_id = 33;
   */ _define_property(this, "sourceGenerationId", ""), /**
   * @generated from field: string source_change_item_id = 34;
   */ _define_property(this, "sourceChangeItemId", ""), /**
   * @generated from field: string source_change_set_id = 35;
   */ _define_property(this, "sourceChangeSetId", ""), /**
   * @generated from field: string source_label = 36;
   */ _define_property(this, "sourceLabel", ""), /**
   * @generated from field: string mapped_anchor_id = 37;
   */ _define_property(this, "mappedAnchorId", ""), /**
   * @generated from field: string mapped_anchor_title = 38;
   */ _define_property(this, "mappedAnchorTitle", ""), /**
   * @generated from field: string mapped_relation = 39;
   */ _define_property(this, "mappedRelation", ""), /**
   * @generated from field: string mapped_status = 40;
   */ _define_property(this, "mappedStatus", ""), /**
   * @generated from field: string effective_vehicle_id = 42;
   */ _define_property(this, "effectiveVehicleId", ""), /**
   * @generated from field: string effective_vehicle_name = 43;
   */ _define_property(this, "effectiveVehicleName", ""), /**
   * REG-26: decided period bounds key; period_label stays the sheet's own words.
   *
   * @generated from field: string resolved_normalized_period_key = 41;
   */ _define_property(this, "resolvedNormalizedPeriodKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateObservationProto, "runtime", proto3);
_define_property(RateObservationProto, "typeName", "mono.ryugu.v1.RateObservationProto");
_define_property(RateObservationProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "lcat_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "lcat_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "rate_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "burden_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "period_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "normalized_period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "worksite",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "locality",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 22,
            name: "evidence_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "corrects_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 25,
            name: "correction_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "corrected_by_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "invalidation_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "invalidated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "invalidated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 30,
            name: "replacement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 31,
            name: "replaces_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 32,
            name: "recorded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 33,
            name: "source_generation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 34,
            name: "source_change_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 35,
            name: "source_change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 36,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 37,
            name: "mapped_anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 38,
            name: "mapped_anchor_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 39,
            name: "mapped_relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 40,
            name: "mapped_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 42,
            name: "effective_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 43,
            name: "effective_vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 41,
            name: "resolved_normalized_period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * A staged pricing sheet awaiting review, summarised for a list.
 *
 * @generated from message mono.ryugu.v1.PricingSheetReviewSummary
 */ export class PricingSheetReviewSummary extends Message {
    static fromBinary(bytes, options) {
        return new PricingSheetReviewSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingSheetReviewSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingSheetReviewSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingSheetReviewSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * Draft | Parsed | UnderReview | Approved | Applied | Rejected
   *
   * @generated from field: string state = 3;
   */ _define_property(this, "state", ""), /**
   * blocks is what a person works through: one reading per sheet plus one per
   * (company x period x worksite x burden x locality x SIN).
   *
   * @generated from field: int32 blocks = 4;
   */ _define_property(this, "blocks", 0), /**
   * @generated from field: int32 open_blocks = 5;
   */ _define_property(this, "openBlocks", 0), /**
   * @generated from field: int32 blocking_blocks = 6;
   */ _define_property(this, "blockingBlocks", 0), /**
   * Categories proposed, and how many still need a decision. Counted separately
   * from blocks because they are a different decision: what these jobs ARE,
   * rather than what they cost.
   *
   * @generated from field: int32 categories = 14;
   */ _define_property(this, "categories", 0), /**
   * @generated from field: int32 open_categories = 15;
   */ _define_property(this, "openCategories", 0), /**
   * rates is how much rides on the review — 42,000 rates are ~380 blocks, so
   * the two numbers answer different questions.
   *
   * @generated from field: int32 rates = 7;
   */ _define_property(this, "rates", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string created_by = 9;
   */ _define_property(this, "createdBy", ""), /**
   * The artifact the sheet was uploaded as, and how its rates were typed. Both
   * come off the staged payload rather than being stored twice, and both exist so
   * a reviewer can RE-READ the sheet with today's parser without going to find
   * the file again.
   *
   * @generated from field: string source_document_id = 10;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string observation_type = 11;
   */ _define_property(this, "observationType", ""), /**
   * @generated from field: string contract_vehicle_id = 12;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string company_profile_id = 13;
   */ _define_property(this, "companyProfileId", ""), /**
   * Whether the document prices ONE contractor or many: SingleCompany |
   * MultiCompany. Taken from the shape of the rate table — a company that comes
   * from a COLUMN means a rate book — never from counting names.
   *
   * @generated from field: string company_scope = 16;
   */ _define_property(this, "companyScope", ""), /**
   * Every company the document mentions, in reading order. A single-company
   * pricelist that names two is a question for a person: the corpus has one
   * naming both a firm and its pre-merger name, and the page does not say they
   * are the same. Nothing here resolves them.
   *
   * @generated from field: repeated string companies_named = 17;
   */ _define_property(this, "companiesNamed", []), /**
   * The recorded DOCUMENT behind this review (delivery.pricing_sheet_generations),
   * joined on change_set_id. All empty when the sheet was never recorded as a
   * document (older uploads, or an ingest with no vehicle).
   *
   * @generated from field: string generation_id = 18;
   */ _define_property(this, "generationId", ""), /**
   * Lineage number on vehicle x issuer x company x pool; 1 is the first sheet.
   *
   * @generated from field: int32 generation = 19;
   */ _define_property(this, "generation", 0), /**
   * True when a newer generation replaced this one.
   *
   * @generated from field: bool superseded = 20;
   */ _define_property(this, "superseded", false), /**
   * @generated from field: string source_filename = 21;
   */ _define_property(this, "sourceFilename", ""), /**
   * Where the bytes were published, the page that linked them, when they were
   * fetched, and their lowercase hex SHA-256 — enough to re-pull and compare.
   *
   * @generated from field: string source_document_url = 22;
   */ _define_property(this, "sourceDocumentUrl", ""), /**
   * @generated from field: string source_page_url = 23;
   */ _define_property(this, "sourcePageUrl", ""), /**
   * @generated from field: google.protobuf.Timestamp retrieved_at = 24;
   */ _define_property(this, "retrievedAt", void 0), /**
   * @generated from field: string source_sha256 = 25;
   */ _define_property(this, "sourceSha256", ""), /**
   * Display names for contract_vehicle_id / company_profile_id.
   *
   * @generated from field: string contract_vehicle_name = 26;
   */ _define_property(this, "contractVehicleName", ""), /**
   * @generated from field: string company_profile_name = 27;
   */ _define_property(this, "companyProfileName", ""), /**
   * COMPANY | GOVERNMENT — who published the sheet.
   *
   * @generated from field: string issuer_kind = 28;
   */ _define_property(this, "issuerKind", ""), /**
   * PENDING | PARSED | FAILED, from the document row.
   *
   * @generated from field: string parse_status = 29;
   */ _define_property(this, "parseStatus", ""), /**
   * @generated from field: string superseded_by_id = 30;
   */ _define_property(this, "supersededById", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_from = 31;
   */ _define_property(this, "effectiveFrom", void 0), /**
   * @generated from field: google.protobuf.Timestamp effective_to = 32;
   */ _define_property(this, "effectiveTo", void 0), /**
   * @generated from field: string period_span_text = 33;
   */ _define_property(this, "periodSpanText", ""), /**
   * Zero until REG-26 supplies period decisions.
   *
   * @generated from field: int32 pending_period_decisions = 34;
   */ _define_property(this, "pendingPeriodDecisions", 0), /**
   * List-row facts, computed server-side so the list renders without deriving
   * them from the document row and the staged items itself.
   * The generation's row_count when positive, else the staged rate count.
   *
   * @generated from field: int32 row_count = 35;
   */ _define_property(this, "rowCount", 0), /**
   * Companies on a multi-company table; 1 when a single company is known; else 0.
   *
   * @generated from field: int32 company_count = 36;
   */ _define_property(this, "companyCount", 0), /**
   * "{YYYY} generation": contract start, else the document's, else the review's creation.
   *
   * @generated from field: string generation_label = 37;
   */ _define_property(this, "generationLabel", ""), /**
   * History | Committed | Rejected | Cancelled | AwaitingDecision | Parsed.
   *
   * @generated from field: string list_status = 38;
   */ _define_property(this, "listStatus", ""), /**
   * Decisions still open on the review (open_blocks) while it awaits a decision.
   *
   * @generated from field: int32 awaiting_decisions = 39;
   */ _define_property(this, "awaitingDecisions", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingSheetReviewSummary, "runtime", proto3);
_define_property(PricingSheetReviewSummary, "typeName", "mono.ryugu.v1.PricingSheetReviewSummary");
_define_property(PricingSheetReviewSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "blocks",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "open_blocks",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "blocking_blocks",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 14,
            name: "categories",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "open_categories",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "rates",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "company_scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "companies_named",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 18,
            name: "generation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "generation",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 20,
            name: "superseded",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 21,
            name: "source_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "source_document_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "source_page_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "retrieved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 25,
            name: "source_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "contract_vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "company_profile_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "issuer_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "parse_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 30,
            name: "superseded_by_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 31,
            name: "effective_from",
            kind: "message",
            T: Timestamp
        },
        {
            no: 32,
            name: "effective_to",
            kind: "message",
            T: Timestamp
        },
        {
            no: 33,
            name: "period_span_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 34,
            name: "pending_period_decisions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 35,
            name: "row_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 36,
            name: "company_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 37,
            name: "generation_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 38,
            name: "list_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 39,
            name: "awaiting_decisions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * How a sheet was READ. The decision a reviewer confirms once; confirming it
 * writes no rate, because a reading is a decision and not a row.
 *
 * @generated from message mono.ryugu.v1.PricingSheetReading
 */ export class PricingSheetReading extends Message {
    static fromBinary(bytes, options) {
        return new PricingSheetReading().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingSheetReading().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingSheetReading().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingSheetReading, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string item_id = 1;
   */ _define_property(this, "itemId", ""), /**
   * @generated from field: string sheet_name = 2;
   */ _define_property(this, "sheetName", ""), /**
   * The document's own description of itself, verbatim.
   *
   * @generated from field: string title_text = 3;
   */ _define_property(this, "titleText", ""), /**
   * Each axis in the reviewer's words — "each rate column is a period (6
   * distinct)", "no company is named anywhere on this sheet".
   *
   * @generated from field: string company_axis = 4;
   */ _define_property(this, "companyAxis", ""), /**
   * @generated from field: string period_axis = 5;
   */ _define_property(this, "periodAxis", ""), /**
   * @generated from field: string worksite_axis = 6;
   */ _define_property(this, "worksiteAxis", ""), /**
   * What the sheet's own arithmetic says about the reading: rate x hours
   * against the stated price. The only thing that can contradict the map from
   * inside the document.
   *
   * @generated from field: string validation = 7;
   */ _define_property(this, "validation", ""), /**
   * @generated from field: repeated string columns = 8;
   */ _define_property(this, "columns", []), /**
   * What was deliberately NOT extracted, in the parser's words. Silence and
   * "found nothing" are indistinguishable without these.
   *
   * @generated from field: repeated string refusals = 9;
   */ _define_property(this, "refusals", []), /**
   * @generated from field: int32 rate_count = 10;
   */ _define_property(this, "rateCount", 0), /**
   * @generated from field: string severity = 11;
   */ _define_property(this, "severity", ""), /**
   * @generated from field: string resolution_state = 12;
   */ _define_property(this, "resolutionState", ""), /**
   * Where this sheet IS in the source document: the converter's block id and the
   * 1-based page a person would turn to. Both empty for a workbook, which has
   * pages in no sense a viewer can draw.
   *
   * @generated from field: string source_block_id = 13;
   */ _define_property(this, "sourceBlockId", ""), /**
   * @generated from field: int32 source_page = 14;
   */ _define_property(this, "sourcePage", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingSheetReading, "runtime", proto3);
_define_property(PricingSheetReading, "typeName", "mono.ryugu.v1.PricingSheetReading");
_define_property(PricingSheetReading, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "sheet_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_axis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "period_axis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "worksite_axis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "validation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "columns",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "refusals",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "rate_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 11,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "resolution_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "source_block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "source_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * One rate from a block, for spot-checking. The reviewer confirms the reading;
 * these let them sanity-check the values behind it without paging 12,000 rows.
 *
 * @generated from message mono.ryugu.v1.PricingSheetSampleRate
 */ export class PricingSheetSampleRate extends Message {
    static fromBinary(bytes, options) {
        return new PricingSheetSampleRate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingSheetSampleRate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingSheetSampleRate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingSheetSampleRate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string labor_category = 1;
   */ _define_property(this, "laborCategory", ""), /**
   * @generated from field: double amount = 2;
   */ _define_property(this, "amount", 0), /**
   * @generated from field: string rate_unit = 3;
   */ _define_property(this, "rateUnit", ""), /**
   * @generated from field: string period_label = 4;
   */ _define_property(this, "periodLabel", ""), /**
   * @generated from field: string worksite = 5;
   */ _define_property(this, "worksite", ""), /**
   * @generated from field: string sin = 6;
   */ _define_property(this, "sin", ""), /**
   * @generated from field: string burden_basis = 7;
   */ _define_property(this, "burdenBasis", ""), /**
   * What the registry says this category IS, so a reviewer can check that the
   * rate is attached to the right job rather than just to a matching string.
   * Empty when the entry carries no definition — which is itself worth seeing,
   * because a title with no definition cannot be mapped to a SOC anchor or
   * compared with a competitor's category.
   *
   * @generated from field: string qualifications = 8;
   */ _define_property(this, "qualifications", ""), /**
   * @generated from field: string description = 9;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingSheetSampleRate, "runtime", proto3);
_define_property(PricingSheetSampleRate, "typeName", "mono.ryugu.v1.PricingSheetSampleRate");
_define_property(PricingSheetSampleRate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "rate_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "worksite",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "burden_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "qualifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * A block of rates sharing one identity — the unit a person accepts or rejects.
 *
 * @generated from message mono.ryugu.v1.PricingSheetBlock
 */ export class PricingSheetBlock extends Message {
    static fromBinary(bytes, options) {
        return new PricingSheetBlock().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingSheetBlock().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingSheetBlock().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingSheetBlock, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string item_id = 1;
   */ _define_property(this, "itemId", ""), /**
   * The identity in the reviewer's own words: "ICF, Inc. · Year 6 (2026-2027) ·
   * government worksite · SIN 54151S".
   *
   * @generated from field: string identity = 2;
   */ _define_property(this, "identity", ""), /**
   * @generated from field: string sheet_name = 3;
   */ _define_property(this, "sheetName", ""), /**
   * @generated from field: int32 rates = 4;
   */ _define_property(this, "rates", 0), /**
   * Rates in this block whose labor category is NOT in the registry, so they
   * are not staged. Reported because "160 categories" and "160 of 190" are
   * different facts.
   *
   * @generated from field: int32 unresolved = 5;
   */ _define_property(this, "unresolved", 0), /**
   * Why this severity, in one sentence a reviewer can act on.
   *
   * @generated from field: string reason = 6;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string severity = 7;
   */ _define_property(this, "severity", ""), /**
   * @generated from field: string resolution_state = 8;
   */ _define_property(this, "resolutionState", ""), /**
   * @generated from field: repeated mono.ryugu.v1.PricingSheetSampleRate sample = 9;
   */ _define_property(this, "sample", []), /**
   * Where these rates came from, taken from the evidence the parser stored on
   * them: the block a reviewer can be SHOWN, on the page it sits on. A block id
   * is a string until it is a rectangle.
   *
   * @generated from field: string source_block_id = 10;
   */ _define_property(this, "sourceBlockId", ""), /**
   * @generated from field: int32 source_page = 11;
   */ _define_property(this, "sourcePage", 0), /**
   * The company the block's rates are attributed to, as staged (or as the
   * curator corrected it). company_resolved is false while any rate has only a
   * name: such a block is held in staging and cannot be accepted.
   *
   * @generated from field: string company_name = 12;
   */ _define_property(this, "companyName", ""), /**
   * @generated from field: string company_profile_id = 13;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: bool company_resolved = 14;
   */ _define_property(this, "companyResolved", false), /**
   * Labor-category titles in this block that no registry entry backs yet.
   *
   * @generated from field: repeated string unresolved_lcat_titles = 15;
   */ _define_property(this, "unresolvedLcatTitles", []), /**
   * True once a curator has corrected this block (approved value differs).
   *
   * @generated from field: bool corrected = 16;
   */ _define_property(this, "corrected", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingSheetBlock, "runtime", proto3);
_define_property(PricingSheetBlock, "typeName", "mono.ryugu.v1.PricingSheetBlock");
_define_property(PricingSheetBlock, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "identity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sheet_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rates",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "unresolved",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "resolution_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "sample",
            kind: "message",
            T: PricingSheetSampleRate,
            repeated: true
        },
        {
            no: 10,
            name: "source_block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "source_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "company_resolved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 15,
            name: "unresolved_lcat_titles",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 16,
            name: "corrected",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListPricingSheetReviewsRequest
 */ export class ListPricingSheetReviewsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPricingSheetReviewsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPricingSheetReviewsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPricingSheetReviewsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPricingSheetReviewsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string contract_vehicle_id = 2;
   */ _define_property(this, "contractVehicleId", ""), /**
   * include_applied returns finished reviews too; the default answers "what is
   * waiting on me".
   *
   * @generated from field: bool include_applied = 3;
   */ _define_property(this, "includeApplied", false), /**
   * Only sheets for this company (the sheet's own company, or the company its
   * staged rates are attributed to).
   *
   * @generated from field: string company_profile_id = 4;
   */ _define_property(this, "companyProfileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPricingSheetReviewsRequest, "runtime", proto3);
_define_property(ListPricingSheetReviewsRequest, "typeName", "mono.ryugu.v1.ListPricingSheetReviewsRequest");
_define_property(ListPricingSheetReviewsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "include_applied",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListPricingSheetReviewsResponse
 */ export class ListPricingSheetReviewsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPricingSheetReviewsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPricingSheetReviewsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPricingSheetReviewsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPricingSheetReviewsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.PricingSheetReviewSummary reviews = 1;
   */ _define_property(this, "reviews", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPricingSheetReviewsResponse, "runtime", proto3);
_define_property(ListPricingSheetReviewsResponse, "typeName", "mono.ryugu.v1.ListPricingSheetReviewsResponse");
_define_property(ListPricingSheetReviewsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reviews",
            kind: "message",
            T: PricingSheetReviewSummary,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetPricingSheetReviewRequest
 */ export class GetPricingSheetReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPricingSheetReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPricingSheetReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPricingSheetReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPricingSheetReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPricingSheetReviewRequest, "runtime", proto3);
_define_property(GetPricingSheetReviewRequest, "typeName", "mono.ryugu.v1.GetPricingSheetReviewRequest");
_define_property(GetPricingSheetReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * A labor category the sheet names that the registry does not have, proposed for
 * the catalog. A rate cannot be applied until its category has been accepted, so
 * these are the FIRST thing a reviewer rules on.
 *
 * @generated from message mono.ryugu.v1.PricingSheetCategory
 */ export class PricingSheetCategory extends Message {
    static fromBinary(bytes, options) {
        return new PricingSheetCategory().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingSheetCategory().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingSheetCategory().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingSheetCategory, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string item_id = 1;
   */ _define_property(this, "itemId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * What the document says this job IS, verbatim. Empty is the interesting case:
   * a title with no definition cannot be mapped to a SOC anchor or compared with
   * a competitor's category.
   *
   * @generated from field: string qualifications = 3;
   */ _define_property(this, "qualifications", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string clearance = 5;
   */ _define_property(this, "clearance", ""), /**
   * @generated from field: string certifications = 6;
   */ _define_property(this, "certifications", ""), /**
   * How many staged rates are waiting on this category being accepted.
   *
   * @generated from field: int32 waiting_rates = 7;
   */ _define_property(this, "waitingRates", 0), /**
   * @generated from field: string severity = 8;
   */ _define_property(this, "severity", ""), /**
   * @generated from field: string resolution_state = 9;
   */ _define_property(this, "resolutionState", ""), /**
   * @generated from field: string reason = 10;
   */ _define_property(this, "reason", ""), /**
   * Who read this definition — labelled lines in the document, or a model reading
   * its prose. Surfaced because the two are worth different amounts of trust: a
   * model's reading should be checked against the page, and a reviewer cannot do
   * that if the provenance is hidden.
   *
   * @generated from field: string definition_source = 11;
   */ _define_property(this, "definitionSource", ""), /**
   * Where the definition was READ from — the converter's block and the 1-based
   * page. This is what turns "check it against the page" from an instruction into
   * a click. Both empty when the definition came from prose, which spans blocks
   * and has no single rectangle, or when the document never defined the category.
   *
   * @generated from field: string source_block_id = 12;
   */ _define_property(this, "sourceBlockId", ""), /**
   * @generated from field: int32 source_page = 13;
   */ _define_property(this, "sourcePage", 0), /**
   * The document's education/experience SUBSTITUTION rule, stated once and
   * governing every category. Without it "Bachelors" reads as a hard bar; with
   * it the same category is open to an associate's plus four more years, which
   * is the difference between a category you can staff and one you cannot.
   *
   * @generated from field: string equivalency = 14;
   */ _define_property(this, "equivalency", ""), /**
   * @generated from field: int32 equivalency_page = 15;
   */ _define_property(this, "equivalencyPage", 0), /**
   * @generated from field: string equivalency_block_id = 16;
   */ _define_property(this, "equivalencyBlockId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingSheetCategory, "runtime", proto3);
_define_property(PricingSheetCategory, "typeName", "mono.ryugu.v1.PricingSheetCategory");
_define_property(PricingSheetCategory, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "qualifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "clearance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "certifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "waiting_rates",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "resolution_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "definition_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "source_block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "source_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 14,
            name: "equivalency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "equivalency_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 16,
            name: "equivalency_block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * One labor category's rates ACROSS periods — the shape a reviewer can actually
 * judge.
 *
 * Blocks are grouped for STAGING by (company x period x worksite x burden x SIN),
 * which is a rate's identity and is correct. It is the wrong unit for READING: a
 * five-year pricelist puts one role's rates in five different blocks, so nobody
 * can see that Year 3 jumped 40% or that Year 5 is missing. This pivots them
 * back: one row per role per SIN, one column per period.
 *
 * @generated from message mono.ryugu.v1.PricingSheetRateRow
 */ export class PricingSheetRateRow extends Message {
    static fromBinary(bytes, options) {
        return new PricingSheetRateRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingSheetRateRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingSheetRateRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingSheetRateRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string labor_category = 1;
   */ _define_property(this, "laborCategory", ""), /**
   * @generated from field: string sin = 2;
   */ _define_property(this, "sin", ""), /**
   * @generated from field: string worksite = 3;
   */ _define_property(this, "worksite", ""), /**
   * @generated from field: string burden_basis = 4;
   */ _define_property(this, "burdenBasis", ""), /**
   * @generated from field: string rate_unit = 5;
   */ _define_property(this, "rateUnit", ""), /**
   * Amounts in period order, aligned to the response's period list. A gap is a
   * period this role was NOT priced in, which is worth seeing.
   *
   * @generated from field: repeated mono.ryugu.v1.PricingSheetRateCell cells = 6;
   */ _define_property(this, "cells", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingSheetRateRow, "runtime", proto3);
_define_property(PricingSheetRateRow, "typeName", "mono.ryugu.v1.PricingSheetRateRow");
_define_property(PricingSheetRateRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "sin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "worksite",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "burden_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rate_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "cells",
            kind: "message",
            T: PricingSheetRateCell,
            repeated: true
        }
    ]));
/**
 * One period column of the pivot: what the document called it, and — when it
 * said so — the dates it covers. A label compares to nothing across vendors;
 * two vendors' "Year 1" are only comparable once both are dated.
 *
 * @generated from message mono.ryugu.v1.PricingSheetPeriod
 */ export class PricingSheetPeriod extends Message {
    static fromBinary(bytes, options) {
        return new PricingSheetPeriod().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingSheetPeriod().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingSheetPeriod().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingSheetPeriod, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string label = 1;
   */ _define_property(this, "label", ""), /**
   * YYYY-MM-DD, both empty when the document states no span.
   *
   * @generated from field: string start_date = 2;
   */ _define_property(this, "startDate", ""), /**
   * @generated from field: string end_date = 3;
   */ _define_property(this, "endDate", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingSheetPeriod, "runtime", proto3);
_define_property(PricingSheetPeriod, "typeName", "mono.ryugu.v1.PricingSheetPeriod");
_define_property(PricingSheetPeriod, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.PricingSheetRateCell
 */ export class PricingSheetRateCell extends Message {
    static fromBinary(bytes, options) {
        return new PricingSheetRateCell().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingSheetRateCell().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingSheetRateCell().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingSheetRateCell, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string period_label = 1;
   */ _define_property(this, "periodLabel", ""), /**
   * @generated from field: double amount = 2;
   */ _define_property(this, "amount", 0), /**
   * present is false for a period this role carries no rate in — distinct from an
   * amount of zero, which would be a real (and alarming) price.
   *
   * @generated from field: bool present = 3;
   */ _define_property(this, "present", false), /**
   * The staged item this cell came from, so a decision on it is reachable from
   * the row a person is reading.
   *
   * @generated from field: string item_id = 4;
   */ _define_property(this, "itemId", ""), /**
   * Where THIS rate is on the page — per cell, not per row.
   *
   * A row is a pivot across periods and has no page of its own: Year 1 can be on
   * page 4 and Year 5 on page 9, and a multipage schedule splits one role's
   * rates across tables. Taken from the evidence the parser stored on the
   * individual rate, so "show me this number" opens the page that number is
   * printed on rather than the page its row started on.
   *
   * @generated from field: string source_block_id = 5;
   */ _define_property(this, "sourceBlockId", ""), /**
   * @generated from field: int32 source_page = 6;
   */ _define_property(this, "sourcePage", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingSheetRateCell, "runtime", proto3);
_define_property(PricingSheetRateCell, "typeName", "mono.ryugu.v1.PricingSheetRateCell");
_define_property(PricingSheetRateCell, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "present",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetPricingSheetReviewResponse
 */ export class GetPricingSheetReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPricingSheetReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPricingSheetReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPricingSheetReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPricingSheetReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.PricingSheetReviewSummary summary = 1;
   */ _define_property(this, "summary", void 0), /**
   * One reading per sheet in the document.
   *
   * @generated from field: repeated mono.ryugu.v1.PricingSheetReading readings = 2;
   */ _define_property(this, "readings", []), /**
   * Worst severity first: a reviewer should meet the exceptions before the bulk.
   *
   * @generated from field: repeated mono.ryugu.v1.PricingSheetBlock blocks = 3;
   */ _define_property(this, "blocks", []), /**
   * Labor categories waiting to enter the catalog. Ruled on BEFORE the blocks,
   * because a rate whose category was not accepted cannot be applied.
   *
   * @generated from field: repeated mono.ryugu.v1.PricingSheetCategory categories = 4;
   */ _define_property(this, "categories", []), /**
   * The rates pivoted by labor category, for reading. The blocks above remain the
   * unit of DECISION; this is the unit of judgement.
   *
   * @generated from field: repeated mono.ryugu.v1.PricingSheetRateRow rate_rows = 5;
   */ _define_property(this, "rateRows", []), /**
   * Every period the sheet priced, in order, so the columns line up. Kept as
   * the labels for compatibility; period_spans carries the same list with the
   * dates the document stated for each.
   *
   * @generated from field: repeated string periods = 6;
   */ _define_property(this, "periods", []), /**
   * @generated from field: repeated mono.ryugu.v1.PricingSheetPeriod period_spans = 7;
   */ _define_property(this, "periodSpans", []), /**
   * Registry rows the document says must EXIST before anything else can be
   * applied — the contract, and the contractor. First tier of four.
   *
   * @generated from field: repeated mono.ryugu.v1.PricingSheetRegistryRow registry_rows = 8;
   */ _define_property(this, "registryRows", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPricingSheetReviewResponse, "runtime", proto3);
_define_property(GetPricingSheetReviewResponse, "typeName", "mono.ryugu.v1.GetPricingSheetReviewResponse");
_define_property(GetPricingSheetReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: PricingSheetReviewSummary
        },
        {
            no: 2,
            name: "readings",
            kind: "message",
            T: PricingSheetReading,
            repeated: true
        },
        {
            no: 3,
            name: "blocks",
            kind: "message",
            T: PricingSheetBlock,
            repeated: true
        },
        {
            no: 4,
            name: "categories",
            kind: "message",
            T: PricingSheetCategory,
            repeated: true
        },
        {
            no: 5,
            name: "rate_rows",
            kind: "message",
            T: PricingSheetRateRow,
            repeated: true
        },
        {
            no: 6,
            name: "periods",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "period_spans",
            kind: "message",
            T: PricingSheetPeriod,
            repeated: true
        },
        {
            no: 8,
            name: "registry_rows",
            kind: "message",
            T: PricingSheetRegistryRow,
            repeated: true
        }
    ]));
/**
 * A registry row a sheet proposes: the contract its ceilings are binding on, or
 * the contractor whose rates they are.
 *
 * These are the FIRST thing to rule on and were the last thing to get a surface.
 * A PDF's upload preflight sees only a file name — conversion is the slow step and
 * does not run there — so on a cold-start tenant neither exists, and the apply
 * walks four ordered tiers where each resolves against a row the previous one
 * created. Leaving these unruled meant the apply declined all 54 categories with
 * "its contractor has not been accepted" and wrote nothing at all.
 *
 * @generated from message mono.ryugu.v1.PricingSheetRegistryRow
 */ export class PricingSheetRegistryRow extends Message {
    static fromBinary(bytes, options) {
        return new PricingSheetRegistryRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingSheetRegistryRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingSheetRegistryRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingSheetRegistryRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string item_id = 1;
   */ _define_property(this, "itemId", ""), /**
   * ContractVehicle | CompanyProfile.
   *
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * The government's exact handle where the document gave one: a contract number
   * for a vehicle, a UEI for a contractor. Its absence is the interesting case.
   *
   * @generated from field: string identifier = 4;
   */ _define_property(this, "identifier", ""), /**
   * What else the document said — an agency, a CAGE code, a vehicle type.
   *
   * @generated from field: string detail = 5;
   */ _define_property(this, "detail", ""), /**
   * Who read it, and why it is graded the way it is.
   *
   * @generated from field: string source = 6;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string reason = 7;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string severity = 8;
   */ _define_property(this, "severity", ""), /**
   * @generated from field: string resolution_state = 9;
   */ _define_property(this, "resolutionState", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingSheetRegistryRow, "runtime", proto3);
_define_property(PricingSheetRegistryRow, "typeName", "mono.ryugu.v1.PricingSheetRegistryRow");
_define_property(PricingSheetRegistryRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "identifier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "detail",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "resolution_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ResolvePricingSheetBlockRequest
 */ export class ResolvePricingSheetBlockRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolvePricingSheetBlockRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolvePricingSheetBlockRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolvePricingSheetBlockRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolvePricingSheetBlockRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string item_id = 2;
   */ _define_property(this, "itemId", ""), /**
   * Accepted | Rejected | Waived | Corrected
   *
   * @generated from field: string resolution = 3;
   */ _define_property(this, "resolution", ""), /**
   * @generated from field: string note = 4;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolvePricingSheetBlockRequest, "runtime", proto3);
_define_property(ResolvePricingSheetBlockRequest, "typeName", "mono.ryugu.v1.ResolvePricingSheetBlockRequest");
_define_property(ResolvePricingSheetBlockRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "resolution",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ResolvePricingSheetBlockResponse
 */ export class ResolvePricingSheetBlockResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolvePricingSheetBlockResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolvePricingSheetBlockResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolvePricingSheetBlockResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolvePricingSheetBlockResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.PricingSheetBlock block = 1;
   */ _define_property(this, "block", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolvePricingSheetBlockResponse, "runtime", proto3);
_define_property(ResolvePricingSheetBlockResponse, "typeName", "mono.ryugu.v1.ResolvePricingSheetBlockResponse");
_define_property(ResolvePricingSheetBlockResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "block",
            kind: "message",
            T: PricingSheetBlock
        }
    ]));
/**
 * Empty strings leave the field as staged. Rate block fields apply to every
 * rate in the block; the axis fields apply to a PricingSheetMap reading item
 * (header mapping).
 *
 * @generated from message mono.ryugu.v1.CorrectPricingSheetBlockRequest
 */ export class CorrectPricingSheetBlockRequest extends Message {
    static fromBinary(bytes, options) {
        return new CorrectPricingSheetBlockRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CorrectPricingSheetBlockRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CorrectPricingSheetBlockRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CorrectPricingSheetBlockRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string item_id = 2;
   */ _define_property(this, "itemId", ""), /**
   * @generated from field: string note = 3;
   */ _define_property(this, "note", ""), /**
   * Resolve the company to an existing registry profile.
   *
   * @generated from field: string company_profile_id = 4;
   */ _define_property(this, "companyProfileId", ""), /**
   * Resolve a labor category: every rate whose staged title equals
   * lcat_title is bound to lcat_entry_id.
   *
   * @generated from field: string lcat_title = 5;
   */ _define_property(this, "lcatTitle", ""), /**
   * @generated from field: string lcat_entry_id = 6;
   */ _define_property(this, "lcatEntryId", ""), /**
   * @generated from field: string rate_unit = 7;
   */ _define_property(this, "rateUnit", ""), /**
   * @generated from field: string burden_basis = 8;
   */ _define_property(this, "burdenBasis", ""), /**
   * @generated from field: string period_label = 9;
   */ _define_property(this, "periodLabel", ""), /**
   * @generated from field: string period_start = 10;
   */ _define_property(this, "periodStart", ""), /**
   * @generated from field: string period_end = 11;
   */ _define_property(this, "periodEnd", ""), /**
   * Header mapping, for a reading item.
   *
   * @generated from field: string company_axis = 12;
   */ _define_property(this, "companyAxis", ""), /**
   * @generated from field: string period_axis = 13;
   */ _define_property(this, "periodAxis", ""), /**
   * @generated from field: string worksite_axis = 14;
   */ _define_property(this, "worksiteAxis", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CorrectPricingSheetBlockRequest, "runtime", proto3);
_define_property(CorrectPricingSheetBlockRequest, "typeName", "mono.ryugu.v1.CorrectPricingSheetBlockRequest");
_define_property(CorrectPricingSheetBlockRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "lcat_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "lcat_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "rate_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "burden_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "period_start",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "period_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "company_axis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "period_axis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "worksite_axis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CorrectPricingSheetBlockResponse
 */ export class CorrectPricingSheetBlockResponse extends Message {
    static fromBinary(bytes, options) {
        return new CorrectPricingSheetBlockResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CorrectPricingSheetBlockResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CorrectPricingSheetBlockResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CorrectPricingSheetBlockResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.PricingSheetBlock block = 1;
   */ _define_property(this, "block", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CorrectPricingSheetBlockResponse, "runtime", proto3);
_define_property(CorrectPricingSheetBlockResponse, "typeName", "mono.ryugu.v1.CorrectPricingSheetBlockResponse");
_define_property(CorrectPricingSheetBlockResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "block",
            kind: "message",
            T: PricingSheetBlock
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ApplyPricingSheetReviewRequest
 */ export class ApplyPricingSheetReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApplyPricingSheetReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyPricingSheetReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyPricingSheetReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyPricingSheetReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyPricingSheetReviewRequest, "runtime", proto3);
_define_property(ApplyPricingSheetReviewRequest, "typeName", "mono.ryugu.v1.ApplyPricingSheetReviewRequest");
_define_property(ApplyPricingSheetReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ApplyPricingSheetReviewResponse
 */ export class ApplyPricingSheetReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApplyPricingSheetReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyPricingSheetReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyPricingSheetReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyPricingSheetReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 applied_blocks = 1;
   */ _define_property(this, "appliedBlocks", 0), /**
   * @generated from field: int32 skipped_blocks = 2;
   */ _define_property(this, "skippedBlocks", 0), /**
   * Unsupported targets and undecodable values that were skipped rather than
   * failing the apply. Silence here would make a partial apply look total.
   *
   * @generated from field: repeated string warnings = 3;
   */ _define_property(this, "warnings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyPricingSheetReviewResponse, "runtime", proto3);
_define_property(ApplyPricingSheetReviewResponse, "typeName", "mono.ryugu.v1.ApplyPricingSheetReviewResponse");
_define_property(ApplyPricingSheetReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "applied_blocks",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "skipped_blocks",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListRateObservationsRequest
 */ export class ListRateObservationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRateObservationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRateObservationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRateObservationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRateObservationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * Empty entry id lists the tenant's whole book (Compare reads it that way).
   *
   * @generated from field: string lcat_entry_id = 2;
   */ _define_property(this, "lcatEntryId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string contract_vehicle_id = 4;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string observation_type = 5;
   */ _define_property(this, "observationType", ""), /**
   * @generated from field: string normalized_period_key = 6;
   */ _define_property(this, "normalizedPeriodKey", ""), /**
   * @generated from field: bool include_corrected = 7;
   */ _define_property(this, "includeCorrected", false), /**
   * When true and lcat_entry_id is set, spans the entry's VERSION CHAIN —
   * "every rate this labor category has ever carried".
   *
   * @generated from field: bool across_versions = 8;
   */ _define_property(this, "acrossVersions", false), /**
   * Pagination mirrors ListLaborCategoryEntries. Compare reads the whole
   * book, so an unbounded read is a latent problem once a tenant has real
   * data; the browser passes an explicit page size.
   *
   * @generated from field: int32 offset = 9;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 10;
   */ _define_property(this, "limit", 0), /**
   * Rate Book filters (SAD-446): exact match on the recorded unit / burden.
   *
   * @generated from field: string rate_unit = 11;
   */ _define_property(this, "rateUnit", ""), /**
   * @generated from field: string burden_basis = 12;
   */ _define_property(this, "burdenBasis", ""), /**
   * @generated from field: string anchor_id = 13;
   */ _define_property(this, "anchorId", ""), /**
   * @generated from field: repeated string relation_in = 14;
   */ _define_property(this, "relationIn", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRateObservationsRequest, "runtime", proto3);
_define_property(ListRateObservationsRequest, "typeName", "mono.ryugu.v1.ListRateObservationsRequest");
_define_property(ListRateObservationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "lcat_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "normalized_period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "include_corrected",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "across_versions",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 11,
            name: "rate_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "burden_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "relation_in",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListRateObservationsResponse
 */ export class ListRateObservationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRateObservationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRateObservationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRateObservationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRateObservationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.RateObservationProto observations = 1;
   */ _define_property(this, "observations", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRateObservationsResponse, "runtime", proto3);
_define_property(ListRateObservationsResponse, "typeName", "mono.ryugu.v1.ListRateObservationsResponse");
_define_property(ListRateObservationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "observations",
            kind: "message",
            T: RateObservationProto,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateRateObservationRequest
 */ export class CreateRateObservationRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateRateObservationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRateObservationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRateObservationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRateObservationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string lcat_entry_id = 2;
   */ _define_property(this, "lcatEntryId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string contract_vehicle_id = 4;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string program_id = 5;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string observation_type = 6;
   */ _define_property(this, "observationType", ""), /**
   * @generated from field: double amount = 7;
   */ _define_property(this, "amount", 0), /**
   * @generated from field: string rate_unit = 8;
   */ _define_property(this, "rateUnit", ""), /**
   * @generated from field: string burden_basis = 9;
   */ _define_property(this, "burdenBasis", ""), /**
   * Source text, kept verbatim. The coercion layer is derived server-side.
   *
   * @generated from field: string period_label = 10;
   */ _define_property(this, "periodLabel", ""), /**
   * @generated from field: google.protobuf.Timestamp period_start = 11;
   */ _define_property(this, "periodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp period_end = 12;
   */ _define_property(this, "periodEnd", void 0), /**
   * @generated from field: string period_kind = 13;
   */ _define_property(this, "periodKind", ""), /**
   * @generated from field: string worksite = 14;
   */ _define_property(this, "worksite", ""), /**
   * @generated from field: string locality = 15;
   */ _define_property(this, "locality", ""), /**
   * @generated from field: string source_document_id = 16;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * Where the number came from, in the recorder's words — a manual rate with
   * no document still deserves provenance ({"note":"quoted by their BD lead"}).
   *
   * @generated from field: string evidence_json = 17;
   */ _define_property(this, "evidenceJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRateObservationRequest, "runtime", proto3);
_define_property(CreateRateObservationRequest, "typeName", "mono.ryugu.v1.CreateRateObservationRequest");
_define_property(CreateRateObservationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "lcat_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "rate_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "burden_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "period_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "worksite",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "locality",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "evidence_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateRateObservationResponse
 */ export class CreateRateObservationResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateRateObservationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRateObservationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRateObservationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRateObservationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.RateObservationProto observation = 1;
   */ _define_property(this, "observation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRateObservationResponse, "runtime", proto3);
_define_property(CreateRateObservationResponse, "typeName", "mono.ryugu.v1.CreateRateObservationResponse");
_define_property(CreateRateObservationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "observation",
            kind: "message",
            T: RateObservationProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CorrectRateObservationRequest
 */ export class CorrectRateObservationRequest extends Message {
    static fromBinary(bytes, options) {
        return new CorrectRateObservationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CorrectRateObservationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CorrectRateObservationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CorrectRateObservationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string corrects_id = 2;
   */ _define_property(this, "correctsId", ""), /**
   * @generated from field: double amount = 3;
   */ _define_property(this, "amount", 0), /**
   * Optional measurement restatements; observation_type may never change.
   *
   * @generated from field: string rate_unit = 4;
   */ _define_property(this, "rateUnit", ""), /**
   * @generated from field: string burden_basis = 5;
   */ _define_property(this, "burdenBasis", ""), /**
   * @generated from field: string reason = 6;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CorrectRateObservationRequest, "runtime", proto3);
_define_property(CorrectRateObservationRequest, "typeName", "mono.ryugu.v1.CorrectRateObservationRequest");
_define_property(CorrectRateObservationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "corrects_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "rate_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "burden_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CorrectRateObservationResponse
 */ export class CorrectRateObservationResponse extends Message {
    static fromBinary(bytes, options) {
        return new CorrectRateObservationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CorrectRateObservationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CorrectRateObservationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CorrectRateObservationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.RateObservationProto observation = 1;
   */ _define_property(this, "observation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CorrectRateObservationResponse, "runtime", proto3);
_define_property(CorrectRateObservationResponse, "typeName", "mono.ryugu.v1.CorrectRateObservationResponse");
_define_property(CorrectRateObservationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "observation",
            kind: "message",
            T: RateObservationProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteRateObservationRequest
 */ export class DeleteRateObservationRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteRateObservationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteRateObservationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteRateObservationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteRateObservationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: mono.ryugu.v1.CreateRateObservationRequest replacement = 4;
   */ _define_property(this, "replacement", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteRateObservationRequest, "runtime", proto3);
_define_property(DeleteRateObservationRequest, "typeName", "mono.ryugu.v1.DeleteRateObservationRequest");
_define_property(DeleteRateObservationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "replacement",
            kind: "message",
            T: CreateRateObservationRequest
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteRateObservationResponse
 */ export class DeleteRateObservationResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteRateObservationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteRateObservationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteRateObservationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteRateObservationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.RateObservationProto replacement = 1;
   */ _define_property(this, "replacement", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteRateObservationResponse, "runtime", proto3);
_define_property(DeleteRateObservationResponse, "typeName", "mono.ryugu.v1.DeleteRateObservationResponse");
_define_property(DeleteRateObservationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "replacement",
            kind: "message",
            T: RateObservationProto
        }
    ]));
/**
 * SAD-451 RATE-07: a Proposal pricing input's version-pinned pick of rate evidence.
 *
 * @generated from message mono.ryugu.v1.RateSelectionProto
 */ export class RateSelectionProto extends Message {
    static fromBinary(bytes, options) {
        return new RateSelectionProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateSelectionProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateSelectionProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateSelectionProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string consumer_id = 2;
   */ _define_property(this, "consumerId", ""), /**
   * @generated from field: string consumer_ref = 3;
   */ _define_property(this, "consumerRef", ""), /**
   * @generated from field: string observation_id = 4;
   */ _define_property(this, "observationId", ""), /**
   * @generated from field: int32 observation_version = 5;
   */ _define_property(this, "observationVersion", 0), /**
   * @generated from field: double observation_amount = 6;
   */ _define_property(this, "observationAmount", 0), /**
   * @generated from field: double selected_amount = 7;
   */ _define_property(this, "selectedAmount", 0), /**
   * @generated from field: string applicability_json = 8;
   */ _define_property(this, "applicabilityJson", ""), /**
   * @generated from field: string assumptions_json = 9;
   */ _define_property(this, "assumptionsJson", ""), /**
   * "" | CORRECTED | INVALIDATED | NEWER_EVIDENCE — an offer to review, never a change.
   *
   * @generated from field: string review_status = 10;
   */ _define_property(this, "reviewStatus", ""), /**
   * @generated from field: string review_candidate_id = 11;
   */ _define_property(this, "reviewCandidateId", ""), /**
   * @generated from field: double review_candidate_amount = 12;
   */ _define_property(this, "reviewCandidateAmount", 0), /**
   * @generated from field: int32 review_candidate_version = 13;
   */ _define_property(this, "reviewCandidateVersion", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateSelectionProto, "runtime", proto3);
_define_property(RateSelectionProto, "typeName", "mono.ryugu.v1.RateSelectionProto");
_define_property(RateSelectionProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "consumer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "consumer_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "observation_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "observation_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "selected_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "applicability_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "assumptions_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "review_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "review_candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "review_candidate_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 13,
            name: "review_candidate_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SelectRateObservationRequest
 */ export class SelectRateObservationRequest extends Message {
    static fromBinary(bytes, options) {
        return new SelectRateObservationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SelectRateObservationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SelectRateObservationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SelectRateObservationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * proposal pricing scenario id
   *
   * @generated from field: string consumer_id = 2;
   */ _define_property(this, "consumerId", ""), /**
   * "{categoryId}@{periodKey}"; a bare "{categoryId}" means "@base".
   *
   * @generated from field: string consumer_ref = 3;
   */ _define_property(this, "consumerRef", ""), /**
   * @generated from field: string observation_id = 4;
   */ _define_property(this, "observationId", ""), /**
   * 0 = take the observation's amount
   *
   * @generated from field: double selected_amount = 5;
   */ _define_property(this, "selectedAmount", 0), /**
   * @generated from field: string assumptions_json = 6;
   */ _define_property(this, "assumptionsJson", ""), /**
   * optional applicability context
   *
   * @generated from field: string registry_contract_id = 7;
   */ _define_property(this, "registryContractId", ""), /**
   * the proposal project; zou checks consumer_id belongs to it
   *
   * @generated from field: string project_id = 8;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SelectRateObservationRequest, "runtime", proto3);
_define_property(SelectRateObservationRequest, "typeName", "mono.ryugu.v1.SelectRateObservationRequest");
_define_property(SelectRateObservationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "consumer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "consumer_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "selected_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "assumptions_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "registry_contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SelectRateObservationResponse
 */ export class SelectRateObservationResponse extends Message {
    static fromBinary(bytes, options) {
        return new SelectRateObservationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SelectRateObservationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SelectRateObservationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SelectRateObservationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.RateSelectionProto selection = 1;
   */ _define_property(this, "selection", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SelectRateObservationResponse, "runtime", proto3);
_define_property(SelectRateObservationResponse, "typeName", "mono.ryugu.v1.SelectRateObservationResponse");
_define_property(SelectRateObservationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "selection",
            kind: "message",
            T: RateSelectionProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListRateSelectionsRequest
 */ export class ListRateSelectionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRateSelectionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRateSelectionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRateSelectionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRateSelectionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * required: the pricing scenario id
   *
   * @generated from field: string consumer_id = 2;
   */ _define_property(this, "consumerId", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRateSelectionsRequest, "runtime", proto3);
_define_property(ListRateSelectionsRequest, "typeName", "mono.ryugu.v1.ListRateSelectionsRequest");
_define_property(ListRateSelectionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "consumer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListRateSelectionsResponse
 */ export class ListRateSelectionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRateSelectionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRateSelectionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRateSelectionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRateSelectionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.RateSelectionProto selections = 1;
   */ _define_property(this, "selections", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRateSelectionsResponse, "runtime", proto3);
_define_property(ListRateSelectionsResponse, "typeName", "mono.ryugu.v1.ListRateSelectionsResponse");
_define_property(ListRateSelectionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "selections",
            kind: "message",
            T: RateSelectionProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AcknowledgeRateSelectionReviewRequest
 */ export class AcknowledgeRateSelectionReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new AcknowledgeRateSelectionReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcknowledgeRateSelectionReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcknowledgeRateSelectionReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcknowledgeRateSelectionReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string selection_id = 2;
   */ _define_property(this, "selectionId", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", ""), /**
   * the pricing scenario id the selection belongs to
   *
   * @generated from field: string consumer_id = 4;
   */ _define_property(this, "consumerId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcknowledgeRateSelectionReviewRequest, "runtime", proto3);
_define_property(AcknowledgeRateSelectionReviewRequest, "typeName", "mono.ryugu.v1.AcknowledgeRateSelectionReviewRequest");
_define_property(AcknowledgeRateSelectionReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "selection_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "consumer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AcknowledgeRateSelectionReviewResponse
 */ export class AcknowledgeRateSelectionReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new AcknowledgeRateSelectionReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcknowledgeRateSelectionReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcknowledgeRateSelectionReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcknowledgeRateSelectionReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.RateSelectionProto selection = 1;
   */ _define_property(this, "selection", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcknowledgeRateSelectionReviewResponse, "runtime", proto3);
_define_property(AcknowledgeRateSelectionReviewResponse, "typeName", "mono.ryugu.v1.AcknowledgeRateSelectionReviewResponse");
_define_property(AcknowledgeRateSelectionReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "selection",
            kind: "message",
            T: RateSelectionProto
        }
    ]));
/**
 * CapabilityProto is a company-wide catalog entry (e.g. "Cyber Security") that a
 * program's capabilities are picked from — the same registry shape as a Contact.
 *
 * @generated from message mono.ryugu.v1.CapabilityProto
 */ export class CapabilityProto extends Message {
    static fromBinary(bytes, options) {
        return new CapabilityProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapabilityProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapabilityProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapabilityProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */ _define_property(this, "updatedAt", void 0), /**
   * System-seeded default (the 6 Sprezz capabilities): read-only, cannot be
   * edited or deleted by a tenant.
   *
   * @generated from field: bool is_system = 7;
   */ _define_property(this, "isSystem", false), /**
   * Retired for this tenant: hidden from new selections, kept on existing programs.
   *
   * @generated from field: google.protobuf.Timestamp retired_at = 8;
   */ _define_property(this, "retiredAt", void 0), /**
   * @generated from field: bool is_retired = 9;
   */ _define_property(this, "isRetired", false), /**
   * @generated from field: string category = 10;
   */ _define_property(this, "category", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapabilityProto, "runtime", proto3);
_define_property(CapabilityProto, "typeName", "mono.ryugu.v1.CapabilityProto");
_define_property(CapabilityProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "is_system",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "retired_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "is_retired",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCapabilitiesRequest
 */ export class ListCapabilitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCapabilitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapabilitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapabilitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapabilitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * optional name search
   *
   * @generated from field: string search = 2;
   */ _define_property(this, "search", ""), /**
   * @generated from field: bool include_retired = 3;
   */ _define_property(this, "includeRetired", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapabilitiesRequest, "runtime", proto3);
_define_property(ListCapabilitiesRequest, "typeName", "mono.ryugu.v1.ListCapabilitiesRequest");
_define_property(ListCapabilitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "include_retired",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCapabilitiesResponse
 */ export class ListCapabilitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCapabilitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapabilitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapabilitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapabilitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.CapabilityProto capabilities = 1;
   */ _define_property(this, "capabilities", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapabilitiesResponse, "runtime", proto3);
_define_property(ListCapabilitiesResponse, "typeName", "mono.ryugu.v1.ListCapabilitiesResponse");
_define_property(ListCapabilitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capabilities",
            kind: "message",
            T: CapabilityProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertCapabilityRequest
 */ export class UpsertCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: optional string category = 5;
   */ _define_property(this, "category", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCapabilityRequest, "runtime", proto3);
_define_property(UpsertCapabilityRequest, "typeName", "mono.ryugu.v1.UpsertCapabilityRequest");
_define_property(UpsertCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertCapabilityResponse
 */ export class UpsertCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCapabilityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CapabilityProto capability = 1;
   */ _define_property(this, "capability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCapabilityResponse, "runtime", proto3);
_define_property(UpsertCapabilityResponse, "typeName", "mono.ryugu.v1.UpsertCapabilityResponse");
_define_property(UpsertCapabilityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability",
            kind: "message",
            T: CapabilityProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteCapabilityRequest
 */ export class DeleteCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCapabilityRequest, "runtime", proto3);
_define_property(DeleteCapabilityRequest, "typeName", "mono.ryugu.v1.DeleteCapabilityRequest");
_define_property(DeleteCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteCapabilityResponse
 */ export class DeleteCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCapabilityResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCapabilityResponse, "runtime", proto3);
_define_property(DeleteCapabilityResponse, "typeName", "mono.ryugu.v1.DeleteCapabilityResponse");
_define_property(DeleteCapabilityResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.RetireCapabilityRequest
 */ export class RetireCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new RetireCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetireCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetireCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetireCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetireCapabilityRequest, "runtime", proto3);
_define_property(RetireCapabilityRequest, "typeName", "mono.ryugu.v1.RetireCapabilityRequest");
_define_property(RetireCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RetireCapabilityResponse
 */ export class RetireCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new RetireCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetireCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetireCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetireCapabilityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CapabilityProto capability = 1;
   */ _define_property(this, "capability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetireCapabilityResponse, "runtime", proto3);
_define_property(RetireCapabilityResponse, "typeName", "mono.ryugu.v1.RetireCapabilityResponse");
_define_property(RetireCapabilityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability",
            kind: "message",
            T: CapabilityProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ReactivateCapabilityRequest
 */ export class ReactivateCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReactivateCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReactivateCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReactivateCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReactivateCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReactivateCapabilityRequest, "runtime", proto3);
_define_property(ReactivateCapabilityRequest, "typeName", "mono.ryugu.v1.ReactivateCapabilityRequest");
_define_property(ReactivateCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ReactivateCapabilityResponse
 */ export class ReactivateCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReactivateCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReactivateCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReactivateCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReactivateCapabilityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CapabilityProto capability = 1;
   */ _define_property(this, "capability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReactivateCapabilityResponse, "runtime", proto3);
_define_property(ReactivateCapabilityResponse, "typeName", "mono.ryugu.v1.ReactivateCapabilityResponse");
_define_property(ReactivateCapabilityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability",
            kind: "message",
            T: CapabilityProto
        }
    ]));
/**
 * Program Contact Assignments (junction: program × contact)
 *
 * @generated from message mono.ryugu.v1.ProgramContactProto
 */ export class ProgramContactProto extends Message {
    static fromBinary(bytes, options) {
        return new ProgramContactProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramContactProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramContactProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramContactProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string contact_id = 3;
   */ _define_property(this, "contactId", ""), /**
   * CO, COR, CS, PM, Alternate COR, Administrative CO, Other
   *
   * @generated from field: string role = 4;
   */ _define_property(this, "role", ""), /**
   * Denormalized from Contact for convenience
   *
   * @generated from field: string contact_name = 5;
   */ _define_property(this, "contactName", ""), /**
   * @generated from field: string contact_email = 6;
   */ _define_property(this, "contactEmail", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string customer_poc_role_id = 9;
   */ _define_property(this, "customerPocRoleId", ""), /**
   * @generated from field: string customer_poc_role_label = 10;
   */ _define_property(this, "customerPocRoleLabel", ""), /**
   * @generated from field: string contact_phone = 11;
   */ _define_property(this, "contactPhone", ""), /**
   * @generated from field: string contact_type = 12;
   */ _define_property(this, "contactType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramContactProto, "runtime", proto3);
_define_property(ProgramContactProto, "typeName", "mono.ryugu.v1.ProgramContactProto");
_define_property(ProgramContactProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contact_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contact_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "customer_poc_role_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "customer_poc_role_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "contact_phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "contact_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramContactsRequest
 */ export class ListProgramContactsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramContactsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramContactsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramContactsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramContactsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * Optional filter; empty means no filtering by contact type.
   *
   * @generated from field: string contact_type = 2;
   */ _define_property(this, "contactType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramContactsRequest, "runtime", proto3);
_define_property(ListProgramContactsRequest, "typeName", "mono.ryugu.v1.ListProgramContactsRequest");
_define_property(ListProgramContactsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramContactsResponse
 */ export class ListProgramContactsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramContactsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramContactsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramContactsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramContactsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ProgramContactProto contacts = 1;
   */ _define_property(this, "contacts", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramContactsResponse, "runtime", proto3);
_define_property(ListProgramContactsResponse, "typeName", "mono.ryugu.v1.ListProgramContactsResponse");
_define_property(ListProgramContactsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contacts",
            kind: "message",
            T: ProgramContactProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertProgramContactRequest
 */ export class UpsertProgramContactRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramContactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramContactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramContactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramContactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string contact_id = 3;
   */ _define_property(this, "contactId", ""), /**
   * legacy; use customer_poc_role_id
   *
   * @generated from field: string role = 4;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string customer_poc_role_id = 5;
   */ _define_property(this, "customerPocRoleId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramContactRequest, "runtime", proto3);
_define_property(UpsertProgramContactRequest, "typeName", "mono.ryugu.v1.UpsertProgramContactRequest");
_define_property(UpsertProgramContactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "customer_poc_role_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertProgramContactResponse
 */ export class UpsertProgramContactResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramContactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramContactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramContactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramContactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ProgramContactProto contact = 1;
   */ _define_property(this, "contact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramContactResponse, "runtime", proto3);
_define_property(UpsertProgramContactResponse, "typeName", "mono.ryugu.v1.UpsertProgramContactResponse");
_define_property(UpsertProgramContactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact",
            kind: "message",
            T: ProgramContactProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteProgramContactRequest
 */ export class DeleteProgramContactRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramContactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramContactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramContactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramContactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramContactRequest, "runtime", proto3);
_define_property(DeleteProgramContactRequest, "typeName", "mono.ryugu.v1.DeleteProgramContactRequest");
_define_property(DeleteProgramContactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteProgramContactResponse
 */ export class DeleteProgramContactResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramContactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramContactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramContactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramContactResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramContactResponse, "runtime", proto3);
_define_property(DeleteProgramContactResponse, "typeName", "mono.ryugu.v1.DeleteProgramContactResponse");
_define_property(DeleteProgramContactResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.ContractVehicleProto
 */ export class ContractVehicleProto extends Message {
    static fromBinary(bytes, options) {
        return new ContractVehicleProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractVehicleProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractVehicleProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractVehicleProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * GSA_SCHEDULE, GWAC, BPA, IDIQ, MAC, OTHER
   *
   * @generated from field: string vehicle_type = 4;
   */ _define_property(this, "vehicleType", ""), /**
   * @generated from field: string contract_number = 5;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string description = 8;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string agency_acronym = 9;
   */ _define_property(this, "agencyAcronym", ""), /**
   * ACTIVE, INACTIVE
   *
   * @generated from field: string status = 10;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string seed_key = 11;
   */ _define_property(this, "seedKey", ""), /**
   * @generated from field: bool is_system_seed = 12;
   */ _define_property(this, "isSystemSeed", false), /**
   * @generated from field: string notes = 13;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string full_name = 14;
   */ _define_property(this, "fullName", ""), /**
   * GOVERNMENT_WIDE|AGENCY_SPECIFIC|UNKNOWN (empty = UNKNOWN)
   *
   * @generated from field: string ordering_eligibility = 15;
   */ _define_property(this, "orderingEligibility", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractVehicleProto, "runtime", proto3);
_define_property(ContractVehicleProto, "typeName", "mono.ryugu.v1.ContractVehicleProto");
_define_property(ContractVehicleProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "vehicle_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "agency_acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "seed_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "is_system_seed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "full_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "ordering_eligibility",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListContractVehiclesRequest
 */ export class ListContractVehiclesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListContractVehiclesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContractVehiclesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContractVehiclesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContractVehiclesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContractVehiclesRequest, "runtime", proto3);
_define_property(ListContractVehiclesRequest, "typeName", "mono.ryugu.v1.ListContractVehiclesRequest");
_define_property(ListContractVehiclesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListContractVehiclesResponse
 */ export class ListContractVehiclesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListContractVehiclesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContractVehiclesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContractVehiclesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContractVehiclesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ContractVehicleProto vehicles = 1;
   */ _define_property(this, "vehicles", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContractVehiclesResponse, "runtime", proto3);
_define_property(ListContractVehiclesResponse, "typeName", "mono.ryugu.v1.ListContractVehiclesResponse");
_define_property(ListContractVehiclesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicles",
            kind: "message",
            T: ContractVehicleProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertContractVehicleRequest
 */ export class UpsertContractVehicleRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertContractVehicleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertContractVehicleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertContractVehicleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertContractVehicleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string vehicle_type = 4;
   */ _define_property(this, "vehicleType", ""), /**
   * @generated from field: string contract_number = 5;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string agency_acronym = 7;
   */ _define_property(this, "agencyAcronym", ""), /**
   * @generated from field: string status = 8;
   */ _define_property(this, "status", ""), /**
   * @generated from field: optional string full_name = 9;
   */ _define_property(this, "fullName", void 0), /**
   * @generated from field: optional string ordering_eligibility = 10;
   */ _define_property(this, "orderingEligibility", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertContractVehicleRequest, "runtime", proto3);
_define_property(UpsertContractVehicleRequest, "typeName", "mono.ryugu.v1.UpsertContractVehicleRequest");
_define_property(UpsertContractVehicleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "vehicle_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "agency_acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "full_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 10,
            name: "ordering_eligibility",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertContractVehicleResponse
 */ export class UpsertContractVehicleResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertContractVehicleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertContractVehicleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertContractVehicleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertContractVehicleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ContractVehicleProto vehicle = 1;
   */ _define_property(this, "vehicle", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertContractVehicleResponse, "runtime", proto3);
_define_property(UpsertContractVehicleResponse, "typeName", "mono.ryugu.v1.UpsertContractVehicleResponse");
_define_property(UpsertContractVehicleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicle",
            kind: "message",
            T: ContractVehicleProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteContractVehicleRequest
 */ export class DeleteContractVehicleRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteContractVehicleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteContractVehicleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteContractVehicleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteContractVehicleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteContractVehicleRequest, "runtime", proto3);
_define_property(DeleteContractVehicleRequest, "typeName", "mono.ryugu.v1.DeleteContractVehicleRequest");
_define_property(DeleteContractVehicleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteContractVehicleResponse
 */ export class DeleteContractVehicleResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteContractVehicleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteContractVehicleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteContractVehicleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteContractVehicleResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteContractVehicleResponse, "runtime", proto3);
_define_property(DeleteContractVehicleResponse, "typeName", "mono.ryugu.v1.DeleteContractVehicleResponse");
_define_property(DeleteContractVehicleResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.PeriodOfPerformanceProto
 */ export class PeriodOfPerformanceProto extends Message {
    static fromBinary(bytes, options) {
        return new PeriodOfPerformanceProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PeriodOfPerformanceProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PeriodOfPerformanceProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PeriodOfPerformanceProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string period_name = 3;
   */ _define_property(this, "periodName", ""), /**
   * base, option_period
   *
   * @generated from field: string period_type = 4;
   */ _define_property(this, "periodType", ""), /**
   * @generated from field: int32 option_number = 5;
   */ _define_property(this, "optionNumber", 0), /**
   * @generated from field: bool exercised = 6;
   */ _define_property(this, "exercised", false), /**
   * @generated from field: google.protobuf.Timestamp start_date = 7;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 8;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: double funded_amount = 9;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double total_amount = 10;
   */ _define_property(this, "totalAmount", 0), /**
   * @generated from field: int32 sort_order = 11;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 13;
   */ _define_property(this, "updatedAt", void 0), /**
   * Read-only source presence: absent is legacy; false is unknown; true includes zero.
   *
   * @generated from field: optional bool funded_amount_known = 14;
   */ _define_property(this, "fundedAmountKnown", void 0), /**
   * @generated from field: optional bool total_amount_known = 15;
   */ _define_property(this, "totalAmountKnown", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PeriodOfPerformanceProto, "runtime", proto3);
_define_property(PeriodOfPerformanceProto, "typeName", "mono.ryugu.v1.PeriodOfPerformanceProto");
_define_property(PeriodOfPerformanceProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "period_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "option_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "exercised",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "total_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "funded_amount_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 15,
            name: "total_amount_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListPeriodsOfPerformanceRequest
 */ export class ListPeriodsOfPerformanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPeriodsOfPerformanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPeriodsOfPerformanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPeriodsOfPerformanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPeriodsOfPerformanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPeriodsOfPerformanceRequest, "runtime", proto3);
_define_property(ListPeriodsOfPerformanceRequest, "typeName", "mono.ryugu.v1.ListPeriodsOfPerformanceRequest");
_define_property(ListPeriodsOfPerformanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListPeriodsOfPerformanceResponse
 */ export class ListPeriodsOfPerformanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPeriodsOfPerformanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPeriodsOfPerformanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPeriodsOfPerformanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPeriodsOfPerformanceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.PeriodOfPerformanceProto periods = 1;
   */ _define_property(this, "periods", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPeriodsOfPerformanceResponse, "runtime", proto3);
_define_property(ListPeriodsOfPerformanceResponse, "typeName", "mono.ryugu.v1.ListPeriodsOfPerformanceResponse");
_define_property(ListPeriodsOfPerformanceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "periods",
            kind: "message",
            T: PeriodOfPerformanceProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertPeriodOfPerformanceRequest
 */ export class UpsertPeriodOfPerformanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertPeriodOfPerformanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertPeriodOfPerformanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertPeriodOfPerformanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertPeriodOfPerformanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string period_name = 3;
   */ _define_property(this, "periodName", ""), /**
   * @generated from field: string period_type = 4;
   */ _define_property(this, "periodType", ""), /**
   * @generated from field: int32 option_number = 5;
   */ _define_property(this, "optionNumber", 0), /**
   * @generated from field: bool exercised = 6;
   */ _define_property(this, "exercised", false), /**
   * @generated from field: google.protobuf.Timestamp start_date = 7;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 8;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: double funded_amount = 9;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double total_amount = 10;
   */ _define_property(this, "totalAmount", 0), /**
   * @generated from field: int32 sort_order = 11;
   */ _define_property(this, "sortOrder", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertPeriodOfPerformanceRequest, "runtime", proto3);
_define_property(UpsertPeriodOfPerformanceRequest, "typeName", "mono.ryugu.v1.UpsertPeriodOfPerformanceRequest");
_define_property(UpsertPeriodOfPerformanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "period_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "option_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "exercised",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "total_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertPeriodOfPerformanceResponse
 */ export class UpsertPeriodOfPerformanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertPeriodOfPerformanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertPeriodOfPerformanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertPeriodOfPerformanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertPeriodOfPerformanceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.PeriodOfPerformanceProto period = 1;
   */ _define_property(this, "period", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertPeriodOfPerformanceResponse, "runtime", proto3);
_define_property(UpsertPeriodOfPerformanceResponse, "typeName", "mono.ryugu.v1.UpsertPeriodOfPerformanceResponse");
_define_property(UpsertPeriodOfPerformanceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "period",
            kind: "message",
            T: PeriodOfPerformanceProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeletePeriodOfPerformanceRequest
 */ export class DeletePeriodOfPerformanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeletePeriodOfPerformanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePeriodOfPerformanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePeriodOfPerformanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePeriodOfPerformanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeletePeriodOfPerformanceRequest, "runtime", proto3);
_define_property(DeletePeriodOfPerformanceRequest, "typeName", "mono.ryugu.v1.DeletePeriodOfPerformanceRequest");
_define_property(DeletePeriodOfPerformanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeletePeriodOfPerformanceResponse
 */ export class DeletePeriodOfPerformanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeletePeriodOfPerformanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePeriodOfPerformanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePeriodOfPerformanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePeriodOfPerformanceResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeletePeriodOfPerformanceResponse, "runtime", proto3);
_define_property(DeletePeriodOfPerformanceResponse, "typeName", "mono.ryugu.v1.DeletePeriodOfPerformanceResponse");
_define_property(DeletePeriodOfPerformanceResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.OptionalTaskProto
 */ export class OptionalTaskProto extends Message {
    static fromBinary(bytes, options) {
        return new OptionalTaskProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OptionalTaskProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OptionalTaskProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OptionalTaskProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: int32 task_number = 4;
   */ _define_property(this, "taskNumber", 0), /**
   * Denormalization of count(live exercises) > 0 — maintained by the exercise
   * create/delete paths; still writable via Upsert for wire-compat.
   *
   * @generated from field: bool exercised = 5;
   */ _define_property(this, "exercised", false), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", ""), /**
   * @generated from field: double funded_amount = 7;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double total_amount = 8;
   */ _define_property(this, "totalAmount", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * JSON []string
   *
   * @generated from field: string pws_sections = 11;
   */ _define_property(this, "pwsSections", ""), /**
   * @generated from field: string clin_number = 12;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string pricing_type = 13;
   */ _define_property(this, "pricingType", ""), /**
   * Complete extracted requirement/source text this task was derived from --
   * preserved verbatim so the concise `name` never destroys provenance.
   *
   * @generated from field: string requirement_text = 14;
   */ _define_property(this, "requirementText", ""), /**
   * not_exercised / exercised / completed. Additive to `exercised`.
   *
   * @generated from field: string status = 15;
   */ _define_property(this, "status", ""), /**
   * Read-only source presence: absent is legacy; false is unknown; true includes zero.
   *
   * @generated from field: optional bool funded_amount_known = 16;
   */ _define_property(this, "fundedAmountKnown", void 0), /**
   * @generated from field: optional bool total_amount_known = 17;
   */ _define_property(this, "totalAmountKnown", void 0), /**
   * The stated exercise cap ("may be exercised up to N times", K9c-1c), read
   * only: documents set it and modifications move it. max_exercises_known
   * false means no document states one; true includes a stated 0.
   *
   * @generated from field: int32 max_exercises = 18;
   */ _define_property(this, "maxExercises", 0), /**
   * @generated from field: optional bool max_exercises_known = 19;
   */ _define_property(this, "maxExercisesKnown", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OptionalTaskProto, "runtime", proto3);
_define_property(OptionalTaskProto, "typeName", "mono.ryugu.v1.OptionalTaskProto");
_define_property(OptionalTaskProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "task_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "exercised",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "total_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "pws_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "pricing_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "requirement_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "funded_amount_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 17,
            name: "total_amount_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 18,
            name: "max_exercises",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 19,
            name: "max_exercises_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListOptionalTasksRequest
 */ export class ListOptionalTasksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOptionalTasksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOptionalTasksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOptionalTasksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOptionalTasksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOptionalTasksRequest, "runtime", proto3);
_define_property(ListOptionalTasksRequest, "typeName", "mono.ryugu.v1.ListOptionalTasksRequest");
_define_property(ListOptionalTasksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListOptionalTasksResponse
 */ export class ListOptionalTasksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOptionalTasksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOptionalTasksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOptionalTasksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOptionalTasksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.OptionalTaskProto tasks = 1;
   */ _define_property(this, "tasks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOptionalTasksResponse, "runtime", proto3);
_define_property(ListOptionalTasksResponse, "typeName", "mono.ryugu.v1.ListOptionalTasksResponse");
_define_property(ListOptionalTasksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tasks",
            kind: "message",
            T: OptionalTaskProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertOptionalTaskRequest
 */ export class UpsertOptionalTaskRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertOptionalTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertOptionalTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertOptionalTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertOptionalTaskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: int32 task_number = 4;
   */ _define_property(this, "taskNumber", 0), /**
   * @generated from field: bool exercised = 5;
   */ _define_property(this, "exercised", false), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", ""), /**
   * @generated from field: double funded_amount = 7;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double total_amount = 8;
   */ _define_property(this, "totalAmount", 0), /**
   * JSON []string
   *
   * @generated from field: string pws_sections = 9;
   */ _define_property(this, "pwsSections", ""), /**
   * Manual entry/correction fallback for when extraction is missing or wrong.
   *
   * @generated from field: string requirement_text = 10;
   */ _define_property(this, "requirementText", ""), /**
   * @generated from field: string status = 11;
   */ _define_property(this, "status", ""), /**
   * The task's CLIN family and contract type. Empty keeps the stored value,
   * as requirement_text and status do.
   *
   * @generated from field: string clin_number = 12;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string pricing_type = 13;
   */ _define_property(this, "pricingType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertOptionalTaskRequest, "runtime", proto3);
_define_property(UpsertOptionalTaskRequest, "typeName", "mono.ryugu.v1.UpsertOptionalTaskRequest");
_define_property(UpsertOptionalTaskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "task_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "exercised",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "total_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "pws_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "requirement_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "pricing_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertOptionalTaskResponse
 */ export class UpsertOptionalTaskResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertOptionalTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertOptionalTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertOptionalTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertOptionalTaskResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.OptionalTaskProto task = 1;
   */ _define_property(this, "task", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertOptionalTaskResponse, "runtime", proto3);
_define_property(UpsertOptionalTaskResponse, "typeName", "mono.ryugu.v1.UpsertOptionalTaskResponse");
_define_property(UpsertOptionalTaskResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "task",
            kind: "message",
            T: OptionalTaskProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteOptionalTaskRequest
 */ export class DeleteOptionalTaskRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteOptionalTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteOptionalTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteOptionalTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteOptionalTaskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteOptionalTaskRequest, "runtime", proto3);
_define_property(DeleteOptionalTaskRequest, "typeName", "mono.ryugu.v1.DeleteOptionalTaskRequest");
_define_property(DeleteOptionalTaskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteOptionalTaskResponse
 */ export class DeleteOptionalTaskResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteOptionalTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteOptionalTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteOptionalTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteOptionalTaskResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteOptionalTaskResponse, "runtime", proto3);
_define_property(DeleteOptionalTaskResponse, "typeName", "mono.ryugu.v1.DeleteOptionalTaskResponse");
_define_property(DeleteOptionalTaskResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * One exercise event on an optional task (SDS: each time the task is
 * exercised — how much, at what cost, with a description). A chronological
 * ledger: List returns exercised_at ASC.
 *
 * @generated from message mono.ryugu.v1.OptionalTaskExerciseProto
 */ export class OptionalTaskExerciseProto extends Message {
    static fromBinary(bytes, options) {
        return new OptionalTaskExerciseProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OptionalTaskExerciseProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OptionalTaskExerciseProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OptionalTaskExerciseProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string optional_task_id = 2;
   */ _define_property(this, "optionalTaskId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: double amount_exercised = 4;
   */ _define_property(this, "amountExercised", 0), /**
   * @generated from field: double cost = 5;
   */ _define_property(this, "cost", 0), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", ""), /**
   * @generated from field: google.protobuf.Timestamp exercised_at = 7;
   */ _define_property(this, "exercisedAt", void 0), /**
   * Set when a contract modification's apply created this exercise.
   *
   * @generated from field: string change_set_id = 8;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string created_by = 9;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * Terms at exercise time (from the exercising SLIN when mod-driven).
   *
   * @generated from field: string clin_number = 11;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string pricing_type = 12;
   */ _define_property(this, "pricingType", ""), /**
   * @generated from field: double quantity = 13;
   */ _define_property(this, "quantity", 0), /**
   * @generated from field: double unit_price = 14;
   */ _define_property(this, "unitPrice", 0), /**
   * Period of performance for this exercised instance (from the exercising
   * SLIN when mod-driven). Unset when the SLIN carried no parseable date.
   *
   * @generated from field: google.protobuf.Timestamp pop_start_date = 15;
   */ _define_property(this, "popStartDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp pop_end_date = 16;
   */ _define_property(this, "popEndDate", void 0), /**
   * SAD-151: the SLINs that contributed to this (possibly collapsed) exercise
   * -- itemises each contributing SLIN's own clin_number, funded amount, and
   * terms so the Exercise History card can show the real per-SLIN breakdown.
   *
   * @generated from field: repeated mono.ryugu.v1.OptionalTaskExerciseSlinProto contributing_slins = 17;
   */ _define_property(this, "contributingSlins", []), /**
   * Read-only canonical storage presence: true means NULL, false means a
   * stored value (including zero). Absent means presence is unknown from a
   * legacy server. These markers do not affect writes or certify money roles.
   *
   * @generated from field: optional bool amount_exercised_is_null = 18;
   */ _define_property(this, "amountExercisedIsNull", void 0), /**
   * @generated from field: optional bool cost_is_null = 19;
   */ _define_property(this, "costIsNull", void 0), /**
   * @generated from field: optional bool quantity_is_null = 20;
   */ _define_property(this, "quantityIsNull", void 0), /**
   * @generated from field: optional bool unit_price_is_null = 21;
   */ _define_property(this, "unitPriceIsNull", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OptionalTaskExerciseProto, "runtime", proto3);
_define_property(OptionalTaskExerciseProto, "typeName", "mono.ryugu.v1.OptionalTaskExerciseProto");
_define_property(OptionalTaskExerciseProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "optional_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "amount_exercised",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "exercised_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "pricing_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "quantity",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 14,
            name: "unit_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 15,
            name: "pop_start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "pop_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "contributing_slins",
            kind: "message",
            T: OptionalTaskExerciseSlinProto,
            repeated: true
        },
        {
            no: 18,
            name: "amount_exercised_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 19,
            name: "cost_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 20,
            name: "quantity_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 21,
            name: "unit_price_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        }
    ]));
/**
 * One SLIN that contributed to an OptionalTaskExerciseProto's (possibly
 * collapsed) exercise -- its own clin_number, its own funded amount (never a
 * share of the parent's accumulated cost), and its own terms at exercise
 * time.
 *
 * @generated from message mono.ryugu.v1.OptionalTaskExerciseSlinProto
 */ export class OptionalTaskExerciseSlinProto extends Message {
    static fromBinary(bytes, options) {
        return new OptionalTaskExerciseSlinProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OptionalTaskExerciseSlinProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OptionalTaskExerciseSlinProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OptionalTaskExerciseSlinProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string exercise_id = 3;
   */ _define_property(this, "exerciseId", ""), /**
   * @generated from field: string clin_number = 4;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: double funded_amount = 6;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double quantity = 7;
   */ _define_property(this, "quantity", 0), /**
   * @generated from field: double unit_price = 8;
   */ _define_property(this, "unitPrice", 0), /**
   * @generated from field: string pricing_type = 9;
   */ _define_property(this, "pricingType", ""), /**
   * @generated from field: google.protobuf.Timestamp pop_start_date = 10;
   */ _define_property(this, "popStartDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp pop_end_date = 11;
   */ _define_property(this, "popEndDate", void 0), /**
   * Read-only canonical storage presence; absent means unknown from a legacy
   * server. A present false marker distinguishes stored zero from NULL.
   *
   * @generated from field: optional bool funded_amount_is_null = 12;
   */ _define_property(this, "fundedAmountIsNull", void 0), /**
   * @generated from field: optional bool quantity_is_null = 13;
   */ _define_property(this, "quantityIsNull", void 0), /**
   * @generated from field: optional bool unit_price_is_null = 14;
   */ _define_property(this, "unitPriceIsNull", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OptionalTaskExerciseSlinProto, "runtime", proto3);
_define_property(OptionalTaskExerciseSlinProto, "typeName", "mono.ryugu.v1.OptionalTaskExerciseSlinProto");
_define_property(OptionalTaskExerciseSlinProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "exercise_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "quantity",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "unit_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "pricing_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "pop_start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "pop_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "funded_amount_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 13,
            name: "quantity_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 14,
            name: "unit_price_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateOptionalTaskExerciseRequest
 */ export class CreateOptionalTaskExerciseRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateOptionalTaskExerciseRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateOptionalTaskExerciseRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateOptionalTaskExerciseRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateOptionalTaskExerciseRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string optional_task_id = 2;
   */ _define_property(this, "optionalTaskId", ""), /**
   * @generated from field: double amount_exercised = 3;
   */ _define_property(this, "amountExercised", 0), /**
   * @generated from field: double cost = 4;
   */ _define_property(this, "cost", 0), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: google.protobuf.Timestamp exercised_at = 6;
   */ _define_property(this, "exercisedAt", void 0), /**
   * The exercising SLIN ("5001-1"), its quantity, and the period of
   * performance for this exercised instance. OptionalTaskExerciseProto has
   * carried all four on the read side since SAD-118's first pass, and the
   * columns exist on delivery.optional_task_exercises -- but a modification
   * apply was the only writer that could populate them, so a manually
   * recorded exercise permanently rendered "SLIN — / Qty — / Period — – —".
   * The period here is that instance's own, independent of the program's
   * Base/Option-Year periods.
   *
   * @generated from field: string clin_number = 7;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: double quantity = 8;
   */ _define_property(this, "quantity", 0), /**
   * @generated from field: google.protobuf.Timestamp pop_start_date = 9;
   */ _define_property(this, "popStartDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp pop_end_date = 10;
   */ _define_property(this, "popEndDate", void 0), /**
   * A manually recorded exercise's per-unit price — the figure a mod-driven
   * row's "Qty × unit price" display otherwise has no hand-entry equivalent
   * for.
   *
   * @generated from field: double unit_price = 11;
   */ _define_property(this, "unitPrice", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateOptionalTaskExerciseRequest, "runtime", proto3);
_define_property(CreateOptionalTaskExerciseRequest, "typeName", "mono.ryugu.v1.CreateOptionalTaskExerciseRequest");
_define_property(CreateOptionalTaskExerciseRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "optional_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amount_exercised",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "exercised_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "quantity",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "pop_start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "pop_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "unit_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * Carries the updated parent task — creating the first exercise flips its
 * derived `exercised` flag, so callers can update state without a refetch.
 *
 * @generated from message mono.ryugu.v1.CreateOptionalTaskExerciseResponse
 */ export class CreateOptionalTaskExerciseResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateOptionalTaskExerciseResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateOptionalTaskExerciseResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateOptionalTaskExerciseResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateOptionalTaskExerciseResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.OptionalTaskExerciseProto exercise = 1;
   */ _define_property(this, "exercise", void 0), /**
   * @generated from field: mono.ryugu.v1.OptionalTaskProto task = 2;
   */ _define_property(this, "task", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateOptionalTaskExerciseResponse, "runtime", proto3);
_define_property(CreateOptionalTaskExerciseResponse, "typeName", "mono.ryugu.v1.CreateOptionalTaskExerciseResponse");
_define_property(CreateOptionalTaskExerciseResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "exercise",
            kind: "message",
            T: OptionalTaskExerciseProto
        },
        {
            no: 2,
            name: "task",
            kind: "message",
            T: OptionalTaskProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateOptionalTaskExerciseRequest
 */ export class UpdateOptionalTaskExerciseRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOptionalTaskExerciseRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOptionalTaskExerciseRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOptionalTaskExerciseRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOptionalTaskExerciseRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: double amount_exercised = 3;
   */ _define_property(this, "amountExercised", 0), /**
   * @generated from field: double cost = 4;
   */ _define_property(this, "cost", 0), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: google.protobuf.Timestamp exercised_at = 6;
   */ _define_property(this, "exercisedAt", void 0), /**
   * @generated from field: string clin_number = 7;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: double quantity = 8;
   */ _define_property(this, "quantity", 0), /**
   * @generated from field: google.protobuf.Timestamp pop_start_date = 9;
   */ _define_property(this, "popStartDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp pop_end_date = 10;
   */ _define_property(this, "popEndDate", void 0), /**
   * @generated from field: double unit_price = 11;
   */ _define_property(this, "unitPrice", 0), /**
   * Set every line's PoP to this PoP too (SAD-822).
   *
   * @generated from field: bool apply_pop_to_lines = 12;
   */ _define_property(this, "applyPopToLines", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOptionalTaskExerciseRequest, "runtime", proto3);
_define_property(UpdateOptionalTaskExerciseRequest, "typeName", "mono.ryugu.v1.UpdateOptionalTaskExerciseRequest");
_define_property(UpdateOptionalTaskExerciseRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amount_exercised",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "exercised_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "quantity",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "pop_start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "pop_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "unit_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "apply_pop_to_lines",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateOptionalTaskExerciseResponse
 */ export class UpdateOptionalTaskExerciseResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOptionalTaskExerciseResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOptionalTaskExerciseResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOptionalTaskExerciseResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOptionalTaskExerciseResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.OptionalTaskExerciseProto exercise = 1;
   */ _define_property(this, "exercise", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOptionalTaskExerciseResponse, "runtime", proto3);
_define_property(UpdateOptionalTaskExerciseResponse, "typeName", "mono.ryugu.v1.UpdateOptionalTaskExerciseResponse");
_define_property(UpdateOptionalTaskExerciseResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "exercise",
            kind: "message",
            T: OptionalTaskExerciseProto
        }
    ]));
/**
 * One SLIN line of an exercise, corrected in place (SAD-822). The PoP is
 * replaced as sent; clin_number "" and an absent quantity keep the stored
 * value.
 *
 * @generated from message mono.ryugu.v1.UpdateOptionalTaskExerciseLineRequest
 */ export class UpdateOptionalTaskExerciseLineRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOptionalTaskExerciseLineRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOptionalTaskExerciseLineRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOptionalTaskExerciseLineRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOptionalTaskExerciseLineRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string exercise_id = 3;
   */ _define_property(this, "exerciseId", ""), /**
   * @generated from field: string clin_number = 4;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: optional double quantity = 5;
   */ _define_property(this, "quantity", void 0), /**
   * @generated from field: google.protobuf.Timestamp pop_start_date = 6;
   */ _define_property(this, "popStartDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp pop_end_date = 7;
   */ _define_property(this, "popEndDate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOptionalTaskExerciseLineRequest, "runtime", proto3);
_define_property(UpdateOptionalTaskExerciseLineRequest, "typeName", "mono.ryugu.v1.UpdateOptionalTaskExerciseLineRequest");
_define_property(UpdateOptionalTaskExerciseLineRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "exercise_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "quantity",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 6,
            name: "pop_start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "pop_end_date",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateOptionalTaskExerciseLineResponse
 */ export class UpdateOptionalTaskExerciseLineResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOptionalTaskExerciseLineResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOptionalTaskExerciseLineResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOptionalTaskExerciseLineResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOptionalTaskExerciseLineResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.OptionalTaskExerciseSlinProto line = 1;
   */ _define_property(this, "line", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOptionalTaskExerciseLineResponse, "runtime", proto3);
_define_property(UpdateOptionalTaskExerciseLineResponse, "typeName", "mono.ryugu.v1.UpdateOptionalTaskExerciseLineResponse");
_define_property(UpdateOptionalTaskExerciseLineResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "line",
            kind: "message",
            T: OptionalTaskExerciseSlinProto
        }
    ]));
/**
 * optional_task_id empty → all exercises for the program.
 *
 * @generated from message mono.ryugu.v1.ListOptionalTaskExercisesRequest
 */ export class ListOptionalTaskExercisesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOptionalTaskExercisesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOptionalTaskExercisesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOptionalTaskExercisesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOptionalTaskExercisesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string optional_task_id = 2;
   */ _define_property(this, "optionalTaskId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOptionalTaskExercisesRequest, "runtime", proto3);
_define_property(ListOptionalTaskExercisesRequest, "typeName", "mono.ryugu.v1.ListOptionalTaskExercisesRequest");
_define_property(ListOptionalTaskExercisesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "optional_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListOptionalTaskExercisesResponse
 */ export class ListOptionalTaskExercisesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOptionalTaskExercisesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOptionalTaskExercisesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOptionalTaskExercisesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOptionalTaskExercisesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.OptionalTaskExerciseProto exercises = 1;
   */ _define_property(this, "exercises", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOptionalTaskExercisesResponse, "runtime", proto3);
_define_property(ListOptionalTaskExercisesResponse, "typeName", "mono.ryugu.v1.ListOptionalTaskExercisesResponse");
_define_property(ListOptionalTaskExercisesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "exercises",
            kind: "message",
            T: OptionalTaskExerciseProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteOptionalTaskExerciseRequest
 */ export class DeleteOptionalTaskExerciseRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteOptionalTaskExerciseRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteOptionalTaskExerciseRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteOptionalTaskExerciseRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteOptionalTaskExerciseRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * Required — the write-authz registry gates on program scope.
   *
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteOptionalTaskExerciseRequest, "runtime", proto3);
_define_property(DeleteOptionalTaskExerciseRequest, "typeName", "mono.ryugu.v1.DeleteOptionalTaskExerciseRequest");
_define_property(DeleteOptionalTaskExerciseRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Deleting the last live exercise clears the parent's derived flag.
 *
 * @generated from message mono.ryugu.v1.DeleteOptionalTaskExerciseResponse
 */ export class DeleteOptionalTaskExerciseResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteOptionalTaskExerciseResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteOptionalTaskExerciseResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteOptionalTaskExerciseResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteOptionalTaskExerciseResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.OptionalTaskProto task = 1;
   */ _define_property(this, "task", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteOptionalTaskExerciseResponse, "runtime", proto3);
_define_property(DeleteOptionalTaskExerciseResponse, "typeName", "mono.ryugu.v1.DeleteOptionalTaskExerciseResponse");
_define_property(DeleteOptionalTaskExerciseResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "task",
            kind: "message",
            T: OptionalTaskProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProgramCapabilityProto
 */ export class ProgramCapabilityProto extends Message {
    static fromBinary(bytes, options) {
        return new ProgramCapabilityProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramCapabilityProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramCapabilityProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramCapabilityProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string category = 3;
   */ _define_property(this, "category", ""), /**
   * @generated from field: double percentage = 4;
   */ _define_property(this, "percentage", 0), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramCapabilityProto, "runtime", proto3);
_define_property(ProgramCapabilityProto, "typeName", "mono.ryugu.v1.ProgramCapabilityProto");
_define_property(ProgramCapabilityProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramCapabilitiesRequest
 */ export class ListProgramCapabilitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramCapabilitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramCapabilitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramCapabilitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramCapabilitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramCapabilitiesRequest, "runtime", proto3);
_define_property(ListProgramCapabilitiesRequest, "typeName", "mono.ryugu.v1.ListProgramCapabilitiesRequest");
_define_property(ListProgramCapabilitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramCapabilitiesResponse
 */ export class ListProgramCapabilitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramCapabilitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramCapabilitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramCapabilitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramCapabilitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ProgramCapabilityProto capabilities = 1;
   */ _define_property(this, "capabilities", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramCapabilitiesResponse, "runtime", proto3);
_define_property(ListProgramCapabilitiesResponse, "typeName", "mono.ryugu.v1.ListProgramCapabilitiesResponse");
_define_property(ListProgramCapabilitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capabilities",
            kind: "message",
            T: ProgramCapabilityProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertProgramCapabilityRequest
 */ export class UpsertProgramCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string category = 3;
   */ _define_property(this, "category", ""), /**
   * @generated from field: double percentage = 4;
   */ _define_property(this, "percentage", 0), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramCapabilityRequest, "runtime", proto3);
_define_property(UpsertProgramCapabilityRequest, "typeName", "mono.ryugu.v1.UpsertProgramCapabilityRequest");
_define_property(UpsertProgramCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertProgramCapabilityResponse
 */ export class UpsertProgramCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramCapabilityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ProgramCapabilityProto capability = 1;
   */ _define_property(this, "capability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramCapabilityResponse, "runtime", proto3);
_define_property(UpsertProgramCapabilityResponse, "typeName", "mono.ryugu.v1.UpsertProgramCapabilityResponse");
_define_property(UpsertProgramCapabilityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability",
            kind: "message",
            T: ProgramCapabilityProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteProgramCapabilityRequest
 */ export class DeleteProgramCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramCapabilityRequest, "runtime", proto3);
_define_property(DeleteProgramCapabilityRequest, "typeName", "mono.ryugu.v1.DeleteProgramCapabilityRequest");
_define_property(DeleteProgramCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteProgramCapabilityResponse
 */ export class DeleteProgramCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramCapabilityResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramCapabilityResponse, "runtime", proto3);
_define_property(DeleteProgramCapabilityResponse, "typeName", "mono.ryugu.v1.DeleteProgramCapabilityResponse");
_define_property(DeleteProgramCapabilityResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.ProgramTaskProto
 */ export class ProgramTaskProto extends Message {
    static fromBinary(bytes, options) {
        return new ProgramTaskProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramTaskProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramTaskProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramTaskProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string deliverable_number = 3;
   */ _define_property(this, "deliverableNumber", ""), /**
   * @generated from field: string short_description = 4;
   */ _define_property(this, "shortDescription", ""), /**
   * @generated from field: google.protobuf.Timestamp due_date = 5;
   */ _define_property(this, "dueDate", void 0), /**
   * @generated from field: string due_date_notes = 6;
   */ _define_property(this, "dueDateNotes", ""), /**
   * One Time, Weekly, Monthly, Quarterly, Annually
   *
   * @generated from field: string frequency = 7;
   */ _define_property(this, "frequency", ""), /**
   * Open, Closed, Closed - Not Delivered
   *
   * @generated from field: string state = 8;
   */ _define_property(this, "state", ""), /**
   * @generated from field: google.protobuf.Timestamp closed_at = 9;
   */ _define_property(this, "closedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp submitted_at = 10;
   */ _define_property(this, "submittedAt", void 0), /**
   * @generated from field: string responsible_person = 11;
   */ _define_property(this, "responsiblePerson", ""), /**
   * @generated from field: string rejection_reason = 12;
   */ _define_property(this, "rejectionReason", ""), /**
   * @generated from field: int32 rework_count = 13;
   */ _define_property(this, "reworkCount", 0), /**
   * @generated from field: string zou_deliverable_id = 14;
   */ _define_property(this, "zouDeliverableId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 15;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 16;
   */ _define_property(this, "updatedAt", void 0), /**
   * Phase 0a SDS fields surfaced for the CLIN↔PWS↔deliverable mapping view.
   *
   * @generated from field: string clin_id = 17;
   */ _define_property(this, "clinId", ""), /**
   * @generated from field: string clin_number = 18;
   */ _define_property(this, "clinNumber", ""), /**
   * JSON []string
   *
   * @generated from field: string pws_sections = 19;
   */ _define_property(this, "pwsSections", ""), /**
   * SDS evidence/POD semantics surfaced for the portfolio evidence board.
   * evidence_status: missing|partial|complete|exception_approved|not_required.
   * proof_of_delivery_status: missing|attached|external_reference_captured|
   * customer_receipt_captured|exception_approved.
   *
   * @generated from field: string evidence_status = 20;
   */ _define_property(this, "evidenceStatus", ""), /**
   * @generated from field: string proof_of_delivery_status = 21;
   */ _define_property(this, "proofOfDeliveryStatus", ""), /**
   * @generated from field: bool on_time_flag = 22;
   */ _define_property(this, "onTimeFlag", false), /**
   * @generated from field: bool waived_or_tailored_flag = 23;
   */ _define_property(this, "waivedOrTailoredFlag", false), /**
   * Optional per-task bound for the deliverable series; unset means the
   * series runs to the program PoP end.
   *
   * @generated from field: google.protobuf.Timestamp series_end_date = 24;
   */ _define_property(this, "seriesEndDate", void 0), /**
   * Explicit period-of-performance assignment. Empty means "no explicit
   * period — fall back to CLIN-derived classification".
   *
   * @generated from field: string period_of_performance_id = 25;
   */ _define_property(this, "periodOfPerformanceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramTaskProto, "runtime", proto3);
_define_property(ProgramTaskProto, "typeName", "mono.ryugu.v1.ProgramTaskProto");
_define_property(ProgramTaskProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "deliverable_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "short_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "due_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "due_date_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "frequency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "closed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "submitted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "responsible_person",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "rejection_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "rework_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 14,
            name: "zou_deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "pws_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "evidence_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "proof_of_delivery_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "on_time_flag",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 23,
            name: "waived_or_tailored_flag",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 24,
            name: "series_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 25,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramTasksRequest
 */ export class ListProgramTasksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramTasksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramTasksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramTasksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramTasksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * optional filter
   *
   * @generated from field: string state = 2;
   */ _define_property(this, "state", ""), /**
   * optional filter
   *
   * @generated from field: string frequency = 3;
   */ _define_property(this, "frequency", ""), /**
   * Calendar range filter
   *
   * @generated from field: google.protobuf.Timestamp due_after = 4;
   */ _define_property(this, "dueAfter", void 0), /**
   * @generated from field: google.protobuf.Timestamp due_before = 5;
   */ _define_property(this, "dueBefore", void 0), /**
   * @generated from field: mono.ryugu.v1.PaginationRequest pagination = 6;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramTasksRequest, "runtime", proto3);
_define_property(ListProgramTasksRequest, "typeName", "mono.ryugu.v1.ListProgramTasksRequest");
_define_property(ListProgramTasksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "frequency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "due_after",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "due_before",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "pagination",
            kind: "message",
            T: PaginationRequest
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramTasksResponse
 */ export class ListProgramTasksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramTasksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramTasksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramTasksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramTasksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ProgramTaskProto tasks = 1;
   */ _define_property(this, "tasks", []), /**
   * @generated from field: mono.ryugu.v1.PaginationResponse pagination = 2;
   */ _define_property(this, "pagination", void 0), /**
   * Computed metrics
   *
   * @generated from field: int32 total_tasks = 3;
   */ _define_property(this, "totalTasks", 0), /**
   * @generated from field: int32 overdue_count = 4;
   */ _define_property(this, "overdueCount", 0), /**
   * @generated from field: int32 due_this_month = 5;
   */ _define_property(this, "dueThisMonth", 0), /**
   * @generated from field: double on_time_percent = 6;
   */ _define_property(this, "onTimePercent", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramTasksResponse, "runtime", proto3);
_define_property(ListProgramTasksResponse, "typeName", "mono.ryugu.v1.ListProgramTasksResponse");
_define_property(ListProgramTasksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tasks",
            kind: "message",
            T: ProgramTaskProto,
            repeated: true
        },
        {
            no: 2,
            name: "pagination",
            kind: "message",
            T: PaginationResponse
        },
        {
            no: 3,
            name: "total_tasks",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "overdue_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "due_this_month",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "on_time_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * DeliverableInstanceView is one materialized occurrence joined with its
 * definition — the FE groups these by deliverable to render the tracker's
 * N/M-complete badge + expandable dated schedule.
 *
 * @generated from message mono.ryugu.v1.DeliverableInstanceView
 */ export class DeliverableInstanceView extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableInstanceView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableInstanceView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableInstanceView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableInstanceView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string deliverable_definition_id = 2;
   */ _define_property(this, "deliverableDefinitionId", ""), /**
   * @generated from field: string program_task_id = 3;
   */ _define_property(this, "programTaskId", ""), /**
   * @generated from field: string clin_number = 4;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string deliverable_number = 5;
   */ _define_property(this, "deliverableNumber", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string recurrence_rule = 7;
   */ _define_property(this, "recurrenceRule", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 8;
   */ _define_property(this, "dueAt", void 0), /**
   * @generated from field: string status = 9;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string evidence_status = 10;
   */ _define_property(this, "evidenceStatus", ""), /**
   * @generated from field: string proof_of_delivery_status = 11;
   */ _define_property(this, "proofOfDeliveryStatus", ""), /**
   * @generated from field: google.protobuf.Timestamp submitted_at = 12;
   */ _define_property(this, "submittedAt", void 0), /**
   * Persisted at submit time (computed against due_at); the FE derives the
   * same value from submitted_at <= due_at when absent on older rows.
   *
   * @generated from field: bool on_time_flag = 13;
   */ _define_property(this, "onTimeFlag", false), /**
   * Deduplicated ids of every artifact ever attached to this occurrence
   * (across submissions) — powers upload chips on list surfaces without an
   * extra evidence RPC. Absorbed from PR #872 (matt-issue 21).
   *
   * @generated from field: repeated string artifact_ids = 14;
   */ _define_property(this, "artifactIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableInstanceView, "runtime", proto3);
_define_property(DeliverableInstanceView, "typeName", "mono.ryugu.v1.DeliverableInstanceView");
_define_property(DeliverableInstanceView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "deliverable_definition_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "deliverable_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "recurrence_rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "evidence_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "proof_of_delivery_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "submitted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "on_time_flag",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListDeliverableInstancesRequest
 */ export class ListDeliverableInstancesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDeliverableInstancesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeliverableInstancesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeliverableInstancesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeliverableInstancesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * Optional — absent keeps today's fetch-everything behavior (bounded by the
   * server clamp). Same shape as ListProgramTasks.
   *
   * @generated from field: mono.ryugu.v1.PaginationRequest pagination = 2;
   */ _define_property(this, "pagination", void 0), /**
   * Optional due-date window (inclusive). The evidence board defaults to a
   * window so its cross-program fan-out stays bounded and visible.
   *
   * @generated from field: google.protobuf.Timestamp due_after = 3;
   */ _define_property(this, "dueAfter", void 0), /**
   * @generated from field: google.protobuf.Timestamp due_before = 4;
   */ _define_property(this, "dueBefore", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeliverableInstancesRequest, "runtime", proto3);
_define_property(ListDeliverableInstancesRequest, "typeName", "mono.ryugu.v1.ListDeliverableInstancesRequest");
_define_property(ListDeliverableInstancesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pagination",
            kind: "message",
            T: PaginationRequest
        },
        {
            no: 3,
            name: "due_after",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "due_before",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListDeliverableInstancesResponse
 */ export class ListDeliverableInstancesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDeliverableInstancesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeliverableInstancesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeliverableInstancesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeliverableInstancesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.DeliverableInstanceView instances = 1;
   */ _define_property(this, "instances", []), /**
   * @generated from field: mono.ryugu.v1.PaginationResponse pagination = 2;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeliverableInstancesResponse, "runtime", proto3);
_define_property(ListDeliverableInstancesResponse, "typeName", "mono.ryugu.v1.ListDeliverableInstancesResponse");
_define_property(ListDeliverableInstancesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "instances",
            kind: "message",
            T: DeliverableInstanceView,
            repeated: true
        },
        {
            no: 2,
            name: "pagination",
            kind: "message",
            T: PaginationResponse
        }
    ]));
/**
 * SubmitDeliverableOccurrenceRequest records delivery of one occurrence. tenant
 * + actor are resolved from the gateway principal; delivered_at is the stated
 * (back-datable) delivery date and must not be in the future.
 *
 * @generated from message mono.ryugu.v1.SubmitDeliverableOccurrenceRequest
 */ export class SubmitDeliverableOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new SubmitDeliverableOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmitDeliverableOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmitDeliverableOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmitDeliverableOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string deliverable_instance_id = 1;
   */ _define_property(this, "deliverableInstanceId", ""), /**
   * @generated from field: google.protobuf.Timestamp delivered_at = 2;
   */ _define_property(this, "deliveredAt", void 0), /**
   * Artifact | ExternalReference
   *
   * @generated from field: string evidence_type = 3;
   */ _define_property(this, "evidenceType", ""), /**
   * one or more uploaded proof artifacts
   *
   * @generated from field: repeated string artifact_ids = 4;
   */ _define_property(this, "artifactIds", []), /**
   * @generated from field: string external_reference_id = 5;
   */ _define_property(this, "externalReferenceId", ""), /**
   * @generated from field: repeated string submitted_to_emails = 6;
   */ _define_property(this, "submittedToEmails", []), /**
   * @generated from field: string proof_method = 7;
   */ _define_property(this, "proofMethod", ""), /**
   * @generated from field: bool screenshot_attached = 8;
   */ _define_property(this, "screenshotAttached", false), /**
   * @generated from field: bool email_file_attached = 9;
   */ _define_property(this, "emailFileAttached", false), /**
   * @generated from field: bool customer_receipt_attached = 10;
   */ _define_property(this, "customerReceiptAttached", false), /**
   * The four dates a Proof-of-Delivery review keeps distinct from
   * delivered_at (unchanged): what the PM claimed, what was extracted from
   * the proof, and what a human accepted as operational, plus the
   * verification state comparing them. Unset means "not yet evaluated".
   *
   * @generated from field: google.protobuf.Timestamp claimed_delivery_timestamp = 11;
   */ _define_property(this, "claimedDeliveryTimestamp", void 0), /**
   * @generated from field: google.protobuf.Timestamp extracted_sent_timestamp = 12;
   */ _define_property(this, "extractedSentTimestamp", void 0), /**
   * @generated from field: string extracted_sent_raw = 13;
   */ _define_property(this, "extractedSentRaw", ""), /**
   * @generated from field: string extracted_sent_utc_offset = 14;
   */ _define_property(this, "extractedSentUtcOffset", ""), /**
   * @generated from field: string extracted_sent_timezone = 15;
   */ _define_property(this, "extractedSentTimezone", ""), /**
   * @generated from field: google.protobuf.Timestamp accepted_delivery_timestamp = 16;
   */ _define_property(this, "acceptedDeliveryTimestamp", void 0), /**
   * Match|Mismatch|NotFound|Ambiguous|Unsupported
   *
   * @generated from field: string date_verification_state = 17;
   */ _define_property(this, "dateVerificationState", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmitDeliverableOccurrenceRequest, "runtime", proto3);
_define_property(SubmitDeliverableOccurrenceRequest, "typeName", "mono.ryugu.v1.SubmitDeliverableOccurrenceRequest");
_define_property(SubmitDeliverableOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deliverable_instance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "delivered_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "evidence_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "external_reference_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "submitted_to_emails",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "proof_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "screenshot_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "email_file_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "customer_receipt_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "claimed_delivery_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "extracted_sent_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "extracted_sent_raw",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "extracted_sent_utc_offset",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "extracted_sent_timezone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "accepted_delivery_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "date_verification_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SubmitDeliverableOccurrenceResponse
 */ export class SubmitDeliverableOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new SubmitDeliverableOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmitDeliverableOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmitDeliverableOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmitDeliverableOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.DeliverableInstanceView instance = 1;
   */ _define_property(this, "instance", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmitDeliverableOccurrenceResponse, "runtime", proto3);
_define_property(SubmitDeliverableOccurrenceResponse, "typeName", "mono.ryugu.v1.SubmitDeliverableOccurrenceResponse");
_define_property(SubmitDeliverableOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "instance",
            kind: "message",
            T: DeliverableInstanceView
        }
    ]));
/**
 * One live evidence row attached to an occurrence.
 *
 * @generated from message mono.ryugu.v1.DeliverableEvidenceView
 */ export class DeliverableEvidenceView extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableEvidenceView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableEvidenceView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableEvidenceView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableEvidenceView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string deliverable_instance_id = 2;
   */ _define_property(this, "deliverableInstanceId", ""), /**
   * Artifact|ExternalReference
   *
   * @generated from field: string evidence_type = 3;
   */ _define_property(this, "evidenceType", ""), /**
   * zou attachment id when evidence_type=Artifact
   *
   * @generated from field: string artifact_id = 4;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string external_reference_id = 5;
   */ _define_property(this, "externalReferenceId", ""), /**
   * @generated from field: google.protobuf.Timestamp delivery_timestamp = 6;
   */ _define_property(this, "deliveryTimestamp", void 0), /**
   * @generated from field: string submitted_by_user_id = 7;
   */ _define_property(this, "submittedByUserId", ""), /**
   * JSON []string
   *
   * @generated from field: string submitted_to_emails = 8;
   */ _define_property(this, "submittedToEmails", ""), /**
   * @generated from field: string proof_method = 9;
   */ _define_property(this, "proofMethod", ""), /**
   * @generated from field: bool screenshot_attached = 10;
   */ _define_property(this, "screenshotAttached", false), /**
   * @generated from field: bool email_file_attached = 11;
   */ _define_property(this, "emailFileAttached", false), /**
   * @generated from field: bool customer_receipt_attached = 12;
   */ _define_property(this, "customerReceiptAttached", false), /**
   * @generated from field: string validation_state = 13;
   */ _define_property(this, "validationState", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp claimed_delivery_timestamp = 15;
   */ _define_property(this, "claimedDeliveryTimestamp", void 0), /**
   * @generated from field: google.protobuf.Timestamp extracted_sent_timestamp = 16;
   */ _define_property(this, "extractedSentTimestamp", void 0), /**
   * @generated from field: string extracted_sent_raw = 17;
   */ _define_property(this, "extractedSentRaw", ""), /**
   * @generated from field: string extracted_sent_utc_offset = 18;
   */ _define_property(this, "extractedSentUtcOffset", ""), /**
   * @generated from field: string extracted_sent_timezone = 19;
   */ _define_property(this, "extractedSentTimezone", ""), /**
   * @generated from field: google.protobuf.Timestamp accepted_delivery_timestamp = 20;
   */ _define_property(this, "acceptedDeliveryTimestamp", void 0), /**
   * Match|Mismatch|NotFound|Ambiguous|Unsupported
   *
   * @generated from field: string date_verification_state = 21;
   */ _define_property(this, "dateVerificationState", ""), /**
   * SAD-106: mirrors the customer-record columns already carried on
   * pangaea's datagatewayv1.DeliverableEvidenceView (proto/mono/datagateway/
   * v1/delivery.proto), themselves projected from the DeliverableEvidence
   * entity's migration-000151 columns (delivery_sds.proto fields 29-31).
   * Surfacing them here lets a read-only occurrence detail render acceptance
   * status, delivery notes, and the submitted-to contact from this one
   * occurrence-scoped call instead of a second task-scoped read against
   * zou/projectdata.
   *
   * @generated from field: string customer_acceptance_status = 22;
   */ _define_property(this, "customerAcceptanceStatus", ""), /**
   * @generated from field: string delivery_notes = 23;
   */ _define_property(this, "deliveryNotes", ""), /**
   * @generated from field: string submitted_to_contact_id = 24;
   */ _define_property(this, "submittedToContactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableEvidenceView, "runtime", proto3);
_define_property(DeliverableEvidenceView, "typeName", "mono.ryugu.v1.DeliverableEvidenceView");
_define_property(DeliverableEvidenceView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "deliverable_instance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "evidence_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "external_reference_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "delivery_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "submitted_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "submitted_to_emails",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "proof_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "screenshot_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "email_file_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "customer_receipt_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "validation_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "claimed_delivery_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "extracted_sent_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "extracted_sent_raw",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "extracted_sent_utc_offset",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "extracted_sent_timezone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "accepted_delivery_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 21,
            name: "date_verification_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "customer_acceptance_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "delivery_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "submitted_to_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListDeliverableEvidenceRequest
 */ export class ListDeliverableEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDeliverableEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeliverableEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeliverableEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeliverableEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string deliverable_instance_id = 1;
   */ _define_property(this, "deliverableInstanceId", ""), /**
   * Alternative scope: all live evidence for one task (across its
   * occurrences). Exactly one of the two ids must be set.
   *
   * @generated from field: string program_task_id = 2;
   */ _define_property(this, "programTaskId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeliverableEvidenceRequest, "runtime", proto3);
_define_property(ListDeliverableEvidenceRequest, "typeName", "mono.ryugu.v1.ListDeliverableEvidenceRequest");
_define_property(ListDeliverableEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deliverable_instance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListDeliverableEvidenceResponse
 */ export class ListDeliverableEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDeliverableEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeliverableEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeliverableEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeliverableEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.DeliverableEvidenceView evidence = 1;
   */ _define_property(this, "evidence", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeliverableEvidenceResponse, "runtime", proto3);
_define_property(ListDeliverableEvidenceResponse, "typeName", "mono.ryugu.v1.ListDeliverableEvidenceResponse");
_define_property(ListDeliverableEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: DeliverableEvidenceView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteDeliverableEvidenceRequest
 */ export class DeleteDeliverableEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDeliverableEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDeliverableEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDeliverableEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDeliverableEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string evidence_id = 1;
   */ _define_property(this, "evidenceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDeliverableEvidenceRequest, "runtime", proto3);
_define_property(DeleteDeliverableEvidenceRequest, "typeName", "mono.ryugu.v1.DeleteDeliverableEvidenceRequest");
_define_property(DeleteDeliverableEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Returns the occurrence after its derived state was recomputed from the
 * remaining live evidence (deleting the last row reverts it to NOT_STARTED).
 *
 * @generated from message mono.ryugu.v1.DeleteDeliverableEvidenceResponse
 */ export class DeleteDeliverableEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDeliverableEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDeliverableEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDeliverableEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDeliverableEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.DeliverableInstanceView instance = 1;
   */ _define_property(this, "instance", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDeliverableEvidenceResponse, "runtime", proto3);
_define_property(DeleteDeliverableEvidenceResponse, "typeName", "mono.ryugu.v1.DeleteDeliverableEvidenceResponse");
_define_property(DeleteDeliverableEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "instance",
            kind: "message",
            T: DeliverableInstanceView
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertProgramTaskRequest
 */ export class UpsertProgramTaskRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramTaskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string deliverable_number = 3;
   */ _define_property(this, "deliverableNumber", ""), /**
   * @generated from field: string short_description = 4;
   */ _define_property(this, "shortDescription", ""), /**
   * @generated from field: google.protobuf.Timestamp due_date = 5;
   */ _define_property(this, "dueDate", void 0), /**
   * @generated from field: string due_date_notes = 6;
   */ _define_property(this, "dueDateNotes", ""), /**
   * @generated from field: string frequency = 7;
   */ _define_property(this, "frequency", ""), /**
   * @generated from field: string state = 8;
   */ _define_property(this, "state", ""), /**
   * @generated from field: google.protobuf.Timestamp submitted_at = 9;
   */ _define_property(this, "submittedAt", void 0), /**
   * @generated from field: string responsible_person = 10;
   */ _define_property(this, "responsiblePerson", ""), /**
   * @generated from field: string rejection_reason = 11;
   */ _define_property(this, "rejectionReason", ""), /**
   * @generated from field: string zou_deliverable_id = 12;
   */ _define_property(this, "zouDeliverableId", ""), /**
   * Explicit presence (ISO yyyy-mm-dd): absent leaves the stored bound
   * untouched, "" clears it (series re-expands to the PoP end).
   *
   * @generated from field: optional string series_end_date = 13;
   */ _define_property(this, "seriesEndDate", void 0), /**
   * Explicit presence (JSON []string): absent preserves the stored sections —
   * extraction writes these too, and an edit that omits the field must not
   * wipe them; "" or "[]" clears deliberately.
   *
   * @generated from field: optional string pws_sections = 14;
   */ _define_property(this, "pwsSections", void 0), /**
   * Empty clears the assignment (falls back to CLIN-derived classification);
   * always sent by the form, so no presence wrapper is needed here. Must
   * name a period belonging to this task's own program and tenant — ryugu
   * refuses anything else with InvalidArgument.
   *
   * @generated from field: string period_of_performance_id = 15;
   */ _define_property(this, "periodOfPerformanceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramTaskRequest, "runtime", proto3);
_define_property(UpsertProgramTaskRequest, "typeName", "mono.ryugu.v1.UpsertProgramTaskRequest");
_define_property(UpsertProgramTaskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "deliverable_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "short_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "due_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "due_date_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "frequency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "submitted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "responsible_person",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "rejection_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "zou_deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "series_end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 14,
            name: "pws_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 15,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertProgramTaskResponse
 */ export class UpsertProgramTaskResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramTaskResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ProgramTaskProto task = 1;
   */ _define_property(this, "task", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramTaskResponse, "runtime", proto3);
_define_property(UpsertProgramTaskResponse, "typeName", "mono.ryugu.v1.UpsertProgramTaskResponse");
_define_property(UpsertProgramTaskResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "task",
            kind: "message",
            T: ProgramTaskProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteProgramTaskRequest
 */ export class DeleteProgramTaskRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramTaskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramTaskRequest, "runtime", proto3);
_define_property(DeleteProgramTaskRequest, "typeName", "mono.ryugu.v1.DeleteProgramTaskRequest");
_define_property(DeleteProgramTaskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteProgramTaskResponse
 */ export class DeleteProgramTaskResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramTaskResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramTaskResponse, "runtime", proto3);
_define_property(DeleteProgramTaskResponse, "typeName", "mono.ryugu.v1.DeleteProgramTaskResponse");
_define_property(DeleteProgramTaskResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * GenerateTaskInstances creates individual ProgramTask records from a
 * zou deliverable definition's cadence over a date range.
 *
 * @generated from message mono.ryugu.v1.GenerateTaskInstancesRequest
 */ export class GenerateTaskInstancesRequest extends Message {
    static fromBinary(bytes, options) {
        return new GenerateTaskInstancesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateTaskInstancesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateTaskInstancesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateTaskInstancesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string zou_deliverable_id = 2;
   */ _define_property(this, "zouDeliverableId", ""), /**
   * @generated from field: string deliverable_number = 3;
   */ _define_property(this, "deliverableNumber", ""), /**
   * @generated from field: string short_description = 4;
   */ _define_property(this, "shortDescription", ""), /**
   * Monthly, Weekly, Quarterly, Annually
   *
   * @generated from field: string frequency = 5;
   */ _define_property(this, "frequency", ""), /**
   * @generated from field: google.protobuf.Timestamp range_start = 6;
   */ _define_property(this, "rangeStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp range_end = 7;
   */ _define_property(this, "rangeEnd", void 0), /**
   * @generated from field: string responsible_person = 8;
   */ _define_property(this, "responsiblePerson", ""), /**
   * @generated from field: string due_date_notes = 9;
   */ _define_property(this, "dueDateNotes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateTaskInstancesRequest, "runtime", proto3);
_define_property(GenerateTaskInstancesRequest, "typeName", "mono.ryugu.v1.GenerateTaskInstancesRequest");
_define_property(GenerateTaskInstancesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "zou_deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "deliverable_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "short_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "frequency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "range_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "range_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "responsible_person",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "due_date_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GenerateTaskInstancesResponse
 */ export class GenerateTaskInstancesResponse extends Message {
    static fromBinary(bytes, options) {
        return new GenerateTaskInstancesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateTaskInstancesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateTaskInstancesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateTaskInstancesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 tasks_created = 1;
   */ _define_property(this, "tasksCreated", 0), /**
   * @generated from field: repeated mono.ryugu.v1.ProgramTaskProto tasks = 2;
   */ _define_property(this, "tasks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateTaskInstancesResponse, "runtime", proto3);
_define_property(GenerateTaskInstancesResponse, "typeName", "mono.ryugu.v1.GenerateTaskInstancesResponse");
_define_property(GenerateTaskInstancesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tasks_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "tasks",
            kind: "message",
            T: ProgramTaskProto,
            repeated: true
        }
    ]));
/**
 * Task Attachments
 *
 * @generated from message mono.ryugu.v1.TaskAttachmentProto
 */ export class TaskAttachmentProto extends Message {
    static fromBinary(bytes, options) {
        return new TaskAttachmentProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TaskAttachmentProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TaskAttachmentProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TaskAttachmentProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string task_id = 2;
   */ _define_property(this, "taskId", ""), /**
   * deliverable, delivery_email, other
   *
   * @generated from field: string type = 3;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string file_name = 4;
   */ _define_property(this, "fileName", ""), /**
   * @generated from field: string file_id = 5;
   */ _define_property(this, "fileId", ""), /**
   * @generated from field: google.protobuf.Timestamp uploaded_at = 6;
   */ _define_property(this, "uploadedAt", void 0), /**
   * @generated from field: string uploaded_by = 7;
   */ _define_property(this, "uploadedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TaskAttachmentProto, "runtime", proto3);
_define_property(TaskAttachmentProto, "typeName", "mono.ryugu.v1.TaskAttachmentProto");
_define_property(TaskAttachmentProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "file_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "uploaded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "uploaded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListTaskAttachmentsRequest
 */ export class ListTaskAttachmentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListTaskAttachmentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTaskAttachmentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTaskAttachmentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTaskAttachmentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string task_id = 1;
   */ _define_property(this, "taskId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTaskAttachmentsRequest, "runtime", proto3);
_define_property(ListTaskAttachmentsRequest, "typeName", "mono.ryugu.v1.ListTaskAttachmentsRequest");
_define_property(ListTaskAttachmentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListTaskAttachmentsResponse
 */ export class ListTaskAttachmentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListTaskAttachmentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTaskAttachmentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTaskAttachmentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTaskAttachmentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.TaskAttachmentProto attachments = 1;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTaskAttachmentsResponse, "runtime", proto3);
_define_property(ListTaskAttachmentsResponse, "typeName", "mono.ryugu.v1.ListTaskAttachmentsResponse");
_define_property(ListTaskAttachmentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "attachments",
            kind: "message",
            T: TaskAttachmentProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateTaskAttachmentRequest
 */ export class CreateTaskAttachmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateTaskAttachmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateTaskAttachmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateTaskAttachmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateTaskAttachmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string task_id = 1;
   */ _define_property(this, "taskId", ""), /**
   * @generated from field: string type = 2;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string file_name = 3;
   */ _define_property(this, "fileName", ""), /**
   * @generated from field: string file_id = 4;
   */ _define_property(this, "fileId", ""), /**
   * @generated from field: string uploaded_by = 5;
   */ _define_property(this, "uploadedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateTaskAttachmentRequest, "runtime", proto3);
_define_property(CreateTaskAttachmentRequest, "typeName", "mono.ryugu.v1.CreateTaskAttachmentRequest");
_define_property(CreateTaskAttachmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "file_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "uploaded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateTaskAttachmentResponse
 */ export class CreateTaskAttachmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateTaskAttachmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateTaskAttachmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateTaskAttachmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateTaskAttachmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.TaskAttachmentProto attachment = 1;
   */ _define_property(this, "attachment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateTaskAttachmentResponse, "runtime", proto3);
_define_property(CreateTaskAttachmentResponse, "typeName", "mono.ryugu.v1.CreateTaskAttachmentResponse");
_define_property(CreateTaskAttachmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "attachment",
            kind: "message",
            T: TaskAttachmentProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteTaskAttachmentRequest
 */ export class DeleteTaskAttachmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteTaskAttachmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteTaskAttachmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteTaskAttachmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteTaskAttachmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteTaskAttachmentRequest, "runtime", proto3);
_define_property(DeleteTaskAttachmentRequest, "typeName", "mono.ryugu.v1.DeleteTaskAttachmentRequest");
_define_property(DeleteTaskAttachmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteTaskAttachmentResponse
 */ export class DeleteTaskAttachmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteTaskAttachmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteTaskAttachmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteTaskAttachmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteTaskAttachmentResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteTaskAttachmentResponse, "runtime", proto3);
_define_property(DeleteTaskAttachmentResponse, "typeName", "mono.ryugu.v1.DeleteTaskAttachmentResponse");
_define_property(DeleteTaskAttachmentResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.AuditProto
 */ export class AuditProto extends Message {
    static fromBinary(bytes, options) {
        return new AuditProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuditProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuditProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuditProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: google.protobuf.Timestamp audit_date = 3;
   */ _define_property(this, "auditDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp period_start = 4;
   */ _define_property(this, "periodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp period_end = 5;
   */ _define_property(this, "periodEnd", void 0), /**
   * Program, Contracts, Accounting
   *
   * @generated from field: string area = 6;
   */ _define_property(this, "area", ""), /**
   * Draft, In Review, Published, Closed Complete
   *
   * @generated from field: string state = 7;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string assigned_to = 8;
   */ _define_property(this, "assignedTo", ""), /**
   * @generated from field: string notes = 9;
   */ _define_property(this, "notes", ""), /**
   * Score (live-computed for Draft/In Review, frozen for Published/Closed)
   *
   * applicable (excluding N/A)
   *
   * @generated from field: int32 total_questions = 10;
   */ _define_property(this, "totalQuestions", 0), /**
   * @generated from field: int32 pass_count = 11;
   */ _define_property(this, "passCount", 0), /**
   * @generated from field: int32 fail_count = 12;
   */ _define_property(this, "failCount", 0), /**
   * e.g. "10/10" — set at publish, empty if draft
   *
   * @generated from field: string frozen_score = 15;
   */ _define_property(this, "frozenScore", ""), /**
   * Peer review
   *
   * @generated from field: string reviewed_by = 16;
   */ _define_property(this, "reviewedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp reviewed_at = 17;
   */ _define_property(this, "reviewedAt", void 0), /**
   * @generated from field: string reviewer_notes = 18;
   */ _define_property(this, "reviewerNotes", ""), /**
   * Publish
   *
   * @generated from field: google.protobuf.Timestamp published_at = 19;
   */ _define_property(this, "publishedAt", void 0), /**
   * @generated from field: string published_by = 20;
   */ _define_property(this, "publishedBy", ""), /**
   * final audits not scored, don't impact KPI 4
   *
   * @generated from field: bool is_final = 21;
   */ _define_property(this, "isFinal", false), /**
   * Planned monthly workflow. state ∈ {Not Started, In Progress,
   * Corrective Actions Open, Complete}; the older Draft/In Review/Published
   * values are retired by the handler layer.
   *
   * "2026-07" — one audit per program per month
   *
   * @generated from field: string period_month = 22;
   */ _define_property(this, "periodMonth", ""), /**
   * @generated from field: google.protobuf.Timestamp scheduled_date = 23;
   */ _define_property(this, "scheduledDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp started_at = 24;
   */ _define_property(this, "startedAt", void 0), /**
   * @generated from field: string started_by = 25;
   */ _define_property(this, "startedBy", ""), /**
   * @generated from field: string started_by_contact_id = 26;
   */ _define_property(this, "startedByContactId", ""), /**
   * @generated from field: google.protobuf.Timestamp completed_at = 27;
   */ _define_property(this, "completedAt", void 0), /**
   * @generated from field: string completed_by = 28;
   */ _define_property(this, "completedBy", ""), /**
   * @generated from field: string completed_by_contact_id = 29;
   */ _define_property(this, "completedByContactId", ""), /**
   * @generated from field: string audit_summary = 30;
   */ _define_property(this, "auditSummary", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AuditProto, "runtime", proto3);
_define_property(AuditProto, "typeName", "mono.ryugu.v1.AuditProto");
_define_property(AuditProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "audit_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "assigned_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "total_questions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 11,
            name: "pass_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "fail_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "frozen_score",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "reviewed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "reviewed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "reviewer_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "published_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 20,
            name: "published_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "is_final",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 22,
            name: "period_month",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "scheduled_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 24,
            name: "started_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 25,
            name: "started_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "started_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "completed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 28,
            name: "completed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "completed_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 30,
            name: "audit_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListAuditsRequest
 */ export class ListAuditsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditsRequest, "runtime", proto3);
_define_property(ListAuditsRequest, "typeName", "mono.ryugu.v1.ListAuditsRequest");
_define_property(ListAuditsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListAuditsResponse
 */ export class ListAuditsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.AuditProto audits = 1;
   */ _define_property(this, "audits", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditsResponse, "runtime", proto3);
_define_property(ListAuditsResponse, "typeName", "mono.ryugu.v1.ListAuditsResponse");
_define_property(ListAuditsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audits",
            kind: "message",
            T: AuditProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetAuditRequest
 */ export class GetAuditRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetAuditRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAuditRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAuditRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAuditRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAuditRequest, "runtime", proto3);
_define_property(GetAuditRequest, "typeName", "mono.ryugu.v1.GetAuditRequest");
_define_property(GetAuditRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetAuditResponse
 */ export class GetAuditResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetAuditResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAuditResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAuditResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAuditResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.AuditProto audit = 1;
   */ _define_property(this, "audit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAuditResponse, "runtime", proto3);
_define_property(GetAuditResponse, "typeName", "mono.ryugu.v1.GetAuditResponse");
_define_property(GetAuditResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit",
            kind: "message",
            T: AuditProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateAuditRequest
 */ export class CreateAuditRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateAuditRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuditRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuditRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateAuditRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: google.protobuf.Timestamp audit_date = 2;
   */ _define_property(this, "auditDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp period_start = 3;
   */ _define_property(this, "periodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp period_end = 4;
   */ _define_property(this, "periodEnd", void 0), /**
   * @generated from field: string area = 5;
   */ _define_property(this, "area", ""), /**
   * @generated from field: string assigned_to = 6;
   */ _define_property(this, "assignedTo", ""), /**
   * final audits are not scored, don't impact KPI 4
   *
   * @generated from field: bool is_final = 7;
   */ _define_property(this, "isFinal", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateAuditRequest, "runtime", proto3);
_define_property(CreateAuditRequest, "typeName", "mono.ryugu.v1.CreateAuditRequest");
_define_property(CreateAuditRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "audit_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "assigned_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "is_final",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateAuditResponse
 */ export class CreateAuditResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateAuditResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuditResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuditResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateAuditResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.AuditProto audit = 1;
   */ _define_property(this, "audit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateAuditResponse, "runtime", proto3);
_define_property(CreateAuditResponse, "typeName", "mono.ryugu.v1.CreateAuditResponse");
_define_property(CreateAuditResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit",
            kind: "message",
            T: AuditProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateAuditRequest
 */ export class UpdateAuditRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateAuditRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateAuditRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateAuditRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateAuditRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * Deprecated: state is rejected (InvalidArgument) when set — lifecycle
   * transitions go through SubmitAuditForReview / ReviewAudit / CloseAudit.
   * Kept on the wire for compatibility; do not remove or renumber.
   *
   * @generated from field: string state = 2 [deprecated = true];
   * @deprecated
   */ _define_property(this, "state", ""), /**
   * @generated from field: string assigned_to = 3;
   */ _define_property(this, "assignedTo", ""), /**
   * @generated from field: string notes = 4;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateAuditRequest, "runtime", proto3);
_define_property(UpdateAuditRequest, "typeName", "mono.ryugu.v1.UpdateAuditRequest");
_define_property(UpdateAuditRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "assigned_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateAuditResponse
 */ export class UpdateAuditResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateAuditResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateAuditResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateAuditResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateAuditResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.AuditProto audit = 1;
   */ _define_property(this, "audit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateAuditResponse, "runtime", proto3);
_define_property(UpdateAuditResponse, "typeName", "mono.ryugu.v1.UpdateAuditResponse");
_define_property(UpdateAuditResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit",
            kind: "message",
            T: AuditProto
        }
    ]));
/**
 * Lifecycle: Submit for peer review (Draft → In Review)
 *
 * @generated from message mono.ryugu.v1.SubmitAuditForReviewRequest
 */ export class SubmitAuditForReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new SubmitAuditForReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmitAuditForReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmitAuditForReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmitAuditForReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string audit_id = 1;
   */ _define_property(this, "auditId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmitAuditForReviewRequest, "runtime", proto3);
_define_property(SubmitAuditForReviewRequest, "typeName", "mono.ryugu.v1.SubmitAuditForReviewRequest");
_define_property(SubmitAuditForReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SubmitAuditForReviewResponse
 */ export class SubmitAuditForReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new SubmitAuditForReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmitAuditForReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmitAuditForReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmitAuditForReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.AuditProto audit = 1;
   */ _define_property(this, "audit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmitAuditForReviewResponse, "runtime", proto3);
_define_property(SubmitAuditForReviewResponse, "typeName", "mono.ryugu.v1.SubmitAuditForReviewResponse");
_define_property(SubmitAuditForReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit",
            kind: "message",
            T: AuditProto
        }
    ]));
/**
 * Lifecycle: Peer review decision (In Review → Published or → Draft)
 *
 * @generated from message mono.ryugu.v1.ReviewAuditRequest
 */ export class ReviewAuditRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewAuditRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewAuditRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewAuditRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewAuditRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string audit_id = 1;
   */ _define_property(this, "auditId", ""), /**
   * @generated from field: string reviewer_name = 2;
   */ _define_property(this, "reviewerName", ""), /**
   * @generated from field: bool approved = 3;
   */ _define_property(this, "approved", false), /**
   * required if rejected
   *
   * @generated from field: string reviewer_notes = 4;
   */ _define_property(this, "reviewerNotes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewAuditRequest, "runtime", proto3);
_define_property(ReviewAuditRequest, "typeName", "mono.ryugu.v1.ReviewAuditRequest");
_define_property(ReviewAuditRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "reviewer_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "approved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "reviewer_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ReviewAuditResponse
 */ export class ReviewAuditResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewAuditResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewAuditResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewAuditResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewAuditResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.AuditProto audit = 1;
   */ _define_property(this, "audit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewAuditResponse, "runtime", proto3);
_define_property(ReviewAuditResponse, "typeName", "mono.ryugu.v1.ReviewAuditResponse");
_define_property(ReviewAuditResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit",
            kind: "message",
            T: AuditProto
        }
    ]));
/**
 * Lifecycle: Close audit (Published → Closed Complete, requires all CAs resolved)
 *
 * @generated from message mono.ryugu.v1.CloseAuditRequest
 */ export class CloseAuditRequest extends Message {
    static fromBinary(bytes, options) {
        return new CloseAuditRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseAuditRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseAuditRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseAuditRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string audit_id = 1;
   */ _define_property(this, "auditId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseAuditRequest, "runtime", proto3);
_define_property(CloseAuditRequest, "typeName", "mono.ryugu.v1.CloseAuditRequest");
_define_property(CloseAuditRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CloseAuditResponse
 */ export class CloseAuditResponse extends Message {
    static fromBinary(bytes, options) {
        return new CloseAuditResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseAuditResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseAuditResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseAuditResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.AuditProto audit = 1;
   */ _define_property(this, "audit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseAuditResponse, "runtime", proto3);
_define_property(CloseAuditResponse, "typeName", "mono.ryugu.v1.CloseAuditResponse");
_define_property(CloseAuditResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit",
            kind: "message",
            T: AuditProto
        }
    ]));
/**
 * Planned monthly workflow lifecycle.
 *
 * @generated from message mono.ryugu.v1.StartAuditRequest
 */ export class StartAuditRequest extends Message {
    static fromBinary(bytes, options) {
        return new StartAuditRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartAuditRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartAuditRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartAuditRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * "2026-07"; defaults to the current month if empty
   *
   * @generated from field: string period_month = 2;
   */ _define_property(this, "periodMonth", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StartAuditRequest, "runtime", proto3);
_define_property(StartAuditRequest, "typeName", "mono.ryugu.v1.StartAuditRequest");
_define_property(StartAuditRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "period_month",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.StartAuditResponse
 */ export class StartAuditResponse extends Message {
    static fromBinary(bytes, options) {
        return new StartAuditResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartAuditResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartAuditResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartAuditResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.AuditProto audit = 1;
   */ _define_property(this, "audit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StartAuditResponse, "runtime", proto3);
_define_property(StartAuditResponse, "typeName", "mono.ryugu.v1.StartAuditResponse");
_define_property(StartAuditResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit",
            kind: "message",
            T: AuditProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CompleteAuditRequest
 */ export class CompleteAuditRequest extends Message {
    static fromBinary(bytes, options) {
        return new CompleteAuditRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompleteAuditRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompleteAuditRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompleteAuditRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string audit_id = 1;
   */ _define_property(this, "auditId", ""), /**
   * @generated from field: string audit_summary = 2;
   */ _define_property(this, "auditSummary", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompleteAuditRequest, "runtime", proto3);
_define_property(CompleteAuditRequest, "typeName", "mono.ryugu.v1.CompleteAuditRequest");
_define_property(CompleteAuditRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "audit_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CompleteAuditResponse
 */ export class CompleteAuditResponse extends Message {
    static fromBinary(bytes, options) {
        return new CompleteAuditResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompleteAuditResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompleteAuditResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompleteAuditResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.AuditProto audit = 1;
   */ _define_property(this, "audit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompleteAuditResponse, "runtime", proto3);
_define_property(CompleteAuditResponse, "typeName", "mono.ryugu.v1.CompleteAuditResponse");
_define_property(CompleteAuditResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit",
            kind: "message",
            T: AuditProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ResolveCorrectiveActionRequest
 */ export class ResolveCorrectiveActionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveCorrectiveActionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveCorrectiveActionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveCorrectiveActionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveCorrectiveActionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string corrective_action_id = 1;
   */ _define_property(this, "correctiveActionId", ""), /**
   * @generated from field: string resolution_note = 2;
   */ _define_property(this, "resolutionNote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveCorrectiveActionRequest, "runtime", proto3);
_define_property(ResolveCorrectiveActionRequest, "typeName", "mono.ryugu.v1.ResolveCorrectiveActionRequest");
_define_property(ResolveCorrectiveActionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "corrective_action_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "resolution_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ResolveCorrectiveActionResponse
 */ export class ResolveCorrectiveActionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveCorrectiveActionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveCorrectiveActionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveCorrectiveActionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveCorrectiveActionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CorrectiveActionProto action = 1;
   */ _define_property(this, "action", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveCorrectiveActionResponse, "runtime", proto3);
_define_property(ResolveCorrectiveActionResponse, "typeName", "mono.ryugu.v1.ResolveCorrectiveActionResponse");
_define_property(ResolveCorrectiveActionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "action",
            kind: "message",
            T: CorrectiveActionProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.VerifyCorrectiveActionRequest
 */ export class VerifyCorrectiveActionRequest extends Message {
    static fromBinary(bytes, options) {
        return new VerifyCorrectiveActionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VerifyCorrectiveActionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VerifyCorrectiveActionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VerifyCorrectiveActionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string corrective_action_id = 1;
   */ _define_property(this, "correctiveActionId", ""), /**
   * true → Verified (item flips to Pass); false → back to Open
   *
   * @generated from field: bool accepted = 2;
   */ _define_property(this, "accepted", false), /**
   * @generated from field: string verifier_notes = 3;
   */ _define_property(this, "verifierNotes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(VerifyCorrectiveActionRequest, "runtime", proto3);
_define_property(VerifyCorrectiveActionRequest, "typeName", "mono.ryugu.v1.VerifyCorrectiveActionRequest");
_define_property(VerifyCorrectiveActionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "corrective_action_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "accepted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "verifier_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.VerifyCorrectiveActionResponse
 */ export class VerifyCorrectiveActionResponse extends Message {
    static fromBinary(bytes, options) {
        return new VerifyCorrectiveActionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VerifyCorrectiveActionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VerifyCorrectiveActionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VerifyCorrectiveActionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CorrectiveActionProto action = 1;
   */ _define_property(this, "action", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(VerifyCorrectiveActionResponse, "runtime", proto3);
_define_property(VerifyCorrectiveActionResponse, "typeName", "mono.ryugu.v1.VerifyCorrectiveActionResponse");
_define_property(VerifyCorrectiveActionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "action",
            kind: "message",
            T: CorrectiveActionProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.WithdrawCorrectiveActionRequest
 */ export class WithdrawCorrectiveActionRequest extends Message {
    static fromBinary(bytes, options) {
        return new WithdrawCorrectiveActionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WithdrawCorrectiveActionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WithdrawCorrectiveActionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WithdrawCorrectiveActionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string corrective_action_id = 1;
   */ _define_property(this, "correctiveActionId", ""), /**
   * optional: why it was withdrawn (appended to the record)
   *
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WithdrawCorrectiveActionRequest, "runtime", proto3);
_define_property(WithdrawCorrectiveActionRequest, "typeName", "mono.ryugu.v1.WithdrawCorrectiveActionRequest");
_define_property(WithdrawCorrectiveActionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "corrective_action_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.WithdrawCorrectiveActionResponse
 */ export class WithdrawCorrectiveActionResponse extends Message {
    static fromBinary(bytes, options) {
        return new WithdrawCorrectiveActionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WithdrawCorrectiveActionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WithdrawCorrectiveActionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WithdrawCorrectiveActionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CorrectiveActionProto action = 1;
   */ _define_property(this, "action", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WithdrawCorrectiveActionResponse, "runtime", proto3);
_define_property(WithdrawCorrectiveActionResponse, "typeName", "mono.ryugu.v1.WithdrawCorrectiveActionResponse");
_define_property(WithdrawCorrectiveActionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "action",
            kind: "message",
            T: CorrectiveActionProto
        }
    ]));
/**
 * CA extension request
 *
 * @generated from message mono.ryugu.v1.RequestCAExtensionRequest
 */ export class RequestCAExtensionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RequestCAExtensionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RequestCAExtensionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RequestCAExtensionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RequestCAExtensionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string corrective_action_id = 1;
   */ _define_property(this, "correctiveActionId", ""), /**
   * @generated from field: google.protobuf.Timestamp expected_date = 2;
   */ _define_property(this, "expectedDate", void 0), /**
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RequestCAExtensionRequest, "runtime", proto3);
_define_property(RequestCAExtensionRequest, "typeName", "mono.ryugu.v1.RequestCAExtensionRequest");
_define_property(RequestCAExtensionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "corrective_action_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "expected_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RequestCAExtensionResponse
 */ export class RequestCAExtensionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RequestCAExtensionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RequestCAExtensionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RequestCAExtensionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RequestCAExtensionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CorrectiveActionProto action = 1;
   */ _define_property(this, "action", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RequestCAExtensionResponse, "runtime", proto3);
_define_property(RequestCAExtensionResponse, "typeName", "mono.ryugu.v1.RequestCAExtensionResponse");
_define_property(RequestCAExtensionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "action",
            kind: "message",
            T: CorrectiveActionProto
        }
    ]));
/**
 * Audit Questions
 *
 * @generated from message mono.ryugu.v1.AuditQuestionProto
 */ export class AuditQuestionProto extends Message {
    static fromBinary(bytes, options) {
        return new AuditQuestionProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuditQuestionProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuditQuestionProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuditQuestionProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string audit_id = 2;
   */ _define_property(this, "auditId", ""), /**
   * @generated from field: string question = 3;
   */ _define_property(this, "question", ""), /**
   * Pass, Fail, N/A
   *
   * @generated from field: string result = 4;
   */ _define_property(this, "result", ""), /**
   * @generated from field: string notes = 5;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: bool corrective_action_required = 6;
   */ _define_property(this, "correctiveActionRequired", false), /**
   * @generated from field: bool resolved_during_audit = 7;
   */ _define_property(this, "resolvedDuringAudit", false), /**
   * @generated from field: int32 sort_order = 8;
   */ _define_property(this, "sortOrder", 0), /**
   * Standard-checklist provenance + owner routing (cloned from the template).
   *
   * @generated from field: int32 item_number = 9;
   */ _define_property(this, "itemNumber", 0), /**
   * @generated from field: string checklist_item_key = 10;
   */ _define_property(this, "checklistItemKey", ""), /**
   * @generated from field: string review_area = 11;
   */ _define_property(this, "reviewArea", ""), /**
   * @generated from field: string responsibility_key = 12;
   */ _define_property(this, "responsibilityKey", ""), /**
   * "What the auditor confirms" — the checklist guidance, cloned from the template.
   *
   * @generated from field: string description = 13;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string project_phase = 14;
   */ _define_property(this, "projectPhase", ""), /**
   * @generated from field: string evidence_owner = 15;
   */ _define_property(this, "evidenceOwner", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AuditQuestionProto, "runtime", proto3);
_define_property(AuditQuestionProto, "typeName", "mono.ryugu.v1.AuditQuestionProto");
_define_property(AuditQuestionProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "audit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "question",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "result",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "corrective_action_required",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "resolved_during_audit",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "item_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "checklist_item_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "review_area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "responsibility_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "project_phase",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "evidence_owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListAuditQuestionsRequest
 */ export class ListAuditQuestionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditQuestionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditQuestionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditQuestionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditQuestionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string audit_id = 1;
   */ _define_property(this, "auditId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditQuestionsRequest, "runtime", proto3);
_define_property(ListAuditQuestionsRequest, "typeName", "mono.ryugu.v1.ListAuditQuestionsRequest");
_define_property(ListAuditQuestionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListAuditQuestionsResponse
 */ export class ListAuditQuestionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditQuestionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditQuestionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditQuestionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditQuestionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.AuditQuestionProto questions = 1;
   */ _define_property(this, "questions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditQuestionsResponse, "runtime", proto3);
_define_property(ListAuditQuestionsResponse, "typeName", "mono.ryugu.v1.ListAuditQuestionsResponse");
_define_property(ListAuditQuestionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "questions",
            kind: "message",
            T: AuditQuestionProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertAuditQuestionRequest
 */ export class UpsertAuditQuestionRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertAuditQuestionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertAuditQuestionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertAuditQuestionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertAuditQuestionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string audit_id = 2;
   */ _define_property(this, "auditId", ""), /**
   * @generated from field: string question = 3;
   */ _define_property(this, "question", ""), /**
   * @generated from field: string result = 4;
   */ _define_property(this, "result", ""), /**
   * @generated from field: string notes = 5;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: bool corrective_action_required = 6;
   */ _define_property(this, "correctiveActionRequired", false), /**
   * @generated from field: bool resolved_during_audit = 7;
   */ _define_property(this, "resolvedDuringAudit", false), /**
   * @generated from field: int32 sort_order = 8;
   */ _define_property(this, "sortOrder", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertAuditQuestionRequest, "runtime", proto3);
_define_property(UpsertAuditQuestionRequest, "typeName", "mono.ryugu.v1.UpsertAuditQuestionRequest");
_define_property(UpsertAuditQuestionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "audit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "question",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "result",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "corrective_action_required",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "resolved_during_audit",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertAuditQuestionResponse
 */ export class UpsertAuditQuestionResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertAuditQuestionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertAuditQuestionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertAuditQuestionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertAuditQuestionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.AuditQuestionProto question = 1;
   */ _define_property(this, "question", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertAuditQuestionResponse, "runtime", proto3);
_define_property(UpsertAuditQuestionResponse, "typeName", "mono.ryugu.v1.UpsertAuditQuestionResponse");
_define_property(UpsertAuditQuestionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "question",
            kind: "message",
            T: AuditQuestionProto
        }
    ]));
/**
 * Corrective Actions
 *
 * @generated from message mono.ryugu.v1.CorrectiveActionProto
 */ export class CorrectiveActionProto extends Message {
    static fromBinary(bytes, options) {
        return new CorrectiveActionProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CorrectiveActionProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CorrectiveActionProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CorrectiveActionProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string audit_id = 2;
   */ _define_property(this, "auditId", ""), /**
   * @generated from field: string question_id = 3;
   */ _define_property(this, "questionId", ""), /**
   * the "Finding"
   *
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string assigned_to = 5;
   */ _define_property(this, "assignedTo", ""), /**
   * Open, In Progress, Resolved, Verified
   *
   * @generated from field: string state = 6;
   */ _define_property(this, "state", ""), /**
   * @generated from field: google.protobuf.Timestamp due_date = 7;
   */ _define_property(this, "dueDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp resolved_at = 8;
   */ _define_property(this, "resolvedAt", void 0), /**
   * @generated from field: bool extension_requested = 11;
   */ _define_property(this, "extensionRequested", false), /**
   * @generated from field: google.protobuf.Timestamp extension_expected_date = 12;
   */ _define_property(this, "extensionExpectedDate", void 0), /**
   * @generated from field: string extension_reason = 13;
   */ _define_property(this, "extensionReason", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string assigned_contact_id = 14;
   */ _define_property(this, "assignedContactId", ""), /**
   * Resolution (by the section owner) + verification (by the auditor).
   *
   * @generated from field: string resolution_note = 15;
   */ _define_property(this, "resolutionNote", ""), /**
   * @generated from field: string resolved_by_contact_id = 16;
   */ _define_property(this, "resolvedByContactId", ""), /**
   * @generated from field: string responsibility_key = 17;
   */ _define_property(this, "responsibilityKey", ""), /**
   * @generated from field: string verified_by_contact_id = 18;
   */ _define_property(this, "verifiedByContactId", ""), /**
   * @generated from field: google.protobuf.Timestamp verified_at = 19;
   */ _define_property(this, "verifiedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CorrectiveActionProto, "runtime", proto3);
_define_property(CorrectiveActionProto, "typeName", "mono.ryugu.v1.CorrectiveActionProto");
_define_property(CorrectiveActionProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "audit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "assigned_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "due_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "resolved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "extension_requested",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "extension_expected_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "extension_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "assigned_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "resolution_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "resolved_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "responsibility_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "verified_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "verified_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCorrectiveActionsRequest
 */ export class ListCorrectiveActionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCorrectiveActionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCorrectiveActionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCorrectiveActionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCorrectiveActionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string audit_id = 1;
   */ _define_property(this, "auditId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCorrectiveActionsRequest, "runtime", proto3);
_define_property(ListCorrectiveActionsRequest, "typeName", "mono.ryugu.v1.ListCorrectiveActionsRequest");
_define_property(ListCorrectiveActionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCorrectiveActionsResponse
 */ export class ListCorrectiveActionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCorrectiveActionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCorrectiveActionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCorrectiveActionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCorrectiveActionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.CorrectiveActionProto actions = 1;
   */ _define_property(this, "actions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCorrectiveActionsResponse, "runtime", proto3);
_define_property(ListCorrectiveActionsResponse, "typeName", "mono.ryugu.v1.ListCorrectiveActionsResponse");
_define_property(ListCorrectiveActionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "actions",
            kind: "message",
            T: CorrectiveActionProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertCorrectiveActionRequest
 */ export class UpsertCorrectiveActionRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCorrectiveActionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCorrectiveActionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCorrectiveActionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCorrectiveActionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string audit_id = 2;
   */ _define_property(this, "auditId", ""), /**
   * @generated from field: string question_id = 3;
   */ _define_property(this, "questionId", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string assigned_to = 5;
   */ _define_property(this, "assignedTo", ""), /**
   * @generated from field: string state = 6;
   */ _define_property(this, "state", ""), /**
   * @generated from field: google.protobuf.Timestamp due_date = 7;
   */ _define_property(this, "dueDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp resolved_at = 8;
   */ _define_property(this, "resolvedAt", void 0), /**
   * @generated from field: string assigned_contact_id = 9;
   */ _define_property(this, "assignedContactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCorrectiveActionRequest, "runtime", proto3);
_define_property(UpsertCorrectiveActionRequest, "typeName", "mono.ryugu.v1.UpsertCorrectiveActionRequest");
_define_property(UpsertCorrectiveActionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "audit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "assigned_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "due_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "resolved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "assigned_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertCorrectiveActionResponse
 */ export class UpsertCorrectiveActionResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCorrectiveActionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCorrectiveActionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCorrectiveActionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCorrectiveActionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CorrectiveActionProto action = 1;
   */ _define_property(this, "action", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCorrectiveActionResponse, "runtime", proto3);
_define_property(UpsertCorrectiveActionResponse, "typeName", "mono.ryugu.v1.UpsertCorrectiveActionResponse");
_define_property(UpsertCorrectiveActionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "action",
            kind: "message",
            T: CorrectiveActionProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeviationProto
 */ export class DeviationProto extends Message {
    static fromBinary(bytes, options) {
        return new DeviationProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeviationProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeviationProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeviationProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * Waiver, Tailoring
   *
   * @generated from field: string type = 3;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string category = 4;
   */ _define_property(this, "category", ""), /**
   * @generated from field: string comment = 5;
   */ _define_property(this, "comment", ""), /**
   * Requested, Approved, Denied
   *
   * @generated from field: string state = 6;
   */ _define_property(this, "state", ""), /**
   * CO, COR, BOTH
   *
   * @generated from field: string approval_source = 7;
   */ _define_property(this, "approvalSource", ""), /**
   * @generated from field: string linked_task_id = 8;
   */ _define_property(this, "linkedTaskId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string linked_clin_id = 11;
   */ _define_property(this, "linkedClinId", ""), /**
   * The CO/COR contact this deviation's approval is linked to (alongside the
   * approval_source code).
   *
   * @generated from field: string approved_by_contact_id = 12;
   */ _define_property(this, "approvedByContactId", ""), /**
   * The approver's name at the time of approval, denormalized so it survives
   * that contact being removed from the program (mirrors the risk owner).
   *
   * @generated from field: string approved_by_contact_name = 13;
   */ _define_property(this, "approvedByContactName", ""), /**
   * New due date approved by a WAIVER, substituting for the linked task's own
   * due date (SAD-165). Absent/nil means this waiver approves no new date.
   * Only effective when type = "WAIVER" and state = "Approved" -- Tailoring
   * never modulates timeliness, and a Requested/Denied waiver's date is
   * stored but inert.
   *
   * @generated from field: optional google.protobuf.Timestamp approved_replacement_due_date = 14;
   */ _define_property(this, "approvedReplacementDueDate", void 0), /**
   * When the approval answer (Approved/Denied) came back (SAD-172).
   * Absent/nil means no answer date is recorded yet. Independent of
   * approved_replacement_due_date: this never modulates task timeliness, it
   * only timestamps the answer itself.
   *
   * @generated from field: optional google.protobuf.Timestamp answered_at = 15;
   */ _define_property(this, "answeredAt", void 0), /**
   * Which occurrence of a recurring deliverable this waiver targets
   * (delivery.deliverable_instances.id), a SAD-165 follow-up to
   * approved_replacement_due_date above. Absent/"" means this waiver targets
   * the whole linked task -- the pre-existing behaviour. Only meaningful
   * together with linked_task_id: a waiver cannot name an occurrence without
   * naming the task it belongs to.
   *
   * @generated from field: string linked_deliverable_instance_id = 16;
   */ _define_property(this, "linkedDeliverableInstanceId", ""), /**
   * Recurrence this WAIVER approves for the linked deliverable going forward
   * (SAD-165, matt 2026-08-27): Weekly|Biweekly|Monthly|Quarterly|Annually.
   * "" means this waiver approves no cadence change. Only effective when
   * type = "WAIVER" and state = "Approved", the same gate
   * approved_replacement_due_date carries.
   *
   * The change is re-projected FORWARD ONLY. linked_deliverable_instance_id
   * above names the intended anchor, but an unconditional floor at the latest
   * occurrence carrying real delivery work overrides it, so a cadence change
   * can never delete an already-delivered occurrence nor create one inside
   * delivered history.
   *
   * @generated from field: string approved_cadence = 17;
   */ _define_property(this, "approvedCadence", ""), /**
   * Contract model v2 (D113): the duty and/or occurrence this row is about.
   * "" = none. See pangaea's message for the tenant/program and
   * occurrence-of-duty rules.
   *
   * @generated from field: string linked_duty_id = 18;
   */ _define_property(this, "linkedDutyId", ""), /**
   * @generated from field: string linked_occurrence_id = 19;
   */ _define_property(this, "linkedOccurrenceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeviationProto, "runtime", proto3);
_define_property(DeviationProto, "typeName", "mono.ryugu.v1.DeviationProto");
_define_property(DeviationProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "approval_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "linked_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "linked_clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "approved_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "approved_by_contact_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "approved_replacement_due_date",
            kind: "message",
            T: Timestamp,
            opt: true
        },
        {
            no: 15,
            name: "answered_at",
            kind: "message",
            T: Timestamp,
            opt: true
        },
        {
            no: 16,
            name: "linked_deliverable_instance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "approved_cadence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "linked_duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "linked_occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListDeviationsRequest
 */ export class ListDeviationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDeviationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeviationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeviationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeviationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeviationsRequest, "runtime", proto3);
_define_property(ListDeviationsRequest, "typeName", "mono.ryugu.v1.ListDeviationsRequest");
_define_property(ListDeviationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListDeviationsResponse
 */ export class ListDeviationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDeviationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeviationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeviationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeviationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.DeviationProto deviations = 1;
   */ _define_property(this, "deviations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeviationsResponse, "runtime", proto3);
_define_property(ListDeviationsResponse, "typeName", "mono.ryugu.v1.ListDeviationsResponse");
_define_property(ListDeviationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deviations",
            kind: "message",
            T: DeviationProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertDeviationRequest
 */ export class UpsertDeviationRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertDeviationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertDeviationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertDeviationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertDeviationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string type = 3;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string category = 4;
   */ _define_property(this, "category", ""), /**
   * @generated from field: string comment = 5;
   */ _define_property(this, "comment", ""), /**
   * @generated from field: string state = 6;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string approval_source = 7;
   */ _define_property(this, "approvalSource", ""), /**
   * @generated from field: string linked_task_id = 8;
   */ _define_property(this, "linkedTaskId", ""), /**
   * @generated from field: string linked_clin_id = 9;
   */ _define_property(this, "linkedClinId", ""), /**
   * @generated from field: string approved_by_contact_id = 10;
   */ _define_property(this, "approvedByContactId", ""), /**
   * @generated from field: string approved_by_contact_name = 11;
   */ _define_property(this, "approvedByContactName", ""), /**
   * Explicit-presence, same contract as DeviationProto above: absent leaves
   * the stored replacement due date untouched (a partial-payload update
   * cannot silently blank it). Present sets it, EXCEPT a present zero-value
   * Timestamp (seconds == 0 && nanos == 0) -- no real waiver due date is ever
   * the Unix epoch, so that value is the wire-level signal to clear the
   * stored date back to NULL.
   *
   * @generated from field: optional google.protobuf.Timestamp approved_replacement_due_date = 12;
   */ _define_property(this, "approvedReplacementDueDate", void 0), /**
   * Explicit-presence, same wire contract as approved_replacement_due_date
   * above: absent leaves the stored answered_at untouched; a present
   * zero-value Timestamp clears it back to NULL.
   *
   * @generated from field: optional google.protobuf.Timestamp answered_at = 13;
   */ _define_property(this, "answeredAt", void 0), /**
   * Which occurrence of a recurring deliverable this waiver targets
   * (delivery.deliverable_instances.id). Explicit presence, same contract as
   * approved_replacement_due_date/answered_at above: absent leaves the
   * stored occurrence link untouched (a partial-payload update cannot
   * silently blank it); present "" is the deliberate clear back to "whole
   * linked task" (the pre-existing behaviour); present non-"" sets it. Only
   * meaningful together with linked_task_id: setting this with an empty
   * linked_task_id is rejected, as is naming an occurrence that does not
   * belong to linked_task_id or does not belong to this deviation's program.
   *
   * @generated from field: optional string linked_deliverable_instance_id = 14;
   */ _define_property(this, "linkedDeliverableInstanceId", void 0), /**
   * Explicit presence, same wire contract as the three fields above: absent
   * leaves the stored cadence untouched (an older client that predates this
   * field cannot silently blank an approved cadence change on save); present
   * "" is the deliberate clear back to "this waiver approves no cadence
   * change"; present non-"" sets it. Only meaningful together with
   * linked_task_id -- a cadence belongs to a deliverable's series, so setting
   * this without naming the deliverable is rejected, as is a value outside
   * the recognised recurrence vocabulary.
   *
   * @generated from field: optional string approved_cadence = 15;
   */ _define_property(this, "approvedCadence", void 0), /**
   * Contract model v2 (D113): the duty and/or occurrence this row is about.
   * Explicit presence, as linked_deliverable_instance_id on
   * UpsertDeviationRequest: absent leaves the stored link untouched (a client
   * that predates these fields cannot blank them), present "" clears it,
   * present non-"" sets it. A duty or occurrence outside this program is
   * refused (FailedPrecondition from pangaea), as is an occurrence that is not
   * the named duty's (InvalidArgument).
   *
   * @generated from field: optional string linked_duty_id = 16;
   */ _define_property(this, "linkedDutyId", void 0), /**
   * @generated from field: optional string linked_occurrence_id = 17;
   */ _define_property(this, "linkedOccurrenceId", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertDeviationRequest, "runtime", proto3);
_define_property(UpsertDeviationRequest, "typeName", "mono.ryugu.v1.UpsertDeviationRequest");
_define_property(UpsertDeviationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "approval_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "linked_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "linked_clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "approved_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "approved_by_contact_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "approved_replacement_due_date",
            kind: "message",
            T: Timestamp,
            opt: true
        },
        {
            no: 13,
            name: "answered_at",
            kind: "message",
            T: Timestamp,
            opt: true
        },
        {
            no: 14,
            name: "linked_deliverable_instance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 15,
            name: "approved_cadence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 16,
            name: "linked_duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 17,
            name: "linked_occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertDeviationResponse
 */ export class UpsertDeviationResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertDeviationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertDeviationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertDeviationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertDeviationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.DeviationProto deviation = 1;
   */ _define_property(this, "deviation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertDeviationResponse, "runtime", proto3);
_define_property(UpsertDeviationResponse, "typeName", "mono.ryugu.v1.UpsertDeviationResponse");
_define_property(UpsertDeviationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deviation",
            kind: "message",
            T: DeviationProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteDeviationRequest
 */ export class DeleteDeviationRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDeviationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDeviationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDeviationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDeviationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDeviationRequest, "runtime", proto3);
_define_property(DeleteDeviationRequest, "typeName", "mono.ryugu.v1.DeleteDeviationRequest");
_define_property(DeleteDeviationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteDeviationResponse
 */ export class DeleteDeviationResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDeviationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDeviationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDeviationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDeviationResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDeviationResponse, "runtime", proto3);
_define_property(DeleteDeviationResponse, "typeName", "mono.ryugu.v1.DeleteDeviationResponse");
_define_property(DeleteDeviationResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.CPARSScoreProto
 */ export class CPARSScoreProto extends Message {
    static fromBinary(bytes, options) {
        return new CPARSScoreProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CPARSScoreProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CPARSScoreProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CPARSScoreProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: int32 entry_number = 3;
   */ _define_property(this, "entryNumber", 0), /**
   * @generated from field: optional double overall_score = 4;
   */ _define_property(this, "overallScore", void 0), /**
   * @generated from field: google.protobuf.Timestamp eval_period_start = 5;
   */ _define_property(this, "evalPeriodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp eval_period_end = 6;
   */ _define_property(this, "evalPeriodEnd", void 0), /**
   * @generated from field: string overall_comment = 7;
   */ _define_property(this, "overallComment", ""), /**
   * @generated from field: optional double quality_score = 8;
   */ _define_property(this, "qualityScore", void 0), /**
   * @generated from field: optional double schedule_score = 9;
   */ _define_property(this, "scheduleScore", void 0), /**
   * @generated from field: optional double cost_control_score = 10;
   */ _define_property(this, "costControlScore", void 0), /**
   * @generated from field: optional double management_score = 11;
   */ _define_property(this, "managementScore", void 0), /**
   * @generated from field: optional double small_business_score = 12;
   */ _define_property(this, "smallBusinessScore", void 0), /**
   * @generated from field: optional double regulatory_compliance_score = 13;
   */ _define_property(this, "regulatoryComplianceScore", void 0), /**
   * @generated from field: string quality_narrative = 14;
   */ _define_property(this, "qualityNarrative", ""), /**
   * @generated from field: string schedule_narrative = 15;
   */ _define_property(this, "scheduleNarrative", ""), /**
   * @generated from field: string cost_control_narrative = 16;
   */ _define_property(this, "costControlNarrative", ""), /**
   * @generated from field: string management_narrative = 17;
   */ _define_property(this, "managementNarrative", ""), /**
   * @generated from field: string small_business_narrative = 18;
   */ _define_property(this, "smallBusinessNarrative", ""), /**
   * @generated from field: string regulatory_compliance_narrative = 19;
   */ _define_property(this, "regulatoryComplianceNarrative", ""), /**
   * @generated from field: string get_well_plan = 20;
   */ _define_property(this, "getWellPlan", ""), /**
   * @generated from field: string attachment_id = 21;
   */ _define_property(this, "attachmentId", ""), /**
   * Concurred, Non-concurred, Pending
   *
   * @generated from field: string concurrence_status = 23;
   */ _define_property(this, "concurrenceStatus", ""), /**
   * @generated from field: string concurrence_comment = 24;
   */ _define_property(this, "concurrenceComment", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 22;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CPARSScoreProto, "runtime", proto3);
_define_property(CPARSScoreProto, "typeName", "mono.ryugu.v1.CPARSScoreProto");
_define_property(CPARSScoreProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "entry_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "overall_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 5,
            name: "eval_period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "eval_period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "overall_comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "quality_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 9,
            name: "schedule_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 10,
            name: "cost_control_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 11,
            name: "management_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 12,
            name: "small_business_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 13,
            name: "regulatory_compliance_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 14,
            name: "quality_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "schedule_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "cost_control_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "management_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "small_business_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "regulatory_compliance_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "get_well_plan",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "concurrence_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "concurrence_comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCPARSScoresRequest
 */ export class ListCPARSScoresRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCPARSScoresRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCPARSScoresRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCPARSScoresRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCPARSScoresRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCPARSScoresRequest, "runtime", proto3);
_define_property(ListCPARSScoresRequest, "typeName", "mono.ryugu.v1.ListCPARSScoresRequest");
_define_property(ListCPARSScoresRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCPARSScoresResponse
 */ export class ListCPARSScoresResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCPARSScoresResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCPARSScoresResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCPARSScoresResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCPARSScoresResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.CPARSScoreProto scores = 1;
   */ _define_property(this, "scores", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCPARSScoresResponse, "runtime", proto3);
_define_property(ListCPARSScoresResponse, "typeName", "mono.ryugu.v1.ListCPARSScoresResponse");
_define_property(ListCPARSScoresResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scores",
            kind: "message",
            T: CPARSScoreProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertCPARSScoreRequest
 */ export class UpsertCPARSScoreRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCPARSScoreRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCPARSScoreRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCPARSScoreRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCPARSScoreRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * Intentionally unread by the server (SAD-171): entry_number is now
   * system-assigned on create and preserved as-is on update. Kept on the
   * wire for client compatibility only.
   *
   * @generated from field: int32 entry_number = 3;
   */ _define_property(this, "entryNumber", 0), /**
   * @generated from field: optional double overall_score = 4;
   */ _define_property(this, "overallScore", void 0), /**
   * @generated from field: google.protobuf.Timestamp eval_period_start = 5;
   */ _define_property(this, "evalPeriodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp eval_period_end = 6;
   */ _define_property(this, "evalPeriodEnd", void 0), /**
   * @generated from field: string overall_comment = 7;
   */ _define_property(this, "overallComment", ""), /**
   * @generated from field: optional double quality_score = 8;
   */ _define_property(this, "qualityScore", void 0), /**
   * @generated from field: optional double schedule_score = 9;
   */ _define_property(this, "scheduleScore", void 0), /**
   * @generated from field: optional double cost_control_score = 10;
   */ _define_property(this, "costControlScore", void 0), /**
   * @generated from field: optional double management_score = 11;
   */ _define_property(this, "managementScore", void 0), /**
   * @generated from field: optional double small_business_score = 12;
   */ _define_property(this, "smallBusinessScore", void 0), /**
   * @generated from field: optional double regulatory_compliance_score = 13;
   */ _define_property(this, "regulatoryComplianceScore", void 0), /**
   * @generated from field: string quality_narrative = 14;
   */ _define_property(this, "qualityNarrative", ""), /**
   * @generated from field: string schedule_narrative = 15;
   */ _define_property(this, "scheduleNarrative", ""), /**
   * @generated from field: string cost_control_narrative = 16;
   */ _define_property(this, "costControlNarrative", ""), /**
   * @generated from field: string management_narrative = 17;
   */ _define_property(this, "managementNarrative", ""), /**
   * @generated from field: string small_business_narrative = 18;
   */ _define_property(this, "smallBusinessNarrative", ""), /**
   * @generated from field: string regulatory_compliance_narrative = 19;
   */ _define_property(this, "regulatoryComplianceNarrative", ""), /**
   * @generated from field: string get_well_plan = 20;
   */ _define_property(this, "getWellPlan", ""), /**
   * @generated from field: string attachment_id = 21;
   */ _define_property(this, "attachmentId", ""), /**
   * @generated from field: string concurrence_status = 22;
   */ _define_property(this, "concurrenceStatus", ""), /**
   * @generated from field: string concurrence_comment = 23;
   */ _define_property(this, "concurrenceComment", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCPARSScoreRequest, "runtime", proto3);
_define_property(UpsertCPARSScoreRequest, "typeName", "mono.ryugu.v1.UpsertCPARSScoreRequest");
_define_property(UpsertCPARSScoreRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "entry_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "overall_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 5,
            name: "eval_period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "eval_period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "overall_comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "quality_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 9,
            name: "schedule_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 10,
            name: "cost_control_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 11,
            name: "management_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 12,
            name: "small_business_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 13,
            name: "regulatory_compliance_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 14,
            name: "quality_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "schedule_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "cost_control_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "management_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "small_business_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "regulatory_compliance_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "get_well_plan",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "concurrence_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "concurrence_comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertCPARSScoreResponse
 */ export class UpsertCPARSScoreResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCPARSScoreResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCPARSScoreResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCPARSScoreResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCPARSScoreResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CPARSScoreProto score = 1;
   */ _define_property(this, "score", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCPARSScoreResponse, "runtime", proto3);
_define_property(UpsertCPARSScoreResponse, "typeName", "mono.ryugu.v1.UpsertCPARSScoreResponse");
_define_property(UpsertCPARSScoreResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "score",
            kind: "message",
            T: CPARSScoreProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.QASPScoreProto
 */ export class QASPScoreProto extends Message {
    static fromBinary(bytes, options) {
        return new QASPScoreProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QASPScoreProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QASPScoreProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QASPScoreProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string quarter = 3;
   */ _define_property(this, "quarter", ""), /**
   * @generated from field: optional double overall_score = 4;
   */ _define_property(this, "overallScore", void 0), /**
   * @generated from field: optional double technical_score = 5;
   */ _define_property(this, "technicalScore", void 0), /**
   * @generated from field: optional double schedule_score = 6;
   */ _define_property(this, "scheduleScore", void 0), /**
   * @generated from field: optional double cost_staffing_score = 7;
   */ _define_property(this, "costStaffingScore", void 0), /**
   * @generated from field: optional double management_score = 8;
   */ _define_property(this, "managementScore", void 0), /**
   * @generated from field: string technical_narrative = 9;
   */ _define_property(this, "technicalNarrative", ""), /**
   * @generated from field: string schedule_narrative = 10;
   */ _define_property(this, "scheduleNarrative", ""), /**
   * @generated from field: string cost_staffing_narrative = 11;
   */ _define_property(this, "costStaffingNarrative", ""), /**
   * @generated from field: string management_narrative = 12;
   */ _define_property(this, "managementNarrative", ""), /**
   * @generated from field: google.protobuf.Timestamp report_period_start = 13;
   */ _define_property(this, "reportPeriodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp report_period_end = 14;
   */ _define_property(this, "reportPeriodEnd", void 0), /**
   * @generated from field: string get_well_plan = 15;
   */ _define_property(this, "getWellPlan", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string attachment_id = 17;
   */ _define_property(this, "attachmentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(QASPScoreProto, "runtime", proto3);
_define_property(QASPScoreProto, "typeName", "mono.ryugu.v1.QASPScoreProto");
_define_property(QASPScoreProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "quarter",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "overall_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 5,
            name: "technical_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 6,
            name: "schedule_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 7,
            name: "cost_staffing_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 8,
            name: "management_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 9,
            name: "technical_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "schedule_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "cost_staffing_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "management_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "report_period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "report_period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "get_well_plan",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListQASPScoresRequest
 */ export class ListQASPScoresRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListQASPScoresRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListQASPScoresRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListQASPScoresRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListQASPScoresRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListQASPScoresRequest, "runtime", proto3);
_define_property(ListQASPScoresRequest, "typeName", "mono.ryugu.v1.ListQASPScoresRequest");
_define_property(ListQASPScoresRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListQASPScoresResponse
 */ export class ListQASPScoresResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListQASPScoresResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListQASPScoresResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListQASPScoresResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListQASPScoresResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.QASPScoreProto scores = 1;
   */ _define_property(this, "scores", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListQASPScoresResponse, "runtime", proto3);
_define_property(ListQASPScoresResponse, "typeName", "mono.ryugu.v1.ListQASPScoresResponse");
_define_property(ListQASPScoresResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scores",
            kind: "message",
            T: QASPScoreProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertQASPScoreRequest
 */ export class UpsertQASPScoreRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertQASPScoreRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertQASPScoreRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertQASPScoreRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertQASPScoreRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string quarter = 3;
   */ _define_property(this, "quarter", ""), /**
   * @generated from field: optional double overall_score = 4;
   */ _define_property(this, "overallScore", void 0), /**
   * @generated from field: optional double technical_score = 5;
   */ _define_property(this, "technicalScore", void 0), /**
   * @generated from field: optional double schedule_score = 6;
   */ _define_property(this, "scheduleScore", void 0), /**
   * @generated from field: optional double cost_staffing_score = 7;
   */ _define_property(this, "costStaffingScore", void 0), /**
   * @generated from field: optional double management_score = 8;
   */ _define_property(this, "managementScore", void 0), /**
   * @generated from field: string technical_narrative = 9;
   */ _define_property(this, "technicalNarrative", ""), /**
   * @generated from field: string schedule_narrative = 10;
   */ _define_property(this, "scheduleNarrative", ""), /**
   * @generated from field: string cost_staffing_narrative = 11;
   */ _define_property(this, "costStaffingNarrative", ""), /**
   * @generated from field: string management_narrative = 12;
   */ _define_property(this, "managementNarrative", ""), /**
   * @generated from field: google.protobuf.Timestamp report_period_start = 13;
   */ _define_property(this, "reportPeriodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp report_period_end = 14;
   */ _define_property(this, "reportPeriodEnd", void 0), /**
   * @generated from field: string get_well_plan = 15;
   */ _define_property(this, "getWellPlan", ""), /**
   * @generated from field: string attachment_id = 16;
   */ _define_property(this, "attachmentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertQASPScoreRequest, "runtime", proto3);
_define_property(UpsertQASPScoreRequest, "typeName", "mono.ryugu.v1.UpsertQASPScoreRequest");
_define_property(UpsertQASPScoreRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "quarter",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "overall_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 5,
            name: "technical_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 6,
            name: "schedule_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 7,
            name: "cost_staffing_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 8,
            name: "management_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 9,
            name: "technical_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "schedule_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "cost_staffing_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "management_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "report_period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "report_period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "get_well_plan",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertQASPScoreResponse
 */ export class UpsertQASPScoreResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertQASPScoreResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertQASPScoreResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertQASPScoreResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertQASPScoreResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.QASPScoreProto score = 1;
   */ _define_property(this, "score", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertQASPScoreResponse, "runtime", proto3);
_define_property(UpsertQASPScoreResponse, "typeName", "mono.ryugu.v1.UpsertQASPScoreResponse");
_define_property(UpsertQASPScoreResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "score",
            kind: "message",
            T: QASPScoreProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RiskProto
 */ export class RiskProto extends Message {
    static fromBinary(bytes, options) {
        return new RiskProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RiskProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RiskProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RiskProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string category = 3;
   */ _define_property(this, "category", ""), /**
   * @generated from field: string audience = 4;
   */ _define_property(this, "audience", ""), /**
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string strategy = 6;
   */ _define_property(this, "strategy", ""), /**
   * @generated from field: string probability = 7;
   */ _define_property(this, "probability", ""), /**
   * @generated from field: string impact = 8;
   */ _define_property(this, "impact", ""), /**
   * @generated from field: string short_description = 9;
   */ _define_property(this, "shortDescription", ""), /**
   * @generated from field: string strategy_plan = 10;
   */ _define_property(this, "strategyPlan", ""), /**
   * @generated from field: string owner = 11;
   */ _define_property(this, "owner", ""), /**
   * @generated from field: google.protobuf.Timestamp target_resolution_date = 12;
   */ _define_property(this, "targetResolutionDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp actual_resolution_date = 13;
   */ _define_property(this, "actualResolutionDate", void 0), /**
   * @generated from field: string escalation_path = 14;
   */ _define_property(this, "escalationPath", ""), /**
   * @generated from field: string comments = 15;
   */ _define_property(this, "comments", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 17;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string owner_contact_id = 18;
   */ _define_property(this, "ownerContactId", ""), /**
   * @generated from field: string audience_contact_id = 19;
   */ _define_property(this, "audienceContactId", ""), /**
   * @generated from field: string linked_clin_id = 20;
   */ _define_property(this, "linkedClinId", ""), /**
   * @generated from field: string linked_deliverable_id = 21;
   */ _define_property(this, "linkedDeliverableId", ""), /**
   * NOT-S8 leadership escalation snapshot — surfaced read-only so the UI can
   * render the "Escalate to leadership" button's disabled/enabled state
   * without a second round trip. See pangaea's Risk message for the
   * authoritative doc comment.
   *
   * @generated from field: google.protobuf.Timestamp leadership_escalated_at = 22;
   */ _define_property(this, "leadershipEscalatedAt", void 0), /**
   * @generated from field: string leadership_escalated_probability = 23;
   */ _define_property(this, "leadershipEscalatedProbability", ""), /**
   * @generated from field: string leadership_escalated_impact = 24;
   */ _define_property(this, "leadershipEscalatedImpact", ""), /**
   * Contract model v2 (D113): the duty and/or occurrence this row is about.
   * "" = none. See pangaea's message for the tenant/program and
   * occurrence-of-duty rules.
   *
   * @generated from field: string linked_duty_id = 25;
   */ _define_property(this, "linkedDutyId", ""), /**
   * @generated from field: string linked_occurrence_id = 26;
   */ _define_property(this, "linkedOccurrenceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RiskProto, "runtime", proto3);
_define_property(RiskProto, "typeName", "mono.ryugu.v1.RiskProto");
_define_property(RiskProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "audience",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "strategy",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "probability",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "impact",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "short_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "strategy_plan",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "target_resolution_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "actual_resolution_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "escalation_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "comments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "owner_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "audience_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "linked_clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "linked_deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "leadership_escalated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 23,
            name: "leadership_escalated_probability",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "leadership_escalated_impact",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "linked_duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "linked_occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListRisksRequest
 */ export class ListRisksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRisksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRisksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRisksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRisksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRisksRequest, "runtime", proto3);
_define_property(ListRisksRequest, "typeName", "mono.ryugu.v1.ListRisksRequest");
_define_property(ListRisksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListRisksResponse
 */ export class ListRisksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRisksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRisksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRisksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRisksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.RiskProto risks = 1;
   */ _define_property(this, "risks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRisksResponse, "runtime", proto3);
_define_property(ListRisksResponse, "typeName", "mono.ryugu.v1.ListRisksResponse");
_define_property(ListRisksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "risks",
            kind: "message",
            T: RiskProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertRiskRequest
 */ export class UpsertRiskRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertRiskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertRiskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertRiskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertRiskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string category = 3;
   */ _define_property(this, "category", ""), /**
   * @generated from field: string audience = 4;
   */ _define_property(this, "audience", ""), /**
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string strategy = 6;
   */ _define_property(this, "strategy", ""), /**
   * @generated from field: string probability = 7;
   */ _define_property(this, "probability", ""), /**
   * @generated from field: string impact = 8;
   */ _define_property(this, "impact", ""), /**
   * @generated from field: string short_description = 9;
   */ _define_property(this, "shortDescription", ""), /**
   * @generated from field: string strategy_plan = 10;
   */ _define_property(this, "strategyPlan", ""), /**
   * @generated from field: string owner = 11;
   */ _define_property(this, "owner", ""), /**
   * @generated from field: google.protobuf.Timestamp target_resolution_date = 12;
   */ _define_property(this, "targetResolutionDate", void 0), /**
   * @generated from field: string escalation_path = 13;
   */ _define_property(this, "escalationPath", ""), /**
   * @generated from field: string comments = 14;
   */ _define_property(this, "comments", ""), /**
   * @generated from field: string owner_contact_id = 15;
   */ _define_property(this, "ownerContactId", ""), /**
   * @generated from field: string audience_contact_id = 16;
   */ _define_property(this, "audienceContactId", ""), /**
   * @generated from field: string linked_clin_id = 17;
   */ _define_property(this, "linkedClinId", ""), /**
   * @generated from field: string linked_deliverable_id = 18;
   */ _define_property(this, "linkedDeliverableId", ""), /**
   * Contract model v2 (D113): the duty and/or occurrence this row is about.
   * Explicit presence, as linked_deliverable_instance_id on
   * UpsertDeviationRequest: absent leaves the stored link untouched (a client
   * that predates these fields cannot blank them), present "" clears it,
   * present non-"" sets it. A duty or occurrence outside this program is
   * refused (FailedPrecondition from pangaea), as is an occurrence that is not
   * the named duty's (InvalidArgument).
   *
   * @generated from field: optional string linked_duty_id = 19;
   */ _define_property(this, "linkedDutyId", void 0), /**
   * @generated from field: optional string linked_occurrence_id = 20;
   */ _define_property(this, "linkedOccurrenceId", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertRiskRequest, "runtime", proto3);
_define_property(UpsertRiskRequest, "typeName", "mono.ryugu.v1.UpsertRiskRequest");
_define_property(UpsertRiskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "audience",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "strategy",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "probability",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "impact",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "short_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "strategy_plan",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "target_resolution_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "escalation_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "comments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "owner_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "audience_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "linked_clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "linked_deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "linked_duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 20,
            name: "linked_occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertRiskResponse
 */ export class UpsertRiskResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertRiskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertRiskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertRiskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertRiskResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.RiskProto risk = 1;
   */ _define_property(this, "risk", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertRiskResponse, "runtime", proto3);
_define_property(UpsertRiskResponse, "typeName", "mono.ryugu.v1.UpsertRiskResponse");
_define_property(UpsertRiskResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "risk",
            kind: "message",
            T: RiskProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteRiskRequest
 */ export class DeleteRiskRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteRiskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteRiskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteRiskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteRiskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteRiskRequest, "runtime", proto3);
_define_property(DeleteRiskRequest, "typeName", "mono.ryugu.v1.DeleteRiskRequest");
_define_property(DeleteRiskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteRiskResponse
 */ export class DeleteRiskResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteRiskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteRiskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteRiskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteRiskResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteRiskResponse, "runtime", proto3);
_define_property(DeleteRiskResponse, "typeName", "mono.ryugu.v1.DeleteRiskResponse");
_define_property(DeleteRiskResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.EscalateRiskToLeadershipRequest
 */ export class EscalateRiskToLeadershipRequest extends Message {
    static fromBinary(bytes, options) {
        return new EscalateRiskToLeadershipRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EscalateRiskToLeadershipRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EscalateRiskToLeadershipRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EscalateRiskToLeadershipRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EscalateRiskToLeadershipRequest, "runtime", proto3);
_define_property(EscalateRiskToLeadershipRequest, "typeName", "mono.ryugu.v1.EscalateRiskToLeadershipRequest");
_define_property(EscalateRiskToLeadershipRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.EscalateRiskToLeadershipResponse
 */ export class EscalateRiskToLeadershipResponse extends Message {
    static fromBinary(bytes, options) {
        return new EscalateRiskToLeadershipResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EscalateRiskToLeadershipResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EscalateRiskToLeadershipResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EscalateRiskToLeadershipResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.RiskProto risk = 1;
   */ _define_property(this, "risk", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EscalateRiskToLeadershipResponse, "runtime", proto3);
_define_property(EscalateRiskToLeadershipResponse, "typeName", "mono.ryugu.v1.EscalateRiskToLeadershipResponse");
_define_property(EscalateRiskToLeadershipResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "risk",
            kind: "message",
            T: RiskProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.IssueProto
 */ export class IssueProto extends Message {
    static fromBinary(bytes, options) {
        return new IssueProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IssueProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IssueProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IssueProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string priority = 3;
   */ _define_property(this, "priority", ""), /**
   * @generated from field: string impact = 4;
   */ _define_property(this, "impact", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string state = 6;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string assigned_to = 7;
   */ _define_property(this, "assignedTo", ""), /**
   * @generated from field: string root_cause = 8;
   */ _define_property(this, "rootCause", ""), /**
   * Deprecated as of SAD-129: superseded by IssueCommentProto (append-only
   * comment history). Retained only because buf.yaml uses the FILE breaking
   * category (which includes FIELD_NO_DELETE), so the field cannot be removed.
   *
   * @generated from field: string corrective_action = 9 [deprecated = true];
   * @deprecated
   */ _define_property(this, "correctiveAction", ""), /**
   * @generated from field: google.protobuf.Timestamp target_resolution_date = 10;
   */ _define_property(this, "targetResolutionDate", void 0), /**
   * @generated from field: bool high_risk_flag = 11;
   */ _define_property(this, "highRiskFlag", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 13;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp resolved_at = 14;
   */ _define_property(this, "resolvedAt", void 0), /**
   * @generated from field: string assignee_contact_id = 15;
   */ _define_property(this, "assigneeContactId", ""), /**
   * @generated from field: string linked_clin_id = 16;
   */ _define_property(this, "linkedClinId", ""), /**
   * @generated from field: string linked_deliverable_id = 17;
   */ _define_property(this, "linkedDeliverableId", ""), /**
   * Server-owned provenance for auto-created Issues (e.g. Get Well Plan
   * playbook, Risk conversion). Never settable via UpsertIssueRequest.
   *
   * @generated from field: string auto_generated_type = 18;
   */ _define_property(this, "autoGeneratedType", ""), /**
   * @generated from field: string linked_record_id = 19;
   */ _define_property(this, "linkedRecordId", ""), /**
   * Contract model v2 (D113): the duty and/or occurrence this row is about.
   * "" = none. See pangaea's message for the tenant/program and
   * occurrence-of-duty rules.
   *
   * @generated from field: string linked_duty_id = 20;
   */ _define_property(this, "linkedDutyId", ""), /**
   * @generated from field: string linked_occurrence_id = 21;
   */ _define_property(this, "linkedOccurrenceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(IssueProto, "runtime", proto3);
_define_property(IssueProto, "typeName", "mono.ryugu.v1.IssueProto");
_define_property(IssueProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "priority",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "impact",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "assigned_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "root_cause",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "corrective_action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "target_resolution_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "high_risk_flag",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "resolved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "assignee_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "linked_clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "linked_deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "auto_generated_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "linked_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "linked_duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "linked_occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListIssuesRequest
 */ export class ListIssuesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListIssuesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIssuesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIssuesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIssuesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIssuesRequest, "runtime", proto3);
_define_property(ListIssuesRequest, "typeName", "mono.ryugu.v1.ListIssuesRequest");
_define_property(ListIssuesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListIssuesResponse
 */ export class ListIssuesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListIssuesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIssuesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIssuesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIssuesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.IssueProto issues = 1;
   */ _define_property(this, "issues", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIssuesResponse, "runtime", proto3);
_define_property(ListIssuesResponse, "typeName", "mono.ryugu.v1.ListIssuesResponse");
_define_property(ListIssuesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "issues",
            kind: "message",
            T: IssueProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertIssueRequest
 */ export class UpsertIssueRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertIssueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertIssueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertIssueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertIssueRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string priority = 3;
   */ _define_property(this, "priority", ""), /**
   * @generated from field: string impact = 4;
   */ _define_property(this, "impact", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string state = 6;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string assigned_to = 7;
   */ _define_property(this, "assignedTo", ""), /**
   * @generated from field: string root_cause = 8;
   */ _define_property(this, "rootCause", ""), /**
   * Deprecated as of SAD-129: superseded by IssueCommentProto (append-only
   * comment history). Retained only because buf.yaml uses the FILE breaking
   * category (which includes FIELD_NO_DELETE), so the field cannot be removed.
   *
   * @generated from field: string corrective_action = 9 [deprecated = true];
   * @deprecated
   */ _define_property(this, "correctiveAction", ""), /**
   * @generated from field: google.protobuf.Timestamp target_resolution_date = 10;
   */ _define_property(this, "targetResolutionDate", void 0), /**
   * @generated from field: bool high_risk_flag = 11;
   */ _define_property(this, "highRiskFlag", false), /**
   * @generated from field: string assignee_contact_id = 12;
   */ _define_property(this, "assigneeContactId", ""), /**
   * @generated from field: string linked_clin_id = 13;
   */ _define_property(this, "linkedClinId", ""), /**
   * @generated from field: string linked_deliverable_id = 14;
   */ _define_property(this, "linkedDeliverableId", ""), /**
   * Contract model v2 (D113): the duty and/or occurrence this row is about.
   * Explicit presence, as linked_deliverable_instance_id on
   * UpsertDeviationRequest: absent leaves the stored link untouched (a client
   * that predates these fields cannot blank them), present "" clears it,
   * present non-"" sets it. A duty or occurrence outside this program is
   * refused (FailedPrecondition from pangaea), as is an occurrence that is not
   * the named duty's (InvalidArgument).
   *
   * @generated from field: optional string linked_duty_id = 15;
   */ _define_property(this, "linkedDutyId", void 0), /**
   * @generated from field: optional string linked_occurrence_id = 16;
   */ _define_property(this, "linkedOccurrenceId", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertIssueRequest, "runtime", proto3);
_define_property(UpsertIssueRequest, "typeName", "mono.ryugu.v1.UpsertIssueRequest");
_define_property(UpsertIssueRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "priority",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "impact",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "assigned_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "root_cause",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "corrective_action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "target_resolution_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "high_risk_flag",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "assignee_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "linked_clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "linked_deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "linked_duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 16,
            name: "linked_occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertIssueResponse
 */ export class UpsertIssueResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertIssueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertIssueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertIssueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertIssueResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.IssueProto issue = 1;
   */ _define_property(this, "issue", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertIssueResponse, "runtime", proto3);
_define_property(UpsertIssueResponse, "typeName", "mono.ryugu.v1.UpsertIssueResponse");
_define_property(UpsertIssueResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "issue",
            kind: "message",
            T: IssueProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteIssueRequest
 */ export class DeleteIssueRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteIssueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteIssueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteIssueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteIssueRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteIssueRequest, "runtime", proto3);
_define_property(DeleteIssueRequest, "typeName", "mono.ryugu.v1.DeleteIssueRequest");
_define_property(DeleteIssueRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteIssueResponse
 */ export class DeleteIssueResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteIssueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteIssueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteIssueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteIssueResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteIssueResponse, "runtime", proto3);
_define_property(DeleteIssueResponse, "typeName", "mono.ryugu.v1.DeleteIssueResponse");
_define_property(DeleteIssueResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.ConvertRiskToIssueRequest
 */ export class ConvertRiskToIssueRequest extends Message {
    static fromBinary(bytes, options) {
        return new ConvertRiskToIssueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConvertRiskToIssueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConvertRiskToIssueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConvertRiskToIssueRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string risk_id = 1;
   */ _define_property(this, "riskId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConvertRiskToIssueRequest, "runtime", proto3);
_define_property(ConvertRiskToIssueRequest, "typeName", "mono.ryugu.v1.ConvertRiskToIssueRequest");
_define_property(ConvertRiskToIssueRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "risk_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ConvertRiskToIssueResponse
 */ export class ConvertRiskToIssueResponse extends Message {
    static fromBinary(bytes, options) {
        return new ConvertRiskToIssueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConvertRiskToIssueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConvertRiskToIssueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConvertRiskToIssueResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.IssueProto issue = 1;
   */ _define_property(this, "issue", void 0), /**
   * @generated from field: mono.ryugu.v1.RiskProto risk = 2;
   */ _define_property(this, "risk", void 0), /**
   * @generated from field: bool created = 3;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConvertRiskToIssueResponse, "runtime", proto3);
_define_property(ConvertRiskToIssueResponse, "typeName", "mono.ryugu.v1.ConvertRiskToIssueResponse");
_define_property(ConvertRiskToIssueResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "issue",
            kind: "message",
            T: IssueProto
        },
        {
            no: 2,
            name: "risk",
            kind: "message",
            T: RiskProto
        },
        {
            no: 3,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.IssueCommentProto
 */ export class IssueCommentProto extends Message {
    static fromBinary(bytes, options) {
        return new IssueCommentProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IssueCommentProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IssueCommentProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IssueCommentProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string issue_id = 2;
   */ _define_property(this, "issueId", ""), /**
   * @generated from field: string author_user_id = 3;
   */ _define_property(this, "authorUserId", ""), /**
   * read-time projection; not a column in the table
   *
   * @generated from field: string author_name = 4;
   */ _define_property(this, "authorName", ""), /**
   * @generated from field: string body = 5;
   */ _define_property(this, "body", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IssueCommentProto, "runtime", proto3);
_define_property(IssueCommentProto, "typeName", "mono.ryugu.v1.IssueCommentProto");
_define_property(IssueCommentProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "issue_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "author_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "author_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AddIssueCommentRequest
 */ export class AddIssueCommentRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddIssueCommentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddIssueCommentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddIssueCommentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddIssueCommentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string issue_id = 2;
   */ _define_property(this, "issueId", ""), /**
   * @generated from field: string body = 3;
   */ _define_property(this, "body", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddIssueCommentRequest, "runtime", proto3);
_define_property(AddIssueCommentRequest, "typeName", "mono.ryugu.v1.AddIssueCommentRequest");
_define_property(AddIssueCommentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "issue_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AddIssueCommentResponse
 */ export class AddIssueCommentResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddIssueCommentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddIssueCommentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddIssueCommentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddIssueCommentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.IssueCommentProto comment = 1;
   */ _define_property(this, "comment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddIssueCommentResponse, "runtime", proto3);
_define_property(AddIssueCommentResponse, "typeName", "mono.ryugu.v1.AddIssueCommentResponse");
_define_property(AddIssueCommentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "comment",
            kind: "message",
            T: IssueCommentProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListIssueCommentsRequest
 */ export class ListIssueCommentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListIssueCommentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIssueCommentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIssueCommentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIssueCommentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string issue_id = 2;
   */ _define_property(this, "issueId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIssueCommentsRequest, "runtime", proto3);
_define_property(ListIssueCommentsRequest, "typeName", "mono.ryugu.v1.ListIssueCommentsRequest");
_define_property(ListIssueCommentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "issue_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListIssueCommentsResponse
 */ export class ListIssueCommentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListIssueCommentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIssueCommentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIssueCommentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIssueCommentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.IssueCommentProto comments = 1;
   */ _define_property(this, "comments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIssueCommentsResponse, "runtime", proto3);
_define_property(ListIssueCommentsResponse, "typeName", "mono.ryugu.v1.ListIssueCommentsResponse");
_define_property(ListIssueCommentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "comments",
            kind: "message",
            T: IssueCommentProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CustomerTouchpointProto
 */ export class CustomerTouchpointProto extends Message {
    static fromBinary(bytes, options) {
        return new CustomerTouchpointProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CustomerTouchpointProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CustomerTouchpointProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CustomerTouchpointProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string method = 3;
   */ _define_property(this, "method", ""), /**
   * @generated from field: string briefing_level = 4;
   */ _define_property(this, "briefingLevel", ""), /**
   * @generated from field: google.protobuf.Timestamp date_of_briefing = 5;
   */ _define_property(this, "dateOfBriefing", void 0), /**
   * @generated from field: string provided_by = 6;
   */ _define_property(this, "providedBy", ""), /**
   * FK to Contact registry
   *
   * @generated from field: string provided_to_contact_id = 7;
   */ _define_property(this, "providedToContactId", ""), /**
   * FK to Contact registry
   *
   * @generated from field: string provided_to_secondary_id = 8;
   */ _define_property(this, "providedToSecondaryId", ""), /**
   * fallback name
   *
   * @generated from field: string provided_to_primary = 9;
   */ _define_property(this, "providedToPrimary", ""), /**
   * fallback name
   *
   * @generated from field: string provided_to_secondary = 10;
   */ _define_property(this, "providedToSecondary", ""), /**
   * @generated from field: string comments = 11;
   */ _define_property(this, "comments", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string provided_by_contact_id = 13;
   */ _define_property(this, "providedByContactId", ""), /**
   * @generated from field: string brief_description = 14;
   */ _define_property(this, "briefDescription", ""), /**
   * @generated from field: string summary_and_action_items = 15;
   */ _define_property(this, "summaryAndActionItems", ""), /**
   * Ordered, user-entered plain-text attendee list (SAD-163) -- see
   * UpsertCustomerTouchpointRequest.attendees.
   *
   * @generated from field: repeated string attendees = 16;
   */ _define_property(this, "attendees", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CustomerTouchpointProto, "runtime", proto3);
_define_property(CustomerTouchpointProto, "typeName", "mono.ryugu.v1.CustomerTouchpointProto");
_define_property(CustomerTouchpointProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "briefing_level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "date_of_briefing",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "provided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "provided_to_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "provided_to_secondary_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "provided_to_primary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "provided_to_secondary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "comments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "provided_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "brief_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "summary_and_action_items",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "attendees",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCustomerTouchpointsRequest
 */ export class ListCustomerTouchpointsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerTouchpointsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerTouchpointsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerTouchpointsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerTouchpointsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerTouchpointsRequest, "runtime", proto3);
_define_property(ListCustomerTouchpointsRequest, "typeName", "mono.ryugu.v1.ListCustomerTouchpointsRequest");
_define_property(ListCustomerTouchpointsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCustomerTouchpointsResponse
 */ export class ListCustomerTouchpointsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerTouchpointsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerTouchpointsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerTouchpointsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerTouchpointsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.CustomerTouchpointProto touchpoints = 1;
   */ _define_property(this, "touchpoints", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerTouchpointsResponse, "runtime", proto3);
_define_property(ListCustomerTouchpointsResponse, "typeName", "mono.ryugu.v1.ListCustomerTouchpointsResponse");
_define_property(ListCustomerTouchpointsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "touchpoints",
            kind: "message",
            T: CustomerTouchpointProto,
            repeated: true
        }
    ]));
/**
 * CreateCustomerTouchpointRequest has no in-tree callers -- ryugu's Create RPC
 * is unused; every UI/ui-cli create/edit path goes through Upsert. Attendees
 * (SAD-163) therefore rides the Upsert path only (see
 * UpsertCustomerTouchpointRequest.attendees) and this message is
 * intentionally left without an attendees field.
 *
 * @generated from message mono.ryugu.v1.CreateCustomerTouchpointRequest
 */ export class CreateCustomerTouchpointRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCustomerTouchpointRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCustomerTouchpointRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCustomerTouchpointRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCustomerTouchpointRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string method = 2;
   */ _define_property(this, "method", ""), /**
   * @generated from field: string briefing_level = 3;
   */ _define_property(this, "briefingLevel", ""), /**
   * @generated from field: google.protobuf.Timestamp date_of_briefing = 4;
   */ _define_property(this, "dateOfBriefing", void 0), /**
   * @generated from field: string provided_by = 5;
   */ _define_property(this, "providedBy", ""), /**
   * @generated from field: string provided_to_contact_id = 6;
   */ _define_property(this, "providedToContactId", ""), /**
   * @generated from field: string provided_to_secondary_id = 7;
   */ _define_property(this, "providedToSecondaryId", ""), /**
   * fallback name
   *
   * @generated from field: string provided_to_primary = 8;
   */ _define_property(this, "providedToPrimary", ""), /**
   * fallback name
   *
   * @generated from field: string provided_to_secondary = 9;
   */ _define_property(this, "providedToSecondary", ""), /**
   * @generated from field: string comments = 10;
   */ _define_property(this, "comments", ""), /**
   * @generated from field: string provided_by_contact_id = 11;
   */ _define_property(this, "providedByContactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCustomerTouchpointRequest, "runtime", proto3);
_define_property(CreateCustomerTouchpointRequest, "typeName", "mono.ryugu.v1.CreateCustomerTouchpointRequest");
_define_property(CreateCustomerTouchpointRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "briefing_level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "date_of_briefing",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "provided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "provided_to_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "provided_to_secondary_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "provided_to_primary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "provided_to_secondary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "comments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "provided_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateCustomerTouchpointResponse
 */ export class CreateCustomerTouchpointResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCustomerTouchpointResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCustomerTouchpointResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCustomerTouchpointResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCustomerTouchpointResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CustomerTouchpointProto touchpoint = 1;
   */ _define_property(this, "touchpoint", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCustomerTouchpointResponse, "runtime", proto3);
_define_property(CreateCustomerTouchpointResponse, "typeName", "mono.ryugu.v1.CreateCustomerTouchpointResponse");
_define_property(CreateCustomerTouchpointResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "touchpoint",
            kind: "message",
            T: CustomerTouchpointProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertCustomerTouchpointRequest
 */ export class UpsertCustomerTouchpointRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCustomerTouchpointRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCustomerTouchpointRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCustomerTouchpointRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCustomerTouchpointRequest, a, b);
    }
    constructor(data){
        super(), /**
   * empty = create, set = update
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string method = 3;
   */ _define_property(this, "method", ""), /**
   * Intentionally unread by the UpsertCustomerTouchpoint handler (SAD-163):
   * Touchpoints is now framed as an internal, optional meeting-note
   * recorder, so the form no longer collects a briefing level. On update
   * the stored row's value survives untouched; on create it stays empty.
   * Kept on the message for wire compatibility.
   *
   * @generated from field: string briefing_level = 4;
   */ _define_property(this, "briefingLevel", ""), /**
   * @generated from field: google.protobuf.Timestamp date_of_briefing = 5;
   */ _define_property(this, "dateOfBriefing", void 0), /**
   * @generated from field: string brief_description = 6;
   */ _define_property(this, "briefDescription", ""), /**
   * provided_by, provided_by_contact_id, provided_to_contact_id, and
   * provided_to_primary (below) are intentionally unread by the
   * UpsertCustomerTouchpoint handler (SAD-163): attendees (see field 15)
   * replaces the provided-by/to concept now that Touchpoints is an internal
   * meeting-note recorder. On update each stored value survives untouched;
   * on create each stays empty. Kept on the message for wire compatibility.
   *
   * @generated from field: string provided_by = 7;
   */ _define_property(this, "providedBy", ""), /**
   * @generated from field: string provided_by_contact_id = 8;
   */ _define_property(this, "providedByContactId", ""), /**
   * @generated from field: string provided_to_contact_id = 9;
   */ _define_property(this, "providedToContactId", ""), /**
   * Intentionally unread by the UpsertCustomerTouchpoint handler: the secondary
   * provided-to contact is not managed by this form. On update it is preserved
   * from the stored row; on create it stays empty. Use CreateCustomerTouchpoint
   * to set a secondary. Kept on the message for wire compatibility.
   *
   * @generated from field: string provided_to_secondary_id = 10;
   */ _define_property(this, "providedToSecondaryId", ""), /**
   * @generated from field: string provided_to_primary = 11;
   */ _define_property(this, "providedToPrimary", ""), /**
   * @generated from field: string provided_to_secondary = 12;
   */ _define_property(this, "providedToSecondary", ""), /**
   * @generated from field: string comments = 13;
   */ _define_property(this, "comments", ""), /**
   * @generated from field: string summary_and_action_items = 14;
   */ _define_property(this, "summaryAndActionItems", ""), /**
   * Ordered, user-entered plain-text attendee list (SAD-163) -- no
   * contact/user relationship, just names attached to the record. Full
   * replace on every Upsert: an absent/empty list is a legitimate "no
   * attendees" state and clears whatever was previously stored.
   *
   * @generated from field: repeated string attendees = 15;
   */ _define_property(this, "attendees", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCustomerTouchpointRequest, "runtime", proto3);
_define_property(UpsertCustomerTouchpointRequest, "typeName", "mono.ryugu.v1.UpsertCustomerTouchpointRequest");
_define_property(UpsertCustomerTouchpointRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "briefing_level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "date_of_briefing",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "brief_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "provided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "provided_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "provided_to_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "provided_to_secondary_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "provided_to_primary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "provided_to_secondary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "comments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "summary_and_action_items",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "attendees",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertCustomerTouchpointResponse
 */ export class UpsertCustomerTouchpointResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCustomerTouchpointResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCustomerTouchpointResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCustomerTouchpointResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCustomerTouchpointResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CustomerTouchpointProto touchpoint = 1;
   */ _define_property(this, "touchpoint", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCustomerTouchpointResponse, "runtime", proto3);
_define_property(UpsertCustomerTouchpointResponse, "typeName", "mono.ryugu.v1.UpsertCustomerTouchpointResponse");
_define_property(UpsertCustomerTouchpointResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "touchpoint",
            kind: "message",
            T: CustomerTouchpointProto
        }
    ]));
/**
 * A touchpoint's attached file — the subset of the artifact row the UI renders.
 *
 * @generated from message mono.ryugu.v1.TouchpointFileProto
 */ export class TouchpointFileProto extends Message {
    static fromBinary(bytes, options) {
        return new TouchpointFileProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TouchpointFileProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TouchpointFileProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TouchpointFileProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 3;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: string document_type = 4;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: string classification_label = 5;
   */ _define_property(this, "classificationLabel", ""), /**
   * @generated from field: int64 size_bytes = 6;
   */ _define_property(this, "sizeBytes", protoInt64.zero), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TouchpointFileProto, "runtime", proto3);
_define_property(TouchpointFileProto, "typeName", "mono.ryugu.v1.TouchpointFileProto");
_define_property(TouchpointFileProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "classification_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "size_bytes",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AttachTouchpointFileRequest
 */ export class AttachTouchpointFileRequest extends Message {
    static fromBinary(bytes, options) {
        return new AttachTouchpointFileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AttachTouchpointFileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AttachTouchpointFileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AttachTouchpointFileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string touchpoint_id = 2;
   */ _define_property(this, "touchpointId", ""), /**
   * @generated from field: string artifact_id = 3;
   */ _define_property(this, "artifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AttachTouchpointFileRequest, "runtime", proto3);
_define_property(AttachTouchpointFileRequest, "typeName", "mono.ryugu.v1.AttachTouchpointFileRequest");
_define_property(AttachTouchpointFileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "touchpoint_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AttachTouchpointFileResponse
 */ export class AttachTouchpointFileResponse extends Message {
    static fromBinary(bytes, options) {
        return new AttachTouchpointFileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AttachTouchpointFileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AttachTouchpointFileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AttachTouchpointFileResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(AttachTouchpointFileResponse, "runtime", proto3);
_define_property(AttachTouchpointFileResponse, "typeName", "mono.ryugu.v1.AttachTouchpointFileResponse");
_define_property(AttachTouchpointFileResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.DetachTouchpointFileRequest
 */ export class DetachTouchpointFileRequest extends Message {
    static fromBinary(bytes, options) {
        return new DetachTouchpointFileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DetachTouchpointFileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DetachTouchpointFileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DetachTouchpointFileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string touchpoint_id = 2;
   */ _define_property(this, "touchpointId", ""), /**
   * @generated from field: string artifact_id = 3;
   */ _define_property(this, "artifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DetachTouchpointFileRequest, "runtime", proto3);
_define_property(DetachTouchpointFileRequest, "typeName", "mono.ryugu.v1.DetachTouchpointFileRequest");
_define_property(DetachTouchpointFileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "touchpoint_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DetachTouchpointFileResponse
 */ export class DetachTouchpointFileResponse extends Message {
    static fromBinary(bytes, options) {
        return new DetachTouchpointFileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DetachTouchpointFileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DetachTouchpointFileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DetachTouchpointFileResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DetachTouchpointFileResponse, "runtime", proto3);
_define_property(DetachTouchpointFileResponse, "typeName", "mono.ryugu.v1.DetachTouchpointFileResponse");
_define_property(DetachTouchpointFileResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.ListTouchpointFilesRequest
 */ export class ListTouchpointFilesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListTouchpointFilesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTouchpointFilesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTouchpointFilesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTouchpointFilesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string touchpoint_id = 2;
   */ _define_property(this, "touchpointId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTouchpointFilesRequest, "runtime", proto3);
_define_property(ListTouchpointFilesRequest, "typeName", "mono.ryugu.v1.ListTouchpointFilesRequest");
_define_property(ListTouchpointFilesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "touchpoint_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListTouchpointFilesResponse
 */ export class ListTouchpointFilesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListTouchpointFilesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTouchpointFilesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTouchpointFilesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTouchpointFilesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.TouchpointFileProto files = 1;
   */ _define_property(this, "files", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTouchpointFilesResponse, "runtime", proto3);
_define_property(ListTouchpointFilesResponse, "typeName", "mono.ryugu.v1.ListTouchpointFilesResponse");
_define_property(ListTouchpointFilesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "files",
            kind: "message",
            T: TouchpointFileProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GrowthOpportunityProto
 */ export class GrowthOpportunityProto extends Message {
    static fromBinary(bytes, options) {
        return new GrowthOpportunityProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GrowthOpportunityProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GrowthOpportunityProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GrowthOpportunityProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string status = 4;
   */ _define_property(this, "status", ""), /**
   * @generated from field: double estimated_value = 5;
   */ _define_property(this, "estimatedValue", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string comment = 8;
   */ _define_property(this, "comment", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GrowthOpportunityProto, "runtime", proto3);
_define_property(GrowthOpportunityProto, "typeName", "mono.ryugu.v1.GrowthOpportunityProto");
_define_property(GrowthOpportunityProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "estimated_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListGrowthOpportunitiesRequest
 */ export class ListGrowthOpportunitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListGrowthOpportunitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGrowthOpportunitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGrowthOpportunitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGrowthOpportunitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGrowthOpportunitiesRequest, "runtime", proto3);
_define_property(ListGrowthOpportunitiesRequest, "typeName", "mono.ryugu.v1.ListGrowthOpportunitiesRequest");
_define_property(ListGrowthOpportunitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListGrowthOpportunitiesResponse
 */ export class ListGrowthOpportunitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListGrowthOpportunitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGrowthOpportunitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGrowthOpportunitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGrowthOpportunitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.GrowthOpportunityProto opportunities = 1;
   */ _define_property(this, "opportunities", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGrowthOpportunitiesResponse, "runtime", proto3);
_define_property(ListGrowthOpportunitiesResponse, "typeName", "mono.ryugu.v1.ListGrowthOpportunitiesResponse");
_define_property(ListGrowthOpportunitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunities",
            kind: "message",
            T: GrowthOpportunityProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertGrowthOpportunityRequest
 */ export class UpsertGrowthOpportunityRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertGrowthOpportunityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertGrowthOpportunityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertGrowthOpportunityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertGrowthOpportunityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string status = 4;
   */ _define_property(this, "status", ""), /**
   * @generated from field: double estimated_value = 5;
   */ _define_property(this, "estimatedValue", 0), /**
   * @generated from field: string comment = 6;
   */ _define_property(this, "comment", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertGrowthOpportunityRequest, "runtime", proto3);
_define_property(UpsertGrowthOpportunityRequest, "typeName", "mono.ryugu.v1.UpsertGrowthOpportunityRequest");
_define_property(UpsertGrowthOpportunityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "estimated_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertGrowthOpportunityResponse
 */ export class UpsertGrowthOpportunityResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertGrowthOpportunityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertGrowthOpportunityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertGrowthOpportunityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertGrowthOpportunityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.GrowthOpportunityProto opportunity = 1;
   */ _define_property(this, "opportunity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertGrowthOpportunityResponse, "runtime", proto3);
_define_property(UpsertGrowthOpportunityResponse, "typeName", "mono.ryugu.v1.UpsertGrowthOpportunityResponse");
_define_property(UpsertGrowthOpportunityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity",
            kind: "message",
            T: GrowthOpportunityProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteGrowthOpportunityRequest
 */ export class DeleteGrowthOpportunityRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteGrowthOpportunityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteGrowthOpportunityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteGrowthOpportunityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteGrowthOpportunityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteGrowthOpportunityRequest, "runtime", proto3);
_define_property(DeleteGrowthOpportunityRequest, "typeName", "mono.ryugu.v1.DeleteGrowthOpportunityRequest");
_define_property(DeleteGrowthOpportunityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteGrowthOpportunityResponse
 */ export class DeleteGrowthOpportunityResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteGrowthOpportunityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteGrowthOpportunityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteGrowthOpportunityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteGrowthOpportunityResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteGrowthOpportunityResponse, "runtime", proto3);
_define_property(DeleteGrowthOpportunityResponse, "typeName", "mono.ryugu.v1.DeleteGrowthOpportunityResponse");
_define_property(DeleteGrowthOpportunityResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.GetProgramFinancialSummaryRequest
 */ export class GetProgramFinancialSummaryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramFinancialSummaryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramFinancialSummaryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramFinancialSummaryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramFinancialSummaryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramFinancialSummaryRequest, "runtime", proto3);
_define_property(GetProgramFinancialSummaryRequest, "typeName", "mono.ryugu.v1.GetProgramFinancialSummaryRequest");
_define_property(GetProgramFinancialSummaryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetProgramFinancialSummaryResponse
 */ export class GetProgramFinancialSummaryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramFinancialSummaryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramFinancialSummaryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramFinancialSummaryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramFinancialSummaryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * === TCV (Total Contract Value) ===
   *
   * SUM(pop_amounts) + SUM(optional_task_amounts)
   *
   * @generated from field: mono.ryugu.v1.ComputedValue current_tcv = 2;
   */ _define_property(this, "currentTcv", void 0), /**
   * stored — original award value
   *
   * @generated from field: double tcv_on_award = 3;
   */ _define_property(this, "tcvOnAward", 0), /**
   * === Funding ===
   *
   * SUM(pop_funded) + SUM(optional_task_funded)
   *
   * @generated from field: mono.ryugu.v1.ComputedValue total_funded_amount = 4;
   */ _define_property(this, "totalFundedAmount", void 0), /**
   * total_funded / current_tcv × 100
   *
   * @generated from field: mono.ryugu.v1.ComputedValue funded_percentage = 5;
   */ _define_property(this, "fundedPercentage", void 0), /**
   * === Workforce ===
   *
   * SUM(company_fte_counts)
   *
   * @generated from field: mono.ryugu.v1.ComputedValue total_ftes = 6;
   */ _define_property(this, "totalFtes", void 0), /**
   * SUM(company_vacancies)
   *
   * @generated from field: mono.ryugu.v1.ComputedValue total_vacancies = 7;
   */ _define_property(this, "totalVacancies", void 0), /**
   * @generated from field: repeated mono.ryugu.v1.CompanyWorkshare company_workshares = 8;
   */ _define_property(this, "companyWorkshares", []), /**
   * === PoP Breakdown (inputs for TCV/funding calcs) ===
   *
   * @generated from field: repeated mono.ryugu.v1.PoPLineItem pop_line_items = 9;
   */ _define_property(this, "popLineItems", []), /**
   * @generated from field: repeated mono.ryugu.v1.OptionalTaskLineItem optional_task_line_items = 10;
   */ _define_property(this, "optionalTaskLineItems", []), /**
   * === KPI Compliance Snapshot ===
   *
   * @generated from field: mono.ryugu.v1.KPISnapshot kpi_snapshot = 11;
   */ _define_property(this, "kpiSnapshot", void 0), /**
   * === Latest EAC (if any) ===
   *
   * @generated from field: mono.ryugu.v1.EACSnapshot latest_eac = 12;
   */ _define_property(this, "latestEac", void 0), /**
   * === Latest DSO (if any) ===
   *
   * @generated from field: mono.ryugu.v1.DSOSnapshot latest_dso = 13;
   */ _define_property(this, "latestDso", void 0), /**
   * === Program Financial Health (SAD-166/SAD-176) ===
   * Derived from the program_financial_months ledger + the funding totals
   * above (fields 4/5) — see ProgramFinancialHealth for field semantics.
   *
   * @generated from field: mono.ryugu.v1.ProgramFinancialHealth financial_health = 14;
   */ _define_property(this, "financialHealth", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramFinancialSummaryResponse, "runtime", proto3);
_define_property(GetProgramFinancialSummaryResponse, "typeName", "mono.ryugu.v1.GetProgramFinancialSummaryResponse");
_define_property(GetProgramFinancialSummaryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "current_tcv",
            kind: "message",
            T: ComputedValue
        },
        {
            no: 3,
            name: "tcv_on_award",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "total_funded_amount",
            kind: "message",
            T: ComputedValue
        },
        {
            no: 5,
            name: "funded_percentage",
            kind: "message",
            T: ComputedValue
        },
        {
            no: 6,
            name: "total_ftes",
            kind: "message",
            T: ComputedValue
        },
        {
            no: 7,
            name: "total_vacancies",
            kind: "message",
            T: ComputedValue
        },
        {
            no: 8,
            name: "company_workshares",
            kind: "message",
            T: CompanyWorkshare,
            repeated: true
        },
        {
            no: 9,
            name: "pop_line_items",
            kind: "message",
            T: PoPLineItem,
            repeated: true
        },
        {
            no: 10,
            name: "optional_task_line_items",
            kind: "message",
            T: OptionalTaskLineItem,
            repeated: true
        },
        {
            no: 11,
            name: "kpi_snapshot",
            kind: "message",
            T: KPISnapshot
        },
        {
            no: 12,
            name: "latest_eac",
            kind: "message",
            T: EACSnapshot
        },
        {
            no: 13,
            name: "latest_dso",
            kind: "message",
            T: DSOSnapshot
        },
        {
            no: 14,
            name: "financial_health",
            kind: "message",
            T: ProgramFinancialHealth
        }
    ]));
/**
 * ComputedValue shows a computed number with its formula and inputs,
 * so the user can see exactly how the number was derived.
 *
 * @generated from message mono.ryugu.v1.ComputedValue
 */ export class ComputedValue extends Message {
    static fromBinary(bytes, options) {
        return new ComputedValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComputedValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComputedValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ComputedValue, a, b);
    }
    constructor(data){
        super(), /**
   * the final computed number
   *
   * @generated from field: double value = 1;
   */ _define_property(this, "value", 0), /**
   * human-readable formula, e.g. "SUM(PoP totals) + SUM(OptTask totals)"
   *
   * @generated from field: string formula = 2;
   */ _define_property(this, "formula", ""), /**
   * the actual input values, e.g. ["Base Period: $12,356,287.07", "OP1: $12,462,396.44", ...]
   *
   * @generated from field: repeated string inputs = 3;
   */ _define_property(this, "inputs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ComputedValue, "runtime", proto3);
_define_property(ComputedValue, "typeName", "mono.ryugu.v1.ComputedValue");
_define_property(ComputedValue, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "formula",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "inputs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * CompanyWorkshare shows per-company FTE breakdown.
 *
 * @generated from message mono.ryugu.v1.CompanyWorkshare
 */ export class CompanyWorkshare extends Message {
    static fromBinary(bytes, options) {
        return new CompanyWorkshare().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyWorkshare().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyWorkshare().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyWorkshare, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_profile_id = 1;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string company_name = 2;
   */ _define_property(this, "companyName", ""), /**
   * Prime, Sub
   *
   * @generated from field: string type = 3;
   */ _define_property(this, "type", ""), /**
   * @generated from field: double fte_count = 4;
   */ _define_property(this, "fteCount", 0), /**
   * @generated from field: int32 vacancies = 5;
   */ _define_property(this, "vacancies", 0), /**
   * fte_count / total_ftes × 100
   *
   * @generated from field: double workshare_percent = 6;
   */ _define_property(this, "worksharePercent", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyWorkshare, "runtime", proto3);
_define_property(CompanyWorkshare, "typeName", "mono.ryugu.v1.CompanyWorkshare");
_define_property(CompanyWorkshare, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "fte_count",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "vacancies",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "workshare_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * PoPLineItem is one row in the PoP table (input to TCV calculation).
 *
 * @generated from message mono.ryugu.v1.PoPLineItem
 */ export class PoPLineItem extends Message {
    static fromBinary(bytes, options) {
        return new PoPLineItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PoPLineItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PoPLineItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PoPLineItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string period_name = 1;
   */ _define_property(this, "periodName", ""), /**
   * @generated from field: bool exercised = 2;
   */ _define_property(this, "exercised", false), /**
   * @generated from field: double funded_amount = 3;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double total_amount = 4;
   */ _define_property(this, "totalAmount", 0), /**
   * funded / total × 100
   *
   * @generated from field: double funded_percent = 5;
   */ _define_property(this, "fundedPercent", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PoPLineItem, "runtime", proto3);
_define_property(PoPLineItem, "typeName", "mono.ryugu.v1.PoPLineItem");
_define_property(PoPLineItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "period_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "exercised",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "total_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "funded_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * OptionalTaskLineItem is one row in the optional tasks table.
 *
 * @generated from message mono.ryugu.v1.OptionalTaskLineItem
 */ export class OptionalTaskLineItem extends Message {
    static fromBinary(bytes, options) {
        return new OptionalTaskLineItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OptionalTaskLineItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OptionalTaskLineItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OptionalTaskLineItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: bool exercised = 2;
   */ _define_property(this, "exercised", false), /**
   * @generated from field: double funded_amount = 3;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double total_amount = 4;
   */ _define_property(this, "totalAmount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OptionalTaskLineItem, "runtime", proto3);
_define_property(OptionalTaskLineItem, "typeName", "mono.ryugu.v1.OptionalTaskLineItem");
_define_property(OptionalTaskLineItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "exercised",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "total_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * KPISnapshot shows compliance status for all 4 KPIs.
 * The compliance booleans below are presence-gated: interpret them only
 * alongside their has_* sibling, and never color a tile from a flag alone.
 * Absent sources are vacuous-true for kpi2/kpi3 (no entry ⇒ nothing failed)
 * but kpi4_compliant is false on absence (pass == total over zero rows) —
 * both directions are safe only after a has_* check, as in the spine's
 * kpiStatus(compliant, hasData).
 *
 * @generated from message mono.ryugu.v1.KPISnapshot
 */ export class KPISnapshot extends Message {
    static fromBinary(bytes, options) {
        return new KPISnapshot().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new KPISnapshot().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new KPISnapshot().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(KPISnapshot, a, b);
    }
    constructor(data){
        super(), /**
   * KPI 1: Contractual Commitments — on-time delivery
   *
   * closed-on-time / total-closed × 100
   *
   * @generated from field: double deliverable_on_time_percent = 1;
   */ _define_property(this, "deliverableOnTimePercent", 0), /**
   * @generated from field: int32 total_tasks_closed = 2;
   */ _define_property(this, "totalTasksClosed", 0), /**
   * @generated from field: int32 tasks_closed_on_time = 3;
   */ _define_property(this, "tasksClosedOnTime", 0), /**
   * @generated from field: int32 overdue_tasks = 4;
   */ _define_property(this, "overdueTasks", 0), /**
   * on_time_percent == 100
   *
   * @generated from field: bool kpi1_compliant = 5;
   */ _define_property(this, "kpi1Compliant", false), /**
   * KPI 2: Customer Satisfaction — CPARS/QASP scores
   *
   * @generated from field: double latest_cpars_score = 6;
   */ _define_property(this, "latestCparsScore", 0), /**
   * @generated from field: double latest_qasp_score = 7;
   */ _define_property(this, "latestQaspScore", 0), /**
   * latest_cpars >= 4.0
   *
   * @generated from field: bool kpi2_cpars_compliant = 8;
   */ _define_property(this, "kpi2CparsCompliant", false), /**
   * latest_qasp >= 4.0
   *
   * @generated from field: bool kpi2_qasp_compliant = 9;
   */ _define_property(this, "kpi2QaspCompliant", false), /**
   * KPI 3: Financial Management — margin + DSO
   *
   * @generated from field: double latest_dpaf_margin_percent = 10;
   */ _define_property(this, "latestDpafMarginPercent", 0), /**
   * @generated from field: double target_dpaf_margin = 11;
   */ _define_property(this, "targetDpafMargin", 0), /**
   * @generated from field: int32 latest_dso = 12;
   */ _define_property(this, "latestDso", 0), /**
   * actual >= target (true when no EAC)
   *
   * @generated from field: bool kpi3_margin_compliant = 13;
   */ _define_property(this, "kpi3MarginCompliant", false), /**
   * dso <= 65 (true when no DSO)
   *
   * @generated from field: bool kpi3_dso_compliant = 14;
   */ _define_property(this, "kpi3DsoCompliant", false), /**
   * KPI 4: GDS Compliance — audit scores
   *
   * @generated from field: int32 latest_audit_pass = 15;
   */ _define_property(this, "latestAuditPass", 0), /**
   * @generated from field: int32 latest_audit_total = 16;
   */ _define_property(this, "latestAuditTotal", 0), /**
   * pass == total (10/10 or 8/8)
   *
   * @generated from field: bool kpi4_compliant = 17;
   */ _define_property(this, "kpi4Compliant", false), /**
   * Presence flags, straight from pangaea's row: whether ANY entry exists per
   * source. The UI derives its "no data yet" state from these rather than
   * guessing from value magnitudes — a zero-valued real entry (break-even
   * margin, 0-score CPARS) is data, not absence.
   *
   * @generated from field: bool has_cpars = 18;
   */ _define_property(this, "hasCpars", false), /**
   * @generated from field: bool has_qasp = 19;
   */ _define_property(this, "hasQasp", false), /**
   * @generated from field: bool has_eac = 20;
   */ _define_property(this, "hasEac", false), /**
   * @generated from field: bool has_dso = 21;
   */ _define_property(this, "hasDso", false), /**
   * @generated from field: bool has_audit = 22;
   */ _define_property(this, "hasAudit", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(KPISnapshot, "runtime", proto3);
_define_property(KPISnapshot, "typeName", "mono.ryugu.v1.KPISnapshot");
_define_property(KPISnapshot, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deliverable_on_time_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "total_tasks_closed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "tasks_closed_on_time",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "overdue_tasks",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "kpi1_compliant",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "latest_cpars_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "latest_qasp_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "kpi2_cpars_compliant",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "kpi2_qasp_compliant",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "latest_dpaf_margin_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "target_dpaf_margin",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "latest_dso",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "kpi3_margin_compliant",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "kpi3_dso_compliant",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 15,
            name: "latest_audit_pass",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 16,
            name: "latest_audit_total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 17,
            name: "kpi4_compliant",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 18,
            name: "has_cpars",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 19,
            name: "has_qasp",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 20,
            name: "has_eac",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 21,
            name: "has_dso",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 22,
            name: "has_audit",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * EACSnapshot shows the latest EAC entry with derived margin compliance.
 *
 * @generated from message mono.ryugu.v1.EACSnapshot
 */ export class EACSnapshot extends Message {
    static fromBinary(bytes, options) {
        return new EACSnapshot().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EACSnapshot().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EACSnapshot().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EACSnapshot, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: google.protobuf.Timestamp period_start = 1;
   */ _define_property(this, "periodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp period_end = 2;
   */ _define_property(this, "periodEnd", void 0), /**
   * @generated from field: double revenue = 3;
   */ _define_property(this, "revenue", 0), /**
   * @generated from field: double direct_costs = 4;
   */ _define_property(this, "directCosts", 0), /**
   * @generated from field: double subcontractor_costs = 5;
   */ _define_property(this, "subcontractorCosts", 0), /**
   * @generated from field: double odcs = 6;
   */ _define_property(this, "odcs", 0), /**
   * @generated from field: double management_reserve = 7;
   */ _define_property(this, "managementReserve", 0), /**
   * @generated from field: double dpaf = 8;
   */ _define_property(this, "dpaf", 0), /**
   * @generated from field: double dpaf_margin_percent = 9;
   */ _define_property(this, "dpafMarginPercent", 0), /**
   * @generated from field: double target_dpaf_margin = 10;
   */ _define_property(this, "targetDpafMargin", 0), /**
   * dpaf_margin_percent / target × 100
   *
   * @generated from field: mono.ryugu.v1.ComputedValue dpaf_margin_compliance = 11;
   */ _define_property(this, "dpafMarginCompliance", void 0), /**
   * @generated from field: string comment = 12;
   */ _define_property(this, "comment", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EACSnapshot, "runtime", proto3);
_define_property(EACSnapshot, "typeName", "mono.ryugu.v1.EACSnapshot");
_define_property(EACSnapshot, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 2,
            name: "period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "revenue",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "direct_costs",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "subcontractor_costs",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "odcs",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "management_reserve",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "dpaf",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "dpaf_margin_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "target_dpaf_margin",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "dpaf_margin_compliance",
            kind: "message",
            T: ComputedValue
        },
        {
            no: 12,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * DSOSnapshot shows the latest DSO value with compliance.
 *
 * @generated from message mono.ryugu.v1.DSOSnapshot
 */ export class DSOSnapshot extends Message {
    static fromBinary(bytes, options) {
        return new DSOSnapshot().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DSOSnapshot().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DSOSnapshot().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DSOSnapshot, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: google.protobuf.Timestamp period_end_date = 1;
   */ _define_property(this, "periodEndDate", void 0), /**
   * @generated from field: int32 dso = 2;
   */ _define_property(this, "dso", 0), /**
   * dso <= 65
   *
   * @generated from field: bool compliant = 3;
   */ _define_property(this, "compliant", false), /**
   * "DSO 179 vs target 65 = NOT COMPLIANT"
   *
   * @generated from field: string formula = 4;
   */ _define_property(this, "formula", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DSOSnapshot, "runtime", proto3);
_define_property(DSOSnapshot, "typeName", "mono.ryugu.v1.DSOSnapshot");
_define_property(DSOSnapshot, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "period_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 2,
            name: "dso",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "compliant",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "formula",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ProgramFinancialHealth is the server-computed funding-burn-down picture for
 * a program: how much of its available funding has been consumed by recorded
 * monthly burn, whether that trips the alert threshold, and where the program
 * sits in its current period of performance. See financial_health.go for the
 * derivation rules (current-month selection, consumption math, PoP-state
 * classification).
 *
 * @generated from message mono.ryugu.v1.ProgramFinancialHealth
 */ export class ProgramFinancialHealth extends Message {
    static fromBinary(bytes, options) {
        return new ProgramFinancialHealth().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramFinancialHealth().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramFinancialHealth().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramFinancialHealth, a, b);
    }
    constructor(data){
        super(), /**
   * The latest recorded month <= the current calendar month. has_current
   * false means no such month exists — current_* fields are then zero, never
   * a fabricated value.
   *
   * @generated from field: string current_period_month = 1;
   */ _define_property(this, "currentPeriodMonth", ""), /**
   * @generated from field: bool has_current = 2;
   */ _define_property(this, "hasCurrent", false), /**
   * @generated from field: int64 current_burn_rate_cents = 3;
   */ _define_property(this, "currentBurnRateCents", protoInt64.zero), /**
   * @generated from field: int64 current_ar_balance_cents = 4;
   */ _define_property(this, "currentArBalanceCents", protoInt64.zero), /**
   * @generated from field: int64 total_available_funding_cents = 5;
   */ _define_property(this, "totalAvailableFundingCents", protoInt64.zero), /**
   * @generated from field: bool has_funding = 6;
   */ _define_property(this, "hasFunding", false), /**
   * May be negative — a funding overrun is shown truthfully, never clamped.
   *
   * @generated from field: int64 funding_consumed_cents = 7;
   */ _define_property(this, "fundingConsumedCents", protoInt64.zero), /**
   * @generated from field: int64 funding_remaining_cents = 8;
   */ _define_property(this, "fundingRemainingCents", protoInt64.zero), /**
   * @generated from field: double funding_consumed_pct = 9;
   */ _define_property(this, "fundingConsumedPct", 0), /**
   * @generated from field: int32 threshold_pct = 10;
   */ _define_property(this, "thresholdPct", 0), /**
   * @generated from field: bool threshold_is_default = 11;
   */ _define_property(this, "thresholdIsDefault", false), /**
   * @generated from field: bool threshold_breached = 12;
   */ _define_property(this, "thresholdBreached", false), /**
   * Period-of-performance context for the current burn-down (see
   * selectProgramPoPWindow in financial_health.go for the selection order).
   *
   * @generated from field: string pop_label = 13;
   */ _define_property(this, "popLabel", ""), /**
   * @generated from field: google.protobuf.Timestamp pop_start = 14;
   */ _define_property(this, "popStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp pop_end = 15;
   */ _define_property(this, "popEnd", void 0), /**
   * @generated from field: double pop_elapsed_pct = 16;
   */ _define_property(this, "popElapsedPct", 0), /**
   * @generated from field: int32 pop_days_remaining = 17;
   */ _define_property(this, "popDaysRemaining", 0), /**
   * ACTIVE | NOT_STARTED | COMPLETED | UNKNOWN
   *
   * @generated from field: string pop_state = 18;
   */ _define_property(this, "popState", ""), /**
   * The consumption formula + contributing months, so the number is
   * auditable the same way current_tcv/funded_percentage are above.
   *
   * @generated from field: mono.ryugu.v1.ComputedValue funding_consumed_detail = 19;
   */ _define_property(this, "fundingConsumedDetail", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramFinancialHealth, "runtime", proto3);
_define_property(ProgramFinancialHealth, "typeName", "mono.ryugu.v1.ProgramFinancialHealth");
_define_property(ProgramFinancialHealth, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "current_period_month",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "has_current",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "current_burn_rate_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "current_ar_balance_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "total_available_funding_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "has_funding",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "funding_consumed_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 8,
            name: "funding_remaining_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 9,
            name: "funding_consumed_pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "threshold_pct",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 11,
            name: "threshold_is_default",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "threshold_breached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "pop_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "pop_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "pop_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "pop_elapsed_pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 17,
            name: "pop_days_remaining",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 18,
            name: "pop_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "funding_consumed_detail",
            kind: "message",
            T: ComputedValue
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DSOEntryProto
 */ export class DSOEntryProto extends Message {
    static fromBinary(bytes, options) {
        return new DSOEntryProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DSOEntryProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DSOEntryProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DSOEntryProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: google.protobuf.Timestamp period_end_date = 3;
   */ _define_property(this, "periodEndDate", void 0), /**
   * @generated from field: int32 dso = 4;
   */ _define_property(this, "dso", 0), /**
   * @generated from field: string comment = 5;
   */ _define_property(this, "comment", ""), /**
   * computed: dso <= 65
   *
   * @generated from field: bool compliant = 6;
   */ _define_property(this, "compliant", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * artifact id of the uploaded invoice (optional)
   *
   * @generated from field: string invoice_file_id = 8;
   */ _define_property(this, "invoiceFileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DSOEntryProto, "runtime", proto3);
_define_property(DSOEntryProto, "typeName", "mono.ryugu.v1.DSOEntryProto");
_define_property(DSOEntryProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "period_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "dso",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "compliant",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "invoice_file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListDSOEntriesRequest
 */ export class ListDSOEntriesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDSOEntriesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDSOEntriesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDSOEntriesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDSOEntriesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDSOEntriesRequest, "runtime", proto3);
_define_property(ListDSOEntriesRequest, "typeName", "mono.ryugu.v1.ListDSOEntriesRequest");
_define_property(ListDSOEntriesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListDSOEntriesResponse
 */ export class ListDSOEntriesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDSOEntriesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDSOEntriesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDSOEntriesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDSOEntriesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.DSOEntryProto entries = 1;
   */ _define_property(this, "entries", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDSOEntriesResponse, "runtime", proto3);
_define_property(ListDSOEntriesResponse, "typeName", "mono.ryugu.v1.ListDSOEntriesResponse");
_define_property(ListDSOEntriesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entries",
            kind: "message",
            T: DSOEntryProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateDSOEntryRequest
 */ export class CreateDSOEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateDSOEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDSOEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDSOEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDSOEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: google.protobuf.Timestamp period_end_date = 2;
   */ _define_property(this, "periodEndDate", void 0), /**
   * @generated from field: int32 dso = 3;
   */ _define_property(this, "dso", 0), /**
   * @generated from field: string comment = 4;
   */ _define_property(this, "comment", ""), /**
   * artifact id of the uploaded invoice (optional)
   *
   * @generated from field: string invoice_file_id = 5;
   */ _define_property(this, "invoiceFileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDSOEntryRequest, "runtime", proto3);
_define_property(CreateDSOEntryRequest, "typeName", "mono.ryugu.v1.CreateDSOEntryRequest");
_define_property(CreateDSOEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "period_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "dso",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "invoice_file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateDSOEntryResponse
 */ export class CreateDSOEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateDSOEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDSOEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDSOEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDSOEntryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.DSOEntryProto entry = 1;
   */ _define_property(this, "entry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDSOEntryResponse, "runtime", proto3);
_define_property(CreateDSOEntryResponse, "typeName", "mono.ryugu.v1.CreateDSOEntryResponse");
_define_property(CreateDSOEntryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entry",
            kind: "message",
            T: DSOEntryProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteDSOEntryRequest
 */ export class DeleteDSOEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDSOEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDSOEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDSOEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDSOEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDSOEntryRequest, "runtime", proto3);
_define_property(DeleteDSOEntryRequest, "typeName", "mono.ryugu.v1.DeleteDSOEntryRequest");
_define_property(DeleteDSOEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteDSOEntryResponse
 */ export class DeleteDSOEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDSOEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDSOEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDSOEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDSOEntryResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDSOEntryResponse, "runtime", proto3);
_define_property(DeleteDSOEntryResponse, "typeName", "mono.ryugu.v1.DeleteDSOEntryResponse");
_define_property(DeleteDSOEntryResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.EACEntryProto
 */ export class EACEntryProto extends Message {
    static fromBinary(bytes, options) {
        return new EACEntryProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EACEntryProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EACEntryProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EACEntryProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: google.protobuf.Timestamp start_date = 3;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 4;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: double revenue = 5;
   */ _define_property(this, "revenue", 0), /**
   * @generated from field: double direct_costs = 6;
   */ _define_property(this, "directCosts", 0), /**
   * @generated from field: double subcontractor_costs = 7;
   */ _define_property(this, "subcontractorCosts", 0), /**
   * @generated from field: double odcs = 8;
   */ _define_property(this, "odcs", 0), /**
   * @generated from field: double management_reserve = 9;
   */ _define_property(this, "managementReserve", 0), /**
   * @generated from field: double dpaf = 10;
   */ _define_property(this, "dpaf", 0), /**
   * @generated from field: double forecasted_dpaf_margin = 11;
   */ _define_property(this, "forecastedDpafMargin", 0), /**
   * @generated from field: double dpaf_margin_percent = 12;
   */ _define_property(this, "dpafMarginPercent", 0), /**
   * @generated from field: double target_dpaf_margin = 13;
   */ _define_property(this, "targetDpafMargin", 0), /**
   * @generated from field: double inception_to_date_actuals = 14;
   */ _define_property(this, "inceptionToDateActuals", 0), /**
   * @generated from field: double estimate_to_complete = 15;
   */ _define_property(this, "estimateToComplete", 0), /**
   * @generated from field: string comment = 16;
   */ _define_property(this, "comment", ""), /**
   * Computed
   *
   * dpaf_margin_percent / target × 100
   *
   * @generated from field: double dpaf_margin_compliance = 17;
   */ _define_property(this, "dpafMarginCompliance", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 18;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EACEntryProto, "runtime", proto3);
_define_property(EACEntryProto, "typeName", "mono.ryugu.v1.EACEntryProto");
_define_property(EACEntryProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "revenue",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "direct_costs",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "subcontractor_costs",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "odcs",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "management_reserve",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "dpaf",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "forecasted_dpaf_margin",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "dpaf_margin_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 13,
            name: "target_dpaf_margin",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 14,
            name: "inception_to_date_actuals",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 15,
            name: "estimate_to_complete",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 16,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "dpaf_margin_compliance",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 18,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListEACEntriesRequest
 */ export class ListEACEntriesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListEACEntriesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEACEntriesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEACEntriesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEACEntriesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEACEntriesRequest, "runtime", proto3);
_define_property(ListEACEntriesRequest, "typeName", "mono.ryugu.v1.ListEACEntriesRequest");
_define_property(ListEACEntriesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListEACEntriesResponse
 */ export class ListEACEntriesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListEACEntriesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEACEntriesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEACEntriesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEACEntriesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.EACEntryProto entries = 1;
   */ _define_property(this, "entries", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEACEntriesResponse, "runtime", proto3);
_define_property(ListEACEntriesResponse, "typeName", "mono.ryugu.v1.ListEACEntriesResponse");
_define_property(ListEACEntriesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entries",
            kind: "message",
            T: EACEntryProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateEACEntryRequest
 */ export class CreateEACEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateEACEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateEACEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateEACEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateEACEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: google.protobuf.Timestamp start_date = 2;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 3;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: double revenue = 4;
   */ _define_property(this, "revenue", 0), /**
   * @generated from field: double direct_costs = 5;
   */ _define_property(this, "directCosts", 0), /**
   * @generated from field: double subcontractor_costs = 6;
   */ _define_property(this, "subcontractorCosts", 0), /**
   * @generated from field: double odcs = 7;
   */ _define_property(this, "odcs", 0), /**
   * @generated from field: double management_reserve = 8;
   */ _define_property(this, "managementReserve", 0), /**
   * @generated from field: double dpaf = 9;
   */ _define_property(this, "dpaf", 0), /**
   * @generated from field: double forecasted_dpaf_margin = 10;
   */ _define_property(this, "forecastedDpafMargin", 0), /**
   * @generated from field: double dpaf_margin_percent = 11;
   */ _define_property(this, "dpafMarginPercent", 0), /**
   * @generated from field: double target_dpaf_margin = 12;
   */ _define_property(this, "targetDpafMargin", 0), /**
   * @generated from field: double inception_to_date_actuals = 13;
   */ _define_property(this, "inceptionToDateActuals", 0), /**
   * @generated from field: double estimate_to_complete = 14;
   */ _define_property(this, "estimateToComplete", 0), /**
   * @generated from field: string comment = 15;
   */ _define_property(this, "comment", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateEACEntryRequest, "runtime", proto3);
_define_property(CreateEACEntryRequest, "typeName", "mono.ryugu.v1.CreateEACEntryRequest");
_define_property(CreateEACEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "revenue",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "direct_costs",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "subcontractor_costs",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "odcs",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "management_reserve",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "dpaf",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "forecasted_dpaf_margin",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "dpaf_margin_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "target_dpaf_margin",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 13,
            name: "inception_to_date_actuals",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 14,
            name: "estimate_to_complete",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 15,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateEACEntryResponse
 */ export class CreateEACEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateEACEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateEACEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateEACEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateEACEntryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.EACEntryProto entry = 1;
   */ _define_property(this, "entry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateEACEntryResponse, "runtime", proto3);
_define_property(CreateEACEntryResponse, "typeName", "mono.ryugu.v1.CreateEACEntryResponse");
_define_property(CreateEACEntryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entry",
            kind: "message",
            T: EACEntryProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateEACEntryRequest
 */ export class UpdateEACEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateEACEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateEACEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateEACEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateEACEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: google.protobuf.Timestamp start_date = 2;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 3;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: double revenue = 4;
   */ _define_property(this, "revenue", 0), /**
   * @generated from field: double direct_costs = 5;
   */ _define_property(this, "directCosts", 0), /**
   * @generated from field: double subcontractor_costs = 6;
   */ _define_property(this, "subcontractorCosts", 0), /**
   * @generated from field: double odcs = 7;
   */ _define_property(this, "odcs", 0), /**
   * @generated from field: double management_reserve = 8;
   */ _define_property(this, "managementReserve", 0), /**
   * @generated from field: double dpaf = 9;
   */ _define_property(this, "dpaf", 0), /**
   * @generated from field: double forecasted_dpaf_margin = 10;
   */ _define_property(this, "forecastedDpafMargin", 0), /**
   * @generated from field: double dpaf_margin_percent = 11;
   */ _define_property(this, "dpafMarginPercent", 0), /**
   * @generated from field: double target_dpaf_margin = 12;
   */ _define_property(this, "targetDpafMargin", 0), /**
   * @generated from field: double inception_to_date_actuals = 13;
   */ _define_property(this, "inceptionToDateActuals", 0), /**
   * @generated from field: double estimate_to_complete = 14;
   */ _define_property(this, "estimateToComplete", 0), /**
   * @generated from field: string comment = 15;
   */ _define_property(this, "comment", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateEACEntryRequest, "runtime", proto3);
_define_property(UpdateEACEntryRequest, "typeName", "mono.ryugu.v1.UpdateEACEntryRequest");
_define_property(UpdateEACEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "revenue",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "direct_costs",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "subcontractor_costs",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "odcs",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "management_reserve",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "dpaf",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "forecasted_dpaf_margin",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "dpaf_margin_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "target_dpaf_margin",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 13,
            name: "inception_to_date_actuals",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 14,
            name: "estimate_to_complete",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 15,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateEACEntryResponse
 */ export class UpdateEACEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateEACEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateEACEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateEACEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateEACEntryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.EACEntryProto entry = 1;
   */ _define_property(this, "entry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateEACEntryResponse, "runtime", proto3);
_define_property(UpdateEACEntryResponse, "typeName", "mono.ryugu.v1.UpdateEACEntryResponse");
_define_property(UpdateEACEntryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entry",
            kind: "message",
            T: EACEntryProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteEACEntryRequest
 */ export class DeleteEACEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteEACEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteEACEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteEACEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteEACEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteEACEntryRequest, "runtime", proto3);
_define_property(DeleteEACEntryRequest, "typeName", "mono.ryugu.v1.DeleteEACEntryRequest");
_define_property(DeleteEACEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteEACEntryResponse
 */ export class DeleteEACEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteEACEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteEACEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteEACEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteEACEntryResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteEACEntryResponse, "runtime", proto3);
_define_property(DeleteEACEntryResponse, "typeName", "mono.ryugu.v1.DeleteEACEntryResponse");
_define_property(DeleteEACEntryResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.ProgramFinancialMonthProto
 */ export class ProgramFinancialMonthProto extends Message {
    static fromBinary(bytes, options) {
        return new ProgramFinancialMonthProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramFinancialMonthProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramFinancialMonthProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramFinancialMonthProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * "YYYY-MM"
   *
   * @generated from field: string period_month = 3;
   */ _define_property(this, "periodMonth", ""), /**
   * @generated from field: int64 burn_rate_cents = 4;
   */ _define_property(this, "burnRateCents", protoInt64.zero), /**
   * @generated from field: int64 ar_balance_cents = 5;
   */ _define_property(this, "arBalanceCents", protoInt64.zero), /**
   * @generated from field: string comment = 6;
   */ _define_property(this, "comment", ""), /**
   * @generated from field: string recorded_by = 7;
   */ _define_property(this, "recordedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramFinancialMonthProto, "runtime", proto3);
_define_property(ProgramFinancialMonthProto, "typeName", "mono.ryugu.v1.ProgramFinancialMonthProto");
_define_property(ProgramFinancialMonthProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "period_month",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "burn_rate_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "ar_balance_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "recorded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramFinancialMonthsRequest
 */ export class ListProgramFinancialMonthsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramFinancialMonthsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramFinancialMonthsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramFinancialMonthsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramFinancialMonthsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramFinancialMonthsRequest, "runtime", proto3);
_define_property(ListProgramFinancialMonthsRequest, "typeName", "mono.ryugu.v1.ListProgramFinancialMonthsRequest");
_define_property(ListProgramFinancialMonthsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ProgramOrderCeilingProto is one document's value of one order ceiling.
 * The last of a kind is the current one.
 *
 * @generated from message mono.ryugu.v1.ProgramOrderCeilingProto
 */ export class ProgramOrderCeilingProto extends Message {
    static fromBinary(bytes, options) {
        return new ProgramOrderCeilingProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramOrderCeilingProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramOrderCeilingProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramOrderCeilingProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * time_and_materials | labor_hour | travel | cost_reimbursable |
   * other_direct_costs.
   *
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: double ceiling_amount = 3;
   */ _define_property(this, "ceilingAmount", 0), /**
   * "award", or the modification number that states it.
   *
   * @generated from field: string source_ref = 4;
   */ _define_property(this, "sourceRef", ""), /**
   * ISO date the stating document takes effect; empty when unstated.
   *
   * @generated from field: string effective_date = 5;
   */ _define_property(this, "effectiveDate", ""), /**
   * @generated from field: string source_artifact_id = 6;
   */ _define_property(this, "sourceArtifactId", ""), /**
   * @generated from field: int32 source_page = 7;
   */ _define_property(this, "sourcePage", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramOrderCeilingProto, "runtime", proto3);
_define_property(ProgramOrderCeilingProto, "typeName", "mono.ryugu.v1.ProgramOrderCeilingProto");
_define_property(ProgramOrderCeilingProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "ceiling_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "effective_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramOrderCeilingsRequest
 */ export class ListProgramOrderCeilingsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramOrderCeilingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramOrderCeilingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramOrderCeilingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramOrderCeilingsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramOrderCeilingsRequest, "runtime", proto3);
_define_property(ListProgramOrderCeilingsRequest, "typeName", "mono.ryugu.v1.ListProgramOrderCeilingsRequest");
_define_property(ListProgramOrderCeilingsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ceilings are oldest first within each kind.
 *
 * @generated from message mono.ryugu.v1.ListProgramOrderCeilingsResponse
 */ export class ListProgramOrderCeilingsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramOrderCeilingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramOrderCeilingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramOrderCeilingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramOrderCeilingsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ProgramOrderCeilingProto ceilings = 1;
   */ _define_property(this, "ceilings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramOrderCeilingsResponse, "runtime", proto3);
_define_property(ListProgramOrderCeilingsResponse, "typeName", "mono.ryugu.v1.ListProgramOrderCeilingsResponse");
_define_property(ListProgramOrderCeilingsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ceilings",
            kind: "message",
            T: ProgramOrderCeilingProto,
            repeated: true
        }
    ]));
/**
 * entries are newest month first.
 *
 * @generated from message mono.ryugu.v1.ListProgramFinancialMonthsResponse
 */ export class ListProgramFinancialMonthsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramFinancialMonthsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramFinancialMonthsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramFinancialMonthsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramFinancialMonthsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ProgramFinancialMonthProto entries = 1;
   */ _define_property(this, "entries", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramFinancialMonthsResponse, "runtime", proto3);
_define_property(ListProgramFinancialMonthsResponse, "typeName", "mono.ryugu.v1.ListProgramFinancialMonthsResponse");
_define_property(ListProgramFinancialMonthsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entries",
            kind: "message",
            T: ProgramFinancialMonthProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertProgramFinancialMonthRequest
 */ export class UpsertProgramFinancialMonthRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramFinancialMonthRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramFinancialMonthRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramFinancialMonthRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramFinancialMonthRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string period_month = 2;
   */ _define_property(this, "periodMonth", ""), /**
   * @generated from field: int64 burn_rate_cents = 3;
   */ _define_property(this, "burnRateCents", protoInt64.zero), /**
   * @generated from field: int64 ar_balance_cents = 4;
   */ _define_property(this, "arBalanceCents", protoInt64.zero), /**
   * @generated from field: string comment = 5;
   */ _define_property(this, "comment", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramFinancialMonthRequest, "runtime", proto3);
_define_property(UpsertProgramFinancialMonthRequest, "typeName", "mono.ryugu.v1.UpsertProgramFinancialMonthRequest");
_define_property(UpsertProgramFinancialMonthRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "period_month",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "burn_rate_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "ar_balance_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertProgramFinancialMonthResponse
 */ export class UpsertProgramFinancialMonthResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramFinancialMonthResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramFinancialMonthResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramFinancialMonthResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramFinancialMonthResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ProgramFinancialMonthProto entry = 1;
   */ _define_property(this, "entry", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramFinancialMonthResponse, "runtime", proto3);
_define_property(UpsertProgramFinancialMonthResponse, "typeName", "mono.ryugu.v1.UpsertProgramFinancialMonthResponse");
_define_property(UpsertProgramFinancialMonthResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entry",
            kind: "message",
            T: ProgramFinancialMonthProto
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SetProgramFundingAlertThresholdRequest
 */ export class SetProgramFundingAlertThresholdRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetProgramFundingAlertThresholdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetProgramFundingAlertThresholdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetProgramFundingAlertThresholdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetProgramFundingAlertThresholdRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * 1-100
   *
   * @generated from field: int32 threshold_pct = 2;
   */ _define_property(this, "thresholdPct", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetProgramFundingAlertThresholdRequest, "runtime", proto3);
_define_property(SetProgramFundingAlertThresholdRequest, "typeName", "mono.ryugu.v1.SetProgramFundingAlertThresholdRequest");
_define_property(SetProgramFundingAlertThresholdRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "threshold_pct",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SetProgramFundingAlertThresholdResponse
 */ export class SetProgramFundingAlertThresholdResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetProgramFundingAlertThresholdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetProgramFundingAlertThresholdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetProgramFundingAlertThresholdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetProgramFundingAlertThresholdResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 threshold_pct = 1;
   */ _define_property(this, "thresholdPct", 0), /**
   * true when the program has no override (system default)
   *
   * @generated from field: bool is_default = 2;
   */ _define_property(this, "isDefault", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetProgramFundingAlertThresholdResponse, "runtime", proto3);
_define_property(SetProgramFundingAlertThresholdResponse, "typeName", "mono.ryugu.v1.SetProgramFundingAlertThresholdResponse");
_define_property(SetProgramFundingAlertThresholdResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "threshold_pct",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "is_default",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SubcontractorReviewProto
 */ export class SubcontractorReviewProto extends Message {
    static fromBinary(bytes, options) {
        return new SubcontractorReviewProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubcontractorReviewProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubcontractorReviewProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubcontractorReviewProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string company_assignment_id = 3;
   */ _define_property(this, "companyAssignmentId", ""), /**
   * denormalized
   *
   * @generated from field: string company_name = 4;
   */ _define_property(this, "companyName", ""), /**
   * @generated from field: google.protobuf.Timestamp review_date = 5;
   */ _define_property(this, "reviewDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp due_date = 6;
   */ _define_property(this, "dueDate", void 0), /**
   * @generated from field: double score = 7;
   */ _define_property(this, "score", 0), /**
   * @generated from field: string feedback = 8;
   */ _define_property(this, "feedback", ""), /**
   * Pending, Complete
   *
   * @generated from field: string state = 9;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string reviewed_by = 10;
   */ _define_property(this, "reviewedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubcontractorReviewProto, "runtime", proto3);
_define_property(SubcontractorReviewProto, "typeName", "mono.ryugu.v1.SubcontractorReviewProto");
_define_property(SubcontractorReviewProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "review_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "due_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "feedback",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "reviewed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListSubcontractorReviewsRequest
 */ export class ListSubcontractorReviewsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSubcontractorReviewsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSubcontractorReviewsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSubcontractorReviewsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSubcontractorReviewsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * optional filter
   *
   * @generated from field: string company_assignment_id = 2;
   */ _define_property(this, "companyAssignmentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSubcontractorReviewsRequest, "runtime", proto3);
_define_property(ListSubcontractorReviewsRequest, "typeName", "mono.ryugu.v1.ListSubcontractorReviewsRequest");
_define_property(ListSubcontractorReviewsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListSubcontractorReviewsResponse
 */ export class ListSubcontractorReviewsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSubcontractorReviewsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSubcontractorReviewsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSubcontractorReviewsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSubcontractorReviewsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.SubcontractorReviewProto reviews = 1;
   */ _define_property(this, "reviews", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSubcontractorReviewsResponse, "runtime", proto3);
_define_property(ListSubcontractorReviewsResponse, "typeName", "mono.ryugu.v1.ListSubcontractorReviewsResponse");
_define_property(ListSubcontractorReviewsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reviews",
            kind: "message",
            T: SubcontractorReviewProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertSubcontractorReviewRequest
 */ export class UpsertSubcontractorReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertSubcontractorReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertSubcontractorReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertSubcontractorReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertSubcontractorReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string company_assignment_id = 3;
   */ _define_property(this, "companyAssignmentId", ""), /**
   * @generated from field: google.protobuf.Timestamp review_date = 4;
   */ _define_property(this, "reviewDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp due_date = 5;
   */ _define_property(this, "dueDate", void 0), /**
   * @generated from field: double score = 6;
   */ _define_property(this, "score", 0), /**
   * @generated from field: string feedback = 7;
   */ _define_property(this, "feedback", ""), /**
   * @generated from field: string state = 8;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string reviewed_by = 9;
   */ _define_property(this, "reviewedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertSubcontractorReviewRequest, "runtime", proto3);
_define_property(UpsertSubcontractorReviewRequest, "typeName", "mono.ryugu.v1.UpsertSubcontractorReviewRequest");
_define_property(UpsertSubcontractorReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "review_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "due_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "feedback",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "reviewed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertSubcontractorReviewResponse
 */ export class UpsertSubcontractorReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertSubcontractorReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertSubcontractorReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertSubcontractorReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertSubcontractorReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.SubcontractorReviewProto review = 1;
   */ _define_property(this, "review", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertSubcontractorReviewResponse, "runtime", proto3);
_define_property(UpsertSubcontractorReviewResponse, "typeName", "mono.ryugu.v1.UpsertSubcontractorReviewResponse");
_define_property(UpsertSubcontractorReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: SubcontractorReviewProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteSubcontractorReviewRequest
 */ export class DeleteSubcontractorReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteSubcontractorReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteSubcontractorReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteSubcontractorReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteSubcontractorReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteSubcontractorReviewRequest, "runtime", proto3);
_define_property(DeleteSubcontractorReviewRequest, "typeName", "mono.ryugu.v1.DeleteSubcontractorReviewRequest");
_define_property(DeleteSubcontractorReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteSubcontractorReviewResponse
 */ export class DeleteSubcontractorReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteSubcontractorReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteSubcontractorReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteSubcontractorReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteSubcontractorReviewResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteSubcontractorReviewResponse, "runtime", proto3);
_define_property(DeleteSubcontractorReviewResponse, "typeName", "mono.ryugu.v1.DeleteSubcontractorReviewResponse");
_define_property(DeleteSubcontractorReviewResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.ProgramDocumentProto
 */ export class ProgramDocumentProto extends Message {
    static fromBinary(bytes, options) {
        return new ProgramDocumentProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramDocumentProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramDocumentProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramDocumentProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: google.protobuf.Timestamp doc_date = 5;
   */ _define_property(this, "docDate", void 0), /**
   * @generated from field: string file_id = 6;
   */ _define_property(this, "fileId", ""), /**
   * @generated from field: string file_name = 7;
   */ _define_property(this, "fileName", ""), /**
   * PMR, TPP, Decision Log, Kickoff, Contract, Subcontract, Closeout, Other
   *
   * @generated from field: string category = 8;
   */ _define_property(this, "category", ""), /**
   * @generated from field: google.protobuf.Timestamp uploaded_at = 9;
   */ _define_property(this, "uploadedAt", void 0), /**
   * @generated from field: string uploaded_by = 10;
   */ _define_property(this, "uploadedBy", ""), /**
   * optional: per-company doc
   *
   * @generated from field: string company_assignment_id = 11;
   */ _define_property(this, "companyAssignmentId", ""), /**
   * optional: per-person doc (about them, not the uploader)
   *
   * @generated from field: string contact_id = 12;
   */ _define_property(this, "contactId", ""), /**
   * optional: per-issue doc (an attachment on an Issue)
   *
   * @generated from field: string issue_id = 13;
   */ _define_property(this, "issueId", ""), /**
   * free-text labels
   *
   * @generated from field: repeated string tags = 14;
   */ _define_property(this, "tags", []), /**
   * Processing outcome: "processing", "ready", "failed", or empty when the
   * document was stored, not read. A failure carries a plain reason.
   *
   * @generated from field: string processing_status = 15;
   */ _define_property(this, "processingStatus", ""), /**
   * @generated from field: string processing_reason = 16;
   */ _define_property(this, "processingReason", ""), /**
   * @generated from field: google.protobuf.Timestamp processing_attempted_at = 17;
   */ _define_property(this, "processingAttemptedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramDocumentProto, "runtime", proto3);
_define_property(ProgramDocumentProto, "typeName", "mono.ryugu.v1.ProgramDocumentProto");
_define_property(ProgramDocumentProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "doc_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "file_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "uploaded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "uploaded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "company_assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "issue_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "tags",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 15,
            name: "processing_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "processing_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "processing_attempted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramDocumentsRequest
 */ export class ListProgramDocumentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramDocumentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramDocumentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramDocumentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramDocumentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * optional filter
   *
   * @generated from field: string category = 2;
   */ _define_property(this, "category", ""), /**
   * optional: docs for a specific company
   *
   * @generated from field: string company_assignment_id = 3;
   */ _define_property(this, "companyAssignmentId", ""), /**
   * Include rows a user removed from the Docs tab (tombstoned). The
   * extraction pipeline's dedup reads with this set so automatic linking
   * never resurrects a deliberate removal; the tab itself never sets it.
   *
   * @generated from field: bool include_removed = 4;
   */ _define_property(this, "includeRemoved", false), /**
   * optional: docs for a specific person
   *
   * @generated from field: string contact_id = 5;
   */ _define_property(this, "contactId", ""), /**
   * optional: docs for a specific issue
   *
   * @generated from field: string issue_id = 6;
   */ _define_property(this, "issueId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramDocumentsRequest, "runtime", proto3);
_define_property(ListProgramDocumentsRequest, "typeName", "mono.ryugu.v1.ListProgramDocumentsRequest");
_define_property(ListProgramDocumentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "include_removed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "issue_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramDocumentsResponse
 */ export class ListProgramDocumentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramDocumentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramDocumentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramDocumentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramDocumentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ProgramDocumentProto documents = 1;
   */ _define_property(this, "documents", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramDocumentsResponse, "runtime", proto3);
_define_property(ListProgramDocumentsResponse, "typeName", "mono.ryugu.v1.ListProgramDocumentsResponse");
_define_property(ListProgramDocumentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "documents",
            kind: "message",
            T: ProgramDocumentProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateProgramDocumentRequest
 */ export class CreateProgramDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: google.protobuf.Timestamp doc_date = 4;
   */ _define_property(this, "docDate", void 0), /**
   * @generated from field: string file_id = 5;
   */ _define_property(this, "fileId", ""), /**
   * @generated from field: string file_name = 6;
   */ _define_property(this, "fileName", ""), /**
   * @generated from field: string category = 7;
   */ _define_property(this, "category", ""), /**
   * @generated from field: string uploaded_by = 8;
   */ _define_property(this, "uploadedBy", ""), /**
   * @generated from field: string company_assignment_id = 9;
   */ _define_property(this, "companyAssignmentId", ""), /**
   * @generated from field: string contact_id = 10;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string issue_id = 11;
   */ _define_property(this, "issueId", ""), /**
   * normalised server-side: max 20, each max 50 chars
   *
   * @generated from field: repeated string tags = 12;
   */ _define_property(this, "tags", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramDocumentRequest, "runtime", proto3);
_define_property(CreateProgramDocumentRequest, "typeName", "mono.ryugu.v1.CreateProgramDocumentRequest");
_define_property(CreateProgramDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "doc_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "file_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "uploaded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "company_assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "issue_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "tags",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateProgramDocumentResponse
 */ export class CreateProgramDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ProgramDocumentProto document = 1;
   */ _define_property(this, "document", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramDocumentResponse, "runtime", proto3);
_define_property(CreateProgramDocumentResponse, "typeName", "mono.ryugu.v1.CreateProgramDocumentResponse");
_define_property(CreateProgramDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: ProgramDocumentProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteProgramDocumentRequest
 */ export class DeleteProgramDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramDocumentRequest, "runtime", proto3);
_define_property(DeleteProgramDocumentRequest, "typeName", "mono.ryugu.v1.DeleteProgramDocumentRequest");
_define_property(DeleteProgramDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteProgramDocumentResponse
 */ export class DeleteProgramDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramDocumentResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramDocumentResponse, "runtime", proto3);
_define_property(DeleteProgramDocumentResponse, "typeName", "mono.ryugu.v1.DeleteProgramDocumentResponse");
_define_property(DeleteProgramDocumentResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.SetProgramDocumentTagsRequest
 */ export class SetProgramDocumentTagsRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetProgramDocumentTagsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetProgramDocumentTagsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetProgramDocumentTagsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetProgramDocumentTagsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * replaces the full tag set; normalised server-side
   *
   * @generated from field: repeated string tags = 2;
   */ _define_property(this, "tags", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetProgramDocumentTagsRequest, "runtime", proto3);
_define_property(SetProgramDocumentTagsRequest, "typeName", "mono.ryugu.v1.SetProgramDocumentTagsRequest");
_define_property(SetProgramDocumentTagsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tags",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SetProgramDocumentTagsResponse
 */ export class SetProgramDocumentTagsResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetProgramDocumentTagsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetProgramDocumentTagsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetProgramDocumentTagsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetProgramDocumentTagsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ProgramDocumentProto document = 1;
   */ _define_property(this, "document", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetProgramDocumentTagsResponse, "runtime", proto3);
_define_property(SetProgramDocumentTagsResponse, "typeName", "mono.ryugu.v1.SetProgramDocumentTagsResponse");
_define_property(SetProgramDocumentTagsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: ProgramDocumentProto
        }
    ]));
/**
 * file_id is the document's artifact id, as on CreateProgramDocumentRequest.
 *
 * @generated from message mono.ryugu.v1.SetProgramDocumentProcessingRequest
 */ export class SetProgramDocumentProcessingRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetProgramDocumentProcessingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetProgramDocumentProcessingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetProgramDocumentProcessingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetProgramDocumentProcessingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string file_id = 2;
   */ _define_property(this, "fileId", ""), /**
   * "processing", "ready" or "failed"
   *
   * @generated from field: string status = 3;
   */ _define_property(this, "status", ""), /**
   * plain reason; kept only when failed
   *
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetProgramDocumentProcessingRequest, "runtime", proto3);
_define_property(SetProgramDocumentProcessingRequest, "typeName", "mono.ryugu.v1.SetProgramDocumentProcessingRequest");
_define_property(SetProgramDocumentProcessingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SetProgramDocumentProcessingResponse
 */ export class SetProgramDocumentProcessingResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetProgramDocumentProcessingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetProgramDocumentProcessingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetProgramDocumentProcessingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetProgramDocumentProcessingResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetProgramDocumentProcessingResponse, "runtime", proto3);
_define_property(SetProgramDocumentProcessingResponse, "typeName", "mono.ryugu.v1.SetProgramDocumentProcessingResponse");
_define_property(SetProgramDocumentProcessingResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.AuditTemplateProto
 */ export class AuditTemplateProto extends Message {
    static fromBinary(bytes, options) {
        return new AuditTemplateProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuditTemplateProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuditTemplateProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuditTemplateProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string area = 4;
   */ _define_property(this, "area", ""), /**
   * @generated from field: bool is_default = 5;
   */ _define_property(this, "isDefault", false), /**
   * @generated from field: repeated mono.ryugu.v1.AuditTemplateQuestionProto questions = 6;
   */ _define_property(this, "questions", []), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0), /**
   * empty = company-wide, set = program-specific override
   *
   * @generated from field: string program_id = 9;
   */ _define_property(this, "programId", ""), /**
   * true = read-only system template
   *
   * @generated from field: bool is_system = 10;
   */ _define_property(this, "isSystem", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AuditTemplateProto, "runtime", proto3);
_define_property(AuditTemplateProto, "typeName", "mono.ryugu.v1.AuditTemplateProto");
_define_property(AuditTemplateProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "is_default",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "questions",
            kind: "message",
            T: AuditTemplateQuestionProto,
            repeated: true
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "is_system",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AuditTemplateQuestionProto
 */ export class AuditTemplateQuestionProto extends Message {
    static fromBinary(bytes, options) {
        return new AuditTemplateQuestionProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuditTemplateQuestionProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuditTemplateQuestionProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuditTemplateQuestionProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string template_id = 2;
   */ _define_property(this, "templateId", ""), /**
   * @generated from field: string question = 3;
   */ _define_property(this, "question", ""), /**
   * @generated from field: int32 sort_order = 4;
   */ _define_property(this, "sortOrder", 0), /**
   * Standard-checklist annotations: the review-area title, the "what the
   * auditor confirms" description, and the responsibility that routes a failed
   * item's corrective action to its section owner.
   *
   * @generated from field: int32 item_number = 5;
   */ _define_property(this, "itemNumber", 0), /**
   * @generated from field: string checklist_item_key = 6;
   */ _define_property(this, "checklistItemKey", ""), /**
   * @generated from field: string review_area = 7;
   */ _define_property(this, "reviewArea", ""), /**
   * @generated from field: string description = 8;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string responsibility_key = 9;
   */ _define_property(this, "responsibilityKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AuditTemplateQuestionProto, "runtime", proto3);
_define_property(AuditTemplateQuestionProto, "typeName", "mono.ryugu.v1.AuditTemplateQuestionProto");
_define_property(AuditTemplateQuestionProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "question",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "item_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "checklist_item_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "review_area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "responsibility_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AuditSectionOwnerProto
 */ export class AuditSectionOwnerProto extends Message {
    static fromBinary(bytes, options) {
        return new AuditSectionOwnerProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuditSectionOwnerProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuditSectionOwnerProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuditSectionOwnerProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * deliverables | financials | subcontracts | quality | contracts | program
   *
   * @generated from field: string responsibility_key = 3;
   */ _define_property(this, "responsibilityKey", ""), /**
   * @generated from field: string contact_id = 4;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string contact_name = 5;
   */ _define_property(this, "contactName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AuditSectionOwnerProto, "runtime", proto3);
_define_property(AuditSectionOwnerProto, "typeName", "mono.ryugu.v1.AuditSectionOwnerProto");
_define_property(AuditSectionOwnerProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "responsibility_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contact_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListAuditSectionOwnersRequest
 */ export class ListAuditSectionOwnersRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditSectionOwnersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditSectionOwnersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditSectionOwnersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditSectionOwnersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditSectionOwnersRequest, "runtime", proto3);
_define_property(ListAuditSectionOwnersRequest, "typeName", "mono.ryugu.v1.ListAuditSectionOwnersRequest");
_define_property(ListAuditSectionOwnersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListAuditSectionOwnersResponse
 */ export class ListAuditSectionOwnersResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditSectionOwnersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditSectionOwnersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditSectionOwnersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditSectionOwnersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.AuditSectionOwnerProto owners = 1;
   */ _define_property(this, "owners", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditSectionOwnersResponse, "runtime", proto3);
_define_property(ListAuditSectionOwnersResponse, "typeName", "mono.ryugu.v1.ListAuditSectionOwnersResponse");
_define_property(ListAuditSectionOwnersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "owners",
            kind: "message",
            T: AuditSectionOwnerProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertAuditSectionOwnerRequest
 */ export class UpsertAuditSectionOwnerRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertAuditSectionOwnerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertAuditSectionOwnerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertAuditSectionOwnerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertAuditSectionOwnerRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string responsibility_key = 2;
   */ _define_property(this, "responsibilityKey", ""), /**
   * @generated from field: string contact_id = 3;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string contact_name = 4;
   */ _define_property(this, "contactName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertAuditSectionOwnerRequest, "runtime", proto3);
_define_property(UpsertAuditSectionOwnerRequest, "typeName", "mono.ryugu.v1.UpsertAuditSectionOwnerRequest");
_define_property(UpsertAuditSectionOwnerRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "responsibility_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contact_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertAuditSectionOwnerResponse
 */ export class UpsertAuditSectionOwnerResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertAuditSectionOwnerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertAuditSectionOwnerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertAuditSectionOwnerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertAuditSectionOwnerResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.AuditSectionOwnerProto owner = 1;
   */ _define_property(this, "owner", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertAuditSectionOwnerResponse, "runtime", proto3);
_define_property(UpsertAuditSectionOwnerResponse, "typeName", "mono.ryugu.v1.UpsertAuditSectionOwnerResponse");
_define_property(UpsertAuditSectionOwnerResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "owner",
            kind: "message",
            T: AuditSectionOwnerProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListAuditTemplatesRequest
 */ export class ListAuditTemplatesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditTemplatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditTemplatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditTemplatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditTemplatesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * optional: also include program-specific templates
   *
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditTemplatesRequest, "runtime", proto3);
_define_property(ListAuditTemplatesRequest, "typeName", "mono.ryugu.v1.ListAuditTemplatesRequest");
_define_property(ListAuditTemplatesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListAuditTemplatesResponse
 */ export class ListAuditTemplatesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditTemplatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditTemplatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditTemplatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditTemplatesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.AuditTemplateProto templates = 1;
   */ _define_property(this, "templates", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditTemplatesResponse, "runtime", proto3);
_define_property(ListAuditTemplatesResponse, "typeName", "mono.ryugu.v1.ListAuditTemplatesResponse");
_define_property(ListAuditTemplatesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "templates",
            kind: "message",
            T: AuditTemplateProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertAuditTemplateRequest
 */ export class UpsertAuditTemplateRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertAuditTemplateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertAuditTemplateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertAuditTemplateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertAuditTemplateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string area = 4;
   */ _define_property(this, "area", ""), /**
   * @generated from field: bool is_default = 5;
   */ _define_property(this, "isDefault", false), /**
   * @generated from field: repeated mono.ryugu.v1.AuditTemplateQuestionProto questions = 6;
   */ _define_property(this, "questions", []), /**
   * empty = company-wide, set = program-specific override
   *
   * @generated from field: string program_id = 7;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertAuditTemplateRequest, "runtime", proto3);
_define_property(UpsertAuditTemplateRequest, "typeName", "mono.ryugu.v1.UpsertAuditTemplateRequest");
_define_property(UpsertAuditTemplateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "is_default",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "questions",
            kind: "message",
            T: AuditTemplateQuestionProto,
            repeated: true
        },
        {
            no: 7,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertAuditTemplateResponse
 */ export class UpsertAuditTemplateResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertAuditTemplateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertAuditTemplateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertAuditTemplateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertAuditTemplateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.AuditTemplateProto template = 1;
   */ _define_property(this, "template", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertAuditTemplateResponse, "runtime", proto3);
_define_property(UpsertAuditTemplateResponse, "typeName", "mono.ryugu.v1.UpsertAuditTemplateResponse");
_define_property(UpsertAuditTemplateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "template",
            kind: "message",
            T: AuditTemplateProto
        }
    ]));
/**
 * Create an audit from a template — clones all questions into new AuditQuestion records.
 *
 * @generated from message mono.ryugu.v1.CreateAuditFromTemplateRequest
 */ export class CreateAuditFromTemplateRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateAuditFromTemplateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuditFromTemplateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuditFromTemplateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateAuditFromTemplateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string template_id = 2;
   */ _define_property(this, "templateId", ""), /**
   * @generated from field: google.protobuf.Timestamp audit_date = 3;
   */ _define_property(this, "auditDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp period_start = 4;
   */ _define_property(this, "periodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp period_end = 5;
   */ _define_property(this, "periodEnd", void 0), /**
   * @generated from field: string assigned_to = 6;
   */ _define_property(this, "assignedTo", ""), /**
   * @generated from field: bool is_final = 7;
   */ _define_property(this, "isFinal", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateAuditFromTemplateRequest, "runtime", proto3);
_define_property(CreateAuditFromTemplateRequest, "typeName", "mono.ryugu.v1.CreateAuditFromTemplateRequest");
_define_property(CreateAuditFromTemplateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "audit_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "assigned_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "is_final",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateAuditFromTemplateResponse
 */ export class CreateAuditFromTemplateResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateAuditFromTemplateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuditFromTemplateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuditFromTemplateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateAuditFromTemplateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.AuditProto audit = 1;
   */ _define_property(this, "audit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateAuditFromTemplateResponse, "runtime", proto3);
_define_property(CreateAuditFromTemplateResponse, "typeName", "mono.ryugu.v1.CreateAuditFromTemplateResponse");
_define_property(CreateAuditFromTemplateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit",
            kind: "message",
            T: AuditProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListTaskOrdersRequest
 */ export class ListTaskOrdersRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListTaskOrdersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTaskOrdersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTaskOrdersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTaskOrdersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * parent IDIQ program ID
   *
   * @generated from field: string idiq_program_id = 1;
   */ _define_property(this, "idiqProgramId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTaskOrdersRequest, "runtime", proto3);
_define_property(ListTaskOrdersRequest, "typeName", "mono.ryugu.v1.ListTaskOrdersRequest");
_define_property(ListTaskOrdersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "idiq_program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListTaskOrdersResponse
 */ export class ListTaskOrdersResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListTaskOrdersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTaskOrdersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTaskOrdersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTaskOrdersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.Program task_orders = 1;
   */ _define_property(this, "taskOrders", []), /**
   * Aggregated across all task orders
   *
   * @generated from field: mono.ryugu.v1.ComputedValue aggregate_tcv = 2;
   */ _define_property(this, "aggregateTcv", void 0), /**
   * @generated from field: mono.ryugu.v1.ComputedValue aggregate_funded = 3;
   */ _define_property(this, "aggregateFunded", void 0), /**
   * @generated from field: mono.ryugu.v1.ComputedValue aggregate_ftes = 4;
   */ _define_property(this, "aggregateFtes", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTaskOrdersResponse, "runtime", proto3);
_define_property(ListTaskOrdersResponse, "typeName", "mono.ryugu.v1.ListTaskOrdersResponse");
_define_property(ListTaskOrdersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "task_orders",
            kind: "message",
            T: Program,
            repeated: true
        },
        {
            no: 2,
            name: "aggregate_tcv",
            kind: "message",
            T: ComputedValue
        },
        {
            no: 3,
            name: "aggregate_funded",
            kind: "message",
            T: ComputedValue
        },
        {
            no: 4,
            name: "aggregate_ftes",
            kind: "message",
            T: ComputedValue
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetPortfolioDashboardRequest
 */ export class GetPortfolioDashboardRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPortfolioDashboardRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPortfolioDashboardRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPortfolioDashboardRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPortfolioDashboardRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * optional filters
   *
   * @generated from field: string sector_id = 2;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string business_unit_id = 3;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string portfolio_id = 4;
   */ _define_property(this, "portfolioId", ""), /**
   * Contract lifecycle state filter — a tenant_enum_values id
   * (domain contract_lifecycle_state); empty means all states.
   *
   * @generated from field: string contract_state = 5;
   */ _define_property(this, "contractState", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPortfolioDashboardRequest, "runtime", proto3);
_define_property(GetPortfolioDashboardRequest, "typeName", "mono.ryugu.v1.GetPortfolioDashboardRequest");
_define_property(GetPortfolioDashboardRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetPortfolioDashboardResponse
 */ export class GetPortfolioDashboardResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPortfolioDashboardResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPortfolioDashboardResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPortfolioDashboardResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPortfolioDashboardResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Summary totals (with formulas)
   *
   * @generated from field: int32 total_programs = 1;
   */ _define_property(this, "totalPrograms", 0), /**
   * @generated from field: mono.ryugu.v1.ComputedValue total_tcv = 2;
   */ _define_property(this, "totalTcv", void 0), /**
   * @generated from field: mono.ryugu.v1.ComputedValue total_funded = 3;
   */ _define_property(this, "totalFunded", void 0), /**
   * @generated from field: mono.ryugu.v1.ComputedValue total_ftes = 4;
   */ _define_property(this, "totalFtes", void 0), /**
   * Per-program KPI summary for the health grid
   *
   * @generated from field: repeated mono.ryugu.v1.ProgramHealthRow programs = 5;
   */ _define_property(this, "programs", []), /**
   * Aggregate KPI compliance counts
   *
   * @generated from field: int32 kpi1_compliant_count = 6;
   */ _define_property(this, "kpi1CompliantCount", 0), /**
   * @generated from field: int32 kpi2_compliant_count = 7;
   */ _define_property(this, "kpi2CompliantCount", 0), /**
   * @generated from field: int32 kpi3_compliant_count = 8;
   */ _define_property(this, "kpi3CompliantCount", 0), /**
   * @generated from field: int32 kpi4_compliant_count = 9;
   */ _define_property(this, "kpi4CompliantCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPortfolioDashboardResponse, "runtime", proto3);
_define_property(GetPortfolioDashboardResponse, "typeName", "mono.ryugu.v1.GetPortfolioDashboardResponse");
_define_property(GetPortfolioDashboardResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_programs",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "total_tcv",
            kind: "message",
            T: ComputedValue
        },
        {
            no: 3,
            name: "total_funded",
            kind: "message",
            T: ComputedValue
        },
        {
            no: 4,
            name: "total_ftes",
            kind: "message",
            T: ComputedValue
        },
        {
            no: 5,
            name: "programs",
            kind: "message",
            T: ProgramHealthRow,
            repeated: true
        },
        {
            no: 6,
            name: "kpi1_compliant_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "kpi2_compliant_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "kpi3_compliant_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "kpi4_compliant_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ProgramHealthRow is one row in the portfolio dashboard grid.
 *
 * @generated from message mono.ryugu.v1.ProgramHealthRow
 */ export class ProgramHealthRow extends Message {
    static fromBinary(bytes, options) {
        return new ProgramHealthRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramHealthRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramHealthRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramHealthRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string program_name = 2;
   */ _define_property(this, "programName", ""), /**
   * @generated from field: string contract_number = 3;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string state = 4;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string sector_name = 5;
   */ _define_property(this, "sectorName", ""), /**
   * @generated from field: string business_unit_name = 6;
   */ _define_property(this, "businessUnitName", ""), /**
   * @generated from field: string portfolio_name = 7;
   */ _define_property(this, "portfolioName", ""), /**
   * TCV + Funding
   *
   * @generated from field: double current_tcv = 8;
   */ _define_property(this, "currentTcv", 0), /**
   * @generated from field: double funded_amount = 9;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double funded_percent = 10;
   */ _define_property(this, "fundedPercent", 0), /**
   * KPI 1: Deliverables
   *
   * @generated from field: double deliverable_on_time_pct = 11;
   */ _define_property(this, "deliverableOnTimePct", 0), /**
   * @generated from field: int32 overdue_tasks = 12;
   */ _define_property(this, "overdueTasks", 0), /**
   * @generated from field: bool kpi1_compliant = 13;
   */ _define_property(this, "kpi1Compliant", false), /**
   * KPI 2: Customer Satisfaction
   *
   * @generated from field: double latest_cpars = 14;
   */ _define_property(this, "latestCpars", 0), /**
   * @generated from field: double latest_qasp = 15;
   */ _define_property(this, "latestQasp", 0), /**
   * @generated from field: bool kpi2_compliant = 16;
   */ _define_property(this, "kpi2Compliant", false), /**
   * KPI 3: Financial
   *
   * @generated from field: double latest_dpaf_margin = 17;
   */ _define_property(this, "latestDpafMargin", 0), /**
   * @generated from field: int32 latest_dso = 18;
   */ _define_property(this, "latestDso", 0), /**
   * @generated from field: bool kpi3_compliant = 19;
   */ _define_property(this, "kpi3Compliant", false), /**
   * KPI 4: GDS Compliance
   *
   * @generated from field: int32 audit_pass = 20;
   */ _define_property(this, "auditPass", 0), /**
   * @generated from field: int32 audit_total = 21;
   */ _define_property(this, "auditTotal", 0), /**
   * @generated from field: bool kpi4_compliant = 22;
   */ _define_property(this, "kpi4Compliant", false), /**
   * Workforce
   *
   * @generated from field: double total_ftes = 23;
   */ _define_property(this, "totalFtes", 0), /**
   * SAD-178 (RPT-02): current self-assessment (Program Lead audit) state, its
   * period month, and a readiness figure. has_self_assessment distinguishes
   * "none this cycle" from a genuine 0/0. The readiness pair's meaning
   * depends on state: for a Complete assessment it is the frozen first-pass
   * score; for an in-flight one it is reviewed-vs-total checklist progress.
   * The open-Correction count is NOT here — it is read separately from
   * GetOpenCorrectiveActionCounts (spans ALL of a program's audits, viewer-
   * projected already), not duplicated onto this row.
   *
   * @generated from field: bool has_self_assessment = 24;
   */ _define_property(this, "hasSelfAssessment", false), /**
   * @generated from field: string self_assessment_state = 25;
   */ _define_property(this, "selfAssessmentState", ""), /**
   * @generated from field: string self_assessment_period_month = 26;
   */ _define_property(this, "selfAssessmentPeriodMonth", ""), /**
   * @generated from field: int32 self_assessment_readiness_num = 27;
   */ _define_property(this, "selfAssessmentReadinessNum", 0), /**
   * @generated from field: int32 self_assessment_readiness_den = 28;
   */ _define_property(this, "selfAssessmentReadinessDen", 0), /**
   * The scope ids behind sector_name / business_unit_name / portfolio_name
   * (D114 #5): the Command Center matches a program to its roll-up card by
   * id, never by a display name two scopes could share. "" = unassigned.
   *
   * @generated from field: string sector_id = 29;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string business_unit_id = 30;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string portfolio_id = 31;
   */ _define_property(this, "portfolioId", ""), /**
   * Whether a CPARS evaluation / QASP assessment with an overall score is on
   * record (SAD-998). latest_cpars / latest_qasp zero-fill when absent, so
   * only these tell "not evaluated" from "scored zero". kpi2_compliant is
   * true only when at least one is on record and every one on record meets
   * the 4.0 floor; a program with neither reads "No evaluation", never
   * "meets target".
   *
   * @generated from field: bool has_cpars = 32;
   */ _define_property(this, "hasCpars", false), /**
   * @generated from field: bool has_qasp = 33;
   */ _define_property(this, "hasQasp", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramHealthRow, "runtime", proto3);
_define_property(ProgramHealthRow, "typeName", "mono.ryugu.v1.ProgramHealthRow");
_define_property(ProgramHealthRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "sector_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "business_unit_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "portfolio_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "current_tcv",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "funded_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "deliverable_on_time_pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "overdue_tasks",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "kpi1_compliant",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "latest_cpars",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 15,
            name: "latest_qasp",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 16,
            name: "kpi2_compliant",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 17,
            name: "latest_dpaf_margin",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 18,
            name: "latest_dso",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 19,
            name: "kpi3_compliant",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 20,
            name: "audit_pass",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 21,
            name: "audit_total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 22,
            name: "kpi4_compliant",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 23,
            name: "total_ftes",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 24,
            name: "has_self_assessment",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 25,
            name: "self_assessment_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "self_assessment_period_month",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "self_assessment_readiness_num",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 28,
            name: "self_assessment_readiness_den",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 29,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 30,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 31,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 32,
            name: "has_cpars",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 33,
            name: "has_qasp",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetDeliveryKPIRollupsRequest
 */ export class GetDeliveryKPIRollupsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDeliveryKPIRollupsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeliveryKPIRollupsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeliveryKPIRollupsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeliveryKPIRollupsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * optional filters
   *
   * @generated from field: string sector_id = 2;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string business_unit_id = 3;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string portfolio_id = 4;
   */ _define_property(this, "portfolioId", ""), /**
   * @generated from field: string contract_state = 5;
   */ _define_property(this, "contractState", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeliveryKPIRollupsRequest, "runtime", proto3);
_define_property(GetDeliveryKPIRollupsRequest, "typeName", "mono.ryugu.v1.GetDeliveryKPIRollupsRequest");
_define_property(GetDeliveryKPIRollupsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * DeliveryKPIRollup is one org-node rollup of delivery-truth metrics. scope_id
 * is the portfolio or sector id ("" = unassigned); scope_name is resolved by
 * ryugu. Percentages come from summed raw counts in pangaea, not averaged.
 *
 * @generated from message mono.ryugu.v1.DeliveryKPIRollup
 */ export class DeliveryKPIRollup extends Message {
    static fromBinary(bytes, options) {
        return new DeliveryKPIRollup().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliveryKPIRollup().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliveryKPIRollup().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliveryKPIRollup, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string scope_id = 1;
   */ _define_property(this, "scopeId", ""), /**
   * @generated from field: string scope_name = 2;
   */ _define_property(this, "scopeName", ""), /**
   * @generated from field: int32 program_count = 3;
   */ _define_property(this, "programCount", 0), /**
   * @generated from field: double total_tcv = 4;
   */ _define_property(this, "totalTcv", 0), /**
   * @generated from field: double total_funded = 5;
   */ _define_property(this, "totalFunded", 0), /**
   * @generated from field: double funding_utilization_pct = 6;
   */ _define_property(this, "fundingUtilizationPct", 0), /**
   * @generated from field: double on_time_pct = 7;
   */ _define_property(this, "onTimePct", 0), /**
   * @generated from field: double evidence_completeness_pct = 8;
   */ _define_property(this, "evidenceCompletenessPct", 0), /**
   * @generated from field: int64 open_risk_count = 9;
   */ _define_property(this, "openRiskCount", protoInt64.zero), /**
   * @generated from field: int64 open_issue_count = 10;
   */ _define_property(this, "openIssueCount", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliveryKPIRollup, "runtime", proto3);
_define_property(DeliveryKPIRollup, "typeName", "mono.ryugu.v1.DeliveryKPIRollup");
_define_property(DeliveryKPIRollup, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scope_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "total_tcv",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "total_funded",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "funding_utilization_pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "on_time_pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "evidence_completeness_pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "open_risk_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 10,
            name: "open_issue_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetDeliveryKPIRollupsResponse
 */ export class GetDeliveryKPIRollupsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDeliveryKPIRollupsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeliveryKPIRollupsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeliveryKPIRollupsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeliveryKPIRollupsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.DeliveryKPIRollup portfolio_rollups = 1;
   */ _define_property(this, "portfolioRollups", []), /**
   * @generated from field: repeated mono.ryugu.v1.DeliveryKPIRollup sector_rollups = 2;
   */ _define_property(this, "sectorRollups", []), /**
   * hidden_count is the number of programs the viewer cannot see (NoView)
   * that were excluded from every rollup. Surfaced as "N hidden" so a
   * viewer-projected total never silently omits programs (DRIFT-2 / C3).
   *
   * @generated from field: int32 hidden_count = 3;
   */ _define_property(this, "hiddenCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeliveryKPIRollupsResponse, "runtime", proto3);
_define_property(GetDeliveryKPIRollupsResponse, "typeName", "mono.ryugu.v1.GetDeliveryKPIRollupsResponse");
_define_property(GetDeliveryKPIRollupsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "portfolio_rollups",
            kind: "message",
            T: DeliveryKPIRollup,
            repeated: true
        },
        {
            no: 2,
            name: "sector_rollups",
            kind: "message",
            T: DeliveryKPIRollup,
            repeated: true
        },
        {
            no: 3,
            name: "hidden_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * GetOnTimeReportRequest scopes RPT-01's on-time drill-down. company_id is
 * resolved like DeliveryService's other delivery rpcs (the gateway principal
 * wins over the request body); empty program_id means tenant-wide. from/to
 * form a half-open window [from, to) over submitted_at; both unset means
 * cumulative (no window predicate). from/to are UTC instants — callers derive
 * their own trailing windows in UTC before passing them in.
 *
 * @generated from message mono.ryugu.v1.GetOnTimeReportRequest
 */ export class GetOnTimeReportRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOnTimeReportRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOnTimeReportRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOnTimeReportRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOnTimeReportRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: google.protobuf.Timestamp from = 3;
   */ _define_property(this, "from", void 0), /**
   * @generated from field: google.protobuf.Timestamp to = 4;
   */ _define_property(this, "to", void 0), /**
   * window and explicit from/to are mutually exclusive: setting both is an
   * InvalidArgument error. UNSPECIFIED means cumulative, so a caller that sets
   * neither window nor from/to still gets the cumulative report.
   *
   * @generated from field: mono.ryugu.v1.OnTimeWindow window = 5;
   */ _define_property(this, "window", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOnTimeReportRequest, "runtime", proto3);
_define_property(GetOnTimeReportRequest, "typeName", "mono.ryugu.v1.GetOnTimeReportRequest");
_define_property(GetOnTimeReportRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "from",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "to",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "window",
            kind: "enum",
            T: proto3.getEnumType(OnTimeWindow)
        }
    ]));
/**
 * OnTimeReportRow is one submitted deliverable instance in the drill-down;
 * mirrors datagateway.v1.OnTimeReportRow.
 *
 * @generated from message mono.ryugu.v1.OnTimeReportRow
 */ export class OnTimeReportRow extends Message {
    static fromBinary(bytes, options) {
        return new OnTimeReportRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OnTimeReportRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OnTimeReportRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OnTimeReportRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string instance_id = 1;
   */ _define_property(this, "instanceId", ""), /**
   * @generated from field: string deliverable_definition_id = 2;
   */ _define_property(this, "deliverableDefinitionId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string clin_number = 4;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string deliverable_number = 5;
   */ _define_property(this, "deliverableNumber", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 7;
   */ _define_property(this, "dueAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp submitted_at = 8;
   */ _define_property(this, "submittedAt", void 0), /**
   * @generated from field: bool on_time_flag = 9;
   */ _define_property(this, "onTimeFlag", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OnTimeReportRow, "runtime", proto3);
_define_property(OnTimeReportRow, "typeName", "mono.ryugu.v1.OnTimeReportRow");
_define_property(OnTimeReportRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "instance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "deliverable_definition_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "deliverable_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "submitted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "on_time_flag",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * GetOnTimeReportResponse is the windowed on-time report. numerator/
 * denominator/pct are recomputed from `rows` AFTER viewer projection (never
 * passed through from pangaea's own aggregate), so a restricted viewer's
 * percentage always matches only the rows they can see.
 *
 * @generated from message mono.ryugu.v1.GetOnTimeReportResponse
 */ export class GetOnTimeReportResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOnTimeReportResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOnTimeReportResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOnTimeReportResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOnTimeReportResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.OnTimeReportRow rows = 1;
   */ _define_property(this, "rows", []), /**
   * @generated from field: int64 numerator = 2;
   */ _define_property(this, "numerator", protoInt64.zero), /**
   * @generated from field: int64 denominator = 3;
   */ _define_property(this, "denominator", protoInt64.zero), /**
   * @generated from field: double pct = 4;
   */ _define_property(this, "pct", 0), /**
   * window_from/window_to echo the half-open bounds the server actually
   * applied, whether they came from an OnTimeWindow or from explicit from/to,
   * so a caller can label the range it is looking at. Both unset when the
   * report was cumulative.
   *
   * @generated from field: google.protobuf.Timestamp window_from = 5;
   */ _define_property(this, "windowFrom", void 0), /**
   * @generated from field: google.protobuf.Timestamp window_to = 6;
   */ _define_property(this, "windowTo", void 0), /**
   * OPEN instances: past-due deliverable instances with no submission at all.
   * These are NEVER part of numerator/denominator/pct above — a consumer must
   * not fold them into the on-time rate. on_time_flag is always false on these
   * rows, meaning "not applicable" (there is no submission to be on time or
   * late), not "late"; submitted_at is unset. Viewer-projected the same way as
   * rows: a program the caller cannot see never appears here either.
   *
   * @generated from field: repeated mono.ryugu.v1.OnTimeReportRow outstanding_overdue = 7;
   */ _define_property(this, "outstandingOverdue", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOnTimeReportResponse, "runtime", proto3);
_define_property(GetOnTimeReportResponse, "typeName", "mono.ryugu.v1.GetOnTimeReportResponse");
_define_property(GetOnTimeReportResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: OnTimeReportRow,
            repeated: true
        },
        {
            no: 2,
            name: "numerator",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "denominator",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "window_from",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "window_to",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "outstanding_overdue",
            kind: "message",
            T: OnTimeReportRow,
            repeated: true
        }
    ]));
/**
 * GetWeeklyRecapRequest scopes RPT-06's weekly recap. Unlike
 * GetOnTimeReportRequest, company_id AND program_id are both required — a
 * weekly recap is always a per-program artifact, never company-wide. There is
 * no explicit from/to field: window is the only way to name the range, and
 * it must not be UNSPECIFIED.
 *
 * @generated from message mono.ryugu.v1.GetWeeklyRecapRequest
 */ export class GetWeeklyRecapRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetWeeklyRecapRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWeeklyRecapRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWeeklyRecapRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWeeklyRecapRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.ryugu.v1.OnTimeWindow window = 3;
   */ _define_property(this, "window", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWeeklyRecapRequest, "runtime", proto3);
_define_property(GetWeeklyRecapRequest, "typeName", "mono.ryugu.v1.GetWeeklyRecapRequest");
_define_property(GetWeeklyRecapRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "window",
            kind: "enum",
            T: proto3.getEnumType(OnTimeWindow)
        }
    ]));
/**
 * WeeklyRecapRow is one on-time report row (embedded verbatim, so consumers
 * get the identical row shape as GetOnTimeReport) enriched with its linked
 * program task's id, waiver state, notes, and how many calendar days late
 * the submission was.
 *
 * @generated from message mono.ryugu.v1.WeeklyRecapRow
 */ export class WeeklyRecapRow extends Message {
    static fromBinary(bytes, options) {
        return new WeeklyRecapRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WeeklyRecapRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WeeklyRecapRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WeeklyRecapRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.OnTimeReportRow row = 1;
   */ _define_property(this, "row", void 0), /**
   * @generated from field: string program_task_id = 2;
   */ _define_property(this, "programTaskId", ""), /**
   * @generated from field: bool waived = 3;
   */ _define_property(this, "waived", false), /**
   * @generated from field: string task_notes = 4;
   */ _define_property(this, "taskNotes", ""), /**
   * @generated from field: int32 days_late = 5;
   */ _define_property(this, "daysLate", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WeeklyRecapRow, "runtime", proto3);
_define_property(WeeklyRecapRow, "typeName", "mono.ryugu.v1.WeeklyRecapRow");
_define_property(WeeklyRecapRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "row",
            kind: "message",
            T: OnTimeReportRow
        },
        {
            no: 2,
            name: "program_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "waived",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "task_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "days_late",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * GetWeeklyRecapResponse is the windowed weekly recap: rows is the full
 * enriched drill-down, and numerator/denominator/pct are the underlying
 * on-time report's own numerator/denominator/pct (never a separate
 * aggregate) — same contract as GetOnTimeReportResponse.
 *
 * @generated from message mono.ryugu.v1.GetWeeklyRecapResponse
 */ export class GetWeeklyRecapResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetWeeklyRecapResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWeeklyRecapResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWeeklyRecapResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWeeklyRecapResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.WeeklyRecapRow rows = 1;
   */ _define_property(this, "rows", []), /**
   * @generated from field: int64 numerator = 2;
   */ _define_property(this, "numerator", protoInt64.zero), /**
   * @generated from field: int64 denominator = 3;
   */ _define_property(this, "denominator", protoInt64.zero), /**
   * @generated from field: double pct = 4;
   */ _define_property(this, "pct", 0), /**
   * window_from/window_to echo the half-open bounds the server actually
   * applied for the resolved window.
   *
   * @generated from field: google.protobuf.Timestamp window_from = 5;
   */ _define_property(this, "windowFrom", void 0), /**
   * @generated from field: google.protobuf.Timestamp window_to = 6;
   */ _define_property(this, "windowTo", void 0), /**
   * OPEN instances: past-due deliverable instances with no submission at all
   * (the plain row type, not WeeklyRecapRow — these have no linked submission
   * to enrich with waiver/notes/days-late). NEVER part of numerator/
   * denominator/pct above. on_time_flag is always false on these rows,
   * meaning "not applicable", not "late"; submitted_at is unset. Forwarded
   * verbatim from pangaea — this RPC is single-program-gated by the
   * interceptor, so there is no cross-program set left to project.
   *
   * @generated from field: repeated mono.ryugu.v1.OnTimeReportRow outstanding_overdue = 7;
   */ _define_property(this, "outstandingOverdue", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWeeklyRecapResponse, "runtime", proto3);
_define_property(GetWeeklyRecapResponse, "typeName", "mono.ryugu.v1.GetWeeklyRecapResponse");
_define_property(GetWeeklyRecapResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: WeeklyRecapRow,
            repeated: true
        },
        {
            no: 2,
            name: "numerator",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "denominator",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "window_from",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "window_to",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "outstanding_overdue",
            kind: "message",
            T: OnTimeReportRow,
            repeated: true
        }
    ]));
/**
 * GetOpenCorrectiveActionCountsRequest scopes RPT-07's tenant-wide open
 * corrective-action rollup. company_id ONLY, no program_id: Home's card
 * needs the tenant total, and program-level counts are a byproduct of how
 * the rollup is computed, not a filterable dimension here.
 *
 * @generated from message mono.ryugu.v1.GetOpenCorrectiveActionCountsRequest
 */ export class GetOpenCorrectiveActionCountsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOpenCorrectiveActionCountsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpenCorrectiveActionCountsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpenCorrectiveActionCountsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpenCorrectiveActionCountsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpenCorrectiveActionCountsRequest, "runtime", proto3);
_define_property(GetOpenCorrectiveActionCountsRequest, "typeName", "mono.ryugu.v1.GetOpenCorrectiveActionCountsRequest");
_define_property(GetOpenCorrectiveActionCountsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * OpenCorrectiveActionCount mirrors datagateway.v1.OpenCorrectiveActionCount.
 *
 * @generated from message mono.ryugu.v1.OpenCorrectiveActionCount
 */ export class OpenCorrectiveActionCount extends Message {
    static fromBinary(bytes, options) {
        return new OpenCorrectiveActionCount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpenCorrectiveActionCount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpenCorrectiveActionCount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpenCorrectiveActionCount, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: int64 open_count = 2;
   */ _define_property(this, "openCount", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpenCorrectiveActionCount, "runtime", proto3);
_define_property(OpenCorrectiveActionCount, "typeName", "mono.ryugu.v1.OpenCorrectiveActionCount");
_define_property(OpenCorrectiveActionCount, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "open_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * GetOpenCorrectiveActionCountsResponse: counts is projected per-program (a
 * NoView program's row is dropped), and total_open_count is summed from ONLY
 * the rows that survive that projection — never pangaea's own tenant-wide
 * total — so a restricted viewer's total always matches what they can see.
 *
 * @generated from message mono.ryugu.v1.GetOpenCorrectiveActionCountsResponse
 */ export class GetOpenCorrectiveActionCountsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOpenCorrectiveActionCountsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpenCorrectiveActionCountsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpenCorrectiveActionCountsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpenCorrectiveActionCountsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.OpenCorrectiveActionCount counts = 1;
   */ _define_property(this, "counts", []), /**
   * @generated from field: int64 total_open_count = 2;
   */ _define_property(this, "totalOpenCount", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpenCorrectiveActionCountsResponse, "runtime", proto3);
_define_property(GetOpenCorrectiveActionCountsResponse, "typeName", "mono.ryugu.v1.GetOpenCorrectiveActionCountsResponse");
_define_property(GetOpenCorrectiveActionCountsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "counts",
            kind: "message",
            T: OpenCorrectiveActionCount,
            repeated: true
        },
        {
            no: 2,
            name: "total_open_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * DeliveryCalendarEvent is one cross-project deadline (deliverable due, PoP
 * option-period expiration, or protest/debrief window).
 *
 * @generated from message mono.ryugu.v1.DeliveryCalendarEvent
 */ export class DeliveryCalendarEvent extends Message {
    static fromBinary(bytes, options) {
        return new DeliveryCalendarEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliveryCalendarEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliveryCalendarEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliveryCalendarEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string source_object_type = 2;
   */ _define_property(this, "sourceObjectType", ""), /**
   * @generated from field: string source_object_id = 3;
   */ _define_property(this, "sourceObjectId", ""), /**
   * @generated from field: string event_type = 4;
   */ _define_property(this, "eventType", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 7;
   */ _define_property(this, "dueAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp start_at = 8;
   */ _define_property(this, "startAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_at = 9;
   */ _define_property(this, "endAt", void 0), /**
   * @generated from field: string status = 10;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string program_id = 11;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string program_name = 12;
   */ _define_property(this, "programName", ""), /**
   * @generated from field: string sector_id = 13;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string business_unit_id = 14;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string portfolio_id = 15;
   */ _define_property(this, "portfolioId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliveryCalendarEvent, "runtime", proto3);
_define_property(DeliveryCalendarEvent, "typeName", "mono.ryugu.v1.DeliveryCalendarEvent");
_define_property(DeliveryCalendarEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "event_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "start_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "end_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetDeliveryCalendarRequest
 */ export class GetDeliveryCalendarRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDeliveryCalendarRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeliveryCalendarRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeliveryCalendarRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeliveryCalendarRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: google.protobuf.Timestamp due_after = 2;
   */ _define_property(this, "dueAfter", void 0), /**
   * @generated from field: google.protobuf.Timestamp due_before = 3;
   */ _define_property(this, "dueBefore", void 0), /**
   * @generated from field: string sector_id = 4;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string business_unit_id = 5;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string portfolio_id = 6;
   */ _define_property(this, "portfolioId", ""), /**
   * @generated from field: string event_type = 7;
   */ _define_property(this, "eventType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeliveryCalendarRequest, "runtime", proto3);
_define_property(GetDeliveryCalendarRequest, "typeName", "mono.ryugu.v1.GetDeliveryCalendarRequest");
_define_property(GetDeliveryCalendarRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "due_after",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "due_before",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "event_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetDeliveryCalendarResponse
 */ export class GetDeliveryCalendarResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDeliveryCalendarResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeliveryCalendarResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeliveryCalendarResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeliveryCalendarResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.DeliveryCalendarEvent events = 1;
   */ _define_property(this, "events", []), /**
   * hidden_count is the number of NoView programs whose events were dropped
   * from the calendar (DRIFT-2 / C3) — surfaced so deadlines for hidden
   * programs are disclosed as a count, never silently absent.
   *
   * @generated from field: int32 hidden_count = 2;
   */ _define_property(this, "hiddenCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeliveryCalendarResponse, "runtime", proto3);
_define_property(GetDeliveryCalendarResponse, "typeName", "mono.ryugu.v1.GetDeliveryCalendarResponse");
_define_property(GetDeliveryCalendarResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: DeliveryCalendarEvent,
            repeated: true
        },
        {
            no: 2,
            name: "hidden_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * DeliverableLookaheadItem mirrors datagateway.v1.DeliverableLookaheadItem —
 * one deliverable-shaped occurrence (program_task or deliverable_instance
 * source only) due inside the server-computed 14-day window.
 *
 * @generated from message mono.ryugu.v1.DeliverableLookaheadItem
 */ export class DeliverableLookaheadItem extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableLookaheadItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableLookaheadItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableLookaheadItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableLookaheadItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string occurrence_id = 1;
   */ _define_property(this, "occurrenceId", ""), /**
   * program_task | deliverable_instance
   *
   * @generated from field: string source_object_type = 2;
   */ _define_property(this, "sourceObjectType", ""), /**
   * @generated from field: string deliverable_number = 3;
   */ _define_property(this, "deliverableNumber", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 6;
   */ _define_property(this, "dueAt", void 0), /**
   * @generated from field: bool waived = 7;
   */ _define_property(this, "waived", false), /**
   * @generated from field: string program_id = 8;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string program_name = 9;
   */ _define_property(this, "programName", ""), /**
   * @generated from field: string sector_id = 10;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string business_unit_id = 11;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string portfolio_id = 12;
   */ _define_property(this, "portfolioId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableLookaheadItem, "runtime", proto3);
_define_property(DeliverableLookaheadItem, "typeName", "mono.ryugu.v1.DeliverableLookaheadItem");
_define_property(DeliverableLookaheadItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "deliverable_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "waived",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * GetDeliverableLookaheadRequest deliberately has NO due_after/due_before —
 * see the rpc's own doc comment above. company_id resolves the same way
 * every other Delivery RPC's does; program_id optionally narrows to one
 * program.
 *
 * @generated from message mono.ryugu.v1.GetDeliverableLookaheadRequest
 */ export class GetDeliverableLookaheadRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDeliverableLookaheadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeliverableLookaheadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeliverableLookaheadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeliverableLookaheadRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeliverableLookaheadRequest, "runtime", proto3);
_define_property(GetDeliverableLookaheadRequest, "typeName", "mono.ryugu.v1.GetDeliverableLookaheadRequest");
_define_property(GetDeliverableLookaheadRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetDeliverableLookaheadResponse
 */ export class GetDeliverableLookaheadResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDeliverableLookaheadResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeliverableLookaheadResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeliverableLookaheadResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeliverableLookaheadResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.DeliverableLookaheadItem items = 1;
   */ _define_property(this, "items", []), /**
   * hidden_count mirrors GetDeliveryCalendarResponse's own field — the number
   * of NoView programs whose occurrences were dropped by viewer projection.
   *
   * @generated from field: int32 hidden_count = 2;
   */ _define_property(this, "hiddenCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeliverableLookaheadResponse, "runtime", proto3);
_define_property(GetDeliverableLookaheadResponse, "typeName", "mono.ryugu.v1.GetDeliverableLookaheadResponse");
_define_property(GetDeliverableLookaheadResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "items",
            kind: "message",
            T: DeliverableLookaheadItem,
            repeated: true
        },
        {
            no: 2,
            name: "hidden_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * DeliveryNotification is one row in the signed-in user's inbox.
 *
 * @generated from message mono.ryugu.v1.DeliveryNotification
 */ export class DeliveryNotification extends Message {
    static fromBinary(bytes, options) {
        return new DeliveryNotification().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliveryNotification().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliveryNotification().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliveryNotification, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string recipient_id = 1;
   */ _define_property(this, "recipientId", ""), /**
   * @generated from field: string notification_type = 2;
   */ _define_property(this, "notificationType", ""), /**
   * @generated from field: string severity = 3;
   */ _define_property(this, "severity", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string body = 5;
   */ _define_property(this, "body", ""), /**
   * @generated from field: string source_object_type = 6;
   */ _define_property(this, "sourceObjectType", ""), /**
   * @generated from field: string source_object_id = 7;
   */ _define_property(this, "sourceObjectId", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 8;
   */ _define_property(this, "dueAt", void 0), /**
   * @generated from field: string delivery_status = 9;
   */ _define_property(this, "deliveryStatus", ""), /**
   * @generated from field: google.protobuf.Timestamp acknowledged_at = 10;
   */ _define_property(this, "acknowledgedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * program_id is the projection key computed server-side (empty for
   * personal, non-program-linked rows). Carried through so the client can
   * build program-scoped deep links; it never widens what a viewer sees —
   * the row itself already passed per-row NoView projection before this
   * field is populated.
   *
   * @generated from field: string program_id = 12;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliveryNotification, "runtime", proto3);
_define_property(DeliveryNotification, "typeName", "mono.ryugu.v1.DeliveryNotification");
_define_property(DeliveryNotification, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "recipient_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notification_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "delivery_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "acknowledged_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetMyNotificationPreferencesRequest
 */ export class GetMyNotificationPreferencesRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetMyNotificationPreferencesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMyNotificationPreferencesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMyNotificationPreferencesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMyNotificationPreferencesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMyNotificationPreferencesRequest, "runtime", proto3);
_define_property(GetMyNotificationPreferencesRequest, "typeName", "mono.ryugu.v1.GetMyNotificationPreferencesRequest");
_define_property(GetMyNotificationPreferencesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateMyNotificationPreferencesRequest
 */ export class UpdateMyNotificationPreferencesRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateMyNotificationPreferencesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateMyNotificationPreferencesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateMyNotificationPreferencesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateMyNotificationPreferencesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.NotificationPreferenceChange changes = 2;
   */ _define_property(this, "changes", []), /**
   * Clears every choice first: "Reset all to defaults".
   *
   * @generated from field: bool reset_all = 3;
   */ _define_property(this, "resetAll", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateMyNotificationPreferencesRequest, "runtime", proto3);
_define_property(UpdateMyNotificationPreferencesRequest, "typeName", "mono.ryugu.v1.UpdateMyNotificationPreferencesRequest");
_define_property(UpdateMyNotificationPreferencesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "changes",
            kind: "message",
            T: NotificationPreferenceChange,
            repeated: true
        },
        {
            no: 3,
            name: "reset_all",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetCompanyNotificationDefaultsRequest
 */ export class GetCompanyNotificationDefaultsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCompanyNotificationDefaultsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCompanyNotificationDefaultsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCompanyNotificationDefaultsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCompanyNotificationDefaultsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCompanyNotificationDefaultsRequest, "runtime", proto3);
_define_property(GetCompanyNotificationDefaultsRequest, "typeName", "mono.ryugu.v1.GetCompanyNotificationDefaultsRequest");
_define_property(GetCompanyNotificationDefaultsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateCompanyNotificationDefaultsRequest
 */ export class UpdateCompanyNotificationDefaultsRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCompanyNotificationDefaultsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCompanyNotificationDefaultsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCompanyNotificationDefaultsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCompanyNotificationDefaultsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.NotificationPreferenceChange changes = 2;
   */ _define_property(this, "changes", []), /**
   * @generated from field: bool reset_all = 3;
   */ _define_property(this, "resetAll", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCompanyNotificationDefaultsRequest, "runtime", proto3);
_define_property(UpdateCompanyNotificationDefaultsRequest, "typeName", "mono.ryugu.v1.UpdateCompanyNotificationDefaultsRequest");
_define_property(UpdateCompanyNotificationDefaultsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "changes",
            kind: "message",
            T: NotificationPreferenceChange,
            repeated: true
        },
        {
            no: 3,
            name: "reset_all",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetMyNotificationPreferencesResponse
 */ export class GetMyNotificationPreferencesResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetMyNotificationPreferencesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMyNotificationPreferencesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMyNotificationPreferencesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMyNotificationPreferencesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.NotificationKindPreference kinds = 1;
   */ _define_property(this, "kinds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMyNotificationPreferencesResponse, "runtime", proto3);
_define_property(GetMyNotificationPreferencesResponse, "typeName", "mono.ryugu.v1.GetMyNotificationPreferencesResponse");
_define_property(GetMyNotificationPreferencesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kinds",
            kind: "message",
            T: NotificationKindPreference,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateMyNotificationPreferencesResponse
 */ export class UpdateMyNotificationPreferencesResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateMyNotificationPreferencesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateMyNotificationPreferencesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateMyNotificationPreferencesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateMyNotificationPreferencesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.NotificationKindPreference kinds = 1;
   */ _define_property(this, "kinds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateMyNotificationPreferencesResponse, "runtime", proto3);
_define_property(UpdateMyNotificationPreferencesResponse, "typeName", "mono.ryugu.v1.UpdateMyNotificationPreferencesResponse");
_define_property(UpdateMyNotificationPreferencesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kinds",
            kind: "message",
            T: NotificationKindPreference,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetCompanyNotificationDefaultsResponse
 */ export class GetCompanyNotificationDefaultsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCompanyNotificationDefaultsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCompanyNotificationDefaultsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCompanyNotificationDefaultsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCompanyNotificationDefaultsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.NotificationKindPreference kinds = 1;
   */ _define_property(this, "kinds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCompanyNotificationDefaultsResponse, "runtime", proto3);
_define_property(GetCompanyNotificationDefaultsResponse, "typeName", "mono.ryugu.v1.GetCompanyNotificationDefaultsResponse");
_define_property(GetCompanyNotificationDefaultsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kinds",
            kind: "message",
            T: NotificationKindPreference,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateCompanyNotificationDefaultsResponse
 */ export class UpdateCompanyNotificationDefaultsResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCompanyNotificationDefaultsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCompanyNotificationDefaultsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCompanyNotificationDefaultsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCompanyNotificationDefaultsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.NotificationKindPreference kinds = 1;
   */ _define_property(this, "kinds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCompanyNotificationDefaultsResponse, "runtime", proto3);
_define_property(UpdateCompanyNotificationDefaultsResponse, "typeName", "mono.ryugu.v1.UpdateCompanyNotificationDefaultsResponse");
_define_property(UpdateCompanyNotificationDefaultsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kinds",
            kind: "message",
            T: NotificationKindPreference,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListMyNotificationsRequest
 */ export class ListMyNotificationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListMyNotificationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListMyNotificationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListMyNotificationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListMyNotificationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: bool unacknowledged_only = 2;
   */ _define_property(this, "unacknowledgedOnly", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListMyNotificationsRequest, "runtime", proto3);
_define_property(ListMyNotificationsRequest, "typeName", "mono.ryugu.v1.ListMyNotificationsRequest");
_define_property(ListMyNotificationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "unacknowledged_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListMyNotificationsResponse
 */ export class ListMyNotificationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListMyNotificationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListMyNotificationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListMyNotificationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListMyNotificationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.DeliveryNotification notifications = 1;
   */ _define_property(this, "notifications", []), /**
   * hidden_count is the number of notifications suppressed because the
   * recipient can no longer see the source program (NoView). Disclosed as a
   * count so a revoked principal sees that something exists they can't read
   * (DRIFT-2 / C3), rather than the inbox silently shrinking.
   *
   * @generated from field: int32 hidden_count = 2;
   */ _define_property(this, "hiddenCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListMyNotificationsResponse, "runtime", proto3);
_define_property(ListMyNotificationsResponse, "typeName", "mono.ryugu.v1.ListMyNotificationsResponse");
_define_property(ListMyNotificationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notifications",
            kind: "message",
            T: DeliveryNotification,
            repeated: true
        },
        {
            no: 2,
            name: "hidden_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AcknowledgeNotificationRequest
 */ export class AcknowledgeNotificationRequest extends Message {
    static fromBinary(bytes, options) {
        return new AcknowledgeNotificationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcknowledgeNotificationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcknowledgeNotificationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcknowledgeNotificationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string recipient_id = 2;
   */ _define_property(this, "recipientId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcknowledgeNotificationRequest, "runtime", proto3);
_define_property(AcknowledgeNotificationRequest, "typeName", "mono.ryugu.v1.AcknowledgeNotificationRequest");
_define_property(AcknowledgeNotificationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "recipient_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AcknowledgeNotificationResponse
 */ export class AcknowledgeNotificationResponse extends Message {
    static fromBinary(bytes, options) {
        return new AcknowledgeNotificationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcknowledgeNotificationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcknowledgeNotificationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcknowledgeNotificationResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcknowledgeNotificationResponse, "runtime", proto3);
_define_property(AcknowledgeNotificationResponse, "typeName", "mono.ryugu.v1.AcknowledgeNotificationResponse");
_define_property(AcknowledgeNotificationResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.AcknowledgeAllNotificationsRequest
 */ export class AcknowledgeAllNotificationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new AcknowledgeAllNotificationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcknowledgeAllNotificationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcknowledgeAllNotificationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcknowledgeAllNotificationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Deliberately no user-id field: the recipient is always the gateway
   * principal, resolved server-side (R7/R8) — never client-supplied.
   *
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcknowledgeAllNotificationsRequest, "runtime", proto3);
_define_property(AcknowledgeAllNotificationsRequest, "typeName", "mono.ryugu.v1.AcknowledgeAllNotificationsRequest");
_define_property(AcknowledgeAllNotificationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AcknowledgeAllNotificationsResponse
 */ export class AcknowledgeAllNotificationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new AcknowledgeAllNotificationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcknowledgeAllNotificationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcknowledgeAllNotificationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcknowledgeAllNotificationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 acknowledged_count = 1;
   */ _define_property(this, "acknowledgedCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcknowledgeAllNotificationsResponse, "runtime", proto3);
_define_property(AcknowledgeAllNotificationsResponse, "typeName", "mono.ryugu.v1.AcknowledgeAllNotificationsResponse");
_define_property(AcknowledgeAllNotificationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "acknowledged_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * NotificationChannelDelivery is one (recipient, channel) send attempt made by
 * the email/Teams dispatcher — mirrors pangaea's ChannelDelivery.
 *
 * @generated from message mono.ryugu.v1.NotificationChannelDelivery
 */ export class NotificationChannelDelivery extends Message {
    static fromBinary(bytes, options) {
        return new NotificationChannelDelivery().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotificationChannelDelivery().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotificationChannelDelivery().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotificationChannelDelivery, a, b);
    }
    constructor(data){
        super(), /**
   * EMAIL | TEAMS
   *
   * @generated from field: string channel = 1;
   */ _define_property(this, "channel", ""), /**
   * SENDING | SENT | FAILED
   *
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Timestamp attempted_at = 3;
   */ _define_property(this, "attemptedAt", void 0), /**
   * set on FAILED
   *
   * @generated from field: string error = 4;
   */ _define_property(this, "error", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(NotificationChannelDelivery, "runtime", proto3);
_define_property(NotificationChannelDelivery, "typeName", "mono.ryugu.v1.NotificationChannelDelivery");
_define_property(NotificationChannelDelivery, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "channel",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "attempted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * NotificationRecipientDelivery is one recipient of a notification plus its
 * per-channel send attempts. channel_deliveries is empty when nothing has been
 * dispatched to this recipient yet. in_app_status is the bell read/ack state
 * (PENDING | DELIVERED | FAILED), NOT an external send outcome.
 *
 * @generated from message mono.ryugu.v1.NotificationRecipientDelivery
 */ export class NotificationRecipientDelivery extends Message {
    static fromBinary(bytes, options) {
        return new NotificationRecipientDelivery().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotificationRecipientDelivery().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotificationRecipientDelivery().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotificationRecipientDelivery, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string recipient_id = 1;
   */ _define_property(this, "recipientId", ""), /**
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string platform_user_id = 3;
   */ _define_property(this, "platformUserId", ""), /**
   * @generated from field: string in_app_status = 4;
   */ _define_property(this, "inAppStatus", ""), /**
   * @generated from field: google.protobuf.Timestamp acknowledged_at = 5;
   */ _define_property(this, "acknowledgedAt", void 0), /**
   * @generated from field: repeated mono.ryugu.v1.NotificationChannelDelivery channel_deliveries = 6;
   */ _define_property(this, "channelDeliveries", []), /**
   * recipient_display_name and recipient_email are best-effort display
   * decoration resolved tenant-safely from delivery.contacts / identity.users.
   * Both are empty when the contact/user is deleted or otherwise unresolvable —
   * the client must have a fallback (e.g. render recipient_id) rather than
   * assume either is populated.
   *
   * @generated from field: string recipient_display_name = 7;
   */ _define_property(this, "recipientDisplayName", ""), /**
   * @generated from field: string recipient_email = 8;
   */ _define_property(this, "recipientEmail", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(NotificationRecipientDelivery, "runtime", proto3);
_define_property(NotificationRecipientDelivery, "typeName", "mono.ryugu.v1.NotificationRecipientDelivery");
_define_property(NotificationRecipientDelivery, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "recipient_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "platform_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "in_app_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "acknowledged_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "channel_deliveries",
            kind: "message",
            T: NotificationChannelDelivery,
            repeated: true
        },
        {
            no: 7,
            name: "recipient_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "recipient_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * NotificationDeliveryStatus is one notification event with its recipients and
 * their per-channel delivery attempts — the admin delivery-status row.
 *
 * @generated from message mono.ryugu.v1.NotificationDeliveryStatus
 */ export class NotificationDeliveryStatus extends Message {
    static fromBinary(bytes, options) {
        return new NotificationDeliveryStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotificationDeliveryStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotificationDeliveryStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotificationDeliveryStatus, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notification_event_id = 1;
   */ _define_property(this, "notificationEventId", ""), /**
   * @generated from field: string notification_type = 2;
   */ _define_property(this, "notificationType", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string severity = 4;
   */ _define_property(this, "severity", ""), /**
   * @generated from field: string program_id = 5;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: repeated mono.ryugu.v1.NotificationRecipientDelivery recipients = 7;
   */ _define_property(this, "recipients", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(NotificationDeliveryStatus, "runtime", proto3);
_define_property(NotificationDeliveryStatus, "typeName", "mono.ryugu.v1.NotificationDeliveryStatus");
_define_property(NotificationDeliveryStatus, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notification_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notification_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "recipients",
            kind: "message",
            T: NotificationRecipientDelivery,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListNotificationDeliveryStatusRequest
 */ export class ListNotificationDeliveryStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListNotificationDeliveryStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNotificationDeliveryStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNotificationDeliveryStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNotificationDeliveryStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * Optional drill-down: when set, only this event is returned. When empty,
   * the company's most recent notifications are returned, newest first.
   *
   * @generated from field: string notification_event_id = 2;
   */ _define_property(this, "notificationEventId", ""), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNotificationDeliveryStatusRequest, "runtime", proto3);
_define_property(ListNotificationDeliveryStatusRequest, "typeName", "mono.ryugu.v1.ListNotificationDeliveryStatusRequest");
_define_property(ListNotificationDeliveryStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notification_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListNotificationDeliveryStatusResponse
 */ export class ListNotificationDeliveryStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListNotificationDeliveryStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNotificationDeliveryStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNotificationDeliveryStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNotificationDeliveryStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.NotificationDeliveryStatus statuses = 1;
   */ _define_property(this, "statuses", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNotificationDeliveryStatusResponse, "runtime", proto3);
_define_property(ListNotificationDeliveryStatusResponse, "typeName", "mono.ryugu.v1.ListNotificationDeliveryStatusResponse");
_define_property(ListNotificationDeliveryStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "statuses",
            kind: "message",
            T: NotificationDeliveryStatus,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ContractCLINProto
 */ export class ContractCLINProto extends Message {
    static fromBinary(bytes, options) {
        return new ContractCLINProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractCLINProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractCLINProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractCLINProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string clin_number = 3;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string parent_clin_number = 4;
   */ _define_property(this, "parentClinNumber", ""), /**
   * @generated from field: bool is_subline_item = 5;
   */ _define_property(this, "isSublineItem", false), /**
   * @generated from field: string option_type = 6;
   */ _define_property(this, "optionType", ""), /**
   * @generated from field: int32 option_period_number = 7;
   */ _define_property(this, "optionPeriodNumber", 0), /**
   * @generated from field: string contract_type = 8;
   */ _define_property(this, "contractType", ""), /**
   * @generated from field: string description = 9;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string short_title = 10;
   */ _define_property(this, "shortTitle", ""), /**
   * @generated from field: string pws_sections = 11;
   */ _define_property(this, "pwsSections", ""), /**
   * @generated from field: int32 quantity = 12;
   */ _define_property(this, "quantity", 0), /**
   * @generated from field: string unit = 13;
   */ _define_property(this, "unit", ""), /**
   * @generated from field: double pricing_unit_price = 14;
   */ _define_property(this, "pricingUnitPrice", 0), /**
   * @generated from field: double pricing_extended_price = 15;
   */ _define_property(this, "pricingExtendedPrice", 0), /**
   * @generated from field: double pricing_funded_amount = 16;
   */ _define_property(this, "pricingFundedAmount", 0), /**
   * @generated from field: double pricing_unfunded_amount = 17;
   */ _define_property(this, "pricingUnfundedAmount", 0), /**
   * @generated from field: double pricing_award_amount = 18;
   */ _define_property(this, "pricingAwardAmount", 0), /**
   * @generated from field: string funding_status = 19;
   */ _define_property(this, "fundingStatus", ""), /**
   * @generated from field: string pop_start_date = 20;
   */ _define_property(this, "popStartDate", ""), /**
   * @generated from field: string pop_end_date = 21;
   */ _define_property(this, "popEndDate", ""), /**
   * @generated from field: int32 pop_duration_months = 22;
   */ _define_property(this, "popDurationMonths", 0), /**
   * @generated from field: string pop_period_name = 23;
   */ _define_property(this, "popPeriodName", ""), /**
   * @generated from field: bool has_deliverables = 24;
   */ _define_property(this, "hasDeliverables", false), /**
   * @generated from field: string corresponding_base_clin = 25;
   */ _define_property(this, "correspondingBaseClin", ""), /**
   * @generated from field: int32 sort_order = 26;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: string status = 27;
   */ _define_property(this, "status", ""), /**
   * @generated from field: bool is_current_version = 28;
   */ _define_property(this, "isCurrentVersion", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */ _define_property(this, "updatedAt", void 0), /**
   * JSON []string of ProgramTask ids mapped to this CLIN
   *
   * @generated from field: string deliverable_ids = 31;
   */ _define_property(this, "deliverableIds", ""), /**
   * Pricing sentinels: a legit $0 NSP/TBD line must render as its sentinel,
   * not as a missing value (the CLINs tab's fmtMoney hint contract).
   *
   * @generated from field: bool pricing_is_nsp = 32;
   */ _define_property(this, "pricingIsNsp", false), /**
   * @generated from field: bool pricing_is_tbd = 33;
   */ _define_property(this, "pricingIsTbd", false), /**
   * "" (untouched) | MODIFIED | ADDED | REMOVED (mod stamping)
   *
   * @generated from field: string amendment_status = 34;
   */ _define_property(this, "amendmentStatus", ""), /**
   * mod number that last touched this CLIN (0 = original)
   *
   * @generated from field: int32 last_modified_in = 35;
   */ _define_property(this, "lastModifiedIn", 0), /**
   * pricing_nte_ceiling is only meaningful when pricing_is_nte is set; like the
   * NSP/TBD sentinels above, a CLIN with no NTE ceiling reports false/0, not a
   * missing value.
   *
   * @generated from field: bool pricing_is_nte = 36;
   */ _define_property(this, "pricingIsNte", false), /**
   * @generated from field: double pricing_nte_ceiling = 37;
   */ _define_property(this, "pricingNteCeiling", 0), /**
   * Read-only canonical storage state, forwarded with presence intact.
   * Absent means unknown from an older server; true means SQL NULL; false
   * means the exact date string above is stored, including an empty string.
   *
   * @generated from field: optional bool pop_start_date_is_null = 38;
   */ _define_property(this, "popStartDateIsNull", void 0), /**
   * @generated from field: optional bool pop_end_date_is_null = 39;
   */ _define_property(this, "popEndDateIsNull", void 0), /**
   * @generated from field: optional string funding_basis = 40;
   */ _define_property(this, "fundingBasis", void 0), /**
   * @generated from field: optional bool pricing_unit_price_known = 41;
   */ _define_property(this, "pricingUnitPriceKnown", void 0), /**
   * @generated from field: optional bool pricing_extended_price_known = 42;
   */ _define_property(this, "pricingExtendedPriceKnown", void 0), /**
   * @generated from field: optional bool pricing_ceiling_known = 43;
   */ _define_property(this, "pricingCeilingKnown", void 0), /**
   * Source quantity, with qualifiers and presence intact; not an asserted count.
   *
   * @generated from field: optional string raw_quantity = 44;
   */ _define_property(this, "rawQuantity", void 0), /**
   * The line's exercise terms (FAR clause, frequency, PoP months) as JSON
   * CLINExerciseInfo, verbatim from contract_clins.exercise_info_json; "" when
   * the line states none (K9c-3).
   *
   * @generated from field: string exercise_info_json = 45;
   */ _define_property(this, "exerciseInfoJson", ""), /**
   * The line's price cells as the document prints them (K10b), verbatim from
   * contract_clins.pricing_raw_*; absent when no cell is stored.
   *
   * @generated from field: optional string raw_unit_price = 46;
   */ _define_property(this, "rawUnitPrice", void 0), /**
   * @generated from field: optional string raw_extended_price = 47;
   */ _define_property(this, "rawExtendedPrice", void 0), /**
   * @generated from field: optional string raw_ceiling = 48;
   */ _define_property(this, "rawCeiling", void 0), /**
   * @generated from field: string labor_mix_json = 49;
   */ _define_property(this, "laborMixJson", ""), /**
   * @generated from field: bool has_labor_mix = 50;
   */ _define_property(this, "hasLaborMix", false), /**
   * JSON []string
   *
   * @generated from field: string attachment_references = 51;
   */ _define_property(this, "attachmentReferences", ""), /**
   * JSON []ScopedPWSReference
   *
   * @generated from field: string scoped_pws_refs_json = 52;
   */ _define_property(this, "scopedPwsRefsJson", ""), /**
   * The optional task this line belongs to (contract_clins.is_optional_task,
   * optional_task_number, optional_task_title). An optional-task line is
   * filed under its task, never under an option period.
   *
   * @generated from field: bool is_optional_task = 53;
   */ _define_property(this, "isOptionalTask", false), /**
   * @generated from field: int32 optional_task_number = 54;
   */ _define_property(this, "optionalTaskNumber", 0), /**
   * @generated from field: string optional_task_title = 55;
   */ _define_property(this, "optionalTaskTitle", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractCLINProto, "runtime", proto3);
_define_property(ContractCLINProto, "typeName", "mono.ryugu.v1.ContractCLINProto");
_define_property(ContractCLINProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "parent_clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "is_subline_item",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "option_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "option_period_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "short_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "pws_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "quantity",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "pricing_unit_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 15,
            name: "pricing_extended_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 16,
            name: "pricing_funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 17,
            name: "pricing_unfunded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 18,
            name: "pricing_award_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 19,
            name: "funding_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "pop_start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "pop_end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "pop_duration_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 23,
            name: "pop_period_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "has_deliverables",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 25,
            name: "corresponding_base_clin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 27,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "is_current_version",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 29,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 30,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 31,
            name: "deliverable_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 32,
            name: "pricing_is_nsp",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 33,
            name: "pricing_is_tbd",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 34,
            name: "amendment_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 35,
            name: "last_modified_in",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 36,
            name: "pricing_is_nte",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 37,
            name: "pricing_nte_ceiling",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 38,
            name: "pop_start_date_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 39,
            name: "pop_end_date_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 40,
            name: "funding_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 41,
            name: "pricing_unit_price_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 42,
            name: "pricing_extended_price_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 43,
            name: "pricing_ceiling_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 44,
            name: "raw_quantity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 45,
            name: "exercise_info_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 46,
            name: "raw_unit_price",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 47,
            name: "raw_extended_price",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 48,
            name: "raw_ceiling",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 49,
            name: "labor_mix_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 50,
            name: "has_labor_mix",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 51,
            name: "attachment_references",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 52,
            name: "scoped_pws_refs_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 53,
            name: "is_optional_task",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 54,
            name: "optional_task_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 55,
            name: "optional_task_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListContractCLINsRequest
 */ export class ListContractCLINsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListContractCLINsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContractCLINsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContractCLINsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContractCLINsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: bool only_current_version = 2;
   */ _define_property(this, "onlyCurrentVersion", false), /**
   * offset + limit support paginated reads. When unset, ryugu defaults to a
   * page size that's safe for current dev workloads and surfaces `total` so
   * the UI can tell when it's truncated. Phase 0b adds keyset pagination.
   *
   * @generated from field: int32 offset = 3;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 4;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContractCLINsRequest, "runtime", proto3);
_define_property(ListContractCLINsRequest, "typeName", "mono.ryugu.v1.ListContractCLINsRequest");
_define_property(ListContractCLINsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "only_current_version",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListContractCLINsResponse
 */ export class ListContractCLINsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListContractCLINsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContractCLINsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContractCLINsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContractCLINsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ContractCLINProto clins = 1;
   */ _define_property(this, "clins", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContractCLINsResponse, "runtime", proto3);
_define_property(ListContractCLINsResponse, "typeName", "mono.ryugu.v1.ListContractCLINsResponse");
_define_property(ListContractCLINsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clins",
            kind: "message",
            T: ContractCLINProto,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.PlaceOfPerformanceProto
 */ export class PlaceOfPerformanceProto extends Message {
    static fromBinary(bytes, options) {
        return new PlaceOfPerformanceProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlaceOfPerformanceProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlaceOfPerformanceProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlaceOfPerformanceProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: bool primary = 3;
   */ _define_property(this, "primary", false), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: double percentage = 5;
   */ _define_property(this, "percentage", 0), /**
   * @generated from field: string city = 6;
   */ _define_property(this, "city", ""), /**
   * @generated from field: string state = 7;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string zip_code = 8;
   */ _define_property(this, "zipCode", ""), /**
   * @generated from field: string country = 9;
   */ _define_property(this, "country", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PlaceOfPerformanceProto, "runtime", proto3);
_define_property(PlaceOfPerformanceProto, "typeName", "mono.ryugu.v1.PlaceOfPerformanceProto");
_define_property(PlaceOfPerformanceProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "city",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "zip_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "country",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListPlacesOfPerformanceRequest
 */ export class ListPlacesOfPerformanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPlacesOfPerformanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPlacesOfPerformanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPlacesOfPerformanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPlacesOfPerformanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPlacesOfPerformanceRequest, "runtime", proto3);
_define_property(ListPlacesOfPerformanceRequest, "typeName", "mono.ryugu.v1.ListPlacesOfPerformanceRequest");
_define_property(ListPlacesOfPerformanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListPlacesOfPerformanceResponse
 */ export class ListPlacesOfPerformanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPlacesOfPerformanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPlacesOfPerformanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPlacesOfPerformanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPlacesOfPerformanceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.PlaceOfPerformanceProto places = 1;
   */ _define_property(this, "places", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPlacesOfPerformanceResponse, "runtime", proto3);
_define_property(ListPlacesOfPerformanceResponse, "typeName", "mono.ryugu.v1.ListPlacesOfPerformanceResponse");
_define_property(ListPlacesOfPerformanceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "places",
            kind: "message",
            T: PlaceOfPerformanceProto,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * Browser projection of a registry LCAT entry — source-faithful text plus
 * denormalized company/vehicle names so the table renders without N+1 lookups.
 *
 * @generated from message mono.ryugu.v1.LaborCategoryEntryProto
 */ export class LaborCategoryEntryProto extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryEntryProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryEntryProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryEntryProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryEntryProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string contract_vehicle_id = 3;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string zou_project_id = 4;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string solicitation_ref = 5;
   */ _define_property(this, "solicitationRef", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 7;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string qualifications = 8;
   */ _define_property(this, "qualifications", ""), /**
   * @generated from field: string clearance = 9;
   */ _define_property(this, "clearance", ""), /**
   * @generated from field: string certifications = 10;
   */ _define_property(this, "certifications", ""), /**
   * @generated from field: int32 version = 11;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string superseded_by_id = 12;
   */ _define_property(this, "supersededById", ""), /**
   * MANUAL | CANDIDATE
   *
   * @generated from field: string source = 13;
   */ _define_property(this, "source", ""), /**
   * Denormalized read helpers (lookup, not stored on the row).
   *
   * @generated from field: string company_name = 14;
   */ _define_property(this, "companyName", ""), /**
   * @generated from field: string contract_vehicle_name = 15;
   */ _define_property(this, "contractVehicleName", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 17;
   */ _define_property(this, "updatedAt", void 0), /**
   * ACTIVE | RETIRED
   *
   * @generated from field: string status = 18;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Timestamp retired_at = 19;
   */ _define_property(this, "retiredAt", void 0), /**
   * @generated from field: string scope_kind = 20;
   */ _define_property(this, "scopeKind", ""), /**
   * @generated from field: string issuing_government_organization_id = 21;
   */ _define_property(this, "issuingGovernmentOrganizationId", ""), /**
   * @generated from field: string solicitation_notice_id = 22;
   */ _define_property(this, "solicitationNoticeId", ""), /**
   * computed at read time
   *
   * @generated from field: bool vehicle_mismatch = 23;
   */ _define_property(this, "vehicleMismatch", false), /**
   * @generated from field: string source_label = 24;
   */ _define_property(this, "sourceLabel", ""), /**
   * @generated from field: mono.ryugu.v1.LaborCategoryPrimaryMappingProto primary_mapping = 25;
   */ _define_property(this, "primaryMapping", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryEntryProto, "runtime", proto3);
_define_property(LaborCategoryEntryProto, "typeName", "mono.ryugu.v1.LaborCategoryEntryProto");
_define_property(LaborCategoryEntryProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "solicitation_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "qualifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "clearance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "certifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "superseded_by_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "contract_vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "retired_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 20,
            name: "scope_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "issuing_government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "solicitation_notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "vehicle_mismatch",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 24,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "primary_mapping",
            kind: "message",
            T: LaborCategoryPrimaryMappingProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.LaborCategoryCandidateProto
 */ export class LaborCategoryCandidateProto extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryCandidateProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryCandidateProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryCandidateProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryCandidateProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string candidate_key = 2;
   */ _define_property(this, "candidateKey", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string contract_vehicle_id = 4;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string zou_project_id = 5;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string solicitation_ref = 6;
   */ _define_property(this, "solicitationRef", ""), /**
   * @generated from field: string title = 7;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 8;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string qualifications = 9;
   */ _define_property(this, "qualifications", ""), /**
   * @generated from field: string clearance = 10;
   */ _define_property(this, "clearance", ""), /**
   * @generated from field: string certifications = 11;
   */ _define_property(this, "certifications", ""), /**
   * @generated from field: string evidence_json = 12;
   */ _define_property(this, "evidenceJson", ""), /**
   * PENDING | ACCEPTED | REJECTED
   *
   * @generated from field: string status = 13;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string accepted_entry_id = 14;
   */ _define_property(this, "acceptedEntryId", ""), /**
   * @generated from field: string company_name = 15;
   */ _define_property(this, "companyName", ""), /**
   * @generated from field: string contract_vehicle_name = 16;
   */ _define_property(this, "contractVehicleName", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 17;
   */ _define_property(this, "createdAt", void 0), /**
   * NEW | EXISTING | REJECTED (SAD-439)
   *
   * @generated from field: string resolution = 18;
   */ _define_property(this, "resolution", ""), /**
   * @generated from field: string correction_json = 19;
   */ _define_property(this, "correctionJson", ""), /**
   * @generated from field: bool conflict_acknowledged = 20;
   */ _define_property(this, "conflictAcknowledged", false), /**
   * SAD-439 C2-08: true when the caller may not read the source project, so
   * source provenance was stripped from evidence_json server-side.
   *
   * @generated from field: bool provenance_redacted = 21;
   */ _define_property(this, "provenanceRedacted", false), /**
   * @generated from field: bool vehicle_mismatch = 22;
   */ _define_property(this, "vehicleMismatch", false), /**
   * @generated from field: string mismatch_vehicle_name = 23;
   */ _define_property(this, "mismatchVehicleName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryCandidateProto, "runtime", proto3);
_define_property(LaborCategoryCandidateProto, "typeName", "mono.ryugu.v1.LaborCategoryCandidateProto");
_define_property(LaborCategoryCandidateProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "candidate_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "solicitation_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "qualifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "clearance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "certifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "evidence_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "accepted_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "contract_vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "resolution",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "correction_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "conflict_acknowledged",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 21,
            name: "provenance_redacted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 22,
            name: "vehicle_mismatch",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 23,
            name: "mismatch_vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListLaborCategoryEntriesRequest
 */ export class ListLaborCategoryEntriesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLaborCategoryEntriesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLaborCategoryEntriesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLaborCategoryEntriesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLaborCategoryEntriesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string contract_vehicle_id = 3;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string search = 4;
   */ _define_property(this, "search", ""), /**
   * @generated from field: int32 offset = 5;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 6;
   */ _define_property(this, "limit", 0), /**
   * Retired categories are hidden unless asked for.
   *
   * @generated from field: bool include_retired = 7;
   */ _define_property(this, "includeRetired", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLaborCategoryEntriesRequest, "runtime", proto3);
_define_property(ListLaborCategoryEntriesRequest, "typeName", "mono.ryugu.v1.ListLaborCategoryEntriesRequest");
_define_property(ListLaborCategoryEntriesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "include_retired",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListLaborCategoryEntriesResponse
 */ export class ListLaborCategoryEntriesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLaborCategoryEntriesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLaborCategoryEntriesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLaborCategoryEntriesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLaborCategoryEntriesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.LaborCategoryEntryProto entries = 1;
   */ _define_property(this, "entries", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero), /**
   * Tenant-wide unretracted DAT-13 lcat_mismatch signals (not narrowed by the filters).
   *
   * @generated from field: int64 vehicle_mismatch_signal_count = 3;
   */ _define_property(this, "vehicleMismatchSignalCount", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLaborCategoryEntriesResponse, "runtime", proto3);
_define_property(ListLaborCategoryEntriesResponse, "typeName", "mono.ryugu.v1.ListLaborCategoryEntriesResponse");
_define_property(ListLaborCategoryEntriesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entries",
            kind: "message",
            T: LaborCategoryEntryProto,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "vehicle_mismatch_signal_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertLaborCategoryEntryRequest
 */ export class UpsertLaborCategoryEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertLaborCategoryEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertLaborCategoryEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertLaborCategoryEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertLaborCategoryEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string contract_vehicle_id = 4;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string qualifications = 7;
   */ _define_property(this, "qualifications", ""), /**
   * @generated from field: string clearance = 8;
   */ _define_property(this, "clearance", ""), /**
   * @generated from field: string certifications = 9;
   */ _define_property(this, "certifications", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertLaborCategoryEntryRequest, "runtime", proto3);
_define_property(UpsertLaborCategoryEntryRequest, "typeName", "mono.ryugu.v1.UpsertLaborCategoryEntryRequest");
_define_property(UpsertLaborCategoryEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "qualifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "clearance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "certifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertLaborCategoryEntryResponse
 */ export class UpsertLaborCategoryEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertLaborCategoryEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertLaborCategoryEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertLaborCategoryEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertLaborCategoryEntryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.LaborCategoryEntryProto entry = 1;
   */ _define_property(this, "entry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertLaborCategoryEntryResponse, "runtime", proto3);
_define_property(UpsertLaborCategoryEntryResponse, "typeName", "mono.ryugu.v1.UpsertLaborCategoryEntryResponse");
_define_property(UpsertLaborCategoryEntryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entry",
            kind: "message",
            T: LaborCategoryEntryProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteLaborCategoryEntryRequest
 */ export class DeleteLaborCategoryEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteLaborCategoryEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteLaborCategoryEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteLaborCategoryEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteLaborCategoryEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteLaborCategoryEntryRequest, "runtime", proto3);
_define_property(DeleteLaborCategoryEntryRequest, "typeName", "mono.ryugu.v1.DeleteLaborCategoryEntryRequest");
_define_property(DeleteLaborCategoryEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteLaborCategoryEntryResponse
 */ export class DeleteLaborCategoryEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteLaborCategoryEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteLaborCategoryEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteLaborCategoryEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteLaborCategoryEntryResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteLaborCategoryEntryResponse, "runtime", proto3);
_define_property(DeleteLaborCategoryEntryResponse, "typeName", "mono.ryugu.v1.DeleteLaborCategoryEntryResponse");
_define_property(DeleteLaborCategoryEntryResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * Retire a labor category: closes it to new selection, keeps every version and
 * every reference to it. Not a delete.
 *
 * @generated from message mono.ryugu.v1.RetireLaborCategoryEntryRequest
 */ export class RetireLaborCategoryEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new RetireLaborCategoryEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetireLaborCategoryEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetireLaborCategoryEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetireLaborCategoryEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetireLaborCategoryEntryRequest, "runtime", proto3);
_define_property(RetireLaborCategoryEntryRequest, "typeName", "mono.ryugu.v1.RetireLaborCategoryEntryRequest");
_define_property(RetireLaborCategoryEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RetireLaborCategoryEntryResponse
 */ export class RetireLaborCategoryEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new RetireLaborCategoryEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetireLaborCategoryEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetireLaborCategoryEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetireLaborCategoryEntryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.LaborCategoryEntryProto entry = 1;
   */ _define_property(this, "entry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetireLaborCategoryEntryResponse, "runtime", proto3);
_define_property(RetireLaborCategoryEntryResponse, "typeName", "mono.ryugu.v1.RetireLaborCategoryEntryResponse");
_define_property(RetireLaborCategoryEntryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entry",
            kind: "message",
            T: LaborCategoryEntryProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetLaborCategoryEntryHistoryRequest
 */ export class GetLaborCategoryEntryHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLaborCategoryEntryHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLaborCategoryEntryHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLaborCategoryEntryHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLaborCategoryEntryHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLaborCategoryEntryHistoryRequest, "runtime", proto3);
_define_property(GetLaborCategoryEntryHistoryRequest, "typeName", "mono.ryugu.v1.GetLaborCategoryEntryHistoryRequest");
_define_property(GetLaborCategoryEntryHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetLaborCategoryEntryHistoryResponse
 */ export class GetLaborCategoryEntryHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLaborCategoryEntryHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLaborCategoryEntryHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLaborCategoryEntryHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLaborCategoryEntryHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.LaborCategoryEntryProto entries = 1;
   */ _define_property(this, "entries", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLaborCategoryEntryHistoryResponse, "runtime", proto3);
_define_property(GetLaborCategoryEntryHistoryResponse, "typeName", "mono.ryugu.v1.GetLaborCategoryEntryHistoryResponse");
_define_property(GetLaborCategoryEntryHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entries",
            kind: "message",
            T: LaborCategoryEntryProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListLaborCategoryCandidatesRequest
 */ export class ListLaborCategoryCandidatesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLaborCategoryCandidatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLaborCategoryCandidatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLaborCategoryCandidatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLaborCategoryCandidatesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * empty = all
   *
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * @generated from field: int32 offset = 3;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 4;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLaborCategoryCandidatesRequest, "runtime", proto3);
_define_property(ListLaborCategoryCandidatesRequest, "typeName", "mono.ryugu.v1.ListLaborCategoryCandidatesRequest");
_define_property(ListLaborCategoryCandidatesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListLaborCategoryCandidatesResponse
 */ export class ListLaborCategoryCandidatesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLaborCategoryCandidatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLaborCategoryCandidatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLaborCategoryCandidatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLaborCategoryCandidatesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.LaborCategoryCandidateProto candidates = 1;
   */ _define_property(this, "candidates", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLaborCategoryCandidatesResponse, "runtime", proto3);
_define_property(ListLaborCategoryCandidatesResponse, "typeName", "mono.ryugu.v1.ListLaborCategoryCandidatesResponse");
_define_property(ListLaborCategoryCandidatesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "candidates",
            kind: "message",
            T: LaborCategoryCandidateProto,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * SAD-439: correct before accepting, or resolve to an existing entry version.
 *
 * @generated from message mono.ryugu.v1.LaborCategoryCorrectionProto
 */ export class LaborCategoryCorrectionProto extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryCorrectionProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryCorrectionProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryCorrectionProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryCorrectionProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: optional string title = 1;
   */ _define_property(this, "title", void 0), /**
   * @generated from field: optional string description = 2;
   */ _define_property(this, "description", void 0), /**
   * @generated from field: optional string qualifications = 3;
   */ _define_property(this, "qualifications", void 0), /**
   * @generated from field: optional string clearance = 4;
   */ _define_property(this, "clearance", void 0), /**
   * @generated from field: optional string certifications = 5;
   */ _define_property(this, "certifications", void 0), /**
   * @generated from field: optional string company_profile_id = 6;
   */ _define_property(this, "companyProfileId", void 0), /**
   * @generated from field: optional string contract_vehicle_id = 7;
   */ _define_property(this, "contractVehicleId", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryCorrectionProto, "runtime", proto3);
_define_property(LaborCategoryCorrectionProto, "typeName", "mono.ryugu.v1.LaborCategoryCorrectionProto");
_define_property(LaborCategoryCorrectionProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 2,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 3,
            name: "qualifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 4,
            name: "clearance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 5,
            name: "certifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 6,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 7,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AcceptLaborCategoryCandidateRequest
 */ export class AcceptLaborCategoryCandidateRequest extends Message {
    static fromBinary(bytes, options) {
        return new AcceptLaborCategoryCandidateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcceptLaborCategoryCandidateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcceptLaborCategoryCandidateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcceptLaborCategoryCandidateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: mono.ryugu.v1.LaborCategoryCorrectionProto correction = 2;
   */ _define_property(this, "correction", void 0), /**
   * @generated from field: string resolve_to_entry_id = 3;
   */ _define_property(this, "resolveToEntryId", ""), /**
   * @generated from field: bool acknowledge_conflict = 4;
   */ _define_property(this, "acknowledgeConflict", false), /**
   * @generated from field: string scope_kind = 5;
   */ _define_property(this, "scopeKind", ""), /**
   * @generated from field: string issuing_government_organization_id = 6;
   */ _define_property(this, "issuingGovernmentOrganizationId", ""), /**
   * @generated from field: string propose_anchor_id = 7;
   */ _define_property(this, "proposeAnchorId", ""), /**
   * @generated from field: string propose_relation = 8;
   */ _define_property(this, "proposeRelation", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcceptLaborCategoryCandidateRequest, "runtime", proto3);
_define_property(AcceptLaborCategoryCandidateRequest, "typeName", "mono.ryugu.v1.AcceptLaborCategoryCandidateRequest");
_define_property(AcceptLaborCategoryCandidateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "correction",
            kind: "message",
            T: LaborCategoryCorrectionProto
        },
        {
            no: 3,
            name: "resolve_to_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "acknowledge_conflict",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "scope_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "issuing_government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "propose_anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "propose_relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AcceptLaborCategoryCandidateResponse
 */ export class AcceptLaborCategoryCandidateResponse extends Message {
    static fromBinary(bytes, options) {
        return new AcceptLaborCategoryCandidateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcceptLaborCategoryCandidateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcceptLaborCategoryCandidateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcceptLaborCategoryCandidateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.LaborCategoryCandidateProto candidate = 1;
   */ _define_property(this, "candidate", void 0), /**
   * @generated from field: mono.ryugu.v1.LaborCategoryEntryProto entry = 2;
   */ _define_property(this, "entry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcceptLaborCategoryCandidateResponse, "runtime", proto3);
_define_property(AcceptLaborCategoryCandidateResponse, "typeName", "mono.ryugu.v1.AcceptLaborCategoryCandidateResponse");
_define_property(AcceptLaborCategoryCandidateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "candidate",
            kind: "message",
            T: LaborCategoryCandidateProto
        },
        {
            no: 2,
            name: "entry",
            kind: "message",
            T: LaborCategoryEntryProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RejectLaborCategoryCandidateRequest
 */ export class RejectLaborCategoryCandidateRequest extends Message {
    static fromBinary(bytes, options) {
        return new RejectLaborCategoryCandidateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectLaborCategoryCandidateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectLaborCategoryCandidateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectLaborCategoryCandidateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectLaborCategoryCandidateRequest, "runtime", proto3);
_define_property(RejectLaborCategoryCandidateRequest, "typeName", "mono.ryugu.v1.RejectLaborCategoryCandidateRequest");
_define_property(RejectLaborCategoryCandidateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RejectLaborCategoryCandidateResponse
 */ export class RejectLaborCategoryCandidateResponse extends Message {
    static fromBinary(bytes, options) {
        return new RejectLaborCategoryCandidateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectLaborCategoryCandidateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectLaborCategoryCandidateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectLaborCategoryCandidateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.LaborCategoryCandidateProto candidate = 1;
   */ _define_property(this, "candidate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectLaborCategoryCandidateResponse, "runtime", proto3);
_define_property(RejectLaborCategoryCandidateResponse, "typeName", "mono.ryugu.v1.RejectLaborCategoryCandidateResponse");
_define_property(RejectLaborCategoryCandidateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "candidate",
            kind: "message",
            T: LaborCategoryCandidateProto
        }
    ]));
/**
 * S11b — one employee owner per state (region). owner_name is denormalized
 * beside owner_contact_id, mirroring RiskProto.owner.
 *
 * @generated from message mono.ryugu.v1.RegionOwnerProto
 */ export class RegionOwnerProto extends Message {
    static fromBinary(bytes, options) {
        return new RegionOwnerProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegionOwnerProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegionOwnerProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegionOwnerProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string state = 2;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string owner_contact_id = 3;
   */ _define_property(this, "ownerContactId", ""), /**
   * @generated from field: string owner_name = 4;
   */ _define_property(this, "ownerName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegionOwnerProto, "runtime", proto3);
_define_property(RegionOwnerProto, "typeName", "mono.ryugu.v1.RegionOwnerProto");
_define_property(RegionOwnerProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "owner_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "owner_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListRegionOwnersRequest
 */ export class ListRegionOwnersRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRegionOwnersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRegionOwnersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRegionOwnersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRegionOwnersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRegionOwnersRequest, "runtime", proto3);
_define_property(ListRegionOwnersRequest, "typeName", "mono.ryugu.v1.ListRegionOwnersRequest");
_define_property(ListRegionOwnersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListRegionOwnersResponse
 */ export class ListRegionOwnersResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRegionOwnersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRegionOwnersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRegionOwnersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRegionOwnersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.RegionOwnerProto region_owners = 1;
   */ _define_property(this, "regionOwners", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRegionOwnersResponse, "runtime", proto3);
_define_property(ListRegionOwnersResponse, "typeName", "mono.ryugu.v1.ListRegionOwnersResponse");
_define_property(ListRegionOwnersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "region_owners",
            kind: "message",
            T: RegionOwnerProto,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SetRegionOwnerRequest
 */ export class SetRegionOwnerRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetRegionOwnerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetRegionOwnerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetRegionOwnerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetRegionOwnerRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string state = 2;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string owner_contact_id = 3;
   */ _define_property(this, "ownerContactId", ""), /**
   * @generated from field: string owner_name = 4;
   */ _define_property(this, "ownerName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetRegionOwnerRequest, "runtime", proto3);
_define_property(SetRegionOwnerRequest, "typeName", "mono.ryugu.v1.SetRegionOwnerRequest");
_define_property(SetRegionOwnerRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "owner_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "owner_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SetRegionOwnerResponse
 */ export class SetRegionOwnerResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetRegionOwnerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetRegionOwnerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetRegionOwnerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetRegionOwnerResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.RegionOwnerProto region_owner = 1;
   */ _define_property(this, "regionOwner", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetRegionOwnerResponse, "runtime", proto3);
_define_property(SetRegionOwnerResponse, "typeName", "mono.ryugu.v1.SetRegionOwnerResponse");
_define_property(SetRegionOwnerResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "region_owner",
            kind: "message",
            T: RegionOwnerProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.LaborCategoryAnchorProto
 */ export class LaborCategoryAnchorProto extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryAnchorProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryAnchorProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryAnchorProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryAnchorProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string soc_code = 2;
   */ _define_property(this, "socCode", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string family = 5;
   */ _define_property(this, "family", ""), /**
   * @generated from field: string specialty = 6;
   */ _define_property(this, "specialty", ""), /**
   * @generated from field: string seniority = 7;
   */ _define_property(this, "seniority", ""), /**
   * @generated from field: string source_version = 8;
   */ _define_property(this, "sourceVersion", ""), /**
   * @generated from field: string onet_title = 9;
   */ _define_property(this, "onetTitle", ""), /**
   * @generated from field: string typical_education = 10;
   */ _define_property(this, "typicalEducation", ""), /**
   * -1 = not stated
   *
   * @generated from field: int32 typical_min_experience_years = 11;
   */ _define_property(this, "typicalMinExperienceYears", 0), /**
   * @generated from field: string facts_provenance = 12;
   */ _define_property(this, "factsProvenance", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryAnchorProto, "runtime", proto3);
_define_property(LaborCategoryAnchorProto, "typeName", "mono.ryugu.v1.LaborCategoryAnchorProto");
_define_property(LaborCategoryAnchorProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "soc_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "family",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "specialty",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "seniority",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "onet_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "typical_education",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "typical_min_experience_years",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "facts_provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Browser projection of a mapping edge with denormalized display labels so
 * the drawer and review queue render without N+1 lookups.
 *
 * @generated from message mono.ryugu.v1.LaborCategoryMappingProto
 */ export class LaborCategoryMappingProto extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryMappingProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryMappingProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryMappingProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryMappingProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string from_entry_id = 2;
   */ _define_property(this, "fromEntryId", ""), /**
   * @generated from field: string to_entry_id = 3;
   */ _define_property(this, "toEntryId", ""), /**
   * @generated from field: string to_anchor_id = 4;
   */ _define_property(this, "toAnchorId", ""), /**
   * EQUIVALENT | BROADER | NARROWER
   *
   * @generated from field: string mapping_type = 5;
   */ _define_property(this, "mappingType", ""), /**
   * Optional: explicit 0.0 is distinguishable from unset.
   *
   * @generated from field: optional double confidence = 6;
   */ _define_property(this, "confidence", void 0), /**
   * @generated from field: string evidence_json = 7;
   */ _define_property(this, "evidenceJson", ""), /**
   * PENDING | APPROVED | REJECTED | WITHDRAWN | REVIEW_NEEDED
   *
   * @generated from field: string status = 8;
   */ _define_property(this, "status", ""), /**
   * Display labels (lookup, not stored).
   *
   * @generated from field: string from_entry_title = 9;
   */ _define_property(this, "fromEntryTitle", ""), /**
   * @generated from field: string to_entry_title = 10;
   */ _define_property(this, "toEntryTitle", ""), /**
   * @generated from field: string to_anchor_soc_code = 11;
   */ _define_property(this, "toAnchorSocCode", ""), /**
   * @generated from field: string to_anchor_title = 12;
   */ _define_property(this, "toAnchorTitle", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 14;
   */ _define_property(this, "decidedAt", void 0), /**
   * @generated from field: string original_basis_json = 15;
   */ _define_property(this, "originalBasisJson", ""), /**
   * @generated from field: string reviewed_basis_json = 16;
   */ _define_property(this, "reviewedBasisJson", ""), /**
   * @generated from field: int64 review_revision = 17;
   */ _define_property(this, "reviewRevision", protoInt64.zero), /**
   * @generated from field: string correction_reason = 18;
   */ _define_property(this, "correctionReason", ""), /**
   * @generated from field: string corrected_by = 19;
   */ _define_property(this, "correctedBy", ""), /**
   * @generated from field: string withdrawal_reason = 20;
   */ _define_property(this, "withdrawalReason", ""), /**
   * @generated from field: string withdrawn_by = 21;
   */ _define_property(this, "withdrawnBy", ""), /**
   * @generated from field: google.protobuf.Timestamp withdrawn_at = 22;
   */ _define_property(this, "withdrawnAt", void 0), /**
   * @generated from field: string impact_notice_json = 23;
   */ _define_property(this, "impactNoticeJson", ""), /**
   * @generated from field: string proposed_by = 24;
   */ _define_property(this, "proposedBy", ""), /**
   * @generated from field: string decided_by = 25;
   */ _define_property(this, "decidedBy", ""), /**
   * Read-only current definition heads; reviewed endpoint IDs above stay pinned.
   *
   * @generated from field: string current_from_entry_id = 26;
   */ _define_property(this, "currentFromEntryId", ""), /**
   * @generated from field: string current_to_entry_id = 27;
   */ _define_property(this, "currentToEntryId", ""), /**
   * @generated from field: string review_note = 28;
   */ _define_property(this, "reviewNote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryMappingProto, "runtime", proto3);
_define_property(LaborCategoryMappingProto, "typeName", "mono.ryugu.v1.LaborCategoryMappingProto");
_define_property(LaborCategoryMappingProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "from_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "to_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "to_anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "mapping_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 7,
            name: "evidence_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "from_entry_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "to_entry_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "to_anchor_soc_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "to_anchor_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "original_basis_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "reviewed_basis_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "review_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 18,
            name: "correction_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "corrected_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "withdrawal_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "withdrawn_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "withdrawn_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 23,
            name: "impact_notice_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "proposed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "current_from_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "current_to_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "review_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListLaborCategoryAnchorsRequest
 */ export class ListLaborCategoryAnchorsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLaborCategoryAnchorsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLaborCategoryAnchorsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLaborCategoryAnchorsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLaborCategoryAnchorsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string family = 2;
   */ _define_property(this, "family", ""), /**
   * @generated from field: string search = 3;
   */ _define_property(this, "search", ""), /**
   * @generated from field: int32 offset = 4;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 5;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLaborCategoryAnchorsRequest, "runtime", proto3);
_define_property(ListLaborCategoryAnchorsRequest, "typeName", "mono.ryugu.v1.ListLaborCategoryAnchorsRequest");
_define_property(ListLaborCategoryAnchorsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "family",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListLaborCategoryAnchorsResponse
 */ export class ListLaborCategoryAnchorsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLaborCategoryAnchorsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLaborCategoryAnchorsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLaborCategoryAnchorsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLaborCategoryAnchorsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.LaborCategoryAnchorProto anchors = 1;
   */ _define_property(this, "anchors", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLaborCategoryAnchorsResponse, "runtime", proto3);
_define_property(ListLaborCategoryAnchorsResponse, "typeName", "mono.ryugu.v1.ListLaborCategoryAnchorsResponse");
_define_property(ListLaborCategoryAnchorsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "anchors",
            kind: "message",
            T: LaborCategoryAnchorProto,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeLaborCategoryMappingRequest
 */ export class ProposeLaborCategoryMappingRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeLaborCategoryMappingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeLaborCategoryMappingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeLaborCategoryMappingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeLaborCategoryMappingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string from_entry_id = 2;
   */ _define_property(this, "fromEntryId", ""), /**
   * @generated from field: string to_entry_id = 3;
   */ _define_property(this, "toEntryId", ""), /**
   * @generated from field: string to_anchor_id = 4;
   */ _define_property(this, "toAnchorId", ""), /**
   * @generated from field: string mapping_type = 5;
   */ _define_property(this, "mappingType", ""), /**
   * Optional: explicit 0.0 is distinguishable from unset.
   *
   * @generated from field: optional double confidence = 6;
   */ _define_property(this, "confidence", void 0), /**
   * @generated from field: string evidence_json = 7;
   */ _define_property(this, "evidenceJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeLaborCategoryMappingRequest, "runtime", proto3);
_define_property(ProposeLaborCategoryMappingRequest, "typeName", "mono.ryugu.v1.ProposeLaborCategoryMappingRequest");
_define_property(ProposeLaborCategoryMappingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "from_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "to_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "to_anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "mapping_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 7,
            name: "evidence_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeLaborCategoryMappingResponse
 */ export class ProposeLaborCategoryMappingResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeLaborCategoryMappingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeLaborCategoryMappingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeLaborCategoryMappingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeLaborCategoryMappingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.LaborCategoryMappingProto mapping = 1;
   */ _define_property(this, "mapping", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeLaborCategoryMappingResponse, "runtime", proto3);
_define_property(ProposeLaborCategoryMappingResponse, "typeName", "mono.ryugu.v1.ProposeLaborCategoryMappingResponse");
_define_property(ProposeLaborCategoryMappingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "mapping",
            kind: "message",
            T: LaborCategoryMappingProto
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListLaborCategoryMappingsRequest
 */ export class ListLaborCategoryMappingsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLaborCategoryMappingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLaborCategoryMappingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLaborCategoryMappingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLaborCategoryMappingsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string from_entry_id = 2;
   */ _define_property(this, "fromEntryId", ""), /**
   * @generated from field: string to_anchor_id = 3;
   */ _define_property(this, "toAnchorId", ""), /**
   * empty = all
   *
   * @generated from field: string status = 4;
   */ _define_property(this, "status", ""), /**
   * @generated from field: int32 offset = 5;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 6;
   */ _define_property(this, "limit", 0), /**
   * Edges touching this entry at EITHER endpoint. One row per decision: the
   * caller reverses BROADER/NARROWER when the entry is the to-side.
   *
   * @generated from field: string entry_id = 7;
   */ _define_property(this, "entryId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLaborCategoryMappingsRequest, "runtime", proto3);
_define_property(ListLaborCategoryMappingsRequest, "typeName", "mono.ryugu.v1.ListLaborCategoryMappingsRequest");
_define_property(ListLaborCategoryMappingsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "from_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "to_anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListLaborCategoryMappingsResponse
 */ export class ListLaborCategoryMappingsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLaborCategoryMappingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLaborCategoryMappingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLaborCategoryMappingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLaborCategoryMappingsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.LaborCategoryMappingProto mappings = 1;
   */ _define_property(this, "mappings", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLaborCategoryMappingsResponse, "runtime", proto3);
_define_property(ListLaborCategoryMappingsResponse, "typeName", "mono.ryugu.v1.ListLaborCategoryMappingsResponse");
_define_property(ListLaborCategoryMappingsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "mappings",
            kind: "message",
            T: LaborCategoryMappingProto,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ApproveLaborCategoryMappingRequest
 */ export class ApproveLaborCategoryMappingRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApproveLaborCategoryMappingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApproveLaborCategoryMappingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApproveLaborCategoryMappingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApproveLaborCategoryMappingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: int64 review_revision = 2;
   */ _define_property(this, "reviewRevision", protoInt64.zero), /**
   * @generated from field: string review_note = 3;
   */ _define_property(this, "reviewNote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApproveLaborCategoryMappingRequest, "runtime", proto3);
_define_property(ApproveLaborCategoryMappingRequest, "typeName", "mono.ryugu.v1.ApproveLaborCategoryMappingRequest");
_define_property(ApproveLaborCategoryMappingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "review_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ApproveLaborCategoryMappingResponse
 */ export class ApproveLaborCategoryMappingResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApproveLaborCategoryMappingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApproveLaborCategoryMappingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApproveLaborCategoryMappingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApproveLaborCategoryMappingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.LaborCategoryMappingProto mapping = 1;
   */ _define_property(this, "mapping", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApproveLaborCategoryMappingResponse, "runtime", proto3);
_define_property(ApproveLaborCategoryMappingResponse, "typeName", "mono.ryugu.v1.ApproveLaborCategoryMappingResponse");
_define_property(ApproveLaborCategoryMappingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "mapping",
            kind: "message",
            T: LaborCategoryMappingProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RejectLaborCategoryMappingRequest
 */ export class RejectLaborCategoryMappingRequest extends Message {
    static fromBinary(bytes, options) {
        return new RejectLaborCategoryMappingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectLaborCategoryMappingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectLaborCategoryMappingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectLaborCategoryMappingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectLaborCategoryMappingRequest, "runtime", proto3);
_define_property(RejectLaborCategoryMappingRequest, "typeName", "mono.ryugu.v1.RejectLaborCategoryMappingRequest");
_define_property(RejectLaborCategoryMappingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RejectLaborCategoryMappingResponse
 */ export class RejectLaborCategoryMappingResponse extends Message {
    static fromBinary(bytes, options) {
        return new RejectLaborCategoryMappingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectLaborCategoryMappingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectLaborCategoryMappingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectLaborCategoryMappingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.LaborCategoryMappingProto mapping = 1;
   */ _define_property(this, "mapping", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectLaborCategoryMappingResponse, "runtime", proto3);
_define_property(RejectLaborCategoryMappingResponse, "typeName", "mono.ryugu.v1.RejectLaborCategoryMappingResponse");
_define_property(RejectLaborCategoryMappingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "mapping",
            kind: "message",
            T: LaborCategoryMappingProto
        }
    ]));
/**
 * CloseoutChecklistTemplate is the per-tenant (or platform "_system" default)
 * set of checklist items a program's closeout checklist is instantiated from.
 *
 * @generated from message mono.ryugu.v1.CloseoutChecklistTemplate
 */ export class CloseoutChecklistTemplate extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutChecklistTemplate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutChecklistTemplate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutChecklistTemplate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutChecklistTemplate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string key = 3;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: bool is_system = 6;
   */ _define_property(this, "isSystem", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutChecklistTemplate, "runtime", proto3);
_define_property(CloseoutChecklistTemplate, "typeName", "mono.ryugu.v1.CloseoutChecklistTemplate");
_define_property(CloseoutChecklistTemplate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "is_system",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * CloseoutChecklistTemplateItem is one line of template prose.
 *
 * @generated from message mono.ryugu.v1.CloseoutChecklistTemplateItem
 */ export class CloseoutChecklistTemplateItem extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutChecklistTemplateItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutChecklistTemplateItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutChecklistTemplateItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutChecklistTemplateItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string template_id = 3;
   */ _define_property(this, "templateId", ""), /**
   * @generated from field: int32 ordinal = 4;
   */ _define_property(this, "ordinal", 0), /**
   * @generated from field: string text = 5;
   */ _define_property(this, "text", ""), /**
   * @generated from field: string comments_guidance = 6;
   */ _define_property(this, "commentsGuidance", ""), /**
   * @generated from field: string sds_section = 7;
   */ _define_property(this, "sdsSection", ""), /**
   * @generated from field: string review_instruction = 8;
   */ _define_property(this, "reviewInstruction", ""), /**
   * @generated from field: string accountable_party = 9;
   */ _define_property(this, "accountableParty", ""), /**
   * @generated from field: bool specra_specific = 10;
   */ _define_property(this, "specraSpecific", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */ _define_property(this, "updatedAt", void 0), /**
   * final|period|both
   *
   * @generated from field: string applies_to = 13;
   */ _define_property(this, "appliesTo", ""), /**
   * Read-only: the prefill rule this item carries on a period checklist.
   *
   * @generated from field: string prefill_rule = 14;
   */ _define_property(this, "prefillRule", ""), /**
   * exclude|include. Only the sub_reviews_in_period prefill reads it.
   * Default exclude: subs with no review due are not counted toward a No.
   *
   * @generated from field: string count_subs_with_no_review_due = 15;
   */ _define_property(this, "countSubsWithNoReviewDue", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutChecklistTemplateItem, "runtime", proto3);
_define_property(CloseoutChecklistTemplateItem, "typeName", "mono.ryugu.v1.CloseoutChecklistTemplateItem");
_define_property(CloseoutChecklistTemplateItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "comments_guidance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sds_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "review_instruction",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "accountable_party",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "specra_specific",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "applies_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "prefill_rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "count_subs_with_no_review_due",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CloseoutChecklistTemplateView pairs a resolved template with its items —
 * the shape ListCloseoutTemplates returns per template.
 *
 * @generated from message mono.ryugu.v1.CloseoutChecklistTemplateView
 */ export class CloseoutChecklistTemplateView extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutChecklistTemplateView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutChecklistTemplateView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutChecklistTemplateView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutChecklistTemplateView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CloseoutChecklistTemplate template = 1;
   */ _define_property(this, "template", void 0), /**
   * @generated from field: repeated mono.ryugu.v1.CloseoutChecklistTemplateItem items = 2;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutChecklistTemplateView, "runtime", proto3);
_define_property(CloseoutChecklistTemplateView, "typeName", "mono.ryugu.v1.CloseoutChecklistTemplateView");
_define_property(CloseoutChecklistTemplateView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "template",
            kind: "message",
            T: CloseoutChecklistTemplate
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: CloseoutChecklistTemplateItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCloseoutTemplatesRequest
 */ export class ListCloseoutTemplatesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCloseoutTemplatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCloseoutTemplatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCloseoutTemplatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCloseoutTemplatesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * When false, "_system" defaults the tenant has not overridden are omitted.
   *
   * @generated from field: bool include_system = 2;
   */ _define_property(this, "includeSystem", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCloseoutTemplatesRequest, "runtime", proto3);
_define_property(ListCloseoutTemplatesRequest, "typeName", "mono.ryugu.v1.ListCloseoutTemplatesRequest");
_define_property(ListCloseoutTemplatesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_system",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCloseoutTemplatesResponse
 */ export class ListCloseoutTemplatesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCloseoutTemplatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCloseoutTemplatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCloseoutTemplatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCloseoutTemplatesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.CloseoutChecklistTemplateView templates = 1;
   */ _define_property(this, "templates", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCloseoutTemplatesResponse, "runtime", proto3);
_define_property(ListCloseoutTemplatesResponse, "typeName", "mono.ryugu.v1.ListCloseoutTemplatesResponse");
_define_property(ListCloseoutTemplatesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "templates",
            kind: "message",
            T: CloseoutChecklistTemplateView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertCloseoutTemplateItemRequest
 */ export class UpsertCloseoutTemplateItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCloseoutTemplateItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCloseoutTemplateItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCloseoutTemplateItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCloseoutTemplateItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string template_key = 2;
   */ _define_property(this, "templateKey", ""), /**
   * @generated from field: int32 ordinal = 3;
   */ _define_property(this, "ordinal", 0), /**
   * @generated from field: string text = 4;
   */ _define_property(this, "text", ""), /**
   * @generated from field: string comments_guidance = 5;
   */ _define_property(this, "commentsGuidance", ""), /**
   * @generated from field: string sds_section = 6;
   */ _define_property(this, "sdsSection", ""), /**
   * @generated from field: string review_instruction = 7;
   */ _define_property(this, "reviewInstruction", ""), /**
   * @generated from field: string accountable_party = 8;
   */ _define_property(this, "accountableParty", ""), /**
   * @generated from field: bool specra_specific = 9;
   */ _define_property(this, "specraSpecific", false), /**
   * final|period|both. Empty keeps an existing item's value; a new item
   * defaults to final.
   *
   * @generated from field: string applies_to = 10;
   */ _define_property(this, "appliesTo", ""), /**
   * exclude|include. Empty keeps an existing item's value; a new item
   * defaults to exclude.
   *
   * @generated from field: string count_subs_with_no_review_due = 11;
   */ _define_property(this, "countSubsWithNoReviewDue", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCloseoutTemplateItemRequest, "runtime", proto3);
_define_property(UpsertCloseoutTemplateItemRequest, "typeName", "mono.ryugu.v1.UpsertCloseoutTemplateItemRequest");
_define_property(UpsertCloseoutTemplateItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "comments_guidance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sds_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "review_instruction",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "accountable_party",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "specra_specific",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "applies_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "count_subs_with_no_review_due",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertCloseoutTemplateItemResponse
 */ export class UpsertCloseoutTemplateItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCloseoutTemplateItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCloseoutTemplateItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCloseoutTemplateItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCloseoutTemplateItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CloseoutChecklistTemplateItem item = 1;
   */ _define_property(this, "item", void 0), /**
   * The tenant-owned template's id. Differs from the "_system" template
   * resolved by template_key when this call triggered a copy-on-write clone.
   *
   * @generated from field: string template_id = 2;
   */ _define_property(this, "templateId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCloseoutTemplateItemResponse, "runtime", proto3);
_define_property(UpsertCloseoutTemplateItemResponse, "typeName", "mono.ryugu.v1.UpsertCloseoutTemplateItemResponse");
_define_property(UpsertCloseoutTemplateItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: CloseoutChecklistTemplateItem
        },
        {
            no: 2,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteCloseoutTemplateItemRequest
 */ export class DeleteCloseoutTemplateItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCloseoutTemplateItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCloseoutTemplateItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCloseoutTemplateItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCloseoutTemplateItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string template_key = 2;
   */ _define_property(this, "templateKey", ""), /**
   * @generated from field: int32 ordinal = 3;
   */ _define_property(this, "ordinal", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCloseoutTemplateItemRequest, "runtime", proto3);
_define_property(DeleteCloseoutTemplateItemRequest, "typeName", "mono.ryugu.v1.DeleteCloseoutTemplateItemRequest");
_define_property(DeleteCloseoutTemplateItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteCloseoutTemplateItemResponse
 */ export class DeleteCloseoutTemplateItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCloseoutTemplateItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCloseoutTemplateItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCloseoutTemplateItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCloseoutTemplateItemResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCloseoutTemplateItemResponse, "runtime", proto3);
_define_property(DeleteCloseoutTemplateItemResponse, "typeName", "mono.ryugu.v1.DeleteCloseoutTemplateItemResponse");
_define_property(DeleteCloseoutTemplateItemResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * CloseoutChecklist is one per Program (the final closeout, period_id empty)
 * plus one per contract period.
 *
 * @generated from message mono.ryugu.v1.CloseoutChecklist
 */ export class CloseoutChecklist extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutChecklist().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutChecklist().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutChecklist().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutChecklist, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string template_id = 4;
   */ _define_property(this, "templateId", ""), /**
   * Pending|Completed
   *
   * @generated from field: string state = 5;
   */ _define_property(this, "state", ""), /**
   * @generated from field: google.protobuf.Timestamp closeout_date = 6;
   */ _define_property(this, "closeoutDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp completed_at = 7;
   */ _define_property(this, "completedAt", void 0), /**
   * @generated from field: string completed_by = 8;
   */ _define_property(this, "completedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * The contract period (periods_of_performance id); empty for the final
   * closeout.
   *
   * @generated from field: string period_id = 11;
   */ _define_property(this, "periodId", ""), /**
   * Set once the period is closed.
   *
   * @generated from field: google.protobuf.Timestamp closed_at = 12;
   */ _define_property(this, "closedAt", void 0), /**
   * @generated from field: string closed_by = 13;
   */ _define_property(this, "closedBy", ""), /**
   * completed_by's and closed_by's names, resolved the way program History
   * names an actor; "" when unresolved (fall back to the id).
   *
   * @generated from field: string completed_by_display_name = 14;
   */ _define_property(this, "completedByDisplayName", ""), /**
   * @generated from field: string closed_by_display_name = 15;
   */ _define_property(this, "closedByDisplayName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutChecklist, "runtime", proto3);
_define_property(CloseoutChecklist, "typeName", "mono.ryugu.v1.CloseoutChecklist");
_define_property(CloseoutChecklist, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "closeout_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "completed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "completed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "period_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "closed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "closed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "completed_by_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "closed_by_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CloseoutChecklistItem is a per-checklist instance row. The prose fields are
 * a SNAPSHOT copied from the template item at instantiation.
 *
 * @generated from message mono.ryugu.v1.CloseoutChecklistItem
 */ export class CloseoutChecklistItem extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutChecklistItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutChecklistItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutChecklistItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutChecklistItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string checklist_id = 3;
   */ _define_property(this, "checklistId", ""), /**
   * @generated from field: string template_item_id = 4;
   */ _define_property(this, "templateItemId", ""), /**
   * @generated from field: int32 ordinal = 5;
   */ _define_property(this, "ordinal", 0), /**
   * @generated from field: string text = 6;
   */ _define_property(this, "text", ""), /**
   * @generated from field: string comments_guidance = 7;
   */ _define_property(this, "commentsGuidance", ""), /**
   * @generated from field: string sds_section = 8;
   */ _define_property(this, "sdsSection", ""), /**
   * @generated from field: string review_instruction = 9;
   */ _define_property(this, "reviewInstruction", ""), /**
   * @generated from field: string accountable_party = 10;
   */ _define_property(this, "accountableParty", ""), /**
   * @generated from field: bool specra_specific = 11;
   */ _define_property(this, "specraSpecific", false), /**
   * YES|N_A|NO
   *
   * @generated from field: string answer = 12;
   */ _define_property(this, "answer", ""), /**
   * @generated from field: string comments = 13;
   */ _define_property(this, "comments", ""), /**
   * @generated from field: string answered_by = 14;
   */ _define_property(this, "answeredBy", ""), /**
   * @generated from field: google.protobuf.Timestamp answered_at = 15;
   */ _define_property(this, "answeredAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 17;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string prefill_rule = 18;
   */ _define_property(this, "prefillRule", ""), /**
   * @generated from field: string count_subs_with_no_review_due = 19;
   */ _define_property(this, "countSubsWithNoReviewDue", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutChecklistItem, "runtime", proto3);
_define_property(CloseoutChecklistItem, "typeName", "mono.ryugu.v1.CloseoutChecklistItem");
_define_property(CloseoutChecklistItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "checklist_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "template_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "comments_guidance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "sds_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "review_instruction",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "accountable_party",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "specra_specific",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "answer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "comments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "answered_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "answered_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "prefill_rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "count_subs_with_no_review_due",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CloseoutOutstandingItem is a free row in the checklist's Outstanding Items
 * sub-list — anything not closed at sign-off.
 *
 * @generated from message mono.ryugu.v1.CloseoutOutstandingItem
 */ export class CloseoutOutstandingItem extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutOutstandingItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutOutstandingItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutOutstandingItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutOutstandingItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string checklist_id = 3;
   */ _define_property(this, "checklistId", ""), /**
   * @generated from field: string item = 4;
   */ _define_property(this, "item", ""), /**
   * @generated from field: google.protobuf.Timestamp planned_completion_date = 5;
   */ _define_property(this, "plannedCompletionDate", void 0), /**
   * @generated from field: string comments = 6;
   */ _define_property(this, "comments", ""), /**
   * @generated from field: string sds_section = 7;
   */ _define_property(this, "sdsSection", ""), /**
   * @generated from field: string responsible_party = 8;
   */ _define_property(this, "responsibleParty", ""), /**
   * @generated from field: int32 sort_order = 9;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0), /**
   * Marked true once the item is resolved; purely informational — the
   * Outstanding Items list is not part of the completion gate.
   *
   * @generated from field: bool resolved = 12;
   */ _define_property(this, "resolved", false), /**
   * The previous period's unresolved item this row was carried forward from.
   * Read-only.
   *
   * @generated from field: string carried_from_id = 13;
   */ _define_property(this, "carriedFromId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutOutstandingItem, "runtime", proto3);
_define_property(CloseoutOutstandingItem, "typeName", "mono.ryugu.v1.CloseoutOutstandingItem");
_define_property(CloseoutOutstandingItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "checklist_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "item",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "planned_completion_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "comments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sds_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "responsible_party",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "resolved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "carried_from_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CloseoutPrefillSource is one record a prefill read.
 *
 * @generated from message mono.ryugu.v1.CloseoutPrefillSource
 */ export class CloseoutPrefillSource extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutPrefillSource().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutPrefillSource().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutPrefillSource().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutPrefillSource, a, b);
    }
    constructor(data){
        super(), /**
   * occurrence|cpars|qasp|subcontractor_review|company_assignment|financial_month|period|modification|sow|risk|issue|corrective_action
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string label = 3;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutPrefillSource, "runtime", proto3);
_define_property(CloseoutPrefillSource, "typeName", "mono.ryugu.v1.CloseoutPrefillSource");
_define_property(CloseoutPrefillSource, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CloseoutPrefill is a deterministic proposed answer for one checklist item
 * on a contract-period checklist, with the records it read. answer is
 * YES|N_A|NO, or empty when the records cannot settle it (summary says why).
 *
 * @generated from message mono.ryugu.v1.CloseoutPrefill
 */ export class CloseoutPrefill extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutPrefill().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutPrefill().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutPrefill().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutPrefill, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 ordinal = 1;
   */ _define_property(this, "ordinal", 0), /**
   * @generated from field: string rule = 2;
   */ _define_property(this, "rule", ""), /**
   * @generated from field: string answer = 3;
   */ _define_property(this, "answer", ""), /**
   * @generated from field: string summary = 4;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: repeated mono.ryugu.v1.CloseoutPrefillSource sources = 5;
   */ _define_property(this, "sources", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutPrefill, "runtime", proto3);
_define_property(CloseoutPrefill, "typeName", "mono.ryugu.v1.CloseoutPrefill");
_define_property(CloseoutPrefill, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "answer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "sources",
            kind: "message",
            T: CloseoutPrefillSource,
            repeated: true
        }
    ]));
/**
 * CloseoutChecklistItemCorrection is one answer-log row: kind "correction"
 * is an answer changed after its period closed, kind "override" an answer
 * that departs from the item's prefill. Both keep the value they replaced.
 *
 * @generated from message mono.ryugu.v1.CloseoutChecklistItemCorrection
 */ export class CloseoutChecklistItemCorrection extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutChecklistItemCorrection().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutChecklistItemCorrection().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutChecklistItemCorrection().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutChecklistItemCorrection, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string checklist_id = 2;
   */ _define_property(this, "checklistId", ""), /**
   * @generated from field: int32 ordinal = 3;
   */ _define_property(this, "ordinal", 0), /**
   * @generated from field: string prior_answer = 4;
   */ _define_property(this, "priorAnswer", ""), /**
   * @generated from field: string prior_comments = 5;
   */ _define_property(this, "priorComments", ""), /**
   * @generated from field: string prior_answered_by = 6;
   */ _define_property(this, "priorAnsweredBy", ""), /**
   * @generated from field: google.protobuf.Timestamp prior_answered_at = 7;
   */ _define_property(this, "priorAnsweredAt", void 0), /**
   * @generated from field: string answer = 8;
   */ _define_property(this, "answer", ""), /**
   * @generated from field: string comments = 9;
   */ _define_property(this, "comments", ""), /**
   * @generated from field: string corrected_by = 10;
   */ _define_property(this, "correctedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * correction|override
   *
   * @generated from field: string kind = 12;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string prefill_answer = 13;
   */ _define_property(this, "prefillAnswer", ""), /**
   * @generated from field: repeated mono.ryugu.v1.CloseoutPrefillSource prefill_sources = 14;
   */ _define_property(this, "prefillSources", []), /**
   * corrected_by's and prior_answered_by's names; "" when unresolved.
   *
   * @generated from field: string corrected_by_display_name = 15;
   */ _define_property(this, "correctedByDisplayName", ""), /**
   * @generated from field: string prior_answered_by_display_name = 16;
   */ _define_property(this, "priorAnsweredByDisplayName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutChecklistItemCorrection, "runtime", proto3);
_define_property(CloseoutChecklistItemCorrection, "typeName", "mono.ryugu.v1.CloseoutChecklistItemCorrection");
_define_property(CloseoutChecklistItemCorrection, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "checklist_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "prior_answer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "prior_comments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "prior_answered_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "prior_answered_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "answer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "comments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "corrected_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "prefill_answer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "prefill_sources",
            kind: "message",
            T: CloseoutPrefillSource,
            repeated: true
        },
        {
            no: 15,
            name: "corrected_by_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "prior_answered_by_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetCloseoutChecklistRequest
 */ export class GetCloseoutChecklistRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCloseoutChecklistRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCloseoutChecklistRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCloseoutChecklistRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCloseoutChecklistRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCloseoutChecklistRequest, "runtime", proto3);
_define_property(GetCloseoutChecklistRequest, "typeName", "mono.ryugu.v1.GetCloseoutChecklistRequest");
_define_property(GetCloseoutChecklistRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Returns NotFound (not an empty response) when the program has no checklist
 * yet — see the RPC comment on the service definition.
 *
 * @generated from message mono.ryugu.v1.GetCloseoutChecklistResponse
 */ export class GetCloseoutChecklistResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCloseoutChecklistResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCloseoutChecklistResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCloseoutChecklistResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCloseoutChecklistResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CloseoutChecklist checklist = 1;
   */ _define_property(this, "checklist", void 0), /**
   * @generated from field: repeated mono.ryugu.v1.CloseoutChecklistItem items = 2;
   */ _define_property(this, "items", []), /**
   * @generated from field: repeated mono.ryugu.v1.CloseoutOutstandingItem outstanding_items = 3;
   */ _define_property(this, "outstandingItems", []), /**
   * The closed program's closed_by, named; "" when open or unresolved.
   *
   * @generated from field: string program_closed_by_display_name = 4;
   */ _define_property(this, "programClosedByDisplayName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCloseoutChecklistResponse, "runtime", proto3);
_define_property(GetCloseoutChecklistResponse, "typeName", "mono.ryugu.v1.GetCloseoutChecklistResponse");
_define_property(GetCloseoutChecklistResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "checklist",
            kind: "message",
            T: CloseoutChecklist
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: CloseoutChecklistItem,
            repeated: true
        },
        {
            no: 3,
            name: "outstanding_items",
            kind: "message",
            T: CloseoutOutstandingItem,
            repeated: true
        },
        {
            no: 4,
            name: "program_closed_by_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.StartCloseoutChecklistRequest
 */ export class StartCloseoutChecklistRequest extends Message {
    static fromBinary(bytes, options) {
        return new StartCloseoutChecklistRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartCloseoutChecklistRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartCloseoutChecklistRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartCloseoutChecklistRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * Optional; empty resolves the platform default template
   * ("sprezz_standard", seeded _system-tenant).
   *
   * @generated from field: string template_key = 2;
   */ _define_property(this, "templateKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StartCloseoutChecklistRequest, "runtime", proto3);
_define_property(StartCloseoutChecklistRequest, "typeName", "mono.ryugu.v1.StartCloseoutChecklistRequest");
_define_property(StartCloseoutChecklistRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.StartCloseoutChecklistResponse
 */ export class StartCloseoutChecklistResponse extends Message {
    static fromBinary(bytes, options) {
        return new StartCloseoutChecklistResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartCloseoutChecklistResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartCloseoutChecklistResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartCloseoutChecklistResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CloseoutChecklist checklist = 1;
   */ _define_property(this, "checklist", void 0), /**
   * @generated from field: repeated mono.ryugu.v1.CloseoutChecklistItem items = 2;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StartCloseoutChecklistResponse, "runtime", proto3);
_define_property(StartCloseoutChecklistResponse, "typeName", "mono.ryugu.v1.StartCloseoutChecklistResponse");
_define_property(StartCloseoutChecklistResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "checklist",
            kind: "message",
            T: CloseoutChecklist
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: CloseoutChecklistItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AnswerCloseoutChecklistItemRequest
 */ export class AnswerCloseoutChecklistItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new AnswerCloseoutChecklistItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnswerCloseoutChecklistItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnswerCloseoutChecklistItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnswerCloseoutChecklistItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string checklist_id = 2;
   */ _define_property(this, "checklistId", ""), /**
   * @generated from field: int32 ordinal = 3;
   */ _define_property(this, "ordinal", 0), /**
   * YES|N_A|NO
   *
   * @generated from field: string answer = 4;
   */ _define_property(this, "answer", ""), /**
   * @generated from field: string comments = 5;
   */ _define_property(this, "comments", ""), /**
   * Set to answer a contract period's checklist; empty answers the final
   * closeout. On a closed period the answer is recorded as a correction and
   * comments are required.
   *
   * @generated from field: string period_id = 6;
   */ _define_property(this, "periodId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnswerCloseoutChecklistItemRequest, "runtime", proto3);
_define_property(AnswerCloseoutChecklistItemRequest, "typeName", "mono.ryugu.v1.AnswerCloseoutChecklistItemRequest");
_define_property(AnswerCloseoutChecklistItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "checklist_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "answer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "comments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "period_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AnswerCloseoutChecklistItemResponse
 */ export class AnswerCloseoutChecklistItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new AnswerCloseoutChecklistItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnswerCloseoutChecklistItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnswerCloseoutChecklistItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnswerCloseoutChecklistItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CloseoutChecklistItem item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AnswerCloseoutChecklistItemResponse, "runtime", proto3);
_define_property(AnswerCloseoutChecklistItemResponse, "typeName", "mono.ryugu.v1.AnswerCloseoutChecklistItemResponse");
_define_property(AnswerCloseoutChecklistItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: CloseoutChecklistItem
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertCloseoutOutstandingItemRequest
 */ export class UpsertCloseoutOutstandingItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCloseoutOutstandingItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCloseoutOutstandingItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCloseoutOutstandingItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCloseoutOutstandingItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Present on both create and update — the program-scope write gate keys
   * on it; the handler reconciles it against the fetched program before
   * writing (same confused-deputy guard as the Upsert* entries in
   * viewmode_write_registry.go).
   *
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.ryugu.v1.CloseoutOutstandingItem outstanding_item = 2;
   */ _define_property(this, "outstandingItem", void 0), /**
   * Set to target a contract period's checklist; empty targets the final
   * closeout.
   *
   * @generated from field: string period_id = 3;
   */ _define_property(this, "periodId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCloseoutOutstandingItemRequest, "runtime", proto3);
_define_property(UpsertCloseoutOutstandingItemRequest, "typeName", "mono.ryugu.v1.UpsertCloseoutOutstandingItemRequest");
_define_property(UpsertCloseoutOutstandingItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "outstanding_item",
            kind: "message",
            T: CloseoutOutstandingItem
        },
        {
            no: 3,
            name: "period_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpsertCloseoutOutstandingItemResponse
 */ export class UpsertCloseoutOutstandingItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCloseoutOutstandingItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCloseoutOutstandingItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCloseoutOutstandingItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCloseoutOutstandingItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CloseoutOutstandingItem outstanding_item = 1;
   */ _define_property(this, "outstandingItem", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCloseoutOutstandingItemResponse, "runtime", proto3);
_define_property(UpsertCloseoutOutstandingItemResponse, "typeName", "mono.ryugu.v1.UpsertCloseoutOutstandingItemResponse");
_define_property(UpsertCloseoutOutstandingItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "outstanding_item",
            kind: "message",
            T: CloseoutOutstandingItem
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteCloseoutOutstandingItemRequest
 */ export class DeleteCloseoutOutstandingItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCloseoutOutstandingItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCloseoutOutstandingItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCloseoutOutstandingItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCloseoutOutstandingItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * Set to target a contract period's checklist; empty targets the final
   * closeout.
   *
   * @generated from field: string period_id = 3;
   */ _define_property(this, "periodId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCloseoutOutstandingItemRequest, "runtime", proto3);
_define_property(DeleteCloseoutOutstandingItemRequest, "typeName", "mono.ryugu.v1.DeleteCloseoutOutstandingItemRequest");
_define_property(DeleteCloseoutOutstandingItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "period_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteCloseoutOutstandingItemResponse
 */ export class DeleteCloseoutOutstandingItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCloseoutOutstandingItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCloseoutOutstandingItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCloseoutOutstandingItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCloseoutOutstandingItemResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCloseoutOutstandingItemResponse, "runtime", proto3);
_define_property(DeleteCloseoutOutstandingItemResponse, "typeName", "mono.ryugu.v1.DeleteCloseoutOutstandingItemResponse");
_define_property(DeleteCloseoutOutstandingItemResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.CompleteCloseoutChecklistRequest
 */ export class CompleteCloseoutChecklistRequest extends Message {
    static fromBinary(bytes, options) {
        return new CompleteCloseoutChecklistRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompleteCloseoutChecklistRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompleteCloseoutChecklistRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompleteCloseoutChecklistRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompleteCloseoutChecklistRequest, "runtime", proto3);
_define_property(CompleteCloseoutChecklistRequest, "typeName", "mono.ryugu.v1.CompleteCloseoutChecklistRequest");
_define_property(CompleteCloseoutChecklistRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CompleteCloseoutChecklistResponse
 */ export class CompleteCloseoutChecklistResponse extends Message {
    static fromBinary(bytes, options) {
        return new CompleteCloseoutChecklistResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompleteCloseoutChecklistResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompleteCloseoutChecklistResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompleteCloseoutChecklistResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Populated regardless of outcome.
   *
   * @generated from field: mono.ryugu.v1.CloseoutChecklist checklist = 1;
   */ _define_property(this, "checklist", void 0), /**
   * Ordinals of items violating the completion invariant (unanswered, or a
   * non-YES answer with no comments). Non-empty means the checklist was NOT
   * completed — the caller renders exactly what's missing rather than
   * getting a failed RPC (mirrors ActivateContractResponse.violations).
   *
   * @generated from field: repeated int32 violations = 2;
   */ _define_property(this, "violations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompleteCloseoutChecklistResponse, "runtime", proto3);
_define_property(CompleteCloseoutChecklistResponse, "typeName", "mono.ryugu.v1.CompleteCloseoutChecklistResponse");
_define_property(CompleteCloseoutChecklistResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "checklist",
            kind: "message",
            T: CloseoutChecklist
        },
        {
            no: 2,
            name: "violations",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ExportCloseoutChecklistRequest
 */ export class ExportCloseoutChecklistRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExportCloseoutChecklistRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExportCloseoutChecklistRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExportCloseoutChecklistRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExportCloseoutChecklistRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExportCloseoutChecklistRequest, "runtime", proto3);
_define_property(ExportCloseoutChecklistRequest, "typeName", "mono.ryugu.v1.ExportCloseoutChecklistRequest");
_define_property(ExportCloseoutChecklistRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ExportCloseoutChecklistResponse
 */ export class ExportCloseoutChecklistResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExportCloseoutChecklistResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExportCloseoutChecklistResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExportCloseoutChecklistResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExportCloseoutChecklistResponse, a, b);
    }
    constructor(data){
        super(), /**
   * The program document artifact just created (Documents tab row).
   *
   * @generated from field: mono.ryugu.v1.ProgramDocumentProto document = 1;
   */ _define_property(this, "document", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExportCloseoutChecklistResponse, "runtime", proto3);
_define_property(ExportCloseoutChecklistResponse, "typeName", "mono.ryugu.v1.ExportCloseoutChecklistResponse");
_define_property(ExportCloseoutChecklistResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document",
            kind: "message",
            T: ProgramDocumentProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CloseProgramRequest
 */ export class CloseProgramRequest extends Message {
    static fromBinary(bytes, options) {
        return new CloseProgramRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseProgramRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseProgramRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseProgramRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseProgramRequest, "runtime", proto3);
_define_property(CloseProgramRequest, "typeName", "mono.ryugu.v1.CloseProgramRequest");
_define_property(CloseProgramRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CloseProgramResponse
 */ export class CloseProgramResponse extends Message {
    static fromBinary(bytes, options) {
        return new CloseProgramResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseProgramResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseProgramResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseProgramResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseProgramResponse, "runtime", proto3);
_define_property(CloseProgramResponse, "typeName", "mono.ryugu.v1.CloseProgramResponse");
_define_property(CloseProgramResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.ListPeriodCloseoutsRequest
 */ export class ListPeriodCloseoutsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPeriodCloseoutsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPeriodCloseoutsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPeriodCloseoutsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPeriodCloseoutsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPeriodCloseoutsRequest, "runtime", proto3);
_define_property(ListPeriodCloseoutsRequest, "typeName", "mono.ryugu.v1.ListPeriodCloseoutsRequest");
_define_property(ListPeriodCloseoutsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * One checklist per contract period that has one; a period absent here has
 * not started its closeout. Pair with ListPeriodsOfPerformance for names.
 *
 * @generated from message mono.ryugu.v1.ListPeriodCloseoutsResponse
 */ export class ListPeriodCloseoutsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPeriodCloseoutsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPeriodCloseoutsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPeriodCloseoutsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPeriodCloseoutsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.CloseoutChecklist checklists = 1;
   */ _define_property(this, "checklists", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPeriodCloseoutsResponse, "runtime", proto3);
_define_property(ListPeriodCloseoutsResponse, "typeName", "mono.ryugu.v1.ListPeriodCloseoutsResponse");
_define_property(ListPeriodCloseoutsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "checklists",
            kind: "message",
            T: CloseoutChecklist,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetPeriodCloseoutChecklistRequest
 */ export class GetPeriodCloseoutChecklistRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPeriodCloseoutChecklistRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPeriodCloseoutChecklistRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPeriodCloseoutChecklistRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPeriodCloseoutChecklistRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string period_id = 2;
   */ _define_property(this, "periodId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPeriodCloseoutChecklistRequest, "runtime", proto3);
_define_property(GetPeriodCloseoutChecklistRequest, "typeName", "mono.ryugu.v1.GetPeriodCloseoutChecklistRequest");
_define_property(GetPeriodCloseoutChecklistRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "period_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetPeriodCloseoutChecklistResponse
 */ export class GetPeriodCloseoutChecklistResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPeriodCloseoutChecklistResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPeriodCloseoutChecklistResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPeriodCloseoutChecklistResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPeriodCloseoutChecklistResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CloseoutChecklist checklist = 1;
   */ _define_property(this, "checklist", void 0), /**
   * @generated from field: repeated mono.ryugu.v1.CloseoutChecklistItem items = 2;
   */ _define_property(this, "items", []), /**
   * @generated from field: repeated mono.ryugu.v1.CloseoutOutstandingItem outstanding_items = 3;
   */ _define_property(this, "outstandingItems", []), /**
   * @generated from field: repeated mono.ryugu.v1.CloseoutChecklistItemCorrection corrections = 4;
   */ _define_property(this, "corrections", []), /**
   * Proposed answers, for a period that is not closed. An answer that
   * differs from its prefill needs comments and is logged as an override.
   *
   * @generated from field: repeated mono.ryugu.v1.CloseoutPrefill prefills = 5;
   */ _define_property(this, "prefills", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPeriodCloseoutChecklistResponse, "runtime", proto3);
_define_property(GetPeriodCloseoutChecklistResponse, "typeName", "mono.ryugu.v1.GetPeriodCloseoutChecklistResponse");
_define_property(GetPeriodCloseoutChecklistResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "checklist",
            kind: "message",
            T: CloseoutChecklist
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: CloseoutChecklistItem,
            repeated: true
        },
        {
            no: 3,
            name: "outstanding_items",
            kind: "message",
            T: CloseoutOutstandingItem,
            repeated: true
        },
        {
            no: 4,
            name: "corrections",
            kind: "message",
            T: CloseoutChecklistItemCorrection,
            repeated: true
        },
        {
            no: 5,
            name: "prefills",
            kind: "message",
            T: CloseoutPrefill,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.StartPeriodCloseoutChecklistRequest
 */ export class StartPeriodCloseoutChecklistRequest extends Message {
    static fromBinary(bytes, options) {
        return new StartPeriodCloseoutChecklistRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartPeriodCloseoutChecklistRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartPeriodCloseoutChecklistRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartPeriodCloseoutChecklistRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string period_id = 2;
   */ _define_property(this, "periodId", ""), /**
   * Optional; empty resolves the platform default template.
   *
   * @generated from field: string template_key = 3;
   */ _define_property(this, "templateKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StartPeriodCloseoutChecklistRequest, "runtime", proto3);
_define_property(StartPeriodCloseoutChecklistRequest, "typeName", "mono.ryugu.v1.StartPeriodCloseoutChecklistRequest");
_define_property(StartPeriodCloseoutChecklistRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "period_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "template_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.StartPeriodCloseoutChecklistResponse
 */ export class StartPeriodCloseoutChecklistResponse extends Message {
    static fromBinary(bytes, options) {
        return new StartPeriodCloseoutChecklistResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartPeriodCloseoutChecklistResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartPeriodCloseoutChecklistResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartPeriodCloseoutChecklistResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CloseoutChecklist checklist = 1;
   */ _define_property(this, "checklist", void 0), /**
   * @generated from field: repeated mono.ryugu.v1.CloseoutChecklistItem items = 2;
   */ _define_property(this, "items", []), /**
   * @generated from field: repeated mono.ryugu.v1.CloseoutOutstandingItem outstanding_items = 3;
   */ _define_property(this, "outstandingItems", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StartPeriodCloseoutChecklistResponse, "runtime", proto3);
_define_property(StartPeriodCloseoutChecklistResponse, "typeName", "mono.ryugu.v1.StartPeriodCloseoutChecklistResponse");
_define_property(StartPeriodCloseoutChecklistResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "checklist",
            kind: "message",
            T: CloseoutChecklist
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: CloseoutChecklistItem,
            repeated: true
        },
        {
            no: 3,
            name: "outstanding_items",
            kind: "message",
            T: CloseoutOutstandingItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ClosePeriodRequest
 */ export class ClosePeriodRequest extends Message {
    static fromBinary(bytes, options) {
        return new ClosePeriodRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClosePeriodRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClosePeriodRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClosePeriodRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string period_id = 2;
   */ _define_property(this, "periodId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClosePeriodRequest, "runtime", proto3);
_define_property(ClosePeriodRequest, "typeName", "mono.ryugu.v1.ClosePeriodRequest");
_define_property(ClosePeriodRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "period_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ClosePeriodResponse
 */ export class ClosePeriodResponse extends Message {
    static fromBinary(bytes, options) {
        return new ClosePeriodResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClosePeriodResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClosePeriodResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClosePeriodResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.CloseoutChecklist checklist = 1;
   */ _define_property(this, "checklist", void 0), /**
   * Non-empty means the period was NOT closed (same rule as
   * CompleteCloseoutChecklistResponse.violations).
   *
   * @generated from field: repeated int32 violations = 2;
   */ _define_property(this, "violations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClosePeriodResponse, "runtime", proto3);
_define_property(ClosePeriodResponse, "typeName", "mono.ryugu.v1.ClosePeriodResponse");
_define_property(ClosePeriodResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "checklist",
            kind: "message",
            T: CloseoutChecklist
        },
        {
            no: 2,
            name: "violations",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.LifecycleNodeRef
 */ export class LifecycleNodeRef extends Message {
    static fromBinary(bytes, options) {
        return new LifecycleNodeRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LifecycleNodeRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LifecycleNodeRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LifecycleNodeRef, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.LifecycleNodeKind kind = 1;
   */ _define_property(this, "kind", 0), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string zou_project_id = 3;
   */ _define_property(this, "zouProjectId", ""), /**
   * Best-effort. Pangaea holds the links but zou still owns project names, so
   * a proposal chip may arrive unlabelled rather than with a fabricated title.
   *
   * @generated from field: string label = 4;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LifecycleNodeRef, "runtime", proto3);
_define_property(LifecycleNodeRef, "typeName", "mono.ryugu.v1.LifecycleNodeRef");
_define_property(LifecycleNodeRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(LifecycleNodeKind)
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.LifecycleEdge
 */ export class LifecycleEdge extends Message {
    static fromBinary(bytes, options) {
        return new LifecycleEdge().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LifecycleEdge().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LifecycleEdge().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LifecycleEdge, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.LifecycleNodeRef node = 1;
   */ _define_property(this, "node", void 0), /**
   * @generated from field: mono.ryugu.v1.LifecycleEdgeKind kind = 2;
   */ _define_property(this, "kind", 0), /**
   * The column that produced this edge — provenance for debugging a wrong chip.
   *
   * @generated from field: string relation = 3;
   */ _define_property(this, "relation", ""), /**
   * Presentational only; never implies stage order.
   *
   * @generated from field: bool inbound = 4;
   */ _define_property(this, "inbound", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LifecycleEdge, "runtime", proto3);
_define_property(LifecycleEdge, "typeName", "mono.ryugu.v1.LifecycleEdge");
_define_property(LifecycleEdge, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node",
            kind: "message",
            T: LifecycleNodeRef
        },
        {
            no: 2,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(LifecycleEdgeKind)
        },
        {
            no: 3,
            name: "relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "inbound",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.LifecycleCount
 */ export class LifecycleCount extends Message {
    static fromBinary(bytes, options) {
        return new LifecycleCount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LifecycleCount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LifecycleCount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LifecycleCount, a, b);
    }
    constructor(data){
        super(), /**
   * Stable machine key: rfi_responses, touchpoints, workstreams,
   * proposal_milestones. Display labels are the frontend's business.
   *
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: int32 count = 2;
   */ _define_property(this, "count", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LifecycleCount, "runtime", proto3);
_define_property(LifecycleCount, "typeName", "mono.ryugu.v1.LifecycleCount");
_define_property(LifecycleCount, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UnresolvedLink
 */ export class UnresolvedLink extends Message {
    static fromBinary(bytes, options) {
        return new UnresolvedLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnresolvedLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnresolvedLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnresolvedLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.LifecycleNodeKind expected_kind = 1;
   */ _define_property(this, "expectedKind", 0), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string relation = 3;
   */ _define_property(this, "relation", ""), /**
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnresolvedLink, "runtime", proto3);
_define_property(UnresolvedLink, "typeName", "mono.ryugu.v1.UnresolvedLink");
_define_property(UnresolvedLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "expected_kind",
            kind: "enum",
            T: proto3.getEnumType(LifecycleNodeKind)
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetLinkedNodesRequest
 */ export class GetLinkedNodesRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLinkedNodesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLinkedNodesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLinkedNodesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLinkedNodesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: mono.ryugu.v1.LifecycleNodeKind kind = 2;
   */ _define_property(this, "kind", 0), /**
   * Accepts either the pangaea id or the zou project id for this kind.
   *
   * @generated from field: string id = 3;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLinkedNodesRequest, "runtime", proto3);
_define_property(GetLinkedNodesRequest, "typeName", "mono.ryugu.v1.GetLinkedNodesRequest");
_define_property(GetLinkedNodesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(LifecycleNodeKind)
        },
        {
            no: 3,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetLinkedNodesResponse
 */ export class GetLinkedNodesResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLinkedNodesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLinkedNodesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLinkedNodesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLinkedNodesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.LifecycleNodeRef node = 1;
   */ _define_property(this, "node", void 0), /**
   * @generated from field: repeated mono.ryugu.v1.LifecycleEdge edges = 2;
   */ _define_property(this, "edges", []), /**
   * @generated from field: repeated mono.ryugu.v1.LifecycleCount counts = 3;
   */ _define_property(this, "counts", []), /**
   * Links that should exist but could not be completed. Surfaced so a missing
   * chip is distinguishable from a record with nothing attached.
   *
   * @generated from field: repeated mono.ryugu.v1.UnresolvedLink unresolved = 4;
   */ _define_property(this, "unresolved", []), /**
   * GRW-04 v2.1 (OD-19): PROGRAM requests only. True when a pursuit that
   * recompetes this program was hidden from the caller, opted in to the
   * "Growth is working this" hint, and the FND-25 access rule
   * delivery.growth_hint.view allows it at the program's scope. Carries no
   * pursuit id, name or count.
   *
   * @generated from field: bool growth_presence = 5;
   */ _define_property(this, "growthPresence", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLinkedNodesResponse, "runtime", proto3);
_define_property(GetLinkedNodesResponse, "typeName", "mono.ryugu.v1.GetLinkedNodesResponse");
_define_property(GetLinkedNodesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node",
            kind: "message",
            T: LifecycleNodeRef
        },
        {
            no: 2,
            name: "edges",
            kind: "message",
            T: LifecycleEdge,
            repeated: true
        },
        {
            no: 3,
            name: "counts",
            kind: "message",
            T: LifecycleCount,
            repeated: true
        },
        {
            no: 4,
            name: "unresolved",
            kind: "message",
            T: UnresolvedLink,
            repeated: true
        },
        {
            no: 5,
            name: "growth_presence",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * MyAssignedAction mirrors pangaea's AssignedAction plus destination_path,
 * the exact in-app route for the record (see resolveAssignedActionPath).
 *
 * @generated from message mono.ryugu.v1.MyAssignedAction
 */ export class MyAssignedAction extends Message {
    static fromBinary(bytes, options) {
        return new MyAssignedAction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MyAssignedAction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MyAssignedAction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MyAssignedAction, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: mono.ryugu.v1.AssignedActionKind kind = 2;
   */ _define_property(this, "kind", 0), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string program_name = 4;
   */ _define_property(this, "programName", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 6;
   */ _define_property(this, "dueAt", void 0), /**
   * @generated from field: string state = 7;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string assignee_contact_id = 8;
   */ _define_property(this, "assigneeContactId", ""), /**
   * @generated from field: string parent_id = 9;
   */ _define_property(this, "parentId", ""), /**
   * destination_path is the exact in-app route for this record — see
   * resolveAssignedActionPath in services/ryugu/pkg/connecthandlers for the
   * per-kind mapping and its caveats (two query params below are not yet
   * read by the frontend).
   *
   * @generated from field: string destination_path = 10;
   */ _define_property(this, "destinationPath", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MyAssignedAction, "runtime", proto3);
_define_property(MyAssignedAction, "typeName", "mono.ryugu.v1.MyAssignedAction");
_define_property(MyAssignedAction, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(AssignedActionKind)
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "assignee_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "destination_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ListMyAssignedActionsRequest deliberately carries no user_id, contact_id,
 * or tenant_id — the recipient and tenant are always resolved from the
 * gateway principal (R8), never the request body, so there is nothing
 * spoofable to ignore.
 *
 * @generated from message mono.ryugu.v1.ListMyAssignedActionsRequest
 */ export class ListMyAssignedActionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListMyAssignedActionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListMyAssignedActionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListMyAssignedActionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListMyAssignedActionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * limit <= 0 defaults to 50; hard-capped at 200. Applied to the
   * post-authorization page — see ListMyAssignedActionsResponse.has_more.
   *
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListMyAssignedActionsRequest, "runtime", proto3);
_define_property(ListMyAssignedActionsRequest, "typeName", "mono.ryugu.v1.ListMyAssignedActionsRequest");
_define_property(ListMyAssignedActionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListMyAssignedActionsResponse
 */ export class ListMyAssignedActionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListMyAssignedActionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListMyAssignedActionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListMyAssignedActionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListMyAssignedActionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.MyAssignedAction actions = 1;
   */ _define_property(this, "actions", []), /**
   * has_more reflects the post-authorization picture, not pangaea's raw
   * page: true if the caller's authorized rows exceeded `limit` (rows were
   * trimmed after projection), OR if pangaea reported more rows exist
   * beyond the wide page ryugu reads internally. Never false while
   * authorized rows might remain unseen.
   *
   * @generated from field: bool has_more = 2;
   */ _define_property(this, "hasMore", false), /**
   * hidden_count is rows dropped by per-program viewer projection within the
   * page ryugu actually considered, mirroring ListMyNotificationsResponse.
   * hidden_count. It is NOT a tenant-wide count of every row the caller
   * can't see — a caller with unauthorized rows beyond that page contributes
   * nothing to this number.
   *
   * @generated from field: int32 hidden_count = 3;
   */ _define_property(this, "hiddenCount", 0), /**
   * caller_has_linked_contact is false when the caller's platform user has no
   * matching live delivery.contacts row — distinguishes "not linked" from
   * "linked, nothing assigned."
   *
   * @generated from field: bool caller_has_linked_contact = 4;
   */ _define_property(this, "callerHasLinkedContact", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListMyAssignedActionsResponse, "runtime", proto3);
_define_property(ListMyAssignedActionsResponse, "typeName", "mono.ryugu.v1.ListMyAssignedActionsResponse");
_define_property(ListMyAssignedActionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "actions",
            kind: "message",
            T: MyAssignedAction,
            repeated: true
        },
        {
            no: 2,
            name: "has_more",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "hidden_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "caller_has_linked_contact",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * SAD-171/SAD-174 — delete a CPARS/QASP score record (Matt's "for the program
 * manager and quality, there should be the ability to delete a CPARS/QASP
 * score record" request). program_id is carried explicitly (unlike
 * DeleteRisk's bare id) so the write can be gated per-program; the handler
 * reconciles it against the fetched row's own program_id before deleting.
 *
 * @generated from message mono.ryugu.v1.DeleteCPARSScoreRequest
 */ export class DeleteCPARSScoreRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCPARSScoreRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCPARSScoreRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCPARSScoreRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCPARSScoreRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCPARSScoreRequest, "runtime", proto3);
_define_property(DeleteCPARSScoreRequest, "typeName", "mono.ryugu.v1.DeleteCPARSScoreRequest");
_define_property(DeleteCPARSScoreRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteCPARSScoreResponse
 */ export class DeleteCPARSScoreResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCPARSScoreResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCPARSScoreResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCPARSScoreResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCPARSScoreResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCPARSScoreResponse, "runtime", proto3);
_define_property(DeleteCPARSScoreResponse, "typeName", "mono.ryugu.v1.DeleteCPARSScoreResponse");
_define_property(DeleteCPARSScoreResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.ryugu.v1.DeleteQASPScoreRequest
 */ export class DeleteQASPScoreRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteQASPScoreRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteQASPScoreRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteQASPScoreRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteQASPScoreRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteQASPScoreRequest, "runtime", proto3);
_define_property(DeleteQASPScoreRequest, "typeName", "mono.ryugu.v1.DeleteQASPScoreRequest");
_define_property(DeleteQASPScoreRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteQASPScoreResponse
 */ export class DeleteQASPScoreResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteQASPScoreResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteQASPScoreResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteQASPScoreResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteQASPScoreResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteQASPScoreResponse, "runtime", proto3);
_define_property(DeleteQASPScoreResponse, "typeName", "mono.ryugu.v1.DeleteQASPScoreResponse");
_define_property(DeleteQASPScoreResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * SyncGlossarySection / FindGlossarySection (SAD-857). company_id is read
 * only on the principal-less service lane; a principal's tenant wins.
 *
 * @generated from message mono.ryugu.v1.SyncGlossarySectionRequest
 */ export class SyncGlossarySectionRequest extends Message {
    static fromBinary(bytes, options) {
        return new SyncGlossarySectionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncGlossarySectionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncGlossarySectionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncGlossarySectionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: mono.datagateway.v1.UpsertGlossarySectionRequest body = 2;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncGlossarySectionRequest, "runtime", proto3);
_define_property(SyncGlossarySectionRequest, "typeName", "mono.ryugu.v1.SyncGlossarySectionRequest");
_define_property(SyncGlossarySectionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "body",
            kind: "message",
            T: UpsertGlossarySectionRequest
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SyncGlossarySectionResponse
 */ export class SyncGlossarySectionResponse extends Message {
    static fromBinary(bytes, options) {
        return new SyncGlossarySectionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncGlossarySectionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncGlossarySectionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncGlossarySectionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UpsertGlossarySectionResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncGlossarySectionResponse, "runtime", proto3);
_define_property(SyncGlossarySectionResponse, "typeName", "mono.ryugu.v1.SyncGlossarySectionResponse");
_define_property(SyncGlossarySectionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: UpsertGlossarySectionResponse
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.FindGlossarySectionRequest
 */ export class FindGlossarySectionRequest extends Message {
    static fromBinary(bytes, options) {
        return new FindGlossarySectionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FindGlossarySectionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FindGlossarySectionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FindGlossarySectionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: mono.datagateway.v1.FindGlossarySectionRequest body = 2;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FindGlossarySectionRequest, "runtime", proto3);
_define_property(FindGlossarySectionRequest, "typeName", "mono.ryugu.v1.FindGlossarySectionRequest");
_define_property(FindGlossarySectionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "body",
            kind: "message",
            T: FindGlossarySectionRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.FindGlossarySectionResponse
 */ export class FindGlossarySectionResponse extends Message {
    static fromBinary(bytes, options) {
        return new FindGlossarySectionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FindGlossarySectionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FindGlossarySectionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FindGlossarySectionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.FindGlossarySectionResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FindGlossarySectionResponse, "runtime", proto3);
_define_property(FindGlossarySectionResponse, "typeName", "mono.ryugu.v1.FindGlossarySectionResponse");
_define_property(FindGlossarySectionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: FindGlossarySectionResponse$1
        }
    ]));
/**
 * Correct only a still-pending proposal at the revision inspected by the reviewer.
 *
 * @generated from message mono.ryugu.v1.CorrectLaborCategoryMappingRequest
 */ export class CorrectLaborCategoryMappingRequest extends Message {
    static fromBinary(bytes, options) {
        return new CorrectLaborCategoryMappingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CorrectLaborCategoryMappingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CorrectLaborCategoryMappingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CorrectLaborCategoryMappingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string to_entry_id = 2;
   */ _define_property(this, "toEntryId", ""), /**
   * @generated from field: string to_anchor_id = 3;
   */ _define_property(this, "toAnchorId", ""), /**
   * @generated from field: string mapping_type = 4;
   */ _define_property(this, "mappingType", ""), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: int64 expected_revision = 6;
   */ _define_property(this, "expectedRevision", protoInt64.zero), /**
   * @generated from field: string review_note = 7;
   */ _define_property(this, "reviewNote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CorrectLaborCategoryMappingRequest, "runtime", proto3);
_define_property(CorrectLaborCategoryMappingRequest, "typeName", "mono.ryugu.v1.CorrectLaborCategoryMappingRequest");
_define_property(CorrectLaborCategoryMappingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "to_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "to_anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "mapping_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 7,
            name: "review_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CorrectLaborCategoryMappingResponse
 */ export class CorrectLaborCategoryMappingResponse extends Message {
    static fromBinary(bytes, options) {
        return new CorrectLaborCategoryMappingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CorrectLaborCategoryMappingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CorrectLaborCategoryMappingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CorrectLaborCategoryMappingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.LaborCategoryMappingProto mapping = 1;
   */ _define_property(this, "mapping", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CorrectLaborCategoryMappingResponse, "runtime", proto3);
_define_property(CorrectLaborCategoryMappingResponse, "typeName", "mono.ryugu.v1.CorrectLaborCategoryMappingResponse");
_define_property(CorrectLaborCategoryMappingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "mapping",
            kind: "message",
            T: LaborCategoryMappingProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.WithdrawLaborCategoryMappingRequest
 */ export class WithdrawLaborCategoryMappingRequest extends Message {
    static fromBinary(bytes, options) {
        return new WithdrawLaborCategoryMappingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WithdrawLaborCategoryMappingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WithdrawLaborCategoryMappingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WithdrawLaborCategoryMappingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WithdrawLaborCategoryMappingRequest, "runtime", proto3);
_define_property(WithdrawLaborCategoryMappingRequest, "typeName", "mono.ryugu.v1.WithdrawLaborCategoryMappingRequest");
_define_property(WithdrawLaborCategoryMappingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.WithdrawLaborCategoryMappingResponse
 */ export class WithdrawLaborCategoryMappingResponse extends Message {
    static fromBinary(bytes, options) {
        return new WithdrawLaborCategoryMappingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WithdrawLaborCategoryMappingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WithdrawLaborCategoryMappingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WithdrawLaborCategoryMappingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.LaborCategoryMappingProto mapping = 1;
   */ _define_property(this, "mapping", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WithdrawLaborCategoryMappingResponse, "runtime", proto3);
_define_property(WithdrawLaborCategoryMappingResponse, "typeName", "mono.ryugu.v1.WithdrawLaborCategoryMappingResponse");
_define_property(WithdrawLaborCategoryMappingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "mapping",
            kind: "message",
            T: LaborCategoryMappingProto
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.LaborCategoryPrimaryMappingProto
 */ export class LaborCategoryPrimaryMappingProto extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryPrimaryMappingProto().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryPrimaryMappingProto().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryPrimaryMappingProto().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryPrimaryMappingProto, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string anchor_id = 1;
   */ _define_property(this, "anchorId", ""), /**
   * @generated from field: string anchor_title = 2;
   */ _define_property(this, "anchorTitle", ""), /**
   * @generated from field: string relation = 3;
   */ _define_property(this, "relation", ""), /**
   * @generated from field: string status = 4;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryPrimaryMappingProto, "runtime", proto3);
_define_property(LaborCategoryPrimaryMappingProto, "typeName", "mono.ryugu.v1.LaborCategoryPrimaryMappingProto");
_define_property(LaborCategoryPrimaryMappingProto, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "anchor_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
